webpackJsonp([88],{

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var testHost = 'pre-api.changyan.com';
var loginRedirectUrl = 'http://localhost:8080';
var audioUrl = 'gtzxx-test.oss-cn-beijing.aliyuncs.com';
exports.default = {
  data: function data() {
    return {
      env_name: "production",
      globalConfig: {
        dev: {
          char: ["RZCA", "RWRA"],
          word: ["RCYA", "RWRB", "RSRA"],
          downloadXmlAudioUrl: "http://test.zxx.isay365.com/storage",
          downloadUrl: "http://test.zxx.isay365.com/storage/auth/file?url=",
          downloadPackage: "http://test.zxx.isay365.com/cycoreDownload/jkpt/downloadCenter/",
          tssurl: "http://172.31.7.245:8074/tss/",
          apiConfig: {
            appId: "qiming-zxx-platform-xj-test-apply", //测试环境
            appSecret: "9ccee419422360bb", //测试环境
            host: testHost, //测试环境
            httpPort: 80, //HTTP_PORT,
            httpsPort: 443, //HTTPS_PORT,
            stage: "TEST", //STAGE,
            prefixPath: "dev",
            publicKey: "305C300D06092A864886F70D0101010500034B0030480241009053DCA70D8CF9E1C5B2906649E2A4C4EDEBBEE28BA6ADCE67CAF8618E84221F59E5A3633445F8CC4CDA694641BCD8FF922E5F2B1954BFB9267836F405FFD4A10203010001",
            staticImageUrl: "http://test.zxx.isay365.com/storage/auth/file?url="
          },
          ssoConfig: {
            version_num: "1.35.0.1265-20210630",
            appName: "edc",
            appKey: "qiming-zxx-platform-xj-test-apply", //测试环境
            client: "web",
            SSOServerUrl: "https://test-open.changyan.com/sso",
            loginRedirectUrl: loginRedirectUrl,
            SSOCenterServerUrl: "https://test-open.changyan.com/sso",
            isCenterSSO: true,
            syncType: 1,
            needAttribute: true,
            _retry: false,
            loginType: {
              LOGINBYNORMAL: "loginByNormal",
              LOGINBYVERIFYCODE: "loginByVerifyCode",
              LOGINBYONLINEAUTO: "loginByOnLineAuto",
              LOGINBYGENERIC: "loginByGeneric",
              LOGINBYTOKEN: "loginByToken",
              LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
              LOGINBYNCET: "loginByNcet"
            }
          },
          mdianConfig: {
            appId: "qm_jkpt_center_plat_sdk",
            host: /127\.0\.0\.1/, //接入SDK的网站的域名,域名匹配监测,参数需要与web应用的域名匹配
            configUrl: "http://logconf.iflytek.com",
            collectUrl: "https://ebglog.iflytek.com",
            source: "ebg"
          },
          aliyunConfig: {
            audioUrl: audioUrl
          }
        },
        test: {
          char: ["RZCA", "RWRA"],
          word: ["RCYA", "RWRB", "RSRA"],
          downloadXmlAudioUrl: "http://test.zxx.isay365.com/storage",
          downloadUrl: "http://test.zxx.isay365.com/storage/auth/file?url=",
          downloadPackage: "http://test.zxx.isay365.com/cycoreDownload/jkpt/downloadCenter/",
          tssurl: "http://172.31.7.245:8074/tss/",
          apiConfig: {
            appId: "qiming-zxx-platform-xj-test-apply", //测试环境
            appSecret: "9ccee419422360bb", //测试环境
            host: testHost, //测试环境
            httpPort: 80, //HTTP_PORT,
            httpsPort: 443, //HTTPS_PORT,
            stage: "TEST", //STAGE,
            prefixPath: "test",
            publicKey: "305C300D06092A864886F70D0101010500034B0030480241009053DCA70D8CF9E1C5B2906649E2A4C4EDEBBEE28BA6ADCE67CAF8618E84221F59E5A3633445F8CC4CDA694641BCD8FF922E5F2B1954BFB9267836F405FFD4A10203010001",
            staticImageUrl: "http://test.zxx.isay365.com/storage/auth/file?url="
          },
          ssoConfig: {
            version_num: "1.35.0.1265-20210630",
            appName: "edc",
            appKey: "qiming-zxx-platform-xj-test-apply", //测试环境
            client: "web",
            SSOServerUrl: "https://test-open.changyan.com/sso",
            loginRedirectUrl: loginRedirectUrl,
            SSOCenterServerUrl: "https://test-open.changyan.com/sso",
            isCenterSSO: true,
            syncType: 1,
            needAttribute: true,
            _retry: false,
            loginType: {
              LOGINBYNORMAL: "loginByNormal",
              LOGINBYVERIFYCODE: "loginByVerifyCode",
              LOGINBYONLINEAUTO: "loginByOnLineAuto",
              LOGINBYGENERIC: "loginByGeneric",
              LOGINBYTOKEN: "loginByToken",
              LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
              LOGINBYNCET: "loginByNcet"
            }
          },
          mdianConfig: {
            appId: "qm_jkpt_center_plat_sdk",
            host: /127\.0\.0\.1/, //接入SDK的网站的域名,域名匹配监测,参数需要与web应用的域名匹配
            configUrl: "http://logconf.iflytek.com",
            collectUrl: "https://ebglog.iflytek.com",
            source: "ebg"
          },
          aliyunConfig: {
            audioUrl: audioUrl
          }
        },
        testGch: {
          char: ["RZCA", "RWRA"],
          word: ["RCYA", "RWRB", "RSRA"],
          downloadXmlAudioUrl: "http://test.zxx.isay365.com/storage",
          downloadUrl: "http://test.zxx.isay365.com/storage/auth/file?url=",
          downloadPackage: "http://test.zxx.isay365.com/cycoreDownload/jkpt/downloadCenter/",
          tssurl: "http://172.31.7.245:8074/tss/",
          apiConfig: {
            appId: "qiming-zxx-platform-xj-test-apply", //测试环境
            appSecret: "9ccee419422360bb", //测试环境
            host: testHost, //测试环境
            httpPort: 80, //HTTP_PORT,
            httpsPort: 443, //HTTPS_PORT,
            stage: "TEST", //STAGE,
            prefixPath: "test/gch",
            publicKey: "305C300D06092A864886F70D0101010500034B0030480241009053DCA70D8CF9E1C5B2906649E2A4C4EDEBBEE28BA6ADCE67CAF8618E84221F59E5A3633445F8CC4CDA694641BCD8FF922E5F2B1954BFB9267836F405FFD4A10203010001",
            staticImageUrl: "http://test.zxx.isay365.com/storage/auth/file?url="
          },
          ssoConfig: {
            version_num: "1.35.0.1265-20210630",
            appName: "edc",
            appKey: "qiming-zxx-platform-xj-test-apply", //测试环境
            client: "web",
            SSOServerUrl: "https://test-open.changyan.com/sso",
            loginRedirectUrl: loginRedirectUrl,
            SSOCenterServerUrl: "https://test-open.changyan.com/sso",
            isCenterSSO: true,
            syncType: 1,
            needAttribute: true,
            _retry: false,
            loginType: {
              LOGINBYNORMAL: "loginByNormal",
              LOGINBYVERIFYCODE: "loginByVerifyCode",
              LOGINBYONLINEAUTO: "loginByOnLineAuto",
              LOGINBYGENERIC: "loginByGeneric",
              LOGINBYTOKEN: "loginByToken",
              LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
              LOGINBYNCET: "loginByNcet"
            }
          },
          mdianConfig: {
            appId: "qm_jkpt_center_plat_sdk",
            host: /127\.0\.0\.1/, //接入SDK的网站的域名,域名匹配监测,参数需要与web应用的域名匹配
            configUrl: "http://logconf.iflytek.com",
            collectUrl: "https://ebglog.iflytek.com",
            source: "ebg"
          },
          aliyunConfig: {
            audioUrl: audioUrl
          }
        },
        production: {
          char: ["RZCA", "RWRA"],
          word: ["RCYA", "RWRB", "RSRA"],
          //developmentBak:{
          downloadXmlAudioUrl: "https://zxx-storage.isay365.com/storage",
          downloadUrl: "https://zxx-storage.isay365.com/storage/auth/file?url=",
          downloadPackage: "https://zxx-storage.isay365.com/cycoreDownload/jkpt/downloadCenter/",
          tssurl: "http://172.31.7.245:8074/tss/",
          apiConfig: {
            appId: "qiming-zxx-platform-zx-apply",
            appSecret: "bc5992c3c73ed965",
            host: "zxx-api.isay365.com",
            httpPort: 80,
            httpsPort: 443,
            stage: "RELEASE",
            prefixPath: "/pro",
            publicKey: "305C300D06092A864886F70D0101010500034B003048024100BCA3303719A6E1F8C9C7E38D96EECE02ADDEAD6BF9220795FB0BC573D103B167D5F8917380E98CD6083B63ABAA00AB60FDB935C2EAE96BDD6288D5B2A7A994E70203010001",
            staticImageUrl: "https://zxx-storage.isay365.com/storage/auth/file?url="
          },
          ssoConfig: {
            version_num: "1.35.0.1265-20210630",
            appName: "edc",
            appKey: "qiming-zxx-platform-zx-apply",
            client: "web",
            SSOServerUrl: "https://open.changyan.com/sso",
            loginRedirectUrl: "http://zxx-web.isay365.com",
            SSOCenterServerUrl: "https://open.changyan.com/sso",
            isCenterSSO: true,
            syncType: 1,
            needAttribute: true,
            _retry: false,
            loginType: {
              LOGINBYNORMAL: "loginByNormal",
              LOGINBYVERIFYCODE: "loginByVerifyCode",
              LOGINBYONLINEAUTO: "loginByOnLineAuto",
              LOGINBYGENERIC: "loginByGeneric",
              LOGINBYTOKEN: "loginByToken",
              LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
              LOGINBYNCET: "loginByNcet"
            }
          },
          mdianConfig: {
            appId: "qm_jkpt_center_plat_sdk",
            host: /127\.0\.0\.1/, //接入SDK的网站的域名,域名匹配监测,参数需要与web应用的域名匹配
            configUrl: "http://logconf.iflytek.com",
            collectUrl: "https://ebglog.iflytek.com",
            source: "ebg"
          },
          aliyunConfig: {
            audioUrl: 'gtzxx-test.oss-cn-beijing.aliyuncs.com'
          }
        },
        productionNM: {
          char: ["RZCA", "RWRA"],
          word: ["RCYA", "RWRB", "RSRA"],
          //developmentBak:{
          downloadXmlAudioUrl: "https://zxx-storage.gty.nmgov.edu.cn/storage",
          downloadUrl: "https://zxx-storage.gty.nmgov.edu.cn/storage/auth/file?url=",
          downloadPackage: "https://zxx-storage.gty.nmgov.edu.cn/cycoreDownload/jkpt/downloadCenter/",
          tssurl: "http://172.31.7.245:8074/tss/",
          apiConfig: {

            //appId: "qiming-zxx-platform-nm-apply",
            appId: "qiming-zxx-platform-zx-apply",
            //appSecret: "81FA286E1508A01BB14AC295636C314A",
            appSecret: 'CACCC2D1E6C9BACA91BDCFFFE7690B3F',
            host: 'epasapi.gty.nmgov.edu.cn',
            httpPort: 80,
            httpsPort: 443,
            stage: "RELEASE",
            prefixPath: "/pro",
            // publicKey:
            // "305C300D06092A864886F70D0101010500034B003048024100A3FD21F868063A4181BEA49870E90414C13C48620850AC563FA1FB31E11B0AA05FB5A65C9C54E3B30E23435FBABBC5899AF65D406683E015C5DEF818285C26410203010001"
            publicKey: "305C300D06092A864886F70D0101010500034B0030480241009CC038565E36E34960387CDECC0076370C9F758C49B6A138CCD66597F2B337E1475DB43A7A806C5504228AC0EFBE9A476F9019C45C2524FB89CAB2A8B0EEEE1B0203010001",
            staticImageUrl: "https://zxx-storage.gty.nmgov.edu.cn/storage/auth/file?url="
          },
          ssoConfig: {
            version_num: "1.35.0.1265-20210630",
            appName: "edc",
            appKey: "qiming-zxx-platform-zx-apply",
            //appKey: "qiming-zxx-platform-nm-apply",
            client: "web",
            SSOServerUrl: 'http://gty.nmgov.edu.cn/sso',
            loginRedirectUrl: "http://zxx-web.gty.nmgov.edu.cn",
            SSOCenterServerUrl: "http://gty.nmgov.edu.cn/sso",
            isCenterSSO: true,
            syncType: 1,
            needAttribute: true,
            _retry: false,
            loginType: {
              LOGINBYNORMAL: "loginByNormal",
              LOGINBYVERIFYCODE: "loginByVerifyCode",
              LOGINBYONLINEAUTO: "loginByOnLineAuto",
              LOGINBYGENERIC: "loginByGeneric",
              LOGINBYTOKEN: "loginByToken",
              LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
              LOGINBYNCET: "loginByNcet"
            }
          },
          mdianConfig: {
            appId: "qm_jkpt_center_plat_sdk",
            host: /127\.0\.0\.1/, //接入SDK的网站的域名,域名匹配监测,参数需要与web应用的域名匹配
            configUrl: "http://logconf.iflytek.com",
            collectUrl: "https://ebglog.iflytek.com",
            source: "ebg"
          },
          aliyunConfig: {
            audioUrl: 'zxx-prod.oss-cn-beijing.aliyuncs.com'
          }
        }
      }
    };
  },
  getConfig: function getConfig() {
    var data = this.data();
    if (data.globalConfig.hasOwnProperty(data.env_name)) {
      return data.globalConfig[data.env_name];
    } else {
      return data.globalConfig.dev;
    }
  }
};

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(13);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(0);

var _stringify2 = _interopRequireDefault(_stringify);

var _config = __webpack_require__(1);

var _config2 = _interopRequireDefault(_config);

__webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

///<jscompress sourcefile="Math.uuid.js" />
/*!
Math.uuid.js (v1.4)

Copyright (c) 2010 Robert Kieffer
Dual licensed under the MIT and GPL licenses.
*/

/*
 * Generate a random uuid.
 *
 * USAGE: Math.uuid(length, radix)
 *   length - the desired number of characters
 *   radix  - the number of allowable values for each character.
 *
 * EXAMPLES:
 *   // No arguments  - returns RFC4122, version 4 ID
 *   >>> Math.uuid()
 *   "92329D39-6F5C-4520-ABFC-AAB64544E172"
 *
 *   // One argument - returns ID of the specified length
 *   >>> Math.uuid(15)     // 15 character ID (default base=62)
 *   "VcydxgltxrVZSTV"
 *
 *   // Two arguments - returns ID of the specified length, and radix. (Radix must be <= 62)
 *   >>> Math.uuid(8, 2)  // 8 character ID (base=2)
 *   "01001010"
 *   >>> Math.uuid(8, 10) // 8 character ID (base=10)
 *   "47473046"
 *   >>> Math.uuid(8, 16) // 8 character ID (base=16)
 *   "098F4D35"
 */
(function () {
  // Private array of chars to use
  var CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");

  Math.uuid = function (len, radix) {
    var chars = CHARS,
        uuid = [],
        i;
    radix = radix || chars.length;

    if (len) {
      // Compact form
      for (i = 0; i < len; i++) {
        uuid[i] = chars[0 | Math.random() * radix];
      }
    } else {
      // rfc4122, version 4 form
      var r;

      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
      uuid[14] = "4";

      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16;
          uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
        }
      }
    }

    return uuid.join("");
  };

  // A more performant, but slightly bulkier, RFC4122v4 solution.  We boost performance
  // by minimizing calls to random()
  Math.uuidFast = function () {
    var chars = CHARS,
        uuid = new Array(36),
        rnd = 0,
        r;
    for (var i = 0; i < 36; i++) {
      if (i == 8 || i == 13 || i == 18 || i == 23) {
        uuid[i] = "-";
      } else if (i == 14) {
        uuid[i] = "4";
      } else {
        if (rnd <= 0x02) rnd = 0x2000000 + Math.random() * 0x1000000 | 0;
        r = rnd & 0xf;
        rnd = rnd >> 4;
        uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
      }
    }
    return uuid.join("");
  };

  // A more compact, but less performant, RFC4122v4 solution:
  Math.uuidCompact = function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == "x" ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  };
})();
///<jscompress sourcefile="base64.js" />
(function (undefined) {
  var Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function encode(e) {
      var t = "";
      var n, r, i, s, o, u, a;
      var f = 0;
      e = Base64._utf8_encode(e);
      while (f < e.length) {
        n = e.charCodeAt(f++);
        r = e.charCodeAt(f++);
        i = e.charCodeAt(f++);
        s = n >> 2;
        o = (n & 3) << 4 | r >> 4;
        u = (r & 15) << 2 | i >> 6;
        a = i & 63;
        if (isNaN(r)) {
          u = a = 64;
        } else if (isNaN(i)) {
          a = 64;
        } else {
          // 注释
        }
        t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
      }
      return t;
    },
    decode: function decode(e) {
      var t = "";
      var n, r, i;
      var s, o, u, a;
      var f = 0;
      e = e.replace(/[^A-Za-z0-9+/=]/g, "");
      while (f < e.length) {
        s = this._keyStr.indexOf(e.charAt(f++));
        o = this._keyStr.indexOf(e.charAt(f++));
        u = this._keyStr.indexOf(e.charAt(f++));
        a = this._keyStr.indexOf(e.charAt(f++));
        n = s << 2 | o >> 4;
        r = (o & 15) << 4 | u >> 2;
        i = (u & 3) << 6 | a;
        t = t + String.fromCharCode(n);
        if (u != 64) {
          t = t + String.fromCharCode(r);
        }
        if (a != 64) {
          t = t + String.fromCharCode(i);
        }
      }
      t = Base64._utf8_decode(t);
      return t;
    },
    _utf8_encode: function _utf8_encode(e) {
      e = e.replace(/rn/g, "n");
      var t = "";
      for (var n = 0; n < e.length; n++) {
        var r = e.charCodeAt(n);
        if (r < 128) {
          t += String.fromCharCode(r);
        } else if (r > 127 && r < 2048) {
          t += String.fromCharCode(r >> 6 | 192);
          t += String.fromCharCode(r & 63 | 128);
        } else {
          t += String.fromCharCode(r >> 12 | 224);
          t += String.fromCharCode(r >> 6 & 63 | 128);
          t += String.fromCharCode(r & 63 | 128);
        }
      }
      return t;
    },
    _utf8_decode: function _utf8_decode(e) {
      var t = "";
      var n = 0;
      var r = 0;
      var c1 = 0;
      var c2 = 0;
      var c3 = 0;
      while (n < e.length) {
        r = e.charCodeAt(n);
        if (r < 128) {
          t += String.fromCharCode(r);
          n++;
        } else if (r > 191 && r < 224) {
          c2 = e.charCodeAt(n + 1);
          t += String.fromCharCode((r & 31) << 6 | c2 & 63);
          n += 2;
        } else {
          c2 = e.charCodeAt(n + 1);
          c3 = e.charCodeAt(n + 2);
          t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
          n += 3;
        }
      }
      return t;
    }
  };
  window.Base64 = Base64;
})();
///<jscompress sourcefile="jquery.sha1.js" />

/**
 * jQuery SHA1 hash algorithm function
 *      <code>
 *              Calculate the sha1 hash of a String
 *              String $.sha1 ( String str )
 *      </code>
 *
 * Calculates the sha1 hash of str using the US Secure Hash Algorithm 1.
 * SHA-1 the Secure Hash Algorithm (SHA) was developed by NIST and is specified in the Secure Hash Standard (SHS, FIPS 180).
 * This script is used to process variable length message into a fixed-length output using the SHA-1 algorithm. It is fully compatible with UTF-8 encoding.
 * If you plan using UTF-8 encoding in your project don't forget to set the page encoding to UTF-8 (Content-Type meta tag).
 * This function orginally get from the WebToolkit and rewrite for using as the jQuery plugin.
 *
 * Example
 *      Code
 *              <code>
 *                      $.sha1("I'm Persian.");
 *              </code>
 *      Result
 *              <code>
 *                      "1d302f9dc925d62fc859055999d2052e274513ed"
 *              </code>
 *
 * @param {jQuery} {sha1:function(string))
 * @return string
 */

(function ($) {
  var rotateLeft = function rotateLeft(lValue, iShiftBits) {
    return lValue << iShiftBits | lValue >>> 32 - iShiftBits;
  };

  var lsbHex = function lsbHex(value) {
    var string = "";
    var i;
    var vh;
    var vl;
    for (i = 0; i <= 6; i += 2) {
      vh = value >>> i * 4 + 4 & 0x0f;
      vl = value >>> i * 4 & 0x0f;
      string += vh.toString(16) + vl.toString(16);
    }
    return string;
  };

  var cvtHex = function cvtHex(value) {
    var string = "";
    var i;
    var v;
    for (i = 7; i >= 0; i--) {
      v = value >>> i * 4 & 0x0f;
      string += v.toString(16);
    }
    return string;
  };

  var uTF8Encode = function uTF8Encode(string) {
    string = string.replace(/\x0d\x0a/g, "\x0a");
    var output = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        output += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        output += String.fromCharCode(c >> 6 | 192);
        output += String.fromCharCode(c & 63 | 128);
      } else {
        output += String.fromCharCode(c >> 12 | 224);
        output += String.fromCharCode(c >> 6 & 63 | 128);
        output += String.fromCharCode(c & 63 | 128);
      }
    }
    return output;
  };

  $.extend({
    sha1: function sha1(string) {
      var blockstart;
      var i, j;
      var W = new Array(80);
      var H0 = 0x67452301;
      var H1 = 0xefcdab89;
      var H2 = 0x98badcfe;
      var H3 = 0x10325476;
      var H4 = 0xc3d2e1f0;
      var A, B, C, D, E;
      var tempValue;
      string = uTF8Encode(string);
      var stringLength = string.length;
      var wordArray = new Array();
      for (i = 0; i < stringLength - 3; i += 4) {
        j = string.charCodeAt(i) << 24 | string.charCodeAt(i + 1) << 16 | string.charCodeAt(i + 2) << 8 | string.charCodeAt(i + 3);
        wordArray.push(j);
      }
      switch (stringLength % 4) {
        case 0:
          i = 0x080000000;
          break;
        case 1:
          i = string.charCodeAt(stringLength - 1) << 24 | 0x0800000;
          break;
        case 2:
          i = string.charCodeAt(stringLength - 2) << 24 | string.charCodeAt(stringLength - 1) << 16 | 0x08000;
          break;
        case 3:
          i = string.charCodeAt(stringLength - 3) << 24 | string.charCodeAt(stringLength - 2) << 16 | string.charCodeAt(stringLength - 1) << 8 | 0x80;
          break;
        default:
          break;
      }
      wordArray.push(i);
      while (wordArray.length % 16 != 14) {
        wordArray.push(0);
      }wordArray.push(stringLength >>> 29);
      wordArray.push(stringLength << 3 & 0x0ffffffff);
      for (blockstart = 0; blockstart < wordArray.length; blockstart += 16) {
        for (i = 0; i < 16; i++) {
          W[i] = wordArray[blockstart + i];
        }for (i = 16; i <= 79; i++) {
          W[i] = rotateLeft(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        }A = H0;
        B = H1;
        C = H2;
        D = H3;
        E = H4;
        for (i = 0; i <= 19; i++) {
          tempValue = rotateLeft(A, 5) + (B & C | ~B & D) + E + W[i] + 0x5a827999 & 0x0ffffffff;
          E = D;
          D = C;
          C = rotateLeft(B, 30);
          B = A;
          A = tempValue;
        }
        for (i = 20; i <= 39; i++) {
          tempValue = rotateLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1 & 0x0ffffffff;
          E = D;
          D = C;
          C = rotateLeft(B, 30);
          B = A;
          A = tempValue;
        }
        for (i = 40; i <= 59; i++) {
          tempValue = rotateLeft(A, 5) + (B & C | B & D | C & D) + E + W[i] + 0x8f1bbcdc & 0x0ffffffff;
          E = D;
          D = C;
          C = rotateLeft(B, 30);
          B = A;
          A = tempValue;
        }
        for (i = 60; i <= 79; i++) {
          tempValue = rotateLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6 & 0x0ffffffff;
          E = D;
          D = C;
          C = rotateLeft(B, 30);
          B = A;
          A = tempValue;
        }
        H0 = H0 + A & 0x0ffffffff;
        H1 = H1 + B & 0x0ffffffff;
        H2 = H2 + C & 0x0ffffffff;
        H3 = H3 + D & 0x0ffffffff;
        H4 = H4 + E & 0x0ffffffff;
      }
      tempValue = cvtHex(H0) + cvtHex(H1) + cvtHex(H2) + cvtHex(H3) + cvtHex(H4);
      return tempValue.toLowerCase();
    }
  });
})(jQuery);
///<jscompress sourcefile="security.js" />
/*
 * RSA, a suite of routines for performing RSA public-key computations in JavaScript.
 * Copyright 1998-2005 David Shapiro.
 * Dave Shapiro
 * dave@ohdave.com
 * changed by Fuchun, 2010-05-06
 * fcrpg2005@gmail.com
 */

(function ($w) {
  if (typeof $w.RSAUtils === "undefined") {
    var RSAUtils = $w.RSAUtils = {};
  } else {
    var RSAUtils = $w.RSAUtils;
  }
  var biRadixBase = 2;
  var biRadixBits = 16;
  var bitsPerDigit = biRadixBits;
  var biRadix = 1 << 16; // = 2^16 = 65536
  var biHalfRadix = biRadix >>> 1;
  var biRadixSquared = biRadix * biRadix;
  var maxDigitVal = biRadix - 1;
  var maxInteger = 9999999999999998;

  //maxDigits:
  //Change this to accommodate your largest number size. Use setMaxDigits()
  //to change it!
  //
  //In general, if you're working with numbers of size N bits, you'll need 2*N
  //bits of storage. Each digit holds 16 bits. So, a 1024-bit key will need
  //
  //1024 * 2 / 16 = 128 digits of storage.

  var maxDigits;
  var ZERO_ARRAY;
  var bigZero, bigOne;

  var BigInt = $w.BigInt = function (flag) {
    if (typeof flag == "boolean" && flag == true) {
      this.digits = null;
    } else {
      this.digits = ZERO_ARRAY.slice(0);
    }
    this.isNeg = false;
  };

  RSAUtils.setMaxDigits = function (value) {
    maxDigits = value;
    ZERO_ARRAY = new Array(maxDigits);
    for (var iza = 0; iza < ZERO_ARRAY.length; iza++) {
      ZERO_ARRAY[iza] = 0;
    }bigZero = new BigInt();
    bigOne = new BigInt();
    bigOne.digits[0] = 1;
  };
  RSAUtils.setMaxDigits(20);

  //The maximum number of digits in base 10 you can convert to an
  //integer without JavaScript throwing up on you.
  var dpl10 = 15;

  RSAUtils.biFromNumber = function (i) {
    var result = new BigInt();
    result.isNeg = i < 0;
    i = Math.abs(i);
    var j = 0;
    while (i > 0) {
      result.digits[j++] = i & maxDigitVal;
      i = Math.floor(i / biRadix);
    }
    return result;
  };

  //lr10 = 10 ^ dpl10
  var lr10 = RSAUtils.biFromNumber(1000000000000000);

  RSAUtils.biFromDecimal = function (s) {
    var isNeg = s.charAt(0) == "-";
    var i = isNeg ? 1 : 0;
    var result;
    // Skip leading zeros.
    while (i < s.length && s.charAt(i) == "0") {
      ++i;
    }if (i == s.length) {
      result = new BigInt();
    } else {
      var digitCount = s.length - i;
      var fgl = digitCount % dpl10;
      if (fgl == 0) fgl = dpl10;
      result = RSAUtils.biFromNumber(Number(s.substr(i, fgl)));
      i += fgl;
      while (i < s.length) {
        result = RSAUtils.biAdd(RSAUtils.biMultiply(result, lr10), RSAUtils.biFromNumber(Number(s.substr(i, dpl10))));
        i += dpl10;
      }
      result.isNeg = isNeg;
    }
    return result;
  };

  RSAUtils.biCopy = function (bi) {
    var result = new BigInt(true);
    result.digits = bi.digits.slice(0);
    result.isNeg = bi.isNeg;
    return result;
  };

  RSAUtils.reverseStr = function (s) {
    var result = "";
    for (var i = s.length - 1; i > -1; --i) {
      result += s.charAt(i);
    }
    return result;
  };

  var hexatrigesimalToChar = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];

  RSAUtils.biToString = function (x, radix) {
    // 2 <= radix <= 36
    var b = new BigInt();
    b.digits[0] = radix;
    var qr = RSAUtils.biDivideModulo(x, b);
    var result = hexatrigesimalToChar[qr[1].digits[0]];
    var digit = 0;
    while (RSAUtils.biCompare(qr[0], bigZero) == 1) {
      qr = RSAUtils.biDivideModulo(qr[0], b);
      digit = qr[1].digits[0];
      result += hexatrigesimalToChar[qr[1].digits[0]];
    }
    return (x.isNeg ? "-" : "") + RSAUtils.reverseStr(result);
  };

  RSAUtils.biToDecimal = function (x) {
    var b = new BigInt();
    b.digits[0] = 10;
    var qr = RSAUtils.biDivideModulo(x, b);
    var result = String(qr[1].digits[0]);
    while (RSAUtils.biCompare(qr[0], bigZero) == 1) {
      qr = RSAUtils.biDivideModulo(qr[0], b);
      result += String(qr[1].digits[0]);
    }
    return (x.isNeg ? "-" : "") + RSAUtils.reverseStr(result);
  };

  var hexToChar = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];

  RSAUtils.digitToHex = function (n) {
    var mask = 0xf;
    var result = "";
    for (var i = 0; i < 4; ++i) {
      result += hexToChar[n & mask];
      n >>>= 4;
    }
    return RSAUtils.reverseStr(result);
  };

  RSAUtils.biToHex = function (x) {
    var result = "";
    var n = RSAUtils.biHighIndex(x);
    for (var i = RSAUtils.biHighIndex(x); i > -1; --i) {
      result += RSAUtils.digitToHex(x.digits[i]);
    }
    return result;
  };

  RSAUtils.charToHex = function (c) {
    var ZERO = 48;
    var NINE = ZERO + 9;
    var littleA = 97;
    var littleZ = littleA + 25;
    var bigA = 65;
    var bigZ = 65 + 25;
    var result;

    if (c >= ZERO && c <= NINE) {
      result = c - ZERO;
    } else if (c >= bigA && c <= bigZ) {
      result = 10 + c - bigA;
    } else if (c >= littleA && c <= littleZ) {
      result = 10 + c - littleA;
    } else {
      result = 0;
    }
    return result;
  };

  RSAUtils.hexToDigit = function (s) {
    var result = 0;
    var sl = Math.min(s.length, 4);
    for (var i = 0; i < sl; ++i) {
      result <<= 4;
      result |= RSAUtils.charToHex(s.charCodeAt(i));
    }
    return result;
  };

  RSAUtils.biFromHex = function (s) {
    var result = new BigInt();
    var sl = s.length;
    for (var i = sl, j = 0; i > 0; i -= 4, ++j) {
      result.digits[j] = RSAUtils.hexToDigit(s.substr(Math.max(i - 4, 0), Math.min(i, 4)));
    }
    return result;
  };

  RSAUtils.biFromString = function (s, radix) {
    var isNeg = s.charAt(0) == "-";
    var istop = isNeg ? 1 : 0;
    var result = new BigInt();
    var place = new BigInt();
    place.digits[0] = 1; // radix^0
    for (var i = s.length - 1; i >= istop; i--) {
      var c = s.charCodeAt(i);
      var digit = RSAUtils.charToHex(c);
      var biDigit = RSAUtils.biMultiplyDigit(place, digit);
      result = RSAUtils.biAdd(result, biDigit);
      place = RSAUtils.biMultiplyDigit(place, radix);
    }
    result.isNeg = isNeg;
    return result;
  };

  RSAUtils.biDump = function (b) {
    return (b.isNeg ? "-" : "") + b.digits.join(" ");
  };

  RSAUtils.biAdd = function (x, y) {
    var result;

    if (x.isNeg != y.isNeg) {
      y.isNeg = !y.isNeg;
      result = RSAUtils.biSubtract(x, y);
      y.isNeg = !y.isNeg;
    } else {
      result = new BigInt();
      var c = 0;
      var n;
      for (var i = 0; i < x.digits.length; ++i) {
        n = x.digits[i] + y.digits[i] + c;
        result.digits[i] = n % biRadix;
        c = Number(n >= biRadix);
      }
      result.isNeg = x.isNeg;
    }
    return result;
  };

  RSAUtils.biSubtract = function (x, y) {
    var result;
    if (x.isNeg != y.isNeg) {
      y.isNeg = !y.isNeg;
      result = RSAUtils.biAdd(x, y);
      y.isNeg = !y.isNeg;
    } else {
      result = new BigInt();
      var n, c;
      c = 0;
      for (var i = 0; i < x.digits.length; ++i) {
        n = x.digits[i] - y.digits[i] + c;
        result.digits[i] = n % biRadix;
        // Stupid non-conforming modulus operation.
        if (result.digits[i] < 0) result.digits[i] += biRadix;
        c = 0 - Number(n < 0);
      }
      // Fix up the negative sign, if any.
      if (c == -1) {
        c = 0;
        for (var i = 0; i < x.digits.length; ++i) {
          n = 0 - result.digits[i] + c;
          result.digits[i] = n % biRadix;
          // Stupid non-conforming modulus operation.
          if (result.digits[i] < 0) result.digits[i] += biRadix;
          c = 0 - Number(n < 0);
        }
        // Result is opposite sign of arguments.
        result.isNeg = !x.isNeg;
      } else {
        // Result is same sign.
        result.isNeg = x.isNeg;
      }
    }
    return result;
  };

  RSAUtils.biHighIndex = function (x) {
    var result = x.digits.length - 1;
    while (result > 0 && x.digits[result] == 0) {
      --result;
    }return result;
  };

  RSAUtils.biNumBits = function (x) {
    var n = RSAUtils.biHighIndex(x);
    var d = x.digits[n];
    var m = (n + 1) * bitsPerDigit;
    var result;
    for (result = m; result > m - bitsPerDigit; --result) {
      if ((d & 0x8000) != 0) break;
      d <<= 1;
    }
    return result;
  };

  RSAUtils.biMultiply = function (x, y) {
    var result = new BigInt();
    var c;
    var n = RSAUtils.biHighIndex(x);
    var t = RSAUtils.biHighIndex(y);
    var u, uv, k;

    for (var i = 0; i <= t; ++i) {
      c = 0;
      k = i;
      for (var j = 0; j <= n; ++j, ++k) {
        uv = result.digits[k] + x.digits[j] * y.digits[i] + c;
        result.digits[k] = uv & maxDigitVal;
        c = uv >>> biRadixBits;
        //c = Math.floor(uv / biRadix);
      }
      result.digits[i + n + 1] = c;
    }
    // Someone give me a logical xor, please.
    result.isNeg = x.isNeg != y.isNeg;
    return result;
  };

  RSAUtils.biMultiplyDigit = function (x, y) {
    var n, c, uv;

    var result = new BigInt();
    n = RSAUtils.biHighIndex(x);
    c = 0;
    for (var j = 0; j <= n; ++j) {
      uv = result.digits[j] + x.digits[j] * y + c;
      result.digits[j] = uv & maxDigitVal;
      c = uv >>> biRadixBits;
      //c = Math.floor(uv / biRadix);
    }
    result.digits[1 + n] = c;
    return result;
  };

  RSAUtils.arrayCopy = function (src, srcStart, dest, destStart, n) {
    var m = Math.min(srcStart + n, src.length);
    for (var i = srcStart, j = destStart; i < m; ++i, ++j) {
      dest[j] = src[i];
    }
  };

  var highBitMasks = [0x0000, 0x8000, 0xc000, 0xe000, 0xf000, 0xf800, 0xfc00, 0xfe00, 0xff00, 0xff80, 0xffc0, 0xffe0, 0xfff0, 0xfff8, 0xfffc, 0xfffe, 0xffff];

  RSAUtils.biShiftLeft = function (x, n) {
    var digitCount = Math.floor(n / bitsPerDigit);
    var result = new BigInt();
    RSAUtils.arrayCopy(x.digits, 0, result.digits, digitCount, result.digits.length - digitCount);
    var bits = n % bitsPerDigit;
    var rightBits = bitsPerDigit - bits;
    for (var i = result.digits.length - 1, i1 = i - 1; i > 0; --i, --i1) {
      result.digits[i] = result.digits[i] << bits & maxDigitVal | (result.digits[i1] & highBitMasks[bits]) >>> rightBits;
    }
    result.digits[0] = result.digits[i] << bits & maxDigitVal;
    result.isNeg = x.isNeg;
    return result;
  };

  var lowBitMasks = [0x0000, 0x0001, 0x0003, 0x0007, 0x000f, 0x001f, 0x003f, 0x007f, 0x00ff, 0x01ff, 0x03ff, 0x07ff, 0x0fff, 0x1fff, 0x3fff, 0x7fff, 0xffff];

  RSAUtils.biShiftRight = function (x, n) {
    var digitCount = Math.floor(n / bitsPerDigit);
    var result = new BigInt();
    RSAUtils.arrayCopy(x.digits, digitCount, result.digits, 0, x.digits.length - digitCount);
    var bits = n % bitsPerDigit;
    var leftBits = bitsPerDigit - bits;
    for (var i = 0, i1 = i + 1; i < result.digits.length - 1; ++i, ++i1) {
      result.digits[i] = result.digits[i] >>> bits | (result.digits[i1] & lowBitMasks[bits]) << leftBits;
    }
    result.digits[result.digits.length - 1] >>>= bits;
    result.isNeg = x.isNeg;
    return result;
  };

  RSAUtils.biMultiplyByRadixPower = function (x, n) {
    var result = new BigInt();
    RSAUtils.arrayCopy(x.digits, 0, result.digits, n, result.digits.length - n);
    return result;
  };

  RSAUtils.biDivideByRadixPower = function (x, n) {
    var result = new BigInt();
    RSAUtils.arrayCopy(x.digits, n, result.digits, 0, result.digits.length - n);
    return result;
  };

  RSAUtils.biModuloByRadixPower = function (x, n) {
    var result = new BigInt();
    RSAUtils.arrayCopy(x.digits, 0, result.digits, 0, n);
    return result;
  };

  RSAUtils.biCompare = function (x, y) {
    if (x.isNeg != y.isNeg) {
      return 1 - 2 * Number(x.isNeg);
    }
    for (var i = x.digits.length - 1; i >= 0; --i) {
      if (x.digits[i] != y.digits[i]) {
        if (x.isNeg) {
          return 1 - 2 * Number(x.digits[i] > y.digits[i]);
        } else {
          return 1 - 2 * Number(x.digits[i] < y.digits[i]);
        }
      }
    }
    return 0;
  };

  RSAUtils.biDivideModulo = function (x, y) {
    var nb = RSAUtils.biNumBits(x);
    var tb = RSAUtils.biNumBits(y);
    var origYIsNeg = y.isNeg;
    var q, r;
    if (nb < tb) {
      // |x| < |y|
      if (x.isNeg) {
        q = RSAUtils.biCopy(bigOne);
        q.isNeg = !y.isNeg;
        x.isNeg = false;
        y.isNeg = false;
        r = biSubtract(y, x);
        // Restore signs, 'cause they're references.
        x.isNeg = true;
        y.isNeg = origYIsNeg;
      } else {
        q = new BigInt();
        r = RSAUtils.biCopy(x);
      }
      return [q, r];
    }

    q = new BigInt();
    r = x;

    // Normalize Y.
    var t = Math.ceil(tb / bitsPerDigit) - 1;
    var lambda = 0;
    while (y.digits[t] < biHalfRadix) {
      y = RSAUtils.biShiftLeft(y, 1);
      ++lambda;
      ++tb;
      t = Math.ceil(tb / bitsPerDigit) - 1;
    }
    // Shift r over to keep the quotient constant. We'll shift the
    // remainder back at the end.
    r = RSAUtils.biShiftLeft(r, lambda);
    nb += lambda; // Update the bit count for x.
    var n = Math.ceil(nb / bitsPerDigit) - 1;

    var b = RSAUtils.biMultiplyByRadixPower(y, n - t);
    while (RSAUtils.biCompare(r, b) != -1) {
      ++q.digits[n - t];
      r = RSAUtils.biSubtract(r, b);
    }
    for (var i = n; i > t; --i) {
      var ri = i >= r.digits.length ? 0 : r.digits[i];
      var ri1 = i - 1 >= r.digits.length ? 0 : r.digits[i - 1];
      var ri2 = i - 2 >= r.digits.length ? 0 : r.digits[i - 2];
      var yt = t >= y.digits.length ? 0 : y.digits[t];
      var yt1 = t - 1 >= y.digits.length ? 0 : y.digits[t - 1];
      if (ri == yt) {
        q.digits[i - t - 1] = maxDigitVal;
      } else {
        q.digits[i - t - 1] = Math.floor((ri * biRadix + ri1) / yt);
      }

      var c1 = q.digits[i - t - 1] * (yt * biRadix + yt1);
      var c2 = ri * biRadixSquared + (ri1 * biRadix + ri2);
      while (c1 > c2) {
        --q.digits[i - t - 1];
        c1 = q.digits[i - t - 1] * (yt * biRadix | yt1);
        c2 = ri * biRadix * biRadix + (ri1 * biRadix + ri2);
      }

      b = RSAUtils.biMultiplyByRadixPower(y, i - t - 1);
      r = RSAUtils.biSubtract(r, RSAUtils.biMultiplyDigit(b, q.digits[i - t - 1]));
      if (r.isNeg) {
        r = RSAUtils.biAdd(r, b);
        --q.digits[i - t - 1];
      }
    }
    r = RSAUtils.biShiftRight(r, lambda);
    // Fiddle with the signs and stuff to make sure that 0 <= r < y.
    q.isNeg = x.isNeg != origYIsNeg;
    if (x.isNeg) {
      if (origYIsNeg) {
        q = RSAUtils.biAdd(q, bigOne);
      } else {
        q = RSAUtils.biSubtract(q, bigOne);
      }
      y = RSAUtils.biShiftRight(y, lambda);
      r = RSAUtils.biSubtract(y, r);
    }
    // Check for the unbelievably stupid degenerate case of r == -0.
    if (r.digits[0] == 0 && RSAUtils.biHighIndex(r) == 0) r.isNeg = false;

    return [q, r];
  };

  RSAUtils.biDivide = function (x, y) {
    return RSAUtils.biDivideModulo(x, y)[0];
  };

  RSAUtils.biModulo = function (x, y) {
    return RSAUtils.biDivideModulo(x, y)[1];
  };

  RSAUtils.biMultiplyMod = function (x, y, m) {
    return RSAUtils.biModulo(RSAUtils.biMultiply(x, y), m);
  };

  RSAUtils.biPow = function (x, y) {
    var result = bigOne;
    var a = x;
    while (true) {
      if ((y & 1) != 0) result = RSAUtils.biMultiply(result, a);
      y >>= 1;
      if (y == 0) break;
      a = RSAUtils.biMultiply(a, a);
    }
    return result;
  };

  RSAUtils.biPowMod = function (x, y, m) {
    var result = bigOne;
    var a = x;
    var k = y;
    while (true) {
      if ((k.digits[0] & 1) != 0) result = RSAUtils.biMultiplyMod(result, a, m);
      k = RSAUtils.biShiftRight(k, 1);
      if (k.digits[0] == 0 && RSAUtils.biHighIndex(k) == 0) break;
      a = RSAUtils.biMultiplyMod(a, a, m);
    }
    return result;
  };

  $w.BarrettMu = function (m) {
    this.modulus = RSAUtils.biCopy(m);
    this.k = RSAUtils.biHighIndex(this.modulus) + 1;
    var b2k = new BigInt();
    b2k.digits[2 * this.k] = 1; // b2k = b^(2k)
    this.mu = RSAUtils.biDivide(b2k, this.modulus);
    this.bkplus1 = new BigInt();
    this.bkplus1.digits[this.k + 1] = 1; // bkplus1 = b^(k+1)
    this.modulo = BarrettMu_modulo;
    this.multiplyMod = BarrettMu_multiplyMod;
    this.powMod = BarrettMu_powMod;
  };

  function BarrettMu_modulo(x) {
    var $dmath = RSAUtils;
    var q1 = $dmath.biDivideByRadixPower(x, this.k - 1);
    var q2 = $dmath.biMultiply(q1, this.mu);
    var q3 = $dmath.biDivideByRadixPower(q2, this.k + 1);
    var r1 = $dmath.biModuloByRadixPower(x, this.k + 1);
    var r2term = $dmath.biMultiply(q3, this.modulus);
    var r2 = $dmath.biModuloByRadixPower(r2term, this.k + 1);
    var r = $dmath.biSubtract(r1, r2);
    if (r.isNeg) {
      r = $dmath.biAdd(r, this.bkplus1);
    }
    var rgtem = $dmath.biCompare(r, this.modulus) >= 0;
    while (rgtem) {
      r = $dmath.biSubtract(r, this.modulus);
      rgtem = $dmath.biCompare(r, this.modulus) >= 0;
    }
    return r;
  }

  function BarrettMu_multiplyMod(x, y) {
    /*
     x = this.modulo(x);
     y = this.modulo(y);
     */
    var xy = RSAUtils.biMultiply(x, y);
    return this.modulo(xy);
  }

  function BarrettMu_powMod(x, y) {
    var result = new BigInt();
    result.digits[0] = 1;
    var a = x;
    var k = y;
    while (true) {
      if ((k.digits[0] & 1) != 0) result = this.multiplyMod(result, a);
      k = RSAUtils.biShiftRight(k, 1);
      if (k.digits[0] == 0 && RSAUtils.biHighIndex(k) == 0) break;
      a = this.multiplyMod(a, a);
    }
    return result;
  }

  var RSAKeyPair = function RSAKeyPair(encryptionExponent, decryptionExponent, modulus) {
    var $dmath = RSAUtils;
    this.e = $dmath.biFromHex(encryptionExponent);
    this.d = $dmath.biFromHex(decryptionExponent);
    this.m = $dmath.biFromHex(modulus);
    // We can do two bytes per digit, so
    // chunkSize = 2 * (number of digits in modulus - 1).
    // Since biHighIndex returns the high index, not the number of digits, 1 has
    // already been subtracted.
    this.digitSize = 2 * $dmath.biHighIndex(this.m) + 2;
    this.chunkSize = this.digitSize - 11;
    this.radix = 16;
    this.barrett = new $w.BarrettMu(this.m);
  };

  RSAUtils.getKeyPair = function (encryptionExponent, decryptionExponent, modulus) {
    return new RSAKeyPair(encryptionExponent, decryptionExponent, modulus);
  };

  if (typeof $w.twoDigit === "undefined") {
    $w.twoDigit = function (n) {
      return (n < 10 ? "0" : "") + String(n);
    };
  }

  // Altered by Rob Saunders (rob@robsaunders.net). New routine pads the
  // string after it has been converted to an array. This fixes an
  // incompatibility with Flash MX's ActionScript.
  RSAUtils.encryptedString = function (key, s) {
    var a = [];
    var sl = s.length;

    var i = 0;
    while (i < sl) {
      a[i] = s.charCodeAt(i);
      i++;
    }

    var al = a.length;
    var result = "";
    var j, k, block;
    for (i = 0; i < al; i += key.chunkSize) {
      block = new BigInt();
      j = 0;

      // Add PKCS#1 v1.5 padding
      // 0x00 || 0x02 || PseudoRandomNonZeroBytes || 0x00 || Message
      // Variable a before padding must be of at most digitSize-11
      // That is for 3 marker bytes plus at least 8 random non-zero bytes
      var msgLength = i + key.chunkSize > al ? al % key.chunkSize : key.chunkSize;

      // Variable b with 0x00 || 0x02 at the highest index.
      var b = [];
      var x;
      for (x = 0; x < msgLength; x++) {
        b[x] = a[i + x];
      }
      b[msgLength] = 0; // marker

      var paddedSize = Math.max(8, key.digitSize - 3 - msgLength);
      for (x = 0; x < paddedSize; x++) {
        b[msgLength + 1 + x] = Math.floor(Math.random() * 254) + 1; // [1,255]
      }

      // It can be asserted that msgLength+paddedSize == key.digitSize-3
      b[key.digitSize - 2] = 2; // marker
      b[key.digitSize - 1] = 0; // marker

      for (k = 0; k < key.digitSize; ++j) {
        block.digits[j] = b[k++];
        block.digits[j] += b[k++] << 8;
      }
      var crypt = key.barrett.powMod(block, key.e);
      var text = key.radix === 16 ? RSAUtils.biToHex(crypt) : RSAUtils.biToString(crypt, key.radix);
      result += text + " ";
    }
    var r = "";
    var blocks = result.split(" ");
    for (k = blocks.length; k >= 1; k--) {
      r += blocks[k - 1];
    }
    return r;
  };

  RSAUtils.decryptedString = function (key, s) {
    var blocks = s.split(" ");
    var result = "";
    var i, j, block;
    for (i = 0; i < blocks.length; ++i) {
      var bi;
      if (key.radix === 16) {
        bi = RSAUtils.biFromHex(blocks[i]);
      } else {
        bi = RSAUtils.biFromString(blocks[i], key.radix);
      }
      block = key.barrett.powMod(bi, key.d);
      for (j = 0; j <= RSAUtils.biHighIndex(block); ++j) {
        result += String.fromCharCode(block.digits[j] & 255, block.digits[j] >> 8);
      }
    }
    // Remove trailing null, if any.
    if (result.charCodeAt(result.length - 1) === 0) {
      result = result.substring(0, result.length - 1);
    }
    return result;
  };

  RSAUtils.setMaxDigits(130);
})(window);
///<jscompress sourcefile="url.js" />
(function (undefined) {
  var loc = window.location,
      href = loc.href,
      rHash = /\#.*$/;

  var Url = {
    removeHash: function removeHash(url) {
      return (url || href).replace(rHash, "");
    },
    getHash: function getHash(url) {
      var match = (url || href).match(rHash);
      return match && match[0] ? match[0] : "";
    },
    removeParams: function removeParams(params, url) {
      url = url || href;

      var hash = Url.getHash(url),
          url = this.removeHash(url),
          i;

      for (i = params.length - 1; i >= 0; i--) {
        url = url.replace(new RegExp("(?:[\\?\\&](" + params[i] + "=[^&]*))", "g"), "");
      }

      url = url.replace(/\&+/, "&").replace(/[\&]+$/, "").replace(/[\?]+$/, "") + hash;
      return (/^[^?]*\&/.test(url) ? url.replace("&", "?") : url
      );
    },
    addParams: function addParams(params, url) {
      url = url || href;

      var removeArr = [],
          addArr = [],
          hash = Url.getHash(url),
          url = this.removeHash(url),
          i;

      for (i in params) {
        if (params.hasOwnProperty(i)) {
          removeArr.push(i);
          addArr.push(i + "=" + encodeURIComponent(params[i]));
        }
      }

      url = this.removeParams(removeArr, url);
      return url + (addArr[0] ? (url.indexOf("?") === -1 ? "?" : "&") + addArr.join("&") : "") + hash;
    },
    queryString: function queryString(name, url) {
      var params = this.getParams(url);
      return params[name] != null ? params[name] : undefined;
    },
    getParams: function getParams(url) {
      var search = url.indexOf("?") === -1 ? [] : url.substr(url.indexOf("?") + 1).split("&"),
          i = 0,
          len = search.length,
          params = {},
          pos;

      for (; i < len; i++) {
        pos = search[i].indexOf("=");
        if (pos > 0) {
          params[search[i].substring(0, pos)] = decodeURIComponent(search[i].substring(pos + 1));
        }
      }
      return params;
    },
    getUrl: function getUrl() {
      return loc.protocol + "//" + loc.host + loc.pathname;
    },
    redirect: function redirect(url) {
      loc.href = url;
      try {
        window.event.returnValue = false;
      } catch (e) {}
    }
  };

  window.Url = Url;
})();
///<jscompress sourcefile="sso.js" />
/*
 * 文件名: sso.js
 * 描述: 提供对 CAS 单点登录的封装
 * 版本: 1.35.0.1265-20210630
 *
 * 功能说明:
 * 实现多个应用之间的单点登录（SSO）功能,应用可以部署在不同的域名。
 *
 * 兼容性说明:
 * 此版本sdk,同时支持普通项目使用,以及前后端分离项目使用。
 *
 * 接口列表:
 * login,登录接口
 * loginExt,扩展登录接口
 * logout,登出接口
 * getLoginState,获取登录状态接口
 * validateServiceTicket,验证ST接口
 * getDeviceId,获取设备ID接口
 * getAccessToken,获取访问token接口
 *
 * 登录方式:
 * 1.普通登录(account,password)
 * 2.验证码登录(loginType,phoneNum,smsVerifyCode,smsCaptchaId,smsLoginType,smsCaptchaCode)
 * 3.TGT在线自动登录(account,loginType,mac,tgt,timestamp,username,signature)
 * 4.通用方式登录(loginType,genericValidateUserAttributes,genericUserInfoAttributes)
 * 5.免密登录(loginType,token,platformKey,signature)
 * 6.账号切换(account)
 *
 */

(function (undefined) {
  var SSO = {
    // 版本号，关联SSO服务端版本号-日期
    _version: _config2.default.getConfig().ssoConfig.version_num,
    // 用户服务所属用户组
    appName: _config2.default.getConfig().ssoConfig.appName,
    // 集成应用使用的appKey
    appKey: _config2.default.getConfig().ssoConfig.appKey,
    // 集成端的属性(web,pc,app)
    client: _config2.default.getConfig().ssoConfig.client,
    // 设备ID
    deviceId: _getDeviceId(),
    // Mac地址
    mac: "",
    // Token的Scope范围(openapi/apigateway,空格分隔)
    scope: "openapi apigateway",
    // 当前连接SSO的服务地址
    SSOServerUrl: _config2.default.getConfig().ssoConfig.SSOServerUrl,
    // 登录后跳转服务地址(地址中appId参数会被解析)
    loginRedirectUrl: _config2.default.getConfig().ssoConfig.loginRedirectUrl,
    // 区域EDC项目需要修改
    SSOCenterServerUrl: _config2.default.getConfig().ssoConfig.SSOCenterServerUrl,
    // 当前连接的SSO是否是中心节点
    isCenterSSO: _config2.default.getConfig().ssoConfig.isCenterSSO,
    // tgt同步方式，1表示还是以前的同步方式，2表示使用同步组件来进行同步
    syncType: _config2.default.getConfig().ssoConfig.syncType,
    // 是否返回更多用户属性
    needAttribute: _config2.default.getConfig().ssoConfig.needAttribute,
    // 失败是否重试
    _retry: _config2.default.getConfig().ssoConfig._retry,
    // 登录方式
    loginType: _config2.default.getConfig().ssoConfig.loginType,
    // 自定义退出跳转地址 默认为空
    customLogoutUrl: "",
    // 是否自动匹配帐号类型,默认为null, 如果是true，则登录类型为auto
    accountTypeIsAuto: null,
    //央教管appId,登录如需上报需要填写
    ncetAppId: "",
    //央教管sysCode，非必填
    sysCode: "",
    //是否取获取nextpage参数作为service地址
    useNextPage: true,
    //nextpage是否需要base64解码，默认需要
    nextPageNeedBase64: true,
    //是否使用省内唯一准考证号，默认为false
    useAreaExamNo: false,
    //三方验证码类型
    thirdCaptchaType: "third",
    //图形验证码类型
    picCaptchaType: "pic",
    gtApiServers: "open.changyan.com",
    gtStaticServers: "open.changyan.com",
    gtProtocol: "https://",
    accountLoginVersion: "v2",
    needToken: true,

    login: function login(account, password, callback) {
      SSOLogin(account, password, callback);
    },

    loginExt: function loginExt(loginObj, callback) {
      SSOLoginExt(loginObj, callback);
    },

    logout: function logout(callback) {
      SSOLogout(undefined, callback);
    },

    logoutExt: function logoutExt(param, callback) {
      SSOLogout(param, callback);
    },

    getDeviceId: function getDeviceId(deviceId) {
      return _getDeviceId(deviceId);
    },

    //获取登录状态并返回ST，兼容原版本
    getLoginState: function getLoginState(callback) {
      return getLoginStatus(true, callback);
    },

    //获取登录状态并返回ST
    getLoginStateWithSt: function getLoginStateWithSt(callback) {
      return getLoginStatus(true, callback);
    },

    //获取登录状态不返回ST
    getLoginStateNoSt: function getLoginStateNoSt(callback) {
      return getLoginStatus(false, callback);
    },

    //获取token，appkey使用SSO.appKey
    getAccessToken: function getAccessToken(callback) {
      getTokenFromSSO(null, callback);
    },

    //获取token，参数可以指定appKey
    getAccessTokenWithParam: function getAccessTokenWithParam(param, callback) {
      getTokenFromSSO(param, callback);
    },

    validateServiceTicket: function validateServiceTicket(st, service, callback) {
      _validateServiceTicket(st, service, callback);
    },

    getSingleAccountTicket: function getSingleAccountTicket(param, callback) {
      getSingleATFromSSO(param, callback);
    },

    getOrRefreshSmsLoginCaptcha: function getOrRefreshSmsLoginCaptcha(param, callback) {
      _getOrRefreshSmsLoginCaptcha(param, callback);
    },
    sendSms: function sendSms(param, callback) {
      _sendSms(param, callback);
    },
    checkCaptcha: function checkCaptcha(param, callback) {
      _checkCaptcha(param, callback);
    },
    getCaptcha: function getCaptcha(param) {
      _getCaptcha(param);
    },
    verify: function verify() {
      if (SSO.captchaObj) SSO.captchaObj.verify();
    },
    setCookie: function setCookie(name, value, expiredays) {
      _setCookie(name, value, expiredays);
    }
  };

  window.SSO = window.SSO || SSO;

  /**
   * 获取或更新图形验证码
   * @param param isRefresh = true时为刷新
   * @param callback
   */
  function _getOrRefreshSmsLoginCaptcha(param, callback) {
    analyseServiceURL(SSO.needAttribute, SSO.appKey, SSO.client, SSO.loginRedirectUrl);
    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/getSsoLoginCaptcha";
    var response = {};
    var args = {};
    args.appId = param.appId || SSO.appKey;
    args.client = param.client || SSO.client;
    if (param.service != undefined) {
      args.service = param.service;
    } else {
      args.service = SSO.loginRedirectUrl;
    }
    args.mac = param.mac || SSO.mac;
    var deviceId = param.deviceId || SSO.deviceId;
    args.extInfo = '{"deviceId": "' + deviceId + '"}';
    if (param.isRefresh) {
      args.smsLoginCaptchaId = param.smsLoginCaptchaId;
    } else {
      var captchaCustomConfig = {
        width: param.width,
        height: param.height,
        textLength: param.textLength,
        textChars: param.textChars,
        fontSize: param.fontSize,
        fontColor: param.fontColor
      };
      args.captchaCustomConfig = (0, _stringify2.default)(captchaCustomConfig);
    }

    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function success(resultObj) {
        if (resultObj && resultObj.code === "success") {
          response.result = "success";
          response.code = resultObj.code;
          response.message = resultObj.message;
          response.data = resultObj.data;
        } else {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
        }
        callback && callback(response);
      },
      error: function error(resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      }
    });
  }

  /**
   * 校验图形验证码
   * @param param
   * @param callback
   */
  function _checkCaptcha(param, callback) {
    analyseServiceURL(SSO.needAttribute, SSO.appKey, SSO.client, SSO.loginRedirectUrl);
    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/checkCaptcha";
    var response = {};
    var args = {};
    args.appId = param.appId || SSO.appKey;
    args.client = param.client || SSO.client;
    if (param.service != undefined) {
      args.service = param.service;
    } else {
      args.service = SSO.loginRedirectUrl;
    }
    args.mac = param.mac || SSO.mac;
    var deviceId = param.deviceId || SSO.deviceId;
    args.extInfo = '{"deviceId": "' + deviceId + '"}';
    args.smsLoginCaptchaId = param.smsLoginCaptchaId;
    args.smsLoginCaptchaCode = param.smsLoginCaptchaCode;
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function success(resultObj) {
        if (resultObj && resultObj.code === "success") {
          response.result = "success";
          response.code = resultObj.code;
          response.message = resultObj.message;
        } else {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
        }
        callback && callback(response);
      },
      error: function error(resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      }
    });
  }

  /**
   * 短信验证码发送
   * @param param
   * @param callback
   */
  function _sendSms(param, callback) {
    analyseServiceURL(SSO.needAttribute, SSO.appKey, SSO.client, SSO.loginRedirectUrl);
    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/sendSms";
    var response = {};
    var args = {};
    args.appId = param.appId || SSO.appKey;
    args.client = param.client || SSO.client;
    if (param.service != undefined) {
      args.service = param.service;
    } else {
      args.service = SSO.loginRedirectUrl;
    }
    args.mac = param.mac || SSO.mac;
    var deviceId = param.deviceId || SSO.deviceId;
    args.extInfo = '{"deviceId": "' + deviceId + '"}';
    args.smsLoginCaptchaId = param.smsLoginCaptchaId;
    args.smsLoginCaptchaCode = param.smsLoginCaptchaCode;
    args.mobile = param.mobile;
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function success(resultObj) {
        if (resultObj && resultObj.code === "success") {
          response.result = "success";
        } else {
          response.result = "fail";
        }
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      },
      error: function error(resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      }
    });
  }

  function getToken(resultObj, callback) {
    var response = {};
    // 尝试获取token
    var args = {};
    args.appKey = resultObj.appKey || SSO.appKey;
    args.tgt = resultObj.data.tgt;
    args.st = resultObj.data.st;
    args.service = SSO.loginRedirectUrl;
    args.client = SSO.client;
    args.mac = SSO.mac;
    args.scope = SSO.scope;
    var deviceId = SSO.deviceId;
    args.extInfo = '{"deviceId": "' + deviceId + '"}';

    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/validationWeb";
    if (SSO.client === "pc" || SSO.client === "app" || SSO.client === "pc-web" || SSO.client === "app-web") {
      SSOValidateUrl = SSO.SSOServerUrl + "/v1/validationV2";
    }

    //访问SSO服务地址,获取token
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function success(resultObj) {
        if (resultObj && resultObj.code === "1" && resultObj.data && resultObj.data.token) {
          response.result = "success";
          response.code = resultObj.code;
          response.data = {
            token: resultObj.data.token,
            tgt: args.tgt,
            loginName: resultObj.data.loginName,
            userId: resultObj.data.userId,
            mergingUserId: resultObj.data.mergingUserId
          };
          response.message = resultObj.message;
        } else {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
        }
        callback && callback(response);
      },
      error: function error(resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        response.data = { tgt: args.tgt };
        callback && callback(response);
      }
    });
  }

  function getSingleAT(param, callback) {
    var response = {};
    // 尝试获取at
    var args = {};
    args.appId = param.appKey || SSO.appKey;
    args.client = param.client || SSO.client;
    args.mac = param.mac || SSO.mac;
    args.needTicket = param.needTicket;
    var deviceId = param.deviceId || SSO.deviceId;
    if (deviceId) {
      args.extInfo = '{"deviceId": "' + deviceId + '"}';
    }
    if (param.destAppId) {
      args.destAppId = param.destAppId;
    } else {
      args.service = param.service || SSO.loginRedirectUrl;
    }

    if (param.tgt) {
      args.tgt = param.tgt;
      // 账号密码登录
    } else if (param.loginType === SSO.loginType.LOGINBYNORMAL) {
      var exponent = "010001";
      var modulus = "00ccd806a03c7391ee8f884f5902102d95f6d534d597ac42219dd8a79b1465e186c0162a6771b55e7be7422c4af494ba0112ede4eb00fc751723f2c235ca419876e7103ea904c29522b72d754f66ff1958098396f17c6cd2c9446e8c2bb5f4000a9c1c6577236a57e270bef07e7fe7bbec1f0e8993734c8bd4750e01feb21b6dc9";
      var key = RSAUtils.getKeyPair(exponent, "", modulus);
      args.type = param.loginType;
      args.username = param.account;
      args.password = RSAUtils.encryptedString(key, param.password);
      args.encodeType = "R2/P";
      args.encode = true;
      args.key = param.key || getAccountType(param.account, SSO.isCenterSSO);
      // 第三方免密登录
    } else if (param.loginType === SSO.loginType.LOGINBYTOKEN) {
      args.type = param.loginType;
      args.token = param.token;
      args.platformKey = param.platformKey;
      args.service = param.service || SSO.loginRedirectUrl;
      args.signature = param.signature;
    } else {
      // 注释
    }

    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/getSingleAt";
    //访问SSO服务地址,获取at
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function success(resultObj) {
        if (resultObj && resultObj.code === "success" && resultObj.data && resultObj.data.at) {
          response.result = "success";
          response.code = resultObj.code;
          response.data = {
            at: resultObj.data.at,
            service: resultObj.data.service
          };
          response.message = resultObj.message;
        } else {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
        }
        callback && callback(response);
      },
      error: function error(resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        response.data = { tgt: args.tgt };
        callback && callback(response);
      }
    });
  }

  function getTokenFromSSO(param, callback) {
    analyseServiceURL(SSO.needAttribute, SSO.appKey, SSO.client, SSO.loginRedirectUrl);
    //获取当前用户登录状态
    getLoginStatus(true, function (resultObj) {
      if (resultObj && resultObj.result === "success") {
        if (param && param.appKey) {
          //如果传入appKey参数 使用传入的
          resultObj.appKey = param.appKey;
        }
        getToken(resultObj, callback);
      } else {
        callback && callback(resultObj);
      }
    });
  }

  function getLoginStatus(needServiceTicket, callback) {
    var response = {};
    var getStatusSsoUrl = SSO.SSOServerUrl + "/login";
    if (needServiceTicket && needServiceTicket === true) {
      getStatusSsoUrl = Url.addParams({ service: SSO.loginRedirectUrl }, getStatusSsoUrl);
    }
    //访问SSO服务地址,获取当前SSO登录状态
    $.ajax({
      url: getStatusSsoUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function success(html) {
        html = $.trim(html).replace(/\t/g, "");
        var resultObj = evalJSON(html);
        if (resultObj.result && resultObj.result === "success") {
          //已经登录了
          if (parseInt(resultObj.code) === 1001 && resultObj.data.tgt) {
            response.result = "success";
            response.code = resultObj.code;
            response.message = resultObj.message;
            response.data = {
              tgt: resultObj.data.tgt,
              st: resultObj.data.st,
              mergingUserId: resultObj.data.mergingUserId
            };
            callback && callback(response);
            return;
          }
        }
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      },
      error: function error(resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      }
    });
  }

  function analyseServiceURL() {
    var currentUrl = window.location.href;
    if (!SSO.useNextPage || Url.queryString("nextpage", currentUrl) === undefined) {
      SSO.loginRedirectUrl = SSO.needAttribute && Url.queryString("from", SSO.loginRedirectUrl) === undefined ? Url.addParams({ from: "ew" }, SSO.loginRedirectUrl) : SSO.loginRedirectUrl;
    } else {
      var nextpageUrl = Url.queryString("nextpage", currentUrl);
      if (SSO.nextPageNeedBase64) {
        SSO.loginRedirectUrl = Base64.decode(nextpageUrl);
      } else {
        SSO.loginRedirectUrl = nextpageUrl;
      }
    }
    if (Url.queryString("client", currentUrl) !== undefined) {
      SSO.client = Url.queryString("client", currentUrl);
    }
    if (Url.queryString("appId", SSO.loginRedirectUrl) !== undefined) {
      SSO.appKey = Url.queryString("appId", SSO.loginRedirectUrl);
    }
  }

  function getLoginTicket(loginObj, callback) {
    var loginType = loginObj.loginType || SSO.loginType.LOGINBYNORMAL;
    var redirectUrl = loginType === SSO.loginType.LOGINBYCHANGEACCOUNT ? Url.addParams({ userChangeLogin: true }, SSO.loginRedirectUrl) : SSO.loginRedirectUrl;
    if (SSO.isCenterSSO === false) {
      var SSOCenterRestUrl = SSO.SSOCenterServerUrl + "/login?service=" + encodeURIComponent(redirectUrl);
      $.ajax({
        url: SSOCenterRestUrl,
        type: "GET",
        dataType: "jsonp",
        jsonp: "callback",
        crossDomain: true,
        cache: false,
        success: function success(html) {
          html = $.trim(html).replace(/\t/g, "");
          var resultObj = evalJSON(html);
          if (resultObj.result && resultObj.result === "success") {
            //已经登录了
            if (parseInt(resultObj.code) === 1001 && resultObj.data && resultObj.data.st) {
              if ((loginType !== SSO.loginType.LOGINBYONLINEAUTO || resultObj.data.tgt !== loginObj.tgt) && loginType !== SSO.loginType.LOGINBYCHANGEACCOUNT) {
                CenterSSOLogout();
              }
            }
          }
        },
        error: function error(data) {
          console.log(data);
        }
      });
    }
    var SSORestUrl = SSO.SSOServerUrl + "/login?service=" + encodeURIComponent(redirectUrl);
    $.ajax({
      url: SSORestUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function success(html) {
        html = $.trim(html).replace(/\t/g, "");
        var resultObj = evalJSON(html);
        if (resultObj.result && resultObj.result === "success") {
          //已经登录了
          if (parseInt(resultObj.code) === 1001 && resultObj.data && resultObj.data.st) {
            if ((loginType !== SSO.loginType.LOGINBYONLINEAUTO || resultObj.data.tgt !== loginObj.tgt) && loginType !== SSO.loginType.LOGINBYCHANGEACCOUNT) {
              SSOLogout(undefined, function () {
                setTimeout(function () {
                  getLoginTicket(loginObj, callback);
                }, 100);
              });
            }
            //新增用户切换登录
            else {
                var params = {
                  lt: resultObj.data.lt,
                  execution: resultObj.data.execution
                };
                callback && callback(params);
              }
          } else {
            var params = {
              lt: resultObj.data.lt,
              execution: resultObj.data.execution
            };
            callback && callback(params);
          }
        } else {
          callback && callback(undefined);
        }
      },
      error: function error(data) {
        callback && callback(undefined);
      }
    });
  }

  function SSOLogin(account, password, callback) {
    var loginParam = {};
    loginParam.account = account;
    loginParam.password = password;
    SSOLoginExt(loginParam, callback);
  }

  function SSOLoginExt(loginObj, callback) {
    analyseServiceURL(SSO.needAttribute, SSO.appKey, SSO.client, SSO.loginRedirectUrl);
    var loginType = loginObj.loginType || SSO.loginType.LOGINBYNORMAL;
    getLoginTicket(loginObj, function (ltParams) {
      if (ltParams === undefined && loginType !== SSO.loginType.LOGINBYCHANGEACCOUNT) {
        var resultObj = {
          result: "fail",
          code: "-1",
          data: "登录失败,出现异常！"
        };
        callback && callback(resultObj);
      } else {
        loginObj = loginObj || {};
        var pl = {};
        pl.captchaId = loginObj.captchaId || SSO.captchaId;
        pl.captchaType = loginObj.captchaType || SSO.captchaType;
        if (pl.captchaType == SSO.thirdCaptchaType) {
          pl.thirdCaptchaParam = (0, _stringify2.default)(SSO.captchaObj.getValidate());
        }
        pl.version = SSO.accountLoginVersion;
        pl.captchaCode = loginObj.captchaCode;
        pl.encode = true;
        pl.sourceappname = SSO.appName;
        pl._eventId = "submit";
        pl.appId = SSO.appKey;
        pl.client = loginObj.client || SSO.client;
        pl.type = loginObj.loginType || SSO.loginType.LOGINBYNORMAL;
        pl.key = loginObj.key || getAccountType(loginObj.account, SSO.isCenterSSO);
        pl.lt = ltParams.lt;
        pl.execution = ltParams.execution;
        pl.customLogoutUrl = ltParams.customLogoutUrl || SSO.customLogoutUrl;
        pl.ncetAppId = ltParams.ncetAppId || SSO.ncetAppId;
        pl.sysCode = ltParams.sysCode || SSO.sysCode;
        // 扩展信息字段
        if (loginObj.extInfo != null && loginObj.extInfo !== "") {
          pl.extInfo = loginObj.extInfo;
        } else if (SSO.client === "pc" || SSO.client === "app" || SSO.client === "pc-web" || SSO.client === "app-web") {
          var deviceId = SSO.deviceId;
          pl.extInfo = '{"deviceId": "' + deviceId + '"}';
        } else {
          // 注释
        }
        var exponent = "010001";
        var modulus = "00ccd806a03c7391ee8f884f5902102d95f6d534d597ac42219dd8a79b1465e186c0162a6771b55e7be7422c4af494ba0112ede4eb00fc751723f2c235ca419876e7103ea904c29522b72d754f66ff1958098396f17c6cd2c9446e8c2bb5f4000a9c1c6577236a57e270bef07e7fe7bbec1f0e8993734c8bd4750e01feb21b6dc9";
        // 在线自动登录
        if (loginType === SSO.loginType.LOGINBYONLINEAUTO) {
          pl.username = loginObj.account;
          pl.mac = loginObj.mac || SSO.mac;
          pl.tgt = loginObj.tgt;
          pl.timestamp = loginObj.timestamp;
          pl.signature = loginObj.signature;
        }
        // 手机验证码登录
        else if (loginType === SSO.loginType.LOGINBYVERIFYCODE) {
            pl.phoneNum = loginObj.phoneNum;
            pl.smsVerifyCode = loginObj.smsVerifyCode;
            if (loginObj.smsCaptchaId) {
              pl.smsCaptchaId = loginObj.smsCaptchaId;
            }
          }
          // 通用登录
          else if (loginType === SSO.loginType.LOGINBYGENERIC) {
              pl.genericValidateUserAttributes = loginObj.genericValidateUserAttributes;
              pl.genericUserInfoAttributes = loginObj.genericUserInfoAttributes;
            }
            // 免密令牌登录
            else if (loginType === SSO.loginType.LOGINBYTOKEN) {
                pl.token = loginObj.token;
                pl.platformKey = loginObj.platformKey;
                pl.signature = loginObj.signature;
                pl.mac = loginObj.mac || SSO.mac;
              }
              //多账号免密切换登录
              else if (loginType === SSO.loginType.LOGINBYCHANGEACCOUNT) {
                  pl.username = loginObj.account;
                }
                //央教馆登录
                else if (loginType === SSO.loginType.LOGINBYNCET) {
                    if (loginObj.ticket) {
                      pl.token = loginObj.ticket;
                    } else if (loginObj.at) {
                      pl.token = loginObj.at;
                      pl.username = loginObj.account;
                      var key = RSAUtils.getKeyPair(exponent, "", modulus);
                      var password = "LT/" + ltParams.lt + "/" + loginObj.password;
                      pl.encodeType = "R2/P/LT";
                      pl.password = RSAUtils.encryptedString(key, password);
                    } else {
                      //注释
                    }
                    if (loginObj.mac != null && loginObj.mac !== "" || SSO.mac != null && SSO.mac !== "") {
                      pl.mac = loginObj.mac || SSO.mac;
                    }
                  }
                  // 普通登录
                  else {
                      pl.username = loginObj.account;
                      var key = RSAUtils.getKeyPair(exponent, "", modulus);
                      var password = "LT/" + ltParams.lt + "/" + loginObj.password;
                      pl.encodeType = "R2/P/LT";
                      pl.password = RSAUtils.encryptedString(key, password);
                      if (loginObj.mac != null && loginObj.mac !== "" || SSO.mac != null && SSO.mac !== "") {
                        pl.mac = loginObj.mac || SSO.mac;
                      }
                      pl.useAreaExamNo = loginObj.useAreaExamNo || SSO.useAreaExamNo;
                      pl.areaCode = loginObj.areaCode;
                      pl.personalName = loginObj.personalName;
                    }
        var redirectUrl = loginType === SSO.loginType.LOGINBYCHANGEACCOUNT ? Url.addParams({ userChangeLogin: true }, SSO.loginRedirectUrl) : SSO.loginRedirectUrl;
        var SSORestUrl = SSO.SSOServerUrl + "/login?service=" + encodeURIComponent(redirectUrl);
        $.ajax({
          url: SSORestUrl,
          type: "GET",
          dataType: "jsonp",
          jsonp: "callback",
          data: pl,
          crossDomain: true,
          cache: false,
          success: function success(html) {
            html = $.trim(html).replace(/\t/g, "");
            var resultObj = evalJSON(html);
            if (resultObj.result && resultObj.result === "success") {
              if (parseInt(resultObj.code) === 1000) {
                if (SSO._retry === false) {
                  //try again
                  SSO._retry = true;
                  SSOLoginExt(loginObj, callback);
                  return;
                }
                callback && callback(resultObj);
                return;
              }
              SSO._retry = false;
              resultObj.params = pl;
              if (SSO.needToken) {
                // 获取Token
                getToken(resultObj, function (resultObj) {
                  syncToCenter(resultObj, callback);
                });
              } else {
                syncToCenter(resultObj, callback);
              }
            } else {
              callback && callback(resultObj);
              return;
            }
          },
          error: function error(data) {
            SSO._retry = false;
            var resultObj = {
              result: "fail",
              code: "-1",
              data: "登录失败,出现异常！"
            };
            callback && callback(resultObj);
          }
        });
      }
    });
  }

  function syncToCenter(resultObj, callback) {
    // sync TGT to centerSSO, only to ensure TGC added to center sso path
    if (SSO.isCenterSSO === false && SSO.syncType === 1) {
      syncToCenterSSO(resultObj.data.tgt, function () {
        callback && callback(resultObj);
      });
    } else if (SSO.isCenterSSO === false && SSO.syncType === 2) {
      syncToCenterSSO2(function () {
        callback && callback(resultObj);
      });
    } else {
      callback && callback(resultObj);
    }
  }

  function syncToCenterSSO(TGT, callback) {
    var SSORestUrl = SSO.SSOCenterServerUrl + "/login?ticketGrantingTicketIdFromAreaSSO=" + TGT;
    $.ajax({
      url: SSORestUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      timeout: 3000,
      complete: function complete() {
        callback && callback();
      }
    });
  }

  /**
   *  同步tgt到中心
   **/
  function syncToCenterSSO2(callback) {
    var syncUrl = SSO.SSOServerUrl + "/login?service=" + encodeURIComponent(Url.addParams({ isAjax: "true" }, SSO.loginRedirectUrl)) + "&redirect=true";
    jQuery.ajax({
      url: syncUrl,
      type: "get",
      dataType: "jsonp",
      jsonp: "callback",
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true,
      timeout: 3000,
      complete: function complete() {
        callback && callback();
      }
    });
  }

  function _validateServiceTicket(st, service, callback) {
    if (st === undefined || service === undefined) {
      var resultObj = { result: "fail", code: "-1", data: "参数不合法" };
      callback && callback(resultObj);
      return;
    }
    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/validation";
    var pl = {};
    pl.service = service;
    pl.ticket = st;
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      data: pl,
      crossDomain: true,
      cache: false,
      success: function success(json) {
        callback && callback(json);
      },
      error: function error(data) {
        var resultObj = {
          result: "fail",
          code: "-1",
          data: "校验失败,出现异常！"
        };
        callback && callback(resultObj);
      }
    });
  }

  function getSingleATFromSSO(param, callback) {
    analyseServiceURL(SSO.needAttribute, SSO.appKey, SSO.client, SSO.loginRedirectUrl);
    if (param.tgt || param.loginType) {
      getSingleAT(param, callback);
    } else {
      getLoginStatus(false, function (resultObj) {
        if (resultObj && resultObj.result === "success") {
          param.tgt = resultObj.data.tgt;
          getSingleAT(param, callback);
        } else {
          callback && callback(resultObj);
        }
      });
    }
  }

  function SSOLogout(param, callback) {
    var logoutURL = SSO.SSOServerUrl + "/logout";
    if ((typeof param === "undefined" ? "undefined" : (0, _typeof3.default)(param)) === "object") {
      logoutURL = param.tgtId ? Url.addParams({ tgtId: param.tgtId }, logoutURL) : logoutURL;
      logoutURL = param.clearScope ? Url.addParams({ clearScope: param.clearScope }, logoutURL) : logoutURL;
    }
    $.ajax({
      url: logoutURL,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function success(html) {
        html = $.trim(html).replace(/\t/g, "");
        var resultObj = evalJSON(html);
        if (resultObj.result && resultObj.result === "success") {
          callback && callback(resultObj);
        }
      },
      error: function error(data) {
        var resultObj = {
          result: "fail",
          code: "-1",
          data: "登出失败,出现异常！"
        };
        callback && callback(resultObj);
      }
    });
  }

  function CenterSSOLogout() {
    var logoutURL = SSO.SSOCenterServerUrl + "/logout";
    $.ajax({
      url: logoutURL,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function success(data) {
        console.log(data);
      },
      error: function error(data) {
        console.log(data);
      }
    });
  }

  function getAccountType(account, isCenterSSO) {
    //accountTypeIsAuto 如果是true，则登录类型为auto
    if (SSO.accountTypeIsAuto === true || isCenterSSO === true && SSO.accountTypeIsAuto === null) {
      return "auto";
    }

    var REGEX_EMAIL = new RegExp("^[0-9a-z]([._]?[0-9a-z])+@([0-9a-z][-\\w]*[0-9a-z]\\.)+[a-z]{2,9}$");
    var REGEX_MOBILE = new RegExp("^1[3-9]\\d{9}$");
    var REGEX_EXAM_NO = new RegExp("^(\\d{8}|\\d{10})$"); //准考证号8位数字或10位数字
    var REGEX_STUDENT_EXAM_NO = new RegExp("^\\d{16}$"); //学籍号16位数字
    var type = "login_name";
    if (account === undefined) {
      return type;
    } else if (account.match(REGEX_EMAIL)) {
      type = "email";
    } else if (account.match(REGEX_MOBILE)) {
      type = "mobile";
    } else if (account.match(REGEX_EXAM_NO)) {
      type = "exam_no";
    } else if (account.match(REGEX_STUDENT_EXAM_NO)) {
      type = "student_enroll_no";
    } else {}
    return type;
  }

  function _getDeviceId(deviceId) {
    // 主动设置deviceId
    if (!!deviceId) {
      _setCookie("deviceId", deviceId, 365);
      //写入localStorage
      if (!!window.localStorage) {
        localStorage.setItem("deviceId", deviceId);
      }
    }
    // 获取deviceId
    if (!!window.localStorage) {
      deviceId = localStorage.getItem("deviceId");
    }
    if (!!deviceId) {
      //localstorage取到deviceId 设置到cookie中
      _setCookie("deviceId", deviceId, 365);
    } else {
      //localstorage未取到deviceId
      //尝试cookie获取
      deviceId = getCookie("deviceId");
      if (!deviceId) {
        //未取到 生成随机值
        deviceId = Math.uuid();
        _setCookie("deviceId", deviceId, 365);
      }
      //localstorage设置
      if (!!window.localStorage) {
        localStorage.setItem("deviceId", deviceId);
      }
    }
    return deviceId;
  }

  function evalJSON(s) {
    return eval("(" + s + ")");
  }

  function _setCookie(name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = name + "=" + escape(value) + (expiredays == null ? "" : ";path=/;expires=" + exdate.toGMTString());
  }

  function getCookie(name, base64) {
    var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (document.cookie.match(reg)) {
      arr = document.cookie.match(reg);
      if (base64 === true) return Base64.decode(unescape(arr[2]));else return unescape(arr[2]);
    } else return null;
  }

  function _getCaptcha(param) {
    console.log("极验方法被请求了");
    analyseServiceURL(SSO.needAttribute, SSO.appKey, SSO.client, SSO.loginRedirectUrl);
    var SSOGetCaptchaUrl = SSO.SSOServerUrl + "/v1/getCaptcha";
    var SSOGetCaptchaTypeUrl = SSO.SSOServerUrl + "/v1/getCaptchaType";
    var args = {};
    args.appId = param.appId || SSO.appKey;
    args.client = param.client || SSO.client;
    console.log("SSOGetCaptchaTypeUrl", SSOGetCaptchaTypeUrl);
    $.ajax({
      url: SSOGetCaptchaTypeUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function success(resultObj) {
        console.log("resultObj", resultObj);
        //如果返回的滑块 初始化
        if (resultObj && resultObj.code === "success" && resultObj.data) {
          var captchaConf = evalJSON(resultObj.data.captchaConf);
          SSO.captchaType = captchaConf.captchaType;
          //如果返回的type滑块（third）
          console.log("请求成功了");
          console.log("captchaConf.captchaType", captchaConf.captchaType);
          if (captchaConf.captchaType === "third") {
            param.gt = param.gt || captchaConf.gt;
            createGt(captchaConf);
          } else {
            sucWeb.callCB(getPic, param);
          }
        } else {
          sucWeb.callCB(getPic, param);
        }
      },
      error: function error() {
        console.warn("请求错误了");
        sucWeb.callCB(getPic, param);
      },
      fail: function fail() {
        console.error("请求失败了");
        sucWeb.callCB(getPic, param);
      }
    });

    function createGt(resultData) {
      if (!resultData.apiServers || resultData.apiServers.length == 0) {
        resultData.apiServers = ["gcaptcha4.geetest.com"];
      }
      if (!resultData.staticServers || resultData.staticServers.length == 0) {
        resultData.staticServers = ["static.geetest.com", "dn-staticdown.qbox.me"];
      }
      if (resultData.gtProtocol) {
        if (resultData.gtProtocol.match("https")) {
          resultData.gtProtocol = "https://";
        } else {
          resultData.gtProtocol = "http://";
        }
      }
      SSO.captchaObj = new sucWeb.ui.createGt({
        param: param,
        protocol: resultData.gtProtocol || "https://",
        ssoApiServers: resultData.apiServers,
        ssoStaticServers: resultData.staticServers,
        cbs: {
          onSuccess: param.captchaSuccessResultCB,
          onReady: param.getCaptchaResultCB,
          onError: param.thirdCaptchaErrorCB,
          onClose: param.captchaCloseCB,
          initFail: getPic
        }
      });
      console.log("SSO.captchaObj", SSO.captchaObj);
    }

    function getPic(param) {
      var response = {};
      if (param.service != undefined) {
        args.service = param.service;
      } else {
        args.service = SSO.loginRedirectUrl;
      }
      args.mac = param.mac || SSO.mac;
      var deviceId = param.deviceId || SSO.deviceId;
      args.extInfo = '{"deviceId": "' + deviceId + '"}';
      var captchaCustomConfig = {
        width: param.width,
        height: param.height,
        textLength: param.textLength,
        textChars: param.textChars,
        fontSize: param.fontSize,
        fontColor: param.fontColor
      };
      args.captchaCustomConfig = (0, _stringify2.default)(captchaCustomConfig);
      if (SSO.captchaId) {
        args.captchaId = SSO.captchaId;
      }
      $.ajax({
        url: SSOGetCaptchaUrl,
        type: "GET",
        dataType: "jsonp",
        jsonp: "callback",
        crossDomain: true,
        cache: false,
        data: args,
        success: function success(resultObj) {
          //如果返回的滑块 初始化
          if (resultObj && resultObj.code === "success" && resultObj.data) {
            response.result = "success";
            response.code = resultObj.code;
            response.message = resultObj.message;
            response.data = resultObj.data;
            SSO.captchaId = resultObj.data.captchaId;
            SSO.captchaType = resultObj.data.captchaType;
            sucWeb.callCB(param.getCaptchaResultCB, response);
          } else {
            response.result = "fail";
            response.code = resultObj.code;
            response.message = resultObj.message;
            sucWeb.callCB(param.getCaptchaResultCB, response);
          }
          // callback && callback(response);
        },
        error: function error(resultObj) {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
          sucWeb.callCB(param.getCaptchaResultCB, response);
        }
      });
    }
  }
})();
///<jscompress sourcefile="suc_gt.js" />

window.sucWeb = {};
sucWeb.clazz = function (p, c) {
  if (arguments.length < 2) {
    c = p;
    p = null;
  } else if (typeof p !== "function" && console) console.trace("Error : unkonw parent class");

  function core(d, o, flag) {
    var x = this;
    this.uedo = true;

    if ((typeof o === "undefined" ? "undefined" : (0, _typeof3.default)(o)) != "object") o = { uedo: true };
    d = d || {};

    var t = core.prototype;
    if (typeof p == "function") x._ = p.prototype;
    if ("inborn" in t) t.inborn.call(x, d);
    if (typeof p == "function") p.call(x, d, o, true);
    if (!x.access) x.access = function (n, f, r) {
      o[n] = function () {
        var tmp = f.apply(x, arguments);
        if (r) return o;
        return tmp;
      };
      return x;
    };
    if (typeof p == "function") x._ = p.prototype;
    if ("born" in t) t.born.call(x, d);

    if (!flag && typeof o.getDom == "function") {
      switch (sucWeb.type(o.getDom())) {
        case "dom":
        case "window":
        case "global":
          o.getDom().obj = o;
          break;
        default:
          break;
      }
    }

    return o;
  }

  if (typeof p == "function") {
    var pt = function pt() {};
    pt.prototype = p.prototype;
    core.prototype = new pt();
  }
  if ((typeof c === "undefined" ? "undefined" : (0, _typeof3.default)(c)) == "object") for (var k in c) {
    core.prototype[k] = c[k];
  }return core;
};

sucWeb.callCB = function (f) {
  if (typeof f == "function") f.apply(this, Array.prototype.slice.call(arguments, 1));else if ((typeof f === "undefined" ? "undefined" : (0, _typeof3.default)(f)) == "object" && f != null && typeof f.cb == "function") {
    if ((0, _typeof3.default)(f.scope) == "object") f.cb.apply(f.scope, Array.prototype.slice.call(arguments, 1));else f.cb.apply(this, Array.prototype.slice.call(arguments, 1));
  } else return false;

  return true;
};

sucWeb.type = function (t) {
  if (t === null) return "null";
  if ((typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) === "object") {
    if (t.window && t.window.window && t.window === t.window.window) return "window";
    if (t.nodeType === 1 && typeof t.nodeName === "string") return "dom";
    return Object.prototype.toString.call(t).slice(8, -1).toLowerCase();
  }
  return typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t);
};

sucWeb.define = function (s, d) {
  if (s == null) return d;
  if (d == null) return s;

  if (sucWeb.type(s) !== sucWeb.type(d)) return d;

  switch (sucWeb.type(d)) {
    case "object":
    case "array":
      for (var i in d) {
        s[i] = sucWeb.define(s[i], d[i]);
      }return s;
  }

  return s;
};

sucWeb.ns = function (path) {
  if (typeof path != "string") return;
  var arr = path.split(".");
  var ns = arr[0];
  eval("if(typeof(" + ns + ")=='undefined') " + ns + "={};");
  for (var i = 1; i < arr.length; i++) {
    ns += "." + arr[i];
    eval("if(typeof(" + ns + ")=='undefined') " + ns + "={};");
  }
  return sucWeb;
};

sucWeb.ns("sucWeb.ui");
sucWeb.ui.createGt = sucWeb.clazz({
  born: function born(_c) {
    this.c = sucWeb.define(_c, {
      product: "bind",
      width: "300px",
      lang: "zh-cn",
      https: false,
      timeout: 30000,
      zoomEle: null,
      hideSuccess: false,
      hideClose: false,
      hideRefresh: false,
      parent: "",
      bindForm: "",
      ssoApiServers: [],
      ssoStaticServers: [],
      param: null,
      cbs: {
        initFail: null,
        onReady: null,
        onSuccess: null,
        onError: null,
        onClose: null
      }
    });
    this.init();
    this.access("reset", this.reset).access("destroy", this.destroy).access("verify", this.verify).access("getCaptchaObj", this.getCaptchaObj).access("getValidate", this.getValidate);
  },
  initGt: function initGt() {
    var o = this;
    (function (window, apiServers, staticServers) {
      "use strict";

      if (typeof window === "undefined") {
        throw new Error("Geetest requires browser environment");
      }

      var document = window.document;
      var Math = window.Math;
      var head = document.getElementsByTagName("head")[0];
      var TIMEOUT = 10000;

      function _Object(obj) {
        this._obj = obj;
      }

      _Object.prototype = {
        _each: function _each(process) {
          var _obj = this._obj;
          for (var k in _obj) {
            if (_obj.hasOwnProperty(k)) {
              process(k, _obj[k]);
            }
          }
          return this;
        },
        _extend: function _extend(obj) {
          var self = this;
          new _Object(obj)._each(function (key, value) {
            self._obj[key] = value;
          });
        }
      };

      var uuid = function uuid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0;
          var v = c === "x" ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });
      };

      function Config(config) {
        var self = this;
        new _Object(config)._each(function (key, value) {
          self[key] = value;
        });
      }

      Config.prototype = {
        apiServers: apiServers,
        staticServers: staticServers,
        protocol: "http://",
        typePath: "/load",
        fallback_config: {
          bypass: {
            staticServers: ["static.geetest.com/", "dn-staticdown.qbox.me/"],
            type: "bypass",
            bypass: "/v4/bypass.js"
          }
        },
        _get_fallback_config: function _get_fallback_config() {
          var self = this;
          if (isString(self.type)) {
            return self.fallback_config[self.type];
          } else {
            return self.fallback_config.bypass;
          }
        },
        _extend: function _extend(obj) {
          var self = this;
          new _Object(obj)._each(function (key, value) {
            self[key] = value;
          });
        }
      };
      var isNumber = function isNumber(value) {
        return typeof value === "number";
      };
      var isString = function isString(value) {
        return typeof value === "string";
      };
      var isBoolean = function isBoolean(value) {
        return typeof value === "boolean";
      };
      var isObject = function isObject(value) {
        return (typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object" && value !== null;
      };
      var isFunction = function isFunction(value) {
        return typeof value === "function";
      };
      var MOBILE = /Mobi/i.test(navigator.userAgent);
      var pt = MOBILE ? 3 : 0;

      var callbacks = {};
      var status = {};

      var random = function random() {
        return parseInt(Math.random() * 10000) + new Date().valueOf();
      };

      // bind 函数polify, 不带new功能的bind

      var bind = function bind(target, context) {
        if (typeof target !== "function") {
          return;
        }
        var args = Array.prototype.slice.call(arguments, 2);

        if (Function.prototype.bind) {
          return target.bind(context, args);
        } else {
          return function () {
            var _args = Array.prototype.slice.call(arguments);
            return target.apply(context, args.concat(_args));
          };
        }
      };

      var toString = Object.prototype.toString;

      var _isFunction = function _isFunction(obj) {
        return typeof obj === "function";
      };
      var _isObject = function _isObject(obj) {
        return obj === Object(obj);
      };
      var _isArray = function _isArray(obj) {
        return toString.call(obj) == "[object Array]";
      };
      var _isDate = function _isDate(obj) {
        return toString.call(obj) == "[object Date]";
      };
      var _isRegExp = function _isRegExp(obj) {
        return toString.call(obj) == "[object RegExp]";
      };
      var _isBoolean = function _isBoolean(obj) {
        return toString.call(obj) == "[object Boolean]";
      };

      function resolveKey(input) {
        return input.replace(/(\S)(_([a-zA-Z]))/g, function (match, $1, $2, $3) {
          return $1 + $3.toUpperCase() || "";
        });
      }

      function camelizeKeys(input, convert) {
        if (!_isObject(input) || _isDate(input) || _isRegExp(input) || _isBoolean(input) || _isFunction(input)) {
          return convert ? resolveKey(input) : input;
        }

        if (_isArray(input)) {
          var temp = [];
          for (var i = 0; i < input.length; i++) {
            temp.push(camelizeKeys(input[i]));
          }
        } else {
          var temp = {};
          for (var prop in input) {
            if (input.hasOwnProperty(prop)) {
              temp[camelizeKeys(prop, true)] = camelizeKeys(input[prop]);
            }
          }
        }
        return temp;
      }

      var loadScript = function loadScript(url, cb, timeout) {
        var script = document.createElement("script");
        script.charset = "UTF-8";
        script.async = true;

        // 对geetest的静态资源添加 crossOrigin
        if (/static\.geetest\.com/g.test(url)) {
          script.crossOrigin = "anonymous";
        }

        script.onerror = function () {
          cb(true);
          // 错误触发了，超时逻辑就不用了
          loaded = true;
        };
        var loaded = false;
        script.onload = script.onreadystatechange = function () {
          if (!loaded && (!script.readyState || "loaded" === script.readyState || "complete" === script.readyState)) {
            loaded = true;
            setTimeout(function () {
              cb(false);
            }, 0);
          }
        };
        script.src = url;
        head.appendChild(script);

        setTimeout(function () {
          if (!loaded) {
            script.onerror = script.onload = null;
            script.remove && script.remove();
            cb(true);
          }
        }, timeout || TIMEOUT);
      };

      var normalizeDomain = function normalizeDomain(domain) {
        // special domain: uems.sysu.edu.cn/jwxt/geetest/
        // return domain.replace(/^https?:\/\/|\/.*$/g, ''); uems.sysu.edu.cn
        return domain.replace(/^https?:\/\/|\/$/g, ""); // uems.sysu.edu.cn/jwxt/geetest
      };
      var normalizePath = function normalizePath(path) {
        path = path.replace(/\/+/g, "/");
        if (path.indexOf("/") !== 0) {
          path = "/" + path;
        }
        return path;
      };
      var normalizeQuery = function normalizeQuery(query) {
        if (!query) {
          return "";
        }
        var q = "?";
        new _Object(query)._each(function (key, value) {
          if (isString(value) || isNumber(value) || isBoolean(value)) {
            q = q + encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
          }
        });
        if (q === "?") {
          q = "";
        }
        return q.replace(/&$/, "");
      };
      var makeURL = function makeURL(protocol, domain, path, query) {
        domain = normalizeDomain(domain);

        var url = normalizePath(path) + normalizeQuery(query);
        if (domain) {
          url = protocol + domain + url;
        }

        return url;
      };

      var load = function load(config, protocol, domains, path, query, cb, handleCb) {
        var tryRequest = function tryRequest(at) {
          // 处理jsonp回调，这里为了保证每个不同jsonp都有唯一的回调函数
          if (handleCb) {
            var cbName = "geetest_" + random();
            // 需要与预先定义好cbname参数，删除对象
            window[cbName] = bind(handleCb, null, cbName);
            query.callback = cbName;
          }
          var url = makeURL(protocol, domains[at], path, query);
          loadScript(url, function (err) {
            if (err) {
              // 超时或者出错的时候 移除回调
              if (cbName) {
                try {
                  window[cbName] = function () {
                    window[cbName] = null;
                  };
                } catch (e) {}
              }

              if (at >= domains.length - 1) {
                cb(true);
                // report gettype error
              } else {
                tryRequest(at + 1);
              }
            } else {
              cb(false);
            }
          }, config.timeout);
        };
        tryRequest(0);
      };

      var jsonp = function jsonp(domains, path, config, callback) {
        var handleCb = function handleCb(cbName, data) {
          // 保证只执行一次，全部超时的情况下不会再触发;

          if (data.status == "success") {
            callback(data.data);
          } else if (!data.status) {
            callback(data);
          } else {
            //接口有返回，但是返回了错误状态，进入报错逻辑
            callback(data);
          }
          window[cbName] = undefined;
          try {
            delete window[cbName];
          } catch (e) {}
        };

        load(config, config.protocol, domains, path, {
          captcha_id: config.captchaId,
          challenge: config.challenge || uuid(),
          client_type: 0,
          pt: 0,
          risk_type: config.riskType
        }, function (err) {
          // 网络问题接口没有返回，直接使用本地验证码，走宕机模式
          // 这里可以添加用户的逻辑
          if (err && typeof config.offlineCb === "function") {
            // 执行自己的宕机
            config.offlineCb();
            return;
          }

          if (err) {
            callback(config._get_fallback_config());
          }
        }, handleCb);
      };

      var reportError = function reportError(config, url) {
        load(config, config.protocol, ["monitor.geetest.com"], "/monitor/send", {
          time: Date.now().getTime(),
          captcha_id: config.gt,
          challenge: config.challenge,
          pt: pt,
          exception_url: url,
          error_code: config.error_code
        }, function (err) {});
      };

      var throwError = function throwError(errorType, config, errObj) {
        var errors = {
          networkError: "网络错误",
          gtTypeError: "gt字段不是字符串类型"
        };
        if (typeof config.onError === "function") {
          config.onError({
            desc: errObj.desc,
            msg: errObj.msg,
            code: errObj.code
          });
        } else {
          throw new Error(errors[errorType]);
        }
      };

      var detect = function detect() {
        return window.Geetest || document.getElementById("gt_lib");
      };

      if (detect()) {
        status.slide = "loaded";
      }

      window.initGeetest4 = function (userConfig, callback) {
        var config = new Config(userConfig);
        if (userConfig.https) {
          config.protocol = "https://";
        } else if (!userConfig.protocol) {
          config.protocol = window.location.protocol + "//";
        } else {}

        if (isObject(userConfig.getType)) {
          config._extend(userConfig.getType);
        }

        jsonp(config.apiServers, config.typePath, config, function (newConfig) {
          //错误捕获，第一个load请求可能直接报错
          var newConfig = camelizeKeys(newConfig);

          if (newConfig.status === "error") {
            return throwError("networkError", config, newConfig);
          }

          var type = newConfig.type;

          if (config.debug) {
            new _Object(newConfig)._extend(config.debug);
          }
          var init = function init() {
            config._extend(newConfig);
            callback(new window.Geetest4(config));
          };

          callbacks[type] = callbacks[type] || [];

          var s = status[type] || "init";
          if (s === "init") {
            status[type] = "loading";

            callbacks[type].push(init);

            if (newConfig.gctPath) {
              load(config, config.protocol, Object.hasOwnProperty(config.staticServers) ? config.staticServers : newConfig.staticServers || config.staticServers, newConfig.gctPath, null, function (err) {
                if (err) {
                  throwError("networkError", config, {
                    code: "60205",
                    msg: "Network failure",
                    desc: {
                      detail: "gct resource load timeout"
                    }
                  });
                }
              });
            }

            load(config, config.protocol, Object.hasOwnProperty(config.staticServers) ? config.staticServers : newConfig.staticServers || config.staticServers, newConfig.bypass || newConfig.staticPath + newConfig.js, null, function (err) {
              if (err) {
                status[type] = "fail";
                throwError("networkError", config, {
                  code: "60204",
                  msg: "Network failure",
                  desc: {
                    detail: "js resource load timeout"
                  }
                });
              } else {
                status[type] = "loaded";
                var cbs = callbacks[type];
                for (var i = 0, len = cbs.length; i < len; i = i + 1) {
                  var cb = cbs[i];
                  if (isFunction(cb)) {
                    cb();
                  }
                }
                callbacks[type] = [];
              }
            });
          } else if (s === "loaded") {
            return init();
          } else if (s === "fail") {
            throwError("networkError", config), {
              code: "60204",
              msg: "Network failure",
              desc: {
                detail: "js resource load timeout"
              }
            };
          } else if (s === "loading") {
            callbacks[type].push(init);
          } else {}
        });
      };
    })(window, o.c.ssoApiServers, o.c.ssoStaticServers);
  },
  init: function init() {
    var o = this;
    o.initGt();
    var gtData = JSON.parse((0, _stringify2.default)(o.c));
    delete gtData.param;
    delete gtData.cbs;
    gtData.captchaId = o.c.param.gt;
    gtData.offline = false;
    gtData["new_captcha"] = true;
    gtData.offlineCb = function () {
      sucWeb.callCB(o.c.cbs.initFail, o.c.param);
    };
    console.log("极验初始化前调用");
    o.initGeetest(gtData);
  },
  getValidate: function getValidate() {
    return this.validateCodeObj;
  },
  getValidateCodeObj: function getValidateCodeObj() {
    return this.captchaObj.getValidate();
  },
  initGeetest: function initGeetest(data) {
    console.log("初始化吉言方法");
    var o = this;
    initGeetest4(data, function (captchaObj) {
      o.captchaObj = captchaObj;
      if (o.c.parent) {
        captchaObj.appendTo(o.c.parent);
      }
      captchaObj.onSuccess(function () {
        o.validateCodeObj = o.getValidateCodeObj(captchaObj);
        if (o.c.cbs.onSuccess) {
          sucWeb.callCB(o.c.cbs.onSuccess, o.validateCodeObj);
        } else {
          sucWeb.callCB(o.onSuccess, o.validateCodeObj);
        }
      }).onError(function (error) {
        if (o.c.cbs.onError) {
          sucWeb.callCB(o.c.cbs.onError, error);
        } else {
          sucWeb.callCB(o.onError, error);
        }
      }).onReady(function () {
        if (o.c.cbs.onReady) {
          var response = {};
          response.result = "success";
          response.code = "success";
          response.data = { captchaType: "third" };
          sucWeb.callCB(o.c.cbs.onReady, response);
        }
      }).onClose(function () {
        if (o.c.cbs.onClose) {
          sucWeb.callCB(o.c.cbs.onClose);
        } else {
          sucWeb.callCB(o.onClose);
        }
      });
    });
  },
  onSuccess: function onSuccess(result) {},
  onError: function onError(error) {},
  onClose: function onClose() {},
  getCaptchaObj: function getCaptchaObj() {
    return this.captchaObj;
  },
  reset: function reset() {
    console.log("图形重置");
    this.captchaObj.reset();
  },
  destroy: function destroy() {
    console.log("图形销毁");
    this.captchaObj.destroy();
  },
  verify: function verify() {
    console.log("展示图形");
    this.captchaObj.showBox();
  }
});

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by yuxin Wei on 2017/11/15.
 * 封装常量constants
 */
exports.default = {
  //登录模式
  teachingTag: { isTeaching: 1, isNotTeaching: 0 },

  //任务类型
  record_origin: {
    KeHouLianXi: 1,
    XiaFa: 2,
    QiangDa: 3,
    SuiTang: 4,
    Stop: 5
  },

  //授课类型
  teaching_type: {
    BeiKe: 1
  },

  //任务状态
  inactive_state: {
    errorState: -1,
    init: 0,
    doing: 1,
    done: 2
  },

  //loading类型
  loading: {
    opaque: 0,
    transparency: 1
  },

  commondsStr: {
    /**
     * 消息类型
     */
    commondType: {
      message: "MESSAGE",
      commond: "COMMAND"
    },
    /**
     * commond消息，该值不能动
     */
    xiaoxi_commond: {
      start: "start",
      stop: "stop"
    },

    /**
     * message：消息，需要根据业务来改
     */
    xiaoxi_message: {
      xiaFa: "xiafa",
      qiangDa: "qiangda",
      shouKong: "shouKong",
      shouKe: "shouke",
      suoPing: "suoping",
      tongPing: "tongPingKeyStart",
      common: "normal",
      stop: "sendEndClientKey",
      suiTang: "suiTang"
    },
    /**
     *common消息：自定义的通用消息
     */
    common_message: {
      endTask: "endTask",
      qiangDaJieGuo: "qiangDaJieGuo",
      qiangDaChengGong: "qiangDaChengGong",
      stopTongPing: "tongPingKeyStop",
      endSuiTang: "endSuiTang",
      daTiJieShu: "daTiJieShu",
      noAnswerJieShu: "noAnswerJieShu"
    },

    configInfo: {
      roomId: "roomid"
    }
  },

  //登录提示
  login_Info: {
    empty: "请输入账号和密码！",
    userNameEmpty: "请输入账号！",
    passWordEmpty: "请输入密码！",
    error: "账号或密码错误！",
    exceptions: "登录失败，服务端异常！",
    loginErrCode: "2002",
    captchaCodeErr: "2021",
    captchaCodeErrText: "验证码错误！"
  },
  submit_Msg: {
    error: "提交过程中出现异常！"
  },

  //loading默认时间10s
  loading_Msg: {
    time: 10000,
    msg: "拼命加载中..."
  },

  tongPingType: { BanJi: "banJi", geRen: "geRen" },

  usingClient: {
    studentClient: "1",
    teacherClient: "0"
  },

  result: {
    success: 1000
  },

  taskType: {
    classwork: "classwork",
    interaction: "interaction"
  },

  terminal: "PC",

  qiangDaErrorMsg: "answerFailure",

  interfaceResult: {
    success: 1,
    error: 0,
    qiangDaErrorCode: 209
  },

  //题型常量
  category: {
    word: "read_word", //朗读单词&&字词朗读
    sentence: "read_sentence", //朗读句子
    chapter: "read_passage", //朗读短文&&段落朗读
    listen_shortpassage_record: "listen_shortpassage_record", //听后回答
    choice: "listen_shortpassage_choice", //听后选择 &&听课文，回答问题
    dialog: "read_dialog", //朗读对话
    situational_reply_picture: "situational_reply_picture", //看图问答
    situational_reply_text: "situational_reply_text", //情景问答
    fillblank: "listen_shortpassage_fillblank", //听后填空
    judge: "listen_shortpassage_judge", //听后判断
    listen_phonetic_choice: "listen_phonetic_choice", //听音频，为划线部分选择正确的拼音
    listen_word_choice: "listen_word_choice", //听词语，选择正确的字
    read_chapter: "read_chapter", //听一听，背一背
    recite_chapter: "recite_chapter", //听一听，读一读
    poetry: "poetry", //古诗
    idiom_story_choice: "idiom_story_choice" //成语
  },

  //登录角色
  loginRole: {
    teacher: "teacher",
    student: "student"
  },

  //模块名称
  moduleName: {
    teacher: {
      prepareLessonName: "我的备课",
      textbooksSynchronization: "教材同步",
      specialTopic: "主题专项",
      specialTest: "考试专项",
      inClassTest: "我的备测",
      testRecord: "测试记录",
      practiceEvaluation: "课后练习讲评",
      personalCenter: "个人中心"
    },
    student: {
      ingClasswork: "进行中",
      endClasswork: "已结束",
      specialBreak: "专项突破"
    }
  }
};

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _storage = __webpack_require__(8);

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  //身份类型
  roleType: {
    'teacher': 'teacher', //教师
    'student': 'student', //学生
    'school': 'subjectLeader', //校级
    'district': 'instructor', //区县
    'city': 'cityAdmin', //市级
    'province': 'provinceAdmin', //省级
    'grade': 'grade', //年级
    'class': 'class', //班级
    'proInstructor': 'proInstructor', //省教研员
    'cityInstructor': 'cityInstructor' //市教研员
  },
  anlysisCard: [{
    code: 'basicLearning',
    name: '基础学习',
    unit: '次',
    imgSrc: 'icon-jichuxuexi'
  }, {
    code: 'bookSync',
    name: '课本同步',
    unit: '次',
    imgSrc: 'icon-kebentongbu'
  }, {
    code: 'topicExpr',
    name: '话题表述',
    unit: '次',
    imgSrc: 'icon-huatibiaoshu'
  }, {
    code: 'classicReading',
    name: '经典欣赏',
    unit: '次',
    imgSrc: 'icon-jingdianxinshang'
  }],
  //身份名称
  roleName: {
    'teacher': '教师', //教师
    'student': '学生', //学生
    'school': '校级管理员', //校级
    'district': '区县管理员', //区县
    'city': '市级管理员', //市级
    'province': '省级管理员', //省级
    'grade': '年级管理员', //年级
    'class': '班级管理员' //班级
  },
  //学生个人报告页面类型
  learnReportType: {
    basicLearning: 'stuBaseLearn',
    bookSync: 'stuTextbookLearn',
    topicExpr: 'stuTopicExpress',
    classicReading: ''
  },
  //音调中文类型
  yinDiaoType: {
    0: "轻声",
    1: "阴平",
    2: "阳平",
    3: "上声",
    4: "下声",
    "ZERO": "零声母"
  },
  statisticType: {
    province: -1,
    city: 0,
    district: 1,
    school: 2,
    grade: 3,
    class: 4
  },
  taskType: {
    districtExamination: 3,
    schoolExamination: 2,
    classExamination: 1
  },
  //科目代码
  subjectCode: {
    Chinese: '01'
  },
  singleType: {
    districtSingle: 'districtSingle', //区县单次
    schoolSingle: 'schoolSingle', //学校单次
    gradeSingle: 'gradeSingle', //年级单次
    classSingle: 'classSingle' //班级单次
  },
  moduleType: {
    learnAnalysis: 'learnAnalysis', //学习分析
    examAnalysis: 'examAnalysis', //考试分析
    examManage: 'examManage' //考务管理
  },
  gradeCode: {
    '12': '高三',
    '11': '高二',
    '10': '高一',
    '09': '九年级',
    '08': '八年级',
    '07': '七年级',
    '06': '六年级',
    '05': '五年级',
    '04': '四年级',
    '03': '三年级',
    '02': '二年级',
    '01': '一年级'
  },
  getTaskTypByRole: function getTaskTypByRole() {
    var roleCode = _storage2.default.getSessionStorage("role");
    if (roleCode === this.roleType.teacher) {
      return this.taskType.classExamination;
    }if (roleCode === this.roleType.school) {
      return this.taskType.schoolExamination;
    }if (roleCode === this.roleType.district) {
      return this.taskType.districtExamination;
    } else if (roleCode === this.roleType.city || roleCode === this.roleType.province) {
      return this.taskType.districtExamination;
    } else if (roleCode === this.roleType.student) {} else {}
  }
};

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(9);

var _vuex2 = _interopRequireDefault(_vuex);

var _conf = __webpack_require__(30);

var _conf2 = _interopRequireDefault(_conf);

var _user = __webpack_require__(31);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  strict: "production" !== 'production', //在非生产环境下，使用严格模式
  modules: {
    user: _user2.default,
    conf: _conf2.default,
    name: ""
  },
  mutations: {
    changeName: function changeName(state, newName) {
      state.name = newName;
    }
  }
});

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getUrlKey$decodeBase; /**
                            * Created by Administrator on 2017/9/6.
                            */


var _regex = __webpack_require__(32);

var _regex2 = _interopRequireDefault(_regex);

__webpack_require__(29);

__webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_getUrlKey$decodeBase = {

  /**
   * 获取Url的参数
   * @param name 参数名
   * @returns {string|null}
   */
  getUrlKey: function getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
  },
  decodeBase64Params: function decodeBase64Params() {
    var urlParams = this.getUrlKey("v");
    var search = Base64.decode(urlParams).split("&");
    var params = {};
    var pos = void 0;
    var temp = "";

    for (var i = 0; i < search.length; i++) {
      pos = search[i].indexOf("=");
      if (pos > 0) {
        temp = decodeURIComponent(search[i].substring(pos + 1));
        params[search[i].substring(0, pos)] = temp && temp !== 'undefined' ? temp : '';
      }
    }
    return params;
  },
  encodeBase64Params: function encodeBase64Params(params, htmlName) {
    var urlParams = "";
    urlParams = typeof params == 'string' ? params : function () {
      var addArr = [];
      for (var i in params) {
        if (params.hasOwnProperty(i)) {
          addArr.push(i + "=" + encodeURIComponent(params[i]));
        }
      }
      return addArr.length > 0 ? addArr.join('&') : '';
    }();
    return (htmlName || '') + (urlParams ? '?v=' + Base64.encode(urlParams) : '');
  },

  cutShortBack: function cutShortBack(className, maxLength) {
    if (className == null || className == "") return;

    var nameAvgTotalLength = className.replace(/[^\x00-\xff]/g, "**").length;
    if (nameAvgTotalLength > maxLength) {
      var strName = className.substring(0, maxLength);

      className = strName + "...";
    }
    return className;
  },

  PlayBtAudio: function PlayBtAudio(audioUrl) {
    console.log("播放声音:", audioUrl);
    var audio = document.getElementById('audioPlayer');
    var biaojiCls = "biaoji-bofang-class"; // 标记a标签这个是播放声音的而不是其它的什么链接

    audio.src = audioUrl;
    var $Target = $(event.target);
    if ($Target.is("span") || $Target.is("i")) {
      // 如果用户点击的是图标，那么把target定位到父级的 a 标签
      $Target = $Target.closest("a");
    }
    $Target.addClass(biaojiCls);

    $("span.palybtn").removeClass("current");

    if (!$Target.hasClass("selected")) {
      if ($(".selected").length > 0) {
        $(".selected i").removeClass("icon-other-pauseround").addClass("icon-other-playround");
        $(".selected").removeClass("selected");
      }
      $Target.addClass('selected');
      $Target.find("i").removeClass("icon-other-playround").addClass("icon-other-pauseround");
      $Target.find("span.palybtn").addClass("current");
      audio.play();
    } else {
      $Target.find("i").removeClass("icon-other-pauseround").addClass("icon-other-playround");
      $Target.removeClass('selected');
      audio.pause();
    }

    var is_playFinish = setInterval(function () {
      if (audio.ended) {
        $(".selected").find("i").removeClass("icon-other-pauseround").addClass("icon-other-playround");
        $("span.palybtn").removeClass("current");
        $("a.selected." + biaojiCls).removeClass("selected"); // biaojiCls标记一下，防止把别的非播放组件的a标签的selected样式抹去了，毕竟这个selected在a标签上太常用了
        window.clearInterval(is_playFinish);
      }
    }, 1000);
  },

  PlayAudio: function PlayAudio(audioUrl) {
    console.log("播放声音:", audioUrl);
    var audio = document.getElementById('audioPlayer');

    audio.src = audioUrl;
    var $Target = $(event.target);
    if ($Target.is("span") || $Target.is("i")) {
      // 如果用户点击的是图标，那么把target定位到父级的 a 标签
      $Target = $Target.closest("a");
    }

    $("span.palybtn").removeClass("current");
    if (!$Target.hasClass("read-stop")) {
      //正在播放
      console.log(11111111);
      if ($(".selected").length > 0) {
        $(".selected").removeClass("read-stop");
        $(".selected").removeClass("selected");
      }
      $Target.addClass('selected');
      $Target.addClass("read-stop");
      $Target.addClass("current");
      audio.play();
    } else {
      console.log(222222222222);
      // $Target.find("i").removeClass("icon-other-pauseround").addClass("icon-other-playround");
      $Target.removeClass('selected');
      $Target.removeClass('read-stop');
      audio.pause();
    }

    var is_playFinish = setInterval(function () {
      if (audio.ended) {
        //录音结束
        $("a.selected").removeClass("read-stop");
        $("a.selected").removeClass("selected"); // biaojiCls标记一下，防止把别的非播放组件的a标签的selected样式抹去了，毕竟这个selected在a标签上太常用了
        window.clearInterval(is_playFinish);
      }
    }, 1000);
  },

  //处理填空题答案前后空格、大小写转换等
  stringRegex: function stringRegex(str) {
    if (typeof str !== "string") {
      return str;
    }
    //统一中间空格
    str = str.replace(_regex2.default.centerSpace, ' ');
    //去除前后空格
    str = str.replace(_regex2.default.aroundSpace, '');
    //统一大小写
    return str.toLowerCase();
  },
  //处理注销、退出框居中
  initPosition: function initPosition() {
    var clientWidth = document.body.clientWidth;
    var popWidth = $('.popBox').width();

    var clientHeight = document.body.clientHeight;
    var popHeight = $('.popBox').height();

    $(".popBox").css({
      'left': (clientWidth - popWidth) / 2 + 'px',
      'top': (clientHeight - popHeight) / 2 + 'px'
    });
  },

  //处理保留个数,默认1位，其中0.0返回0,100.0返回100
  regexNumber: function regexNumber(number, n) {
    if (!n) {
      n = 1;
    }
    if (typeof number != 'number' || typeof n != 'number') {
      return number;
    }
    var arr = number.toFixed(n).toString().split('.');
    if (arr.length <= 1) {
      return number;
    }
    if (_regex2.default.isAllZero.test(arr[1])) {
      return number.toFixed(n);
    }
    return arr[0];
  },
  templateCount: function templateCount(templateCode) {
    //templateCode  是数组  为标志  1为查所有的  2为查单个
    var tem = void 0;
    var array = [];
    array = templateCode;
    if (typeof templateCode != 'array') {}
    array.forEach(function (item) {
      switch (item) {
        case 'PassageReading':
        case 'PassageReadingA':
          tem += 120;break;
        case 'SituationalVideoPresentation':
          tem += 120;break;
        default:
          tem += 60;break;
      }
    });
    return tem;
  },

  /*
   * 字符串省略显示，中间显示“...”
   */
  cutShort: function cutShort(className, maxLength) {
    if (className == null || className == "") return;
    var nameAvgTotalLength = className.replace(/[^\x00-\xff]/g, "**").length;
    if (nameAvgTotalLength > maxLength) {
      var newClassName = "";
      var newClassBackName = "";
      var nameLength = className.length;
      var totalLength = 0;
      var avgLength = maxLength / 2;
      nameAvgTotalLength -= avgLength;
      var classNameList = className.split("");
      for (var i = 0; i < nameLength; i++) {
        var cName = classNameList[i];
        if (/^[\u4e00-\u9fa5（）]$/.test(cName)) {
          totalLength += 2;
        } else {
          totalLength += 1;
        }
        if (totalLength <= avgLength || totalLength > nameAvgTotalLength) {
          if (totalLength <= avgLength) newClassName += cName;else newClassBackName += cName;
        }
      }
      className = newClassName + "..." + newClassBackName;
    }
    return className;
  }

}, (0, _defineProperty3.default)(_getUrlKey$decodeBase, 'cutShortBack', function cutShortBack(className, maxLength) {
  if (className == null || className == "") return;
  var nameAvgTotalLength = className.replace(/[^\x00-\xff]/g, "**").length;
  if (nameAvgTotalLength > maxLength) {
    var strName = className.substring(0, maxLength - 3);

    className = strName + "...";
  }
  return className;
}), (0, _defineProperty3.default)(_getUrlKey$decodeBase, 'strSlic', function strSlic(str, n) {
  if (str == '' || str == null) {
    return null;
  }
  var r = /[^\x00-\xff]/g;
  if (str.replace(r, "mm").length <= n) {
    return str;
  }
  if (str.length <= n - 3) {
    return str;
  }
  var m = Math.floor(n / 2);
  for (var i = m; i < str.length + 1; i++) {
    if (str.substr(0, i).replace(r, "mm").length >= n) {
      return str.substr(0, i) + "...";
    }
  }
}), _getUrlKey$decodeBase);

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(7);

var _constants2 = _interopRequireDefault(_constants);

__webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by juzhang on 2018/6/22.
 */
exports.default = {
  common: function common(result, returnAll) {

    var res = JSON.parse(result);
    if (returnAll) {
      return res;
    }
    if (res.statusCode == _constants2.default.interfaceResult.success) {
      //成功
      return res.data;
    } else if (res.statusCode === _constants2.default.interfaceResult.noRight) {
      alert("无操作权限!");
      // window.location.href = "login.html";
    } else {
      //对每个业务进行处理，后面再补充
      console.log(res.message);
      console.log("【程序出现异常】");
      if (res.statusCode === "QM-1000" || res.statusCode === "QM-1004") {
        return res;
      } else {
        //问题抛出
        return null;
      }
    }
  },

  //请求异常处理
  doError: function doError(result, reject) {
    if (!!result.responseText) {
      var response = JSON.parse(result.responseText);
      console.log("【WebApi-ERROR:】" + response.message);
      //token失效，重新登录
      if (response.statusCode === _constants2.default.interfaceResult.tokenfail) {
        SSO.getAccessToken(function (item) {
          if (item.result === "success") {
            sessionStorage.setItem("token", item.data.token);
            sessionStorage.setItem("mac", item.data.mac);
            sessionStorage.setItem("tgt", item.data.tgt);
            SSO.setCookie("token", item.data.token, 1);
            window.location.reload();
          } else {
            if (sessionStorage.getItem('isExamClient')) {
              window.parent.postMessage({ cmd: 'mkClientTokenInvalid' }, '*');
            } else {
              window.location.href = "login.html";
            }
          }
        });
      } else if (response.statusCode === _constants2.default.interfaceResult.noRight) {
        alert("无操作权限!");
        window.location.href = "login.html";
      } else {
        reject(response.message);
      }
    } else {
      reject("");
    }
  }
};

/***/ }),

/***/ 2015:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
module.exports = __webpack_require__(757);


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _storage = __webpack_require__(8);

var _storage2 = _interopRequireDefault(_storage);

var _anlysisConstants = __webpack_require__(12);

var _anlysisConstants2 = _interopRequireDefault(_anlysisConstants);

var _utils = __webpack_require__(19);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  redirect2Index: function redirect2Index() {
    var roleCode = _storage2.default.getSessionStorage("role");
    if (roleCode === _anlysisConstants2.default.roleType.teacher || roleCode === _anlysisConstants2.default.roleType.school || roleCode === _anlysisConstants2.default.roleType.district) {
      this.redirect2Analysis();
    } else if (roleCode === _anlysisConstants2.default.roleType.cityInstructor || roleCode === _anlysisConstants2.default.roleType.proInstructor) {
      this.redirect2Analysis();
    } else if (roleCode === _anlysisConstants2.default.roleType.student) {
      window.location.href = "stuindex.html";
    } else {
      window.location.href = "login.html";
    }
  },
  //跳转到考务管理系统
  redirect2Exam: function redirect2Exam() {
    var roleCode = _storage2.default.getSessionStorage("role");
    if (roleCode === _anlysisConstants2.default.roleType.teacher) {
      window.location.href = "exam.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.school) {
      window.location.href = "mock.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.district) {
      window.location.href = "plan.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.cityInstructor) {
      window.location.href = "cityplan.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.proInstructor) {
      window.location.href = "prolevelplan.html";
    } else {
      window.location.href = "";
    }
  },

  // 跳转到备练习管理页面
  redirect2Practive: function redirect2Practive() {
    window.location.href = "practive.html";
    console.log("window.location.href", window.location.href);
  },
  //跳转到考务管理首页
  redirect2ExamIndex: function redirect2ExamIndex() {
    var roleCode = _storage2.default.getSessionStorage("role");
    if (roleCode === _anlysisConstants2.default.roleType.teacher) {
      window.location.href = "teaindex.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.school) {
      window.location.href = "subindex.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.district) {
      window.location.href = "insindex.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.student) {
      window.location.href = "stuindex.html";
    } else {
      window.location.href = "";
    }
  },
  //跳转到学习分析页面
  redirect2Analysis: function redirect2Analysis(roleCode, params) {
    var userInfo = JSON.parse(_storage2.default.getSessionStorage("user"));
    roleCode = roleCode || _storage2.default.getSessionStorage("role"); //若参数中没有跳转到的角色页面，则默认跳到对应用户当前角色的页面
    var htmlName = "login.html";
    switch (roleCode) {
      case _anlysisConstants2.default.roleType.school:
        //学校概况
        htmlName = "schoolLearnInfo.html";
        params = params || {
          schoolName: userInfo.schoolName,
          schoolId: userInfo.schoolId
        };
        break;
      case _anlysisConstants2.default.roleType.district:
        //区县概况
        htmlName = "districtLearnInfo.html";
        params = params || {
          districtName: userInfo.districtName,
          districtCode: userInfo.districtCode
        };
        break;
      case _anlysisConstants2.default.roleType.cityInstructor:
        //市级概况
        htmlName = "cityplan.html";
        params = params || {
          cityName: userInfo.cityName,
          cityCode: userInfo.cityCode
        };
        break;
      case _anlysisConstants2.default.roleType.proInstructor:
        //省级概况
        // htmlName = "provinceLearnInfo.html";
        htmlName = "prolevelplan.html";
        params = params || {
          provinceName: userInfo.provinceName,
          provinceCode: userInfo.provinceCode
        };
        break;
      case _anlysisConstants2.default.roleType.grade:
        //年级概况
        htmlName = "gradeLearnInfo.html";
        params = params || {
          gradeName: userInfo.gradeName,
          gradeCode: userInfo.gradeCode
        };
        break;
      case _anlysisConstants2.default.roleType.class: //班级详情
      case _anlysisConstants2.default.roleType.teacher:
        htmlName = "classLearnInfo.html";
        params = params || {
          schoolName: userInfo.schoolName,
          schoolId: userInfo.schoolId
        };
        break;
      default:
        htmlName = "";
        break;
    }
    window.location.href = _utils2.default.encodeBase64Params(params, htmlName);
  },
  //跳转到考务分析页面
  redirect2ExamAnalysis: function redirect2ExamAnalysis(roleCode, params) {
    var userInfo = JSON.parse(_storage2.default.getSessionStorage("user"));
    roleCode = roleCode || _storage2.default.getSessionStorage("role"); //若参数中没有跳转到的角色页面，则默认跳到对应用户当前角色的页面
    var htmlName = "login.html";
    switch (roleCode) {
      case _anlysisConstants2.default.roleType.school:
        //学校概况
        htmlName = "schoolExamInfo.html";
        params = params || {
          schoolName: userInfo.schoolName,
          schoolId: userInfo.schoolId
        };
        break;
      case _anlysisConstants2.default.roleType.district:
        //区县概况
        htmlName = "districtExamInfo.html";
        params = params || {
          districtName: userInfo.districtName,
          districtCode: userInfo.districtCode
        };
        break;
      case _anlysisConstants2.default.roleType.grade:
        //年级概况
        htmlName = "gradeExamInfo.html";
        params = params || {
          gradeName: userInfo.gradeName,
          gradeCode: userInfo.gradeCode
        };
        break;
      case _anlysisConstants2.default.roleType.class: //班级详情
      case _anlysisConstants2.default.roleType.teacher:
        htmlName = "classExamInfo.html";
        params = params || {
          schoolName: userInfo.schoolName,
          schoolId: userInfo.schoolId,
          className: userInfo.className,
          classId: userInfo.classId,
          gradeName: userInfo.gradeName,
          gradeCode: userInfo.gradeCode
        };
        break;
      default:
        htmlName = "";
        break;
    }
    window.location.href = _utils2.default.encodeBase64Params(params, htmlName);
  },
  //跳转到考务分析单次报告页面
  redirect2SingleExamReport: function redirect2SingleExamReport(roleCode, params) {

    var userInfo = JSON.parse(_storage2.default.getSessionStorage("user"));
    roleCode = roleCode || _storage2.default.getSessionStorage("role"); //若参数中没有跳转到的角色页面，则默认跳到对应用户当前角色的页面
    var htmlName = "login.html";
    switch (roleCode) {
      case _anlysisConstants2.default.roleType.school:
        //学校单次报告
        htmlName = "schoolSingleExamReport.html";
        params = params || {
          schoolName: userInfo.schoolName,
          schoolId: userInfo.schoolId
        };
        break;
      case _anlysisConstants2.default.roleType.district:
        //区县单次报告
        htmlName = "districtSingleExamReport.html";
        params = params || {
          districtName: userInfo.districtName,
          districtCode: userInfo.districtCode
        };
        break;
      case _anlysisConstants2.default.roleType.cityInstructor:
        //市级单次报告
        htmlName = "citySingleExamReport.html";
        params = params || {
          planCityName: userInfo.planCityName,
          cityCode: userInfo.cityCode
        };
        break;
      case _anlysisConstants2.default.roleType.proInstructor:
        //省级单次报告
        htmlName = "proSingleExamReport.html";
        params = params || {
          planCityName: userInfo.provinceName,
          cityCode: userInfo.provinceCode
        };
        break;
      case _anlysisConstants2.default.roleType.grade:
        //年级单次报告
        htmlName = "gradeSingleExamReport.html";
        params = params || {
          gradeName: userInfo.gradeName,
          gradeCode: userInfo.gradeCode
        };
        break;
      case _anlysisConstants2.default.roleType.class: //班级单次报告
      case _anlysisConstants2.default.roleType.teacher:
        htmlName = "classSingleExamReport.html";
        params = params || {
          className: userInfo.className,
          classId: userInfo.classId
        };
        break;
      case _anlysisConstants2.default.roleType.student:
        //学生个人报告
        htmlName = "studentExamReport.html";
        params = params || {
          studentName: userInfo.studentName,
          studentId: userInfo.studentId
        };
        break;
      default:
        htmlName = "";
        break;
    }
    window.location.href = _utils2.default.encodeBase64Params(params, htmlName);
  },
  //跳转到考务分析历次成绩页面
  redirect2PreviousScoreReport: function redirect2PreviousScoreReport(roleCode, params) {
    var userInfo = JSON.parse(_storage2.default.getSessionStorage("user"));
    roleCode = roleCode || _storage2.default.getSessionStorage("role"); //若参数中没有跳转到的角色页面，则默认跳到对应用户当前角色的页面
    var htmlName = "login.html";
    switch (roleCode) {
      case _anlysisConstants2.default.roleType.student:
        //学生历次成绩
        htmlName = "studentAllPreviousScoreReport.html";
        params = params || {
          studentName: userInfo.studentName,
          studentId: userInfo.studentId
        };
        break;
      default:
        htmlName = "";
        break;
    }
    window.location.href = _utils2.default.encodeBase64Params(params, htmlName);
  },
  //跳转到统计分析页面
  redirect2Statistics: function redirect2Statistics(roleCode, params) {
    var userInfo = JSON.parse(_storage2.default.getSessionStorage("user"));
    roleCode = roleCode || _storage2.default.getSessionStorage("role"); //若参数中没有跳转到的角色页面，则默认跳到对应用户当前角色的页面
    var htmlName = "login.html";
    switch (roleCode) {
      case _anlysisConstants2.default.roleType.grade:
        //年级统计分析
        htmlName = "gradeStatistics.html";
        params = params || {
          gradeName: userInfo.gradeName,
          gradeCode: userInfo.gradeCode
        };
        break;
      case _anlysisConstants2.default.roleType.class:
        //班级统计分析
        htmlName = "classStatistics.html";
        params = params || {
          className: userInfo.className,
          classId: userInfo.classId
        };
        break;
      default:
        htmlName = "";
        break;
    }
    window.location.href = _utils2.default.encodeBase64Params(params, htmlName);
  },
  //跳转到学习报告页面
  redirect2LearnReport: function redirect2LearnReport(type, params) {
    if (!params) {
      //没有参数，错误
      window.location.href = "";
    }
    var htmlName = "login.html";
    switch (type) {
      case _anlysisConstants2.default.learnReportType.basicLearning:
        //基础学习
        htmlName = "stuBaseLearn.html";
        break;
      case _anlysisConstants2.default.learnReportType.bookSync:
        //课本同步
        htmlName = "stuTextbookLearn.html";
        break;
      case _anlysisConstants2.default.learnReportType.topicExpr:
        //话题表述
        htmlName = "stuTopicExpress.html";
        break;
      default:
        htmlName = "";
        break;
    }
    window.open(_utils2.default.encodeBase64Params(params, htmlName));
  },
  redirect2Usercenter: function redirect2Usercenter() {
    var roleCode = _storage2.default.getSessionStorage("role");
    if (roleCode === _anlysisConstants2.default.roleType.teacher) {
      window.location.href = "usercenter.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.school) {
      window.location.href = "usercenter.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.district) {
      window.location.href = "usercenter.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.cityInstructor) {
      window.location.href = "usercenter.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.proInstructor) {
      window.location.href = "usercenter.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.student) {
      window.location.href = "stuusercenter.html";
    } else {}
  },
  redirect2Notice: function redirect2Notice() {
    var roleCode = _storage2.default.getSessionStorage("role");
    if (roleCode == _anlysisConstants2.default.roleType.student) {
      window.location.href = "stunoticemanagement.html";
    } else {
      window.location.href = "noticemanagement.html";
    }
  },
  redirect2Management: function redirect2Management() {
    var roleCode = _storage2.default.getSessionStorage("role");
    if (roleCode === _anlysisConstants2.default.roleType.teacher) {
      window.location.href = "classmanagement.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.school) {
      window.location.href = "schoolmanagement.html";
    } else if (roleCode === _anlysisConstants2.default.roleType.district) {
      window.location.href = "districtmanagement.html";
    } else {}
  },
  // 跳转到创建备练习页面
  redirectAddPiactive: function redirectAddPiactive(params) {
    var htmlName = "addPractive.html";
    window.location.href = _utils2.default.encodeBase64Params(params, htmlName);
  },

  // 跳转到备练习预览页面
  redirectPreviewPiactive: function redirectPreviewPiactive(params) {
    var htmlName = "previewPractive.html";
    window.location.href = _utils2.default.encodeBase64Params(params, htmlName);
  }
};

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  /* 转换百分数后保留1位小数 */
  "RATE_FIXED_NUM": 1,

  /* 分数保留1位小数 */
  "SCORE_FIXED_NUM": 1,

  /**
   * 时间过滤条件起始查询时间, 默认从2015年开始到当前学年
   * */
  "START_YEAR": 2016,

  /**
   * 默认阳历9月1日开学, 到次年农历正月初一算第一学期, 到次年8月31日算第二学期
   * */
  "TERM_START_DATE": "08-15",

  "TERM_END_DATE": "08-14",

  "TERM_SPLIT_MONTH": 1, //农历正月

  "TERM_SPLIT_DATE": 1, //农历初一

  "MIN_RANK_VALUE": 3, //排名最少有3个刻度

  /**
   * ======================================================
   * 分割线, 以下写枚举类型
   * ======================================================
   * */

  //用户类型：1.学生2.教师7.市教研员8.区教研员9.校教研员10.资源组账号
  "USER_TYPE": {
    "student": "1",
    "teacher": "2",
    "city": "7",
    "area": "8",
    'school': "9",
    'resource': "10",
    'admin': "5"
  },

  /**
   * ======================================================
   * 分割线, 以下是图表统一颜色配置
   * ======================================================
   * */

  "ECHARTS_COLOR": [
  //'#2ec7c9',
  '#50b4fa', '#69d9b0', '#f57f71', '#ff475a', '#e5bc65', '#4ed5c5', '#f97286', '#d87a80', '#8d98b3', '#e5cf0d', '#97b552', '#95706d', '#dc69aa', '#07a2a4', '#9a7fd1', '#588dd5', '#f5994e', '#c05050', '#59678c', '#c9ab00', '#7eb00a', '#6f5553', '#c14089'],
  /* 升序 */
  "SORT_ASC": 1,
  /* 降序 */
  "SORT_DESC": 2,

  /**
   * ======================================================
   * 分割线, 以下是考试分析报告中区间段步长设置
   * 饼状图
   * 柱状图
   * ======================================================
   * */
  "PIE_STEP": 5,
  "HISTOGRAM_STEP": 10
};

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recognizeText = exports.getLoginUserInfo = undefined;

var _handleResult = __webpack_require__(2);

var _handleResult2 = _interopRequireDefault(_handleResult);

var _request = __webpack_require__(5);

var _request2 = _interopRequireDefault(_request);

var _serviceConfig = __webpack_require__(6);

var _serviceConfig2 = _interopRequireDefault(_serviceConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//根据token获取登录用户信息
var getLoginUserInfo = exports.getLoginUserInfo = function getLoginUserInfo(param) {
  return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.personalInfo, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
    return _handleResult2.default.common(res);
  });
};
// 敏感词校验
var recognizeText = exports.recognizeText = function recognizeText(param) {
  return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.recognizeText, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
    return _handleResult2.default.common(res);
  });
};

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(13);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*!
 * jQuery JavaScript Library v1.7.2
 * http://jquery.com/
 *
 * Copyright 2011, John Resig
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 * Copyright 2011, The Dojo Foundation
 * Released under the MIT, BSD, and GPL Licenses.
 *
 * Date: Wed Mar 21 12:46:34 2012 -0700
 */
(function (window, undefined) {

    // Use the correct document accordingly with window argument (sandbox)
    var document = window.document,
        navigator = window.navigator,
        location = window.location;
    var jQuery = function () {

        // Define a local copy of jQuery
        var jQuery = function jQuery(selector, context) {
            // The jQuery object is actually just the init constructor 'enhanced'
            return new jQuery.fn.init(selector, context, rootjQuery);
        },


        // Map over jQuery in case of overwrite
        _jQuery = window.jQuery,


        // Map over the $ in case of overwrite
        _$ = window.$,


        // A central reference to the root jQuery(document)
        rootjQuery,


        // A simple way to check for HTML strings or ID strings
        // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
        quickExpr = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/,


        // Check if a string has a non-whitespace character in it
        rnotwhite = /\S/,


        // Used for trimming whitespace
        trimLeft = /^\s+/,
            trimRight = /\s+$/,


        // Match a standalone tag
        rsingleTag = /^<(\w+)\s*\/?>(?:<\/\1>)?$/,


        // JSON RegExp
        rvalidchars = /^[\],:{}\s]*$/,
            rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
            rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
            rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g,


        // Useragent RegExp
        rwebkit = /(webkit)[ \/]([\w.]+)/,
            ropera = /(opera)(?:.*version)?[ \/]([\w.]+)/,
            rmsie = /(msie) ([\w.]+)/,
            rmozilla = /(mozilla)(?:.*? rv:([\w.]+))?/,


        // Matches dashed string for camelizing
        rdashAlpha = /-([a-z]|[0-9])/ig,
            rmsPrefix = /^-ms-/,


        // Used by jQuery.camelCase as callback to replace()
        fcamelCase = function fcamelCase(all, letter) {
            return (letter + "").toUpperCase();
        },


        // Keep a UserAgent string for use with jQuery.browser
        userAgent = navigator.userAgent,


        // For matching the engine and version of the browser
        browserMatch,


        // The deferred used on DOM ready
        readyList,


        // The ready event handler
        _DOMContentLoaded2,


        // Save a reference to some core methods
        toString = Object.prototype.toString,
            hasOwn = Object.prototype.hasOwnProperty,
            push = Array.prototype.push,
            _slice = Array.prototype.slice,
            trim = String.prototype.trim,
            indexOf = Array.prototype.indexOf,


        // [[Class]] -> type pairs
        class2type = {};

        jQuery.fn = jQuery.prototype = {
            constructor: jQuery,
            init: function init(selector, context, rootjQuery) {
                var match, elem, ret, doc;

                // Handle $(""), $(null), or $(undefined)
                if (!selector) {
                    return this;
                }

                // Handle $(DOMElement)
                if (selector.nodeType) {
                    this.context = this[0] = selector;
                    this.length = 1;
                    return this;
                }

                // The body element only exists once, optimize finding it
                if (selector === "body" && !context && document.body) {
                    this.context = document;
                    this[0] = document.body;
                    this.selector = selector;
                    this.length = 1;
                    return this;
                }

                // Handle HTML strings
                if (typeof selector === "string") {
                    // Are we dealing with HTML string or an ID?
                    if (selector.charAt(0) === "<" && selector.charAt(selector.length - 1) === ">" && selector.length >= 3) {
                        // Assume that strings that start and end with <> are HTML and skip the regex check
                        match = [null, selector, null];
                    } else {
                        match = quickExpr.exec(selector);
                    }

                    // Verify a match, and that no context was specified for #id
                    if (match && (match[1] || !context)) {

                        // HANDLE: $(html) -> $(array)
                        if (match[1]) {
                            context = context instanceof jQuery ? context[0] : context;
                            doc = context ? context.ownerDocument || context : document;

                            // If a single string is passed in and it's a single tag
                            // just do a createElement and skip the rest
                            ret = rsingleTag.exec(selector);

                            if (ret) {
                                if (jQuery.isPlainObject(context)) {
                                    selector = [document.createElement(ret[1])];
                                    jQuery.fn.attr.call(selector, context, true);
                                } else {
                                    selector = [doc.createElement(ret[1])];
                                }
                            } else {
                                ret = jQuery.buildFragment([match[1]], [doc]);
                                selector = (ret.cacheable ? jQuery.clone(ret.fragment) : ret.fragment).childNodes;
                            }

                            return jQuery.merge(this, selector);

                            // HANDLE: $("#id")
                        } else {
                            elem = document.getElementById(match[2]);

                            // Check parentNode to catch when Blackberry 4.6 returns
                            // nodes that are no longer in the document #6963
                            if (elem && elem.parentNode) {
                                // Handle the case where IE and Opera return items
                                // by name instead of ID
                                if (elem.id !== match[2]) {
                                    return rootjQuery.find(selector);
                                }

                                // Otherwise, we inject the element directly into the jQuery object
                                this.length = 1;
                                this[0] = elem;
                            }

                            this.context = document;
                            this.selector = selector;
                            return this;
                        }

                        // HANDLE: $(expr, $(...))
                    } else if (!context || context.jquery) {
                        return (context || rootjQuery).find(selector);

                        // HANDLE: $(expr, context)
                        // (which is just equivalent to: $(context).find(expr)
                    } else {
                        return this.constructor(context).find(selector);
                    }

                    // HANDLE: $(function)
                    // Shortcut for document ready
                } else if (jQuery.isFunction(selector)) {
                    return rootjQuery.ready(selector);
                }

                if (selector.selector !== undefined) {
                    this.selector = selector.selector;
                    this.context = selector.context;
                }

                return jQuery.makeArray(selector, this);
            },

            // Start with an empty selector
            selector: "",

            // The current version of jQuery being used
            jquery: "1.7.2",

            // The default length of a jQuery object is 0
            length: 0,

            // The number of elements contained in the matched element set
            size: function size() {
                return this.length;
            },

            toArray: function toArray() {
                return _slice.call(this, 0);
            },

            // Get the Nth element in the matched element set OR
            // Get the whole matched element set as a clean array
            get: function get(num) {
                return num == null ?

                // Return a 'clean' array
                this.toArray() :

                // Return just the object
                num < 0 ? this[this.length + num] : this[num];
            },

            // Take an array of elements and push it onto the stack
            // (returning the new matched element set)
            pushStack: function pushStack(elems, name, selector) {
                // Build a new jQuery matched element set
                var ret = this.constructor();

                if (jQuery.isArray(elems)) {
                    push.apply(ret, elems);
                } else {
                    jQuery.merge(ret, elems);
                }

                // Add the old object onto the stack (as a reference)
                ret.prevObject = this;

                ret.context = this.context;

                if (name === "find") {
                    ret.selector = this.selector + (this.selector ? " " : "") + selector;
                } else if (name) {
                    ret.selector = this.selector + "." + name + "(" + selector + ")";
                }

                // Return the newly-formed element set
                return ret;
            },

            // Execute a callback for every element in the matched set.
            // (You can seed the arguments with an array of args, but this is
            // only used internally.)
            each: function each(callback, args) {
                return jQuery.each(this, callback, args);
            },

            ready: function ready(fn) {
                // Attach the listeners
                jQuery.bindReady();

                // Add the callback
                readyList.add(fn);

                return this;
            },

            eq: function eq(i) {
                i = +i;
                return i === -1 ? this.slice(i) : this.slice(i, i + 1);
            },

            first: function first() {
                return this.eq(0);
            },

            last: function last() {
                return this.eq(-1);
            },

            slice: function slice() {
                return this.pushStack(_slice.apply(this, arguments), "slice", _slice.call(arguments).join(","));
            },

            map: function map(callback) {
                return this.pushStack(jQuery.map(this, function (elem, i) {
                    return callback.call(elem, i, elem);
                }));
            },

            end: function end() {
                return this.prevObject || this.constructor(null);
            },

            // For internal use only.
            // Behaves like an Array's method, not like a jQuery method.
            push: push,
            sort: [].sort,
            splice: [].splice
        };

        // Give the init function the jQuery prototype for later instantiation
        jQuery.fn.init.prototype = jQuery.fn;

        jQuery.extend = jQuery.fn.extend = function () {
            var options,
                name,
                src,
                copy,
                copyIsArray,
                clone,
                target = arguments[0] || {},
                i = 1,
                length = arguments.length,
                deep = false;

            // Handle a deep copy situation
            if (typeof target === "boolean") {
                deep = target;
                target = arguments[1] || {};
                // skip the boolean and the target
                i = 2;
            }

            // Handle case when target is a string or something (possible in deep copy)
            if ((typeof target === "undefined" ? "undefined" : (0, _typeof3.default)(target)) !== "object" && !jQuery.isFunction(target)) {
                target = {};
            }

            // extend jQuery itself if only one argument is passed
            if (length === i) {
                target = this;
                --i;
            }

            for (; i < length; i++) {
                // Only deal with non-null/undefined values
                if ((options = arguments[i]) != null) {
                    // Extend the base object
                    for (name in options) {
                        src = target[name];
                        copy = options[name];

                        // Prevent never-ending loop
                        if (target === copy) {
                            continue;
                        }

                        // Recurse if we're merging plain objects or arrays
                        if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)))) {
                            if (copyIsArray) {
                                copyIsArray = false;
                                clone = src && jQuery.isArray(src) ? src : [];
                            } else {
                                clone = src && jQuery.isPlainObject(src) ? src : {};
                            }

                            // Never move original objects, clone them
                            target[name] = jQuery.extend(deep, clone, copy);

                            // Don't bring in undefined values
                        } else if (copy !== undefined) {
                            target[name] = copy;
                        }
                    }
                }
            }

            // Return the modified object
            return target;
        };

        jQuery.extend({
            noConflict: function noConflict(deep) {
                if (window.$ === jQuery) {
                    window.$ = _$;
                }

                if (deep && window.jQuery === jQuery) {
                    window.jQuery = _jQuery;
                }

                return jQuery;
            },

            // Is the DOM ready to be used? Set to true once it occurs.
            isReady: false,

            // A counter to track how many items to wait for before
            // the ready event fires. See #6781
            readyWait: 1,

            // Hold (or release) the ready event
            holdReady: function holdReady(hold) {
                if (hold) {
                    jQuery.readyWait++;
                } else {
                    jQuery.ready(true);
                }
            },

            // Handle when the DOM is ready
            ready: function ready(wait) {
                // Either a released hold or an DOMready/load event and not yet ready
                if (wait === true && ! --jQuery.readyWait || wait !== true && !jQuery.isReady) {
                    // Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
                    if (!document.body) {
                        return setTimeout(jQuery.ready, 1);
                    }

                    // Remember that the DOM is ready
                    jQuery.isReady = true;

                    // If a normal DOM Ready event fired, decrement, and wait if need be
                    if (wait !== true && --jQuery.readyWait > 0) {
                        return;
                    }

                    // If there are functions bound, to execute
                    readyList.fireWith(document, [jQuery]);

                    // Trigger any bound ready events
                    if (jQuery.fn.trigger) {
                        jQuery(document).trigger("ready").off("ready");
                    }
                }
            },

            bindReady: function bindReady() {
                if (readyList) {
                    return;
                }

                readyList = jQuery.Callbacks("once memory");

                // Catch cases where $(document).ready() is called after the
                // browser event has already occurred.
                if (document.readyState === "complete") {
                    // Handle it asynchronously to allow scripts the opportunity to delay ready
                    return setTimeout(jQuery.ready, 1);
                }

                // Mozilla, Opera and webkit nightlies currently support this event
                if (document.addEventListener) {
                    // Use the handy event callback
                    document.addEventListener("DOMContentLoaded", _DOMContentLoaded2, false);

                    // A fallback to window.onload, that will always work
                    window.addEventListener("load", jQuery.ready, false);

                    // If IE event model is used
                } else if (document.attachEvent) {
                    // ensure firing before onload,
                    // maybe late but safe also for iframes
                    document.attachEvent("onreadystatechange", _DOMContentLoaded2);

                    // A fallback to window.onload, that will always work
                    window.attachEvent("onload", jQuery.ready);

                    // If IE and not a frame
                    // continually check to see if the document is ready
                    var toplevel = false;

                    try {
                        toplevel = window.frameElement == null;
                    } catch (e) {}

                    if (document.documentElement.doScroll && toplevel) {
                        doScrollCheck();
                    }
                }
            },

            // See test/unit/core.js for details concerning isFunction.
            // Since version 1.3, DOM methods and functions like alert
            // aren't supported. They return false on IE (#2968).
            isFunction: function isFunction(obj) {
                return jQuery.type(obj) === "function";
            },

            isArray: Array.isArray || function (obj) {
                return jQuery.type(obj) === "array";
            },

            isWindow: function isWindow(obj) {
                return obj != null && obj == obj.window;
            },

            isNumeric: function isNumeric(obj) {
                return !isNaN(parseFloat(obj)) && isFinite(obj);
            },

            type: function type(obj) {
                return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
            },

            isPlainObject: function isPlainObject(obj) {
                // Must be an Object.
                // Because of IE, we also have to check the presence of the constructor property.
                // Make sure that DOM nodes and window objects don't pass through, as well
                if (!obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow(obj)) {
                    return false;
                }

                try {
                    // Not own constructor property must be Object
                    if (obj.constructor && !hasOwn.call(obj, "constructor") && !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
                        return false;
                    }
                } catch (e) {
                    // IE8,9 Will throw exceptions on certain host objects #9897
                    return false;
                }

                // Own properties are enumerated firstly, so to speed up,
                // if last one is own, then all properties are own.

                var key;
                for (key in obj) {}

                return key === undefined || hasOwn.call(obj, key);
            },

            isEmptyObject: function isEmptyObject(obj) {
                for (var name in obj) {
                    return false;
                }
                return true;
            },

            error: function error(msg) {
                throw new Error(msg);
            },

            parseJSON: function parseJSON(data) {
                if (typeof data !== "string" || !data) {
                    return null;
                }

                // Make sure leading/trailing whitespace is removed (IE can't handle it)
                data = jQuery.trim(data);

                // Attempt to parse using the native JSON parser first
                if (window.JSON && window.JSON.parse) {
                    return window.JSON.parse(data);
                }

                // Make sure the incoming data is actual JSON
                // Logic borrowed from http://json.org/json2.js
                if (rvalidchars.test(data.replace(rvalidescape, "@").replace(rvalidtokens, "]").replace(rvalidbraces, ""))) {

                    return new Function("return " + data)();
                }
                jQuery.error("Invalid JSON: " + data);
            },

            // Cross-browser xml parsing
            parseXML: function parseXML(data) {
                if (typeof data !== "string" || !data) {
                    return null;
                }
                var xml, tmp;
                try {
                    if (window.DOMParser) {
                        // Standard
                        tmp = new DOMParser();
                        xml = tmp.parseFromString(data, "text/xml");
                    } else {
                        // IE
                        xml = new ActiveXObject("Microsoft.XMLDOM");
                        xml.async = "false";
                        xml.loadXML(data);
                    }
                } catch (e) {
                    xml = undefined;
                }
                if (!xml || !xml.documentElement || xml.getElementsByTagName("parsererror").length) {
                    jQuery.error("Invalid XML: " + data);
                }
                return xml;
            },

            noop: function noop() {},

            // Evaluates a script in a global context
            // Workarounds based on findings by Jim Driscoll
            // http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
            globalEval: function globalEval(data) {
                if (data && rnotwhite.test(data)) {
                    // We use execScript on Internet Explorer
                    // We use an anonymous function so that context is window
                    // rather than jQuery in Firefox
                    (window.execScript || function (data) {
                        window["eval"].call(window, data);
                    })(data);
                }
            },

            // Convert dashed to camelCase; used by the css and data modules
            // Microsoft forgot to hump their vendor prefix (#9572)
            camelCase: function camelCase(string) {
                return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
            },

            nodeName: function nodeName(elem, name) {
                return elem.nodeName && elem.nodeName.toUpperCase() === name.toUpperCase();
            },

            // args is for internal usage only
            each: function each(object, callback, args) {
                var name,
                    i = 0,
                    length = object.length,
                    isObj = length === undefined || jQuery.isFunction(object);

                if (args) {
                    if (isObj) {
                        for (name in object) {
                            if (callback.apply(object[name], args) === false) {
                                break;
                            }
                        }
                    } else {
                        for (; i < length;) {
                            if (callback.apply(object[i++], args) === false) {
                                break;
                            }
                        }
                    }

                    // A special, fast, case for the most common use of each
                } else {
                    if (isObj) {
                        for (name in object) {
                            if (callback.call(object[name], name, object[name]) === false) {
                                break;
                            }
                        }
                    } else {
                        for (; i < length;) {
                            if (callback.call(object[i], i, object[i++]) === false) {
                                break;
                            }
                        }
                    }
                }

                return object;
            },

            // Use native String.trim function wherever possible
            trim: trim ? function (text) {
                return text == null ? "" : trim.call(text);
            } :

            // Otherwise use our own trimming functionality
            function (text) {
                return text == null ? "" : text.toString().replace(trimLeft, "").replace(trimRight, "");
            },

            // results is for internal usage only
            makeArray: function makeArray(array, results) {
                var ret = results || [];

                if (array != null) {
                    // The window, strings (and functions) also have 'length'
                    // Tweaked logic slightly to handle Blackberry 4.7 RegExp issues #6930
                    var type = jQuery.type(array);

                    if (array.length == null || type === "string" || type === "function" || type === "regexp" || jQuery.isWindow(array)) {
                        push.call(ret, array);
                    } else {
                        jQuery.merge(ret, array);
                    }
                }

                return ret;
            },

            inArray: function inArray(elem, array, i) {
                var len;

                if (array) {
                    if (indexOf) {
                        return indexOf.call(array, elem, i);
                    }

                    len = array.length;
                    i = i ? i < 0 ? Math.max(0, len + i) : i : 0;

                    for (; i < len; i++) {
                        // Skip accessing in sparse arrays
                        if (i in array && array[i] === elem) {
                            return i;
                        }
                    }
                }

                return -1;
            },

            merge: function merge(first, second) {
                var i = first.length,
                    j = 0;

                if (typeof second.length === "number") {
                    for (var l = second.length; j < l; j++) {
                        first[i++] = second[j];
                    }
                } else {
                    while (second[j] !== undefined) {
                        first[i++] = second[j++];
                    }
                }

                first.length = i;

                return first;
            },

            grep: function grep(elems, callback, inv) {
                var ret = [],
                    retVal;
                inv = !!inv;

                // Go through the array, only saving the items
                // that pass the validator function
                for (var i = 0, length = elems.length; i < length; i++) {
                    retVal = !!callback(elems[i], i);
                    if (inv !== retVal) {
                        ret.push(elems[i]);
                    }
                }

                return ret;
            },

            // arg is for internal usage only
            map: function map(elems, callback, arg) {
                var value,
                    key,
                    ret = [],
                    i = 0,
                    length = elems.length,

                // jquery objects are treated as arrays
                isArray = elems instanceof jQuery || length !== undefined && typeof length === "number" && (length > 0 && elems[0] && elems[length - 1] || length === 0 || jQuery.isArray(elems));

                // Go through the array, translating each of the items to their
                if (isArray) {
                    for (; i < length; i++) {
                        value = callback(elems[i], i, arg);

                        if (value != null) {
                            ret[ret.length] = value;
                        }
                    }

                    // Go through every key on the object,
                } else {
                    for (key in elems) {
                        value = callback(elems[key], key, arg);

                        if (value != null) {
                            ret[ret.length] = value;
                        }
                    }
                }

                // Flatten any nested arrays
                return ret.concat.apply([], ret);
            },

            // A global GUID counter for objects
            guid: 1,

            // Bind a function to a context, optionally partially applying any
            // arguments.
            proxy: function proxy(fn, context) {
                if (typeof context === "string") {
                    var tmp = fn[context];
                    context = fn;
                    fn = tmp;
                }

                // Quick check to determine if target is callable, in the spec
                // this throws a TypeError, but we will just return undefined.
                if (!jQuery.isFunction(fn)) {
                    return undefined;
                }

                // Simulated bind
                var args = _slice.call(arguments, 2),
                    proxy = function proxy() {
                    return fn.apply(context, args.concat(_slice.call(arguments)));
                };

                // Set the guid of unique handler to the same of original handler, so it can be removed
                proxy.guid = fn.guid = fn.guid || proxy.guid || jQuery.guid++;

                return proxy;
            },

            // Mutifunctional method to get and set values to a collection
            // The value/s can optionally be executed if it's a function
            access: function access(elems, fn, key, value, chainable, emptyGet, pass) {
                var exec,
                    bulk = key == null,
                    i = 0,
                    length = elems.length;

                // Sets many values
                if (key && (typeof key === "undefined" ? "undefined" : (0, _typeof3.default)(key)) === "object") {
                    for (i in key) {
                        jQuery.access(elems, fn, i, key[i], 1, emptyGet, value);
                    }
                    chainable = 1;

                    // Sets one value
                } else if (value !== undefined) {
                    // Optionally, function values get executed if exec is true
                    exec = pass === undefined && jQuery.isFunction(value);

                    if (bulk) {
                        // Bulk operations only iterate when executing function values
                        if (exec) {
                            exec = fn;
                            fn = function fn(elem, key, value) {
                                return exec.call(jQuery(elem), value);
                            };

                            // Otherwise they run against the entire set
                        } else {
                            fn.call(elems, value);
                            fn = null;
                        }
                    }

                    if (fn) {
                        for (; i < length; i++) {
                            fn(elems[i], key, exec ? value.call(elems[i], i, fn(elems[i], key)) : value, pass);
                        }
                    }

                    chainable = 1;
                }

                return chainable ? elems :

                // Gets
                bulk ? fn.call(elems) : length ? fn(elems[0], key) : emptyGet;
            },

            now: function now() {
                return new Date().getTime();
            },

            // Use of jQuery.browser is frowned upon.
            // More details: http://docs.jquery.com/Utilities/jQuery.browser
            uaMatch: function uaMatch(ua) {
                ua = ua.toLowerCase();

                var match = rwebkit.exec(ua) || ropera.exec(ua) || rmsie.exec(ua) || ua.indexOf("compatible") < 0 && rmozilla.exec(ua) || [];

                return { browser: match[1] || "", version: match[2] || "0" };
            },

            sub: function sub() {
                function jQuerySub(selector, context) {
                    return new jQuerySub.fn.init(selector, context);
                }

                jQuery.extend(true, jQuerySub, this);
                jQuerySub.superclass = this;
                jQuerySub.fn = jQuerySub.prototype = this();
                jQuerySub.fn.constructor = jQuerySub;
                jQuerySub.sub = this.sub;
                jQuerySub.fn.init = function init(selector, context) {
                    if (context && context instanceof jQuery && !(context instanceof jQuerySub)) {
                        context = jQuerySub(context);
                    }

                    return jQuery.fn.init.call(this, selector, context, rootjQuerySub);
                };
                jQuerySub.fn.init.prototype = jQuerySub.fn;
                var rootjQuerySub = jQuerySub(document);
                return jQuerySub;
            },

            browser: {}
        });

        // Populate the class2type map
        jQuery.each("Boolean Number String Function Array Date RegExp Object".split(" "), function (i, name) {
            class2type["[object " + name + "]"] = name.toLowerCase();
        });

        browserMatch = jQuery.uaMatch(userAgent);
        if (browserMatch.browser) {
            jQuery.browser[browserMatch.browser] = true;
            jQuery.browser.version = browserMatch.version;
        }

        // Deprecated, use jQuery.browser.webkit instead
        if (jQuery.browser.webkit) {
            jQuery.browser.safari = true;
        }

        // IE doesn't match non-breaking spaces with \s
        if (rnotwhite.test("\xA0")) {
            trimLeft = /^[\s\xA0]+/;
            trimRight = /[\s\xA0]+$/;
        }

        // All jQuery objects should point back to these
        rootjQuery = jQuery(document);

        // Cleanup functions for the document ready method
        if (document.addEventListener) {
            _DOMContentLoaded2 = function DOMContentLoaded() {
                document.removeEventListener("DOMContentLoaded", _DOMContentLoaded2, false);
                jQuery.ready();
            };
        } else if (document.attachEvent) {
            _DOMContentLoaded2 = function _DOMContentLoaded() {
                // Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
                if (document.readyState === "complete") {
                    document.detachEvent("onreadystatechange", _DOMContentLoaded2);
                    jQuery.ready();
                }
            };
        }

        // The DOM ready check for Internet Explorer
        function doScrollCheck() {
            if (jQuery.isReady) {
                return;
            }

            try {
                // If IE is used, use the trick by Diego Perini
                // http://javascript.nwbox.com/IEContentLoaded/
                document.documentElement.doScroll("left");
            } catch (e) {
                setTimeout(doScrollCheck, 1);
                return;
            }

            // and execute any waiting functions
            jQuery.ready();
        }

        return jQuery;
    }();

    // String to Object flags format cache
    var flagsCache = {};

    // Convert String-formatted flags into Object-formatted ones and store in cache
    function createFlags(flags) {
        var object = flagsCache[flags] = {},
            i,
            length;
        flags = flags.split(/\s+/);
        for (i = 0, length = flags.length; i < length; i++) {
            object[flags[i]] = true;
        }
        return object;
    }

    /*
     * Create a callback list using the following parameters:
     *
     *	flags:	an optional list of space-separated flags that will change how
     *			the callback list behaves
     *
     * By default a callback list will act like an event callback list and can be
     * "fired" multiple times.
     *
     * Possible flags:
     *
     *	once:			will ensure the callback list can only be fired once (like a Deferred)
     *
     *	memory:			will keep track of previous values and will call any callback added
     *					after the list has been fired right away with the latest "memorized"
     *					values (like a Deferred)
     *
     *	unique:			will ensure a callback can only be added once (no duplicate in the list)
     *
     *	stopOnFalse:	interrupt callings when a callback returns false
     *
     */
    jQuery.Callbacks = function (flags) {

        // Convert flags from String-formatted to Object-formatted
        // (we check in cache first)
        flags = flags ? flagsCache[flags] || createFlags(flags) : {};

        var // Actual callback list
        list = [],

        // Stack of fire calls for repeatable lists
        stack = [],

        // Last fire value (for non-forgettable lists)
        memory,

        // Flag to know if list was already fired
        _fired,

        // Flag to know if list is currently firing
        firing,

        // First callback to fire (used internally by add and fireWith)
        firingStart,

        // End of the loop when firing
        firingLength,

        // Index of currently firing callback (modified by remove if needed)
        firingIndex,

        // Add one or several callbacks to the list
        _add = function _add(args) {
            var i, length, elem, type, actual;
            for (i = 0, length = args.length; i < length; i++) {
                elem = args[i];
                type = jQuery.type(elem);
                if (type === "array") {
                    // Inspect recursively
                    _add(elem);
                } else if (type === "function") {
                    // Add if not in unique mode and callback is not in
                    if (!flags.unique || !self.has(elem)) {
                        list.push(elem);
                    }
                }
            }
        },

        // Fire callbacks
        fire = function fire(context, args) {
            args = args || [];
            memory = !flags.memory || [context, args];
            _fired = true;
            firing = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            for (; list && firingIndex < firingLength; firingIndex++) {
                if (list[firingIndex].apply(context, args) === false && flags.stopOnFalse) {
                    memory = true; // Mark as halted
                    break;
                }
            }
            firing = false;
            if (list) {
                if (!flags.once) {
                    if (stack && stack.length) {
                        memory = stack.shift();
                        self.fireWith(memory[0], memory[1]);
                    }
                } else if (memory === true) {
                    self.disable();
                } else {
                    list = [];
                }
            }
        },

        // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    var length = list.length;
                    _add(arguments);
                    // Do we need to add the callbacks to the
                    // current firing batch?
                    if (firing) {
                        firingLength = list.length;
                        // With memory, if we're not firing then
                        // we should call right away, unless previous
                        // firing was halted (stopOnFalse)
                    } else if (memory && memory !== true) {
                        firingStart = length;
                        fire(memory[0], memory[1]);
                    }
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                if (list) {
                    var args = arguments,
                        argIndex = 0,
                        argLength = args.length;
                    for (; argIndex < argLength; argIndex++) {
                        for (var i = 0; i < list.length; i++) {
                            if (args[argIndex] === list[i]) {
                                // Handle firingIndex and firingLength
                                if (firing) {
                                    if (i <= firingLength) {
                                        firingLength--;
                                        if (i <= firingIndex) {
                                            firingIndex--;
                                        }
                                    }
                                }
                                // Remove the element
                                list.splice(i--, 1);
                                // If we have some unicity property then
                                // we only need to do this once
                                if (flags.unique) {
                                    break;
                                }
                            }
                        }
                    }
                }
                return this;
            },
            // Control if a given callback is in the list
            has: function has(fn) {
                if (list) {
                    var i = 0,
                        length = list.length;
                    for (; i < length; i++) {
                        if (fn === list[i]) {
                            return true;
                        }
                    }
                }
                return false;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                list = [];
                return this;
            },
            // Have the list do nothing anymore
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            // Is it disabled?
            disabled: function disabled() {
                return !list;
            },
            // Lock the list in its current state
            lock: function lock() {
                stack = undefined;
                if (!memory || memory === true) {
                    self.disable();
                }
                return this;
            },
            // Is it locked?
            locked: function locked() {
                return !stack;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                if (stack) {
                    if (firing) {
                        if (!flags.once) {
                            stack.push([context, args]);
                        }
                    } else if (!(flags.once && memory)) {
                        fire(context, args);
                    }
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired() {
                return !!_fired;
            }
        };

        return self;
    };

    var // Static reference to slice
    sliceDeferred = [].slice;

    jQuery.extend({

        Deferred: function Deferred(func) {
            var doneList = jQuery.Callbacks("once memory"),
                failList = jQuery.Callbacks("once memory"),
                progressList = jQuery.Callbacks("memory"),
                _state = "pending",
                lists = {
                resolve: doneList,
                reject: failList,
                notify: progressList
            },
                _promise = {
                done: doneList.add,
                fail: failList.add,
                progress: progressList.add,

                state: function state() {
                    return _state;
                },

                // Deprecated
                isResolved: doneList.fired,
                isRejected: failList.fired,

                then: function then(doneCallbacks, failCallbacks, progressCallbacks) {
                    deferred.done(doneCallbacks).fail(failCallbacks).progress(progressCallbacks);
                    return this;
                },
                always: function always() {
                    deferred.done.apply(deferred, arguments).fail.apply(deferred, arguments);
                    return this;
                },
                pipe: function pipe(fnDone, fnFail, fnProgress) {
                    return jQuery.Deferred(function (newDefer) {
                        jQuery.each({
                            done: [fnDone, "resolve"],
                            fail: [fnFail, "reject"],
                            progress: [fnProgress, "notify"]
                        }, function (handler, data) {
                            var fn = data[0],
                                action = data[1],
                                returned;
                            if (jQuery.isFunction(fn)) {
                                deferred[handler](function () {
                                    returned = fn.apply(this, arguments);
                                    if (returned && jQuery.isFunction(returned.promise)) {
                                        returned.promise().then(newDefer.resolve, newDefer.reject, newDefer.notify);
                                    } else {
                                        newDefer[action + "With"](this === deferred ? newDefer : this, [returned]);
                                    }
                                });
                            } else {
                                deferred[handler](newDefer[action]);
                            }
                        });
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function promise(obj) {
                    if (obj == null) {
                        obj = _promise;
                    } else {
                        for (var key in _promise) {
                            obj[key] = _promise[key];
                        }
                    }
                    return obj;
                }
            },
                deferred = _promise.promise({}),
                key;

            for (key in lists) {
                deferred[key] = lists[key].fire;
                deferred[key + "With"] = lists[key].fireWith;
            }

            // Handle state
            deferred.done(function () {
                _state = "resolved";
            }, failList.disable, progressList.lock).fail(function () {
                _state = "rejected";
            }, doneList.disable, progressList.lock);

            // Call given func if any
            if (func) {
                func.call(deferred, deferred);
            }

            // All done!
            return deferred;
        },

        // Deferred helper
        when: function when(firstParam) {
            var args = sliceDeferred.call(arguments, 0),
                i = 0,
                length = args.length,
                pValues = new Array(length),
                count = length,
                pCount = length,
                deferred = length <= 1 && firstParam && jQuery.isFunction(firstParam.promise) ? firstParam : jQuery.Deferred(),
                promise = deferred.promise();

            function resolveFunc(i) {
                return function (value) {
                    args[i] = arguments.length > 1 ? sliceDeferred.call(arguments, 0) : value;
                    if (! --count) {
                        deferred.resolveWith(deferred, args);
                    }
                };
            }

            function progressFunc(i) {
                return function (value) {
                    pValues[i] = arguments.length > 1 ? sliceDeferred.call(arguments, 0) : value;
                    deferred.notifyWith(promise, pValues);
                };
            }

            if (length > 1) {
                for (; i < length; i++) {
                    if (args[i] && args[i].promise && jQuery.isFunction(args[i].promise)) {
                        args[i].promise().then(resolveFunc(i), deferred.reject, progressFunc(i));
                    } else {
                        --count;
                    }
                }
                if (!count) {
                    deferred.resolveWith(deferred, args);
                }
            } else if (deferred !== firstParam) {
                deferred.resolveWith(deferred, length ? [firstParam] : []);
            }
            return promise;
        }
    });

    jQuery.support = function () {

        var support,
            all,
            a,
            select,
            opt,
            input,
            fragment,
            tds,
            events,
            eventName,
            i,
            isSupported,
            div = document.createElement("div"),
            documentElement = document.documentElement;

        // Preliminary tests
        div.setAttribute("className", "t");
        div.innerHTML = "   <link/><table></table><a href='/a' style='top:1px;float:left;opacity:.55;'>a</a><input type='checkbox'/>";

        all = div.getElementsByTagName("*");
        a = div.getElementsByTagName("a")[0];

        // Can't get basic test support
        if (!all || !all.length || !a) {
            return {};
        }

        // First batch of supports tests
        select = document.createElement("select");
        opt = select.appendChild(document.createElement("option"));
        input = div.getElementsByTagName("input")[0];

        support = {
            // IE strips leading whitespace when .innerHTML is used
            leadingWhitespace: div.firstChild.nodeType === 3,

            // Make sure that tbody elements aren't automatically inserted
            // IE will insert them into empty tables
            tbody: !div.getElementsByTagName("tbody").length,

            // Make sure that link elements get serialized correctly by innerHTML
            // This requires a wrapper element in IE
            htmlSerialize: !!div.getElementsByTagName("link").length,

            // Get the style information from getAttribute
            // (IE uses .cssText instead)
            style: /top/.test(a.getAttribute("style")),

            // Make sure that URLs aren't manipulated
            // (IE normalizes it by default)
            hrefNormalized: a.getAttribute("href") === "/a",

            // Make sure that element opacity exists
            // (IE uses filter instead)
            // Use a regex to work around a WebKit issue. See #5145
            opacity: /^0.55/.test(a.style.opacity),

            // Verify style float existence
            // (IE uses styleFloat instead of cssFloat)
            cssFloat: !!a.style.cssFloat,

            // Make sure that if no value is specified for a checkbox
            // that it defaults to "on".
            // (WebKit defaults to "" instead)
            checkOn: input.value === "on",

            // Make sure that a selected-by-default option has a working selected property.
            // (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
            optSelected: opt.selected,

            // Test setAttribute on camelCase class. If it works, we need attrFixes when doing get/setAttribute (ie6/7)
            getSetAttribute: div.className !== "t",

            // Tests for enctype support on a form(#6743)
            enctype: !!document.createElement("form").enctype,

            // Makes sure cloning an html5 element does not cause problems
            // Where outerHTML is undefined, this still works
            html5Clone: document.createElement("nav").cloneNode(true).outerHTML !== "<:nav></:nav>",

            // Will be defined later
            submitBubbles: true,
            changeBubbles: true,
            focusinBubbles: false,
            deleteExpando: true,
            noCloneEvent: true,
            inlineBlockNeedsLayout: false,
            shrinkWrapBlocks: false,
            reliableMarginRight: true,
            pixelMargin: true
        };

        // jQuery.boxModel DEPRECATED in 1.3, use jQuery.support.boxModel instead
        jQuery.boxModel = support.boxModel = document.compatMode === "CSS1Compat";

        // Make sure checked status is properly cloned
        input.checked = true;
        support.noCloneChecked = input.cloneNode(true).checked;

        // Make sure that the options inside disabled selects aren't marked as disabled
        // (WebKit marks them as disabled)
        select.disabled = true;
        support.optDisabled = !opt.disabled;

        // Test to see if it's possible to delete an expando from an element
        // Fails in Internet Explorer
        try {
            delete div.test;
        } catch (e) {
            support.deleteExpando = false;
        }

        if (!div.addEventListener && div.attachEvent && div.fireEvent) {
            div.attachEvent("onclick", function () {
                // Cloning a node shouldn't copy over any
                // bound event handlers (IE does this)
                support.noCloneEvent = false;
            });
            div.cloneNode(true).fireEvent("onclick");
        }

        // Check if a radio maintains its value
        // after being appended to the DOM
        input = document.createElement("input");
        input.value = "t";
        input.setAttribute("type", "radio");
        support.radioValue = input.value === "t";

        input.setAttribute("checked", "checked");

        // #11217 - WebKit loses check when the name is after the checked attribute
        input.setAttribute("name", "t");

        div.appendChild(input);
        fragment = document.createDocumentFragment();
        fragment.appendChild(div.lastChild);

        // WebKit doesn't clone checked state correctly in fragments
        support.checkClone = fragment.cloneNode(true).cloneNode(true).lastChild.checked;

        // Check if a disconnected checkbox will retain its checked
        // value of true after appended to the DOM (IE6/7)
        support.appendChecked = input.checked;

        fragment.removeChild(input);
        fragment.appendChild(div);

        // Technique from Juriy Zaytsev
        // http://perfectionkills.com/detecting-event-support-without-browser-sniffing/
        // We only care about the case where non-standard event systems
        // are used, namely in IE. Short-circuiting here helps us to
        // avoid an eval call (in setAttribute) which can cause CSP
        // to go haywire. See: https://developer.mozilla.org/en/Security/CSP
        if (div.attachEvent) {
            for (i in {
                submit: 1,
                change: 1,
                focusin: 1
            }) {
                eventName = "on" + i;
                isSupported = eventName in div;
                if (!isSupported) {
                    div.setAttribute(eventName, "return;");
                    isSupported = typeof div[eventName] === "function";
                }
                support[i + "Bubbles"] = isSupported;
            }
        }

        fragment.removeChild(div);

        // Null elements to avoid leaks in IE
        fragment = select = opt = div = input = null;

        // Run tests that need a body at doc ready
        jQuery(function () {
            var container,
                outer,
                inner,
                table,
                td,
                offsetSupport,
                marginDiv,
                conMarginTop,
                style,
                html,
                positionTopLeftWidthHeight,
                paddingMarginBorderVisibility,
                paddingMarginBorder,
                body = document.getElementsByTagName("body")[0];

            if (!body) {
                // Return for frameset docs that don't have a body
                return;
            }

            conMarginTop = 1;
            paddingMarginBorder = "padding:0;margin:0;border:";
            positionTopLeftWidthHeight = "position:absolute;top:0;left:0;width:1px;height:1px;";
            paddingMarginBorderVisibility = paddingMarginBorder + "0;visibility:hidden;";
            style = "style='" + positionTopLeftWidthHeight + paddingMarginBorder + "5px solid #000;";
            html = "<div " + style + "display:block;'><div style='" + paddingMarginBorder + "0;display:block;overflow:hidden;'></div></div>" + "<table " + style + "' cellpadding='0' cellspacing='0'>" + "<tr><td></td></tr></table>";

            container = document.createElement("div");
            container.style.cssText = paddingMarginBorderVisibility + "width:0;height:0;position:static;top:0;margin-top:" + conMarginTop + "px";
            body.insertBefore(container, body.firstChild);

            // Construct the test element
            div = document.createElement("div");
            container.appendChild(div);

            // Check if table cells still have offsetWidth/Height when they are set
            // to display:none and there are still other visible table cells in a
            // table row; if so, offsetWidth/Height are not reliable for use when
            // determining if an element has been hidden directly using
            // display:none (it is still safe to use offsets if a parent element is
            // hidden; don safety goggles and see bug #4512 for more information).
            // (only IE 8 fails this test)
            div.innerHTML = "<table><tr><td style='" + paddingMarginBorder + "0;display:none'></td><td>t</td></tr></table>";
            tds = div.getElementsByTagName("td");
            isSupported = tds[0].offsetHeight === 0;

            tds[0].style.display = "";
            tds[1].style.display = "none";

            // Check if empty table cells still have offsetWidth/Height
            // (IE <= 8 fail this test)
            support.reliableHiddenOffsets = isSupported && tds[0].offsetHeight === 0;

            // Check if div with explicit width and no margin-right incorrectly
            // gets computed margin-right based on width of container. For more
            // info see bug #3333
            // Fails in WebKit before Feb 2011 nightlies
            // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
            if (window.getComputedStyle) {
                div.innerHTML = "";
                marginDiv = document.createElement("div");
                marginDiv.style.width = "0";
                marginDiv.style.marginRight = "0";
                div.style.width = "2px";
                div.appendChild(marginDiv);
                support.reliableMarginRight = (parseInt((window.getComputedStyle(marginDiv, null) || { marginRight: 0 }).marginRight, 10) || 0) === 0;
            }

            if (typeof div.style.zoom !== "undefined") {
                // Check if natively block-level elements act like inline-block
                // elements when setting their display to 'inline' and giving
                // them layout
                // (IE < 8 does this)
                div.innerHTML = "";
                div.style.width = div.style.padding = "1px";
                div.style.border = 0;
                div.style.overflow = "hidden";
                div.style.display = "inline";
                div.style.zoom = 1;
                support.inlineBlockNeedsLayout = div.offsetWidth === 3;

                // Check if elements with layout shrink-wrap their children
                // (IE 6 does this)
                div.style.display = "block";
                div.style.overflow = "visible";
                div.innerHTML = "<div style='width:5px;'></div>";
                support.shrinkWrapBlocks = div.offsetWidth !== 3;
            }

            div.style.cssText = positionTopLeftWidthHeight + paddingMarginBorderVisibility;
            div.innerHTML = html;

            outer = div.firstChild;
            inner = outer.firstChild;
            td = outer.nextSibling.firstChild.firstChild;

            offsetSupport = {
                doesNotAddBorder: inner.offsetTop !== 5,
                doesAddBorderForTableAndCells: td.offsetTop === 5
            };

            inner.style.position = "fixed";
            inner.style.top = "20px";

            // safari subtracts parent border width here which is 5px
            offsetSupport.fixedPosition = inner.offsetTop === 20 || inner.offsetTop === 15;
            inner.style.position = inner.style.top = "";

            outer.style.overflow = "hidden";
            outer.style.position = "relative";

            offsetSupport.subtractsBorderForOverflowNotVisible = inner.offsetTop === -5;
            offsetSupport.doesNotIncludeMarginInBodyOffset = body.offsetTop !== conMarginTop;

            if (window.getComputedStyle) {
                div.style.marginTop = "1%";
                support.pixelMargin = (window.getComputedStyle(div, null) || { marginTop: 0 }).marginTop !== "1%";
            }

            if (typeof container.style.zoom !== "undefined") {
                container.style.zoom = 1;
            }

            body.removeChild(container);
            marginDiv = div = container = null;

            jQuery.extend(support, offsetSupport);
        });

        return support;
    }();

    var rbrace = /^(?:\{.*\}|\[.*\])$/,
        rmultiDash = /([A-Z])/g;

    jQuery.extend({
        cache: {},

        // Please use with caution
        uuid: 0,

        // Unique for each copy of jQuery on the page
        // Non-digits removed to match rinlinejQuery
        expando: "jQuery" + (jQuery.fn.jquery + Math.random()).replace(/\D/g, ""),

        // The following elements throw uncatchable exceptions if you
        // attempt to add expando properties to them.
        noData: {
            "embed": true,
            // Ban all objects except for Flash (which handle expandos)
            "object": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
            "applet": true
        },

        hasData: function hasData(elem) {
            elem = elem.nodeType ? jQuery.cache[elem[jQuery.expando]] : elem[jQuery.expando];
            return !!elem && !isEmptyDataObject(elem);
        },

        data: function data(elem, name, _data, pvt /* Internal Use Only */) {
            if (!jQuery.acceptData(elem)) {
                return;
            }

            var privateCache,
                thisCache,
                ret,
                internalKey = jQuery.expando,
                getByName = typeof name === "string",


            // We have to handle DOM nodes and JS objects differently because IE6-7
            // can't GC object references properly across the DOM-JS boundary
            isNode = elem.nodeType,


            // Only DOM nodes need the global jQuery cache; JS object data is
            // attached directly to the object so GC can occur automatically
            cache = isNode ? jQuery.cache : elem,


            // Only defining an ID for JS objects if its cache already exists allows
            // the code to shortcut on the same path as a DOM node with no cache
            id = isNode ? elem[internalKey] : elem[internalKey] && internalKey,
                isEvents = name === "events";

            // Avoid doing any more work than we need to when trying to get data on an
            // object that has no data at all
            if ((!id || !cache[id] || !isEvents && !pvt && !cache[id].data) && getByName && _data === undefined) {
                return;
            }

            if (!id) {
                // Only DOM nodes need a new unique ID for each element since their data
                // ends up in the global cache
                if (isNode) {
                    elem[internalKey] = id = ++jQuery.uuid;
                } else {
                    id = internalKey;
                }
            }

            if (!cache[id]) {
                cache[id] = {};

                // Avoids exposing jQuery metadata on plain JS objects when the object
                // is serialized using JSON.stringify
                if (!isNode) {
                    cache[id].toJSON = jQuery.noop;
                }
            }

            // An object can be passed to jQuery.data instead of a key/value pair; this gets
            // shallow copied over onto the existing cache
            if ((typeof name === "undefined" ? "undefined" : (0, _typeof3.default)(name)) === "object" || typeof name === "function") {
                if (pvt) {
                    cache[id] = jQuery.extend(cache[id], name);
                } else {
                    cache[id].data = jQuery.extend(cache[id].data, name);
                }
            }

            privateCache = thisCache = cache[id];

            // jQuery data() is stored in a separate object inside the object's internal data
            // cache in order to avoid key collisions between internal data and user-defined
            // data.
            if (!pvt) {
                if (!thisCache.data) {
                    thisCache.data = {};
                }

                thisCache = thisCache.data;
            }

            if (_data !== undefined) {
                thisCache[jQuery.camelCase(name)] = _data;
            }

            // Users should not attempt to inspect the internal events object using jQuery.data,
            // it is undocumented and subject to change. But does anyone listen? No.
            if (isEvents && !thisCache[name]) {
                return privateCache.events;
            }

            // Check for both converted-to-camel and non-converted data property names
            // If a data property was specified
            if (getByName) {

                // First Try to find as-is property data
                ret = thisCache[name];

                // Test for null|undefined property data
                if (ret == null) {

                    // Try to find the camelCased property
                    ret = thisCache[jQuery.camelCase(name)];
                }
            } else {
                ret = thisCache;
            }

            return ret;
        },

        removeData: function removeData(elem, name, pvt /* Internal Use Only */) {
            if (!jQuery.acceptData(elem)) {
                return;
            }

            var thisCache,
                i,
                l,


            // Reference to internal data cache key
            internalKey = jQuery.expando,
                isNode = elem.nodeType,


            // See jQuery.data for more information
            cache = isNode ? jQuery.cache : elem,


            // See jQuery.data for more information
            id = isNode ? elem[internalKey] : internalKey;

            // If there is already no cache entry for this object, there is no
            // purpose in continuing
            if (!cache[id]) {
                return;
            }

            if (name) {

                thisCache = pvt ? cache[id] : cache[id].data;

                if (thisCache) {

                    // Support array or space separated string names for data keys
                    if (!jQuery.isArray(name)) {

                        // try the string as a key before any manipulation
                        if (name in thisCache) {
                            name = [name];
                        } else {

                            // split the camel cased version by spaces unless a key with the spaces exists
                            name = jQuery.camelCase(name);
                            if (name in thisCache) {
                                name = [name];
                            } else {
                                name = name.split(" ");
                            }
                        }
                    }

                    for (i = 0, l = name.length; i < l; i++) {
                        delete thisCache[name[i]];
                    }

                    // If there is no data left in the cache, we want to continue
                    // and let the cache object itself get destroyed
                    if (!(pvt ? isEmptyDataObject : jQuery.isEmptyObject)(thisCache)) {
                        return;
                    }
                }
            }

            // See jQuery.data for more information
            if (!pvt) {
                delete cache[id].data;

                // Don't destroy the parent cache unless the internal data object
                // had been the only thing left in it
                if (!isEmptyDataObject(cache[id])) {
                    return;
                }
            }

            // Browsers that fail expando deletion also refuse to delete expandos on
            // the window, but it will allow it on all other JS objects; other browsers
            // don't care
            // Ensure that `cache` is not a window object #10080
            if (jQuery.support.deleteExpando || !cache.setInterval) {
                delete cache[id];
            } else {
                cache[id] = null;
            }

            // We destroyed the cache and need to eliminate the expando on the node to avoid
            // false lookups in the cache for entries that no longer exist
            if (isNode) {
                // IE does not allow us to delete expando properties from nodes,
                // nor does it have a removeAttribute function on Document nodes;
                // we must handle all of these cases
                if (jQuery.support.deleteExpando) {
                    delete elem[internalKey];
                } else if (elem.removeAttribute) {
                    elem.removeAttribute(internalKey);
                } else {
                    elem[internalKey] = null;
                }
            }
        },

        // For internal use only.
        _data: function _data(elem, name, data) {
            return jQuery.data(elem, name, data, true);
        },

        // A method for determining if a DOM node can handle the data expando
        acceptData: function acceptData(elem) {
            if (elem.nodeName) {
                var match = jQuery.noData[elem.nodeName.toLowerCase()];

                if (match) {
                    return !(match === true || elem.getAttribute("classid") !== match);
                }
            }

            return true;
        }
    });

    jQuery.fn.extend({
        data: function data(key, value) {
            var parts,
                part,
                attr,
                name,
                l,
                elem = this[0],
                i = 0,
                data = null;

            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = jQuery.data(elem);

                    if (elem.nodeType === 1 && !jQuery._data(elem, "parsedAttrs")) {
                        attr = elem.attributes;
                        for (l = attr.length; i < l; i++) {
                            name = attr[i].name;

                            if (name.indexOf("data-") === 0) {
                                name = jQuery.camelCase(name.substring(5));

                                dataAttr(elem, name, data[name]);
                            }
                        }
                        jQuery._data(elem, "parsedAttrs", true);
                    }
                }

                return data;
            }

            // Sets multiple values
            if ((typeof key === "undefined" ? "undefined" : (0, _typeof3.default)(key)) === "object") {
                return this.each(function () {
                    jQuery.data(this, key);
                });
            }

            parts = key.split(".", 2);
            parts[1] = parts[1] ? "." + parts[1] : "";
            part = parts[1] + "!";

            return jQuery.access(this, function (value) {

                if (value === undefined) {
                    data = this.triggerHandler("getData" + part, [parts[0]]);

                    // Try to fetch any internally stored data first
                    if (data === undefined && elem) {
                        data = jQuery.data(elem, key);
                        data = dataAttr(elem, key, data);
                    }

                    return data === undefined && parts[1] ? this.data(parts[0]) : data;
                }

                parts[1] = value;
                this.each(function () {
                    var self = jQuery(this);

                    self.triggerHandler("setData" + part, parts);
                    jQuery.data(this, key, value);
                    self.triggerHandler("changeData" + part, parts);
                });
            }, null, value, arguments.length > 1, null, false);
        },

        removeData: function removeData(key) {
            return this.each(function () {
                jQuery.removeData(this, key);
            });
        }
    });

    function dataAttr(elem, key, data) {
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {

            var name = "data-" + key.replace(rmultiDash, "-$1").toLowerCase();

            data = elem.getAttribute(name);

            if (typeof data === "string") {
                try {
                    data = data === "true" ? true : data === "false" ? false : data === "null" ? null : jQuery.isNumeric(data) ? +data : rbrace.test(data) ? jQuery.parseJSON(data) : data;
                } catch (e) {}

                // Make sure we set the data so it isn't changed later
                jQuery.data(elem, key, data);
            } else {
                data = undefined;
            }
        }

        return data;
    }

    // checks a cache object for emptiness
    function isEmptyDataObject(obj) {
        for (var name in obj) {

            // if the public data object is empty, the private is still empty
            if (name === "data" && jQuery.isEmptyObject(obj[name])) {
                continue;
            }
            if (name !== "toJSON") {
                return false;
            }
        }

        return true;
    }

    function handleQueueMarkDefer(elem, type, src) {
        var deferDataKey = type + "defer",
            queueDataKey = type + "queue",
            markDataKey = type + "mark",
            defer = jQuery._data(elem, deferDataKey);
        if (defer && (src === "queue" || !jQuery._data(elem, queueDataKey)) && (src === "mark" || !jQuery._data(elem, markDataKey))) {
            // Give room for hard-coded callbacks to fire first
            // and eventually mark/queue something else on the element
            setTimeout(function () {
                if (!jQuery._data(elem, queueDataKey) && !jQuery._data(elem, markDataKey)) {
                    jQuery.removeData(elem, deferDataKey, true);
                    defer.fire();
                }
            }, 0);
        }
    }

    jQuery.extend({

        _mark: function _mark(elem, type) {
            if (elem) {
                type = (type || "fx") + "mark";
                jQuery._data(elem, type, (jQuery._data(elem, type) || 0) + 1);
            }
        },

        _unmark: function _unmark(force, elem, type) {
            if (force !== true) {
                type = elem;
                elem = force;
                force = false;
            }
            if (elem) {
                type = type || "fx";
                var key = type + "mark",
                    count = force ? 0 : (jQuery._data(elem, key) || 1) - 1;
                if (count) {
                    jQuery._data(elem, key, count);
                } else {
                    jQuery.removeData(elem, key, true);
                    handleQueueMarkDefer(elem, type, "mark");
                }
            }
        },

        queue: function queue(elem, type, data) {
            var q;
            if (elem) {
                type = (type || "fx") + "queue";
                q = jQuery._data(elem, type);

                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!q || jQuery.isArray(data)) {
                        q = jQuery._data(elem, type, jQuery.makeArray(data));
                    } else {
                        q.push(data);
                    }
                }
                return q || [];
            }
        },

        dequeue: function dequeue(elem, type) {
            type = type || "fx";

            var queue = jQuery.queue(elem, type),
                fn = queue.shift(),
                hooks = {};

            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
            }

            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") {
                    queue.unshift("inprogress");
                }

                jQuery._data(elem, type + ".run", hooks);
                fn.call(elem, function () {
                    jQuery.dequeue(elem, type);
                }, hooks);
            }

            if (!queue.length) {
                jQuery.removeData(elem, type + "queue " + type + ".run", true);
                handleQueueMarkDefer(elem, type, "queue");
            }
        }
    });

    jQuery.fn.extend({
        queue: function queue(type, data) {
            var setter = 2;

            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }

            if (arguments.length < setter) {
                return jQuery.queue(this[0], type);
            }

            return data === undefined ? this : this.each(function () {
                var queue = jQuery.queue(this, type, data);

                if (type === "fx" && queue[0] !== "inprogress") {
                    jQuery.dequeue(this, type);
                }
            });
        },
        dequeue: function dequeue(type) {
            return this.each(function () {
                jQuery.dequeue(this, type);
            });
        },
        // Based off of the plugin by Clint Helfers, with permission.
        // http://blindsignals.com/index.php/2009/07/jquery-delay/
        delay: function delay(time, type) {
            time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
            type = type || "fx";

            return this.queue(type, function (next, hooks) {
                var timeout = setTimeout(next, time);
                hooks.stop = function () {
                    clearTimeout(timeout);
                };
            });
        },
        clearQueue: function clearQueue(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function promise(type, object) {
            if (typeof type !== "string") {
                object = type;
                type = undefined;
            }
            type = type || "fx";
            var defer = jQuery.Deferred(),
                elements = this,
                i = elements.length,
                count = 1,
                deferDataKey = type + "defer",
                queueDataKey = type + "queue",
                markDataKey = type + "mark",
                tmp;

            function resolve() {
                if (! --count) {
                    defer.resolveWith(elements, [elements]);
                }
            }

            while (i--) {
                if (tmp = jQuery.data(elements[i], deferDataKey, undefined, true) || (jQuery.data(elements[i], queueDataKey, undefined, true) || jQuery.data(elements[i], markDataKey, undefined, true)) && jQuery.data(elements[i], deferDataKey, jQuery.Callbacks("once memory"), true)) {
                    count++;
                    tmp.add(resolve);
                }
            }
            resolve();
            return defer.promise(object);
        }
    });

    var rclass = /[\n\t\r]/g,
        rspace = /\s+/,
        rreturn = /\r/g,
        rtype = /^(?:button|input)$/i,
        rfocusable = /^(?:button|input|object|select|textarea)$/i,
        rclickable = /^a(?:rea)?$/i,
        rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
        getSetAttribute = jQuery.support.getSetAttribute,
        nodeHook,
        boolHook,
        fixSpecified;

    jQuery.fn.extend({
        attr: function attr(name, value) {
            return jQuery.access(this, jQuery.attr, name, value, arguments.length > 1);
        },

        removeAttr: function removeAttr(name) {
            return this.each(function () {
                jQuery.removeAttr(this, name);
            });
        },

        prop: function prop(name, value) {
            return jQuery.access(this, jQuery.prop, name, value, arguments.length > 1);
        },

        removeProp: function removeProp(name) {
            name = jQuery.propFix[name] || name;
            return this.each(function () {
                // try/catch handles cases where IE balks (such as removing a property on window)
                try {
                    this[name] = undefined;
                    delete this[name];
                } catch (e) {}
            });
        },

        addClass: function addClass(value) {
            var classNames, i, l, elem, setClass, c, cl;

            if (jQuery.isFunction(value)) {
                return this.each(function (j) {
                    jQuery(this).addClass(value.call(this, j, this.className));
                });
            }

            if (value && typeof value === "string") {
                classNames = value.split(rspace);

                for (i = 0, l = this.length; i < l; i++) {
                    elem = this[i];

                    if (elem.nodeType === 1) {
                        if (!elem.className && classNames.length === 1) {
                            elem.className = value;
                        } else {
                            setClass = " " + elem.className + " ";

                            for (c = 0, cl = classNames.length; c < cl; c++) {
                                if (!~setClass.indexOf(" " + classNames[c] + " ")) {
                                    setClass += classNames[c] + " ";
                                }
                            }
                            elem.className = jQuery.trim(setClass);
                        }
                    }
                }
            }

            return this;
        },

        removeClass: function removeClass(value) {
            var classNames, i, l, elem, className, c, cl;

            if (jQuery.isFunction(value)) {
                return this.each(function (j) {
                    jQuery(this).removeClass(value.call(this, j, this.className));
                });
            }

            if (value && typeof value === "string" || value === undefined) {
                classNames = (value || "").split(rspace);

                for (i = 0, l = this.length; i < l; i++) {
                    elem = this[i];

                    if (elem.nodeType === 1 && elem.className) {
                        if (value) {
                            className = (" " + elem.className + " ").replace(rclass, " ");
                            for (c = 0, cl = classNames.length; c < cl; c++) {
                                className = className.replace(" " + classNames[c] + " ", " ");
                            }
                            elem.className = jQuery.trim(className);
                        } else {
                            elem.className = "";
                        }
                    }
                }
            }

            return this;
        },

        toggleClass: function toggleClass(value, stateVal) {
            var type = typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value),
                isBool = typeof stateVal === "boolean";

            if (jQuery.isFunction(value)) {
                return this.each(function (i) {
                    jQuery(this).toggleClass(value.call(this, i, this.className, stateVal), stateVal);
                });
            }

            return this.each(function () {
                if (type === "string") {
                    // toggle individual class names
                    var className,
                        i = 0,
                        self = jQuery(this),
                        state = stateVal,
                        classNames = value.split(rspace);

                    while (className = classNames[i++]) {
                        // check each className given, space seperated list
                        state = isBool ? state : !self.hasClass(className);
                        self[state ? "addClass" : "removeClass"](className);
                    }
                } else if (type === "undefined" || type === "boolean") {
                    if (this.className) {
                        // store className if set
                        jQuery._data(this, "__className__", this.className);
                    }

                    // toggle whole className
                    this.className = this.className || value === false ? "" : jQuery._data(this, "__className__") || "";
                }
            });
        },

        hasClass: function hasClass(selector) {
            var className = " " + selector + " ",
                i = 0,
                l = this.length;
            for (; i < l; i++) {
                if (this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf(className) > -1) {
                    return true;
                }
            }

            return false;
        },

        val: function val(value) {
            var hooks,
                ret,
                isFunction,
                elem = this[0];

            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];

                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
                        return ret;
                    }

                    ret = elem.value;

                    return typeof ret === "string" ?
                    // handle most common string cases
                    ret.replace(rreturn, "") :
                    // handle cases where value is null/undef or number
                    ret == null ? "" : ret;
                }

                return;
            }

            isFunction = jQuery.isFunction(value);

            return this.each(function (i) {
                var self = jQuery(this),
                    val;

                if (this.nodeType !== 1) {
                    return;
                }

                if (isFunction) {
                    val = value.call(this, i, self.val());
                } else {
                    val = value;
                }

                // Treat null/undefined as ""; convert numbers to string
                if (val == null) {
                    val = "";
                } else if (typeof val === "number") {
                    val += "";
                } else if (jQuery.isArray(val)) {
                    val = jQuery.map(val, function (value) {
                        return value == null ? "" : value + "";
                    });
                }

                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
                    this.value = val;
                }
            });
        }
    });

    jQuery.extend({
        valHooks: {
            option: {
                get: function get(elem) {
                    // attributes.value is undefined in Blackberry 4.7 but
                    // uses .value. See #6932
                    var val = elem.attributes.value;
                    return !val || val.specified ? elem.value : elem.text;
                }
            },
            select: {
                get: function get(elem) {
                    var value,
                        i,
                        max,
                        option,
                        index = elem.selectedIndex,
                        values = [],
                        options = elem.options,
                        one = elem.type === "select-one";

                    // Nothing was selected
                    if (index < 0) {
                        return null;
                    }

                    // Loop through all the selected options
                    i = one ? index : 0;
                    max = one ? index + 1 : options.length;
                    for (; i < max; i++) {
                        option = options[i];

                        // Don't return options that are disabled or in a disabled optgroup
                        if (option.selected && (jQuery.support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null) && (!option.parentNode.disabled || !jQuery.nodeName(option.parentNode, "optgroup"))) {

                            // Get the specific value for the option
                            value = jQuery(option).val();

                            // We don't need an array for one selects
                            if (one) {
                                return value;
                            }

                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }

                    // Fixes Bug #2551 -- select.val() broken in IE after form.reset()
                    if (one && !values.length && options.length) {
                        return jQuery(options[index]).val();
                    }

                    return values;
                },

                set: function set(elem, value) {
                    var values = jQuery.makeArray(value);

                    jQuery(elem).find("option").each(function () {
                        this.selected = jQuery.inArray(jQuery(this).val(), values) >= 0;
                    });

                    if (!values.length) {
                        elem.selectedIndex = -1;
                    }
                    return values;
                }
            }
        },

        attrFn: {
            val: true,
            css: true,
            html: true,
            text: true,
            data: true,
            width: true,
            height: true,
            offset: true
        },

        attr: function attr(elem, name, value, pass) {
            var ret,
                hooks,
                notxml,
                nType = elem.nodeType;

            // don't get/set attributes on text, comment and attribute nodes
            if (!elem || nType === 3 || nType === 8 || nType === 2) {
                return;
            }

            if (pass && name in jQuery.attrFn) {
                return jQuery(elem)[name](value);
            }

            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") {
                return jQuery.prop(elem, name, value);
            }

            notxml = nType !== 1 || !jQuery.isXMLDoc(elem);

            // All attributes are lowercase
            // Grab necessary hook if one is defined
            if (notxml) {
                name = name.toLowerCase();
                hooks = jQuery.attrHooks[name] || (rboolean.test(name) ? boolHook : nodeHook);
            }

            if (value !== undefined) {

                if (value === null) {
                    jQuery.removeAttr(elem, name);
                } else if (hooks && "set" in hooks && notxml && (ret = hooks.set(elem, value, name)) !== undefined) {
                    return ret;
                } else {
                    elem.setAttribute(name, "" + value);
                    return value;
                }
            } else if (hooks && "get" in hooks && notxml && (ret = hooks.get(elem, name)) !== null) {
                return ret;
            } else {

                ret = elem.getAttribute(name);

                // Non-existent attributes return null, we normalize to undefined
                return ret === null ? undefined : ret;
            }
        },

        removeAttr: function removeAttr(elem, value) {
            var propName,
                attrNames,
                name,
                l,
                isBool,
                i = 0;

            if (value && elem.nodeType === 1) {
                attrNames = value.toLowerCase().split(rspace);
                l = attrNames.length;

                for (; i < l; i++) {
                    name = attrNames[i];

                    if (name) {
                        propName = jQuery.propFix[name] || name;
                        isBool = rboolean.test(name);

                        // See #9699 for explanation of this approach (setting first, then removal)
                        // Do not do this for boolean attributes (see #10870)
                        if (!isBool) {
                            jQuery.attr(elem, name, "");
                        }
                        elem.removeAttribute(getSetAttribute ? name : propName);

                        // Set corresponding property to false for boolean attributes
                        if (isBool && propName in elem) {
                            elem[propName] = false;
                        }
                    }
                }
            }
        },

        attrHooks: {
            type: {
                set: function set(elem, value) {
                    // We can't allow the type property to be changed (since it causes problems in IE)
                    if (rtype.test(elem.nodeName) && elem.parentNode) {
                        jQuery.error("type property can't be changed");
                    } else if (!jQuery.support.radioValue && value === "radio" && jQuery.nodeName(elem, "input")) {
                        // Setting the type on a radio button after the value resets the value in IE6-9
                        // Reset value to it's default in case type is set after value
                        // This is for element creation
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) {
                            elem.value = val;
                        }
                        return value;
                    }
                }
            },
            // Use the value property for back compat
            // Use the nodeHook for button elements in IE6/7 (#1954)
            value: {
                get: function get(elem, name) {
                    if (nodeHook && jQuery.nodeName(elem, "button")) {
                        return nodeHook.get(elem, name);
                    }
                    return name in elem ? elem.value : null;
                },
                set: function set(elem, value, name) {
                    if (nodeHook && jQuery.nodeName(elem, "button")) {
                        return nodeHook.set(elem, value, name);
                    }
                    // Does not return so that setAttribute is also used
                    elem.value = value;
                }
            }
        },

        propFix: {
            tabindex: "tabIndex",
            readonly: "readOnly",
            "for": "htmlFor",
            "class": "className",
            maxlength: "maxLength",
            cellspacing: "cellSpacing",
            cellpadding: "cellPadding",
            rowspan: "rowSpan",
            colspan: "colSpan",
            usemap: "useMap",
            frameborder: "frameBorder",
            contenteditable: "contentEditable"
        },

        prop: function prop(elem, name, value) {
            var ret,
                hooks,
                notxml,
                nType = elem.nodeType;

            // don't get/set properties on text, comment and attribute nodes
            if (!elem || nType === 3 || nType === 8 || nType === 2) {
                return;
            }

            notxml = nType !== 1 || !jQuery.isXMLDoc(elem);

            if (notxml) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }

            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
                    return ret;
                } else {
                    return elem[name] = value;
                }
            } else {
                if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
                    return ret;
                } else {
                    return elem[name];
                }
            }
        },

        propHooks: {
            tabIndex: {
                get: function get(elem) {
                    // elem.tabIndex doesn't always return the correct value when it hasn't been explicitly set
                    // http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                    var attributeNode = elem.getAttributeNode("tabindex");

                    return attributeNode && attributeNode.specified ? parseInt(attributeNode.value, 10) : rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href ? 0 : undefined;
                }
            }
        }
    });

    // Add the tabIndex propHook to attrHooks for back-compat (different case is intentional)
    jQuery.attrHooks.tabindex = jQuery.propHooks.tabIndex;

    // Hook for boolean attributes
    boolHook = {
        get: function get(elem, name) {
            // Align boolean attributes with corresponding properties
            // Fall back to attribute presence where some booleans are not supported
            var attrNode,
                property = jQuery.prop(elem, name);
            return property === true || typeof property !== "boolean" && (attrNode = elem.getAttributeNode(name)) && attrNode.nodeValue !== false ? name.toLowerCase() : undefined;
        },
        set: function set(elem, value, name) {
            var propName;
            if (value === false) {
                // Remove boolean attributes when set to false
                jQuery.removeAttr(elem, name);
            } else {
                // value is true since we know at this point it's type boolean and not false
                // Set boolean attributes to the same name and set the DOM property
                propName = jQuery.propFix[name] || name;
                if (propName in elem) {
                    // Only set the IDL specifically if it already exists on the element
                    elem[propName] = true;
                }

                elem.setAttribute(name, name.toLowerCase());
            }
            return name;
        }
    };

    // IE6/7 do not support getting/setting some attributes with get/setAttribute
    if (!getSetAttribute) {

        fixSpecified = {
            name: true,
            id: true,
            coords: true
        };

        // Use this for any attribute in IE6/7
        // This fixes almost every IE6/7 issue
        nodeHook = jQuery.valHooks.button = {
            get: function get(elem, name) {
                var ret;
                ret = elem.getAttributeNode(name);
                return ret && (fixSpecified[name] ? ret.nodeValue !== "" : ret.specified) ? ret.nodeValue : undefined;
            },
            set: function set(elem, value, name) {
                // Set the existing or create a new attribute node
                var ret = elem.getAttributeNode(name);
                if (!ret) {
                    ret = document.createAttribute(name);
                    elem.setAttributeNode(ret);
                }
                return ret.nodeValue = value + "";
            }
        };

        // Apply the nodeHook to tabindex
        jQuery.attrHooks.tabindex.set = nodeHook.set;

        // Set width and height to auto instead of 0 on empty string( Bug #8150 )
        // This is for removals
        jQuery.each(["width", "height"], function (i, name) {
            jQuery.attrHooks[name] = jQuery.extend(jQuery.attrHooks[name], {
                set: function set(elem, value) {
                    if (value === "") {
                        elem.setAttribute(name, "auto");
                        return value;
                    }
                }
            });
        });

        // Set contenteditable to false on removals(#10429)
        // Setting to empty string throws an error as an invalid value
        jQuery.attrHooks.contenteditable = {
            get: nodeHook.get,
            set: function set(elem, value, name) {
                if (value === "") {
                    value = "false";
                }
                nodeHook.set(elem, value, name);
            }
        };
    }

    // Some attributes require a special call on IE
    if (!jQuery.support.hrefNormalized) {
        jQuery.each(["href", "src", "width", "height"], function (i, name) {
            jQuery.attrHooks[name] = jQuery.extend(jQuery.attrHooks[name], {
                get: function get(elem) {
                    var ret = elem.getAttribute(name, 2);
                    return ret === null ? undefined : ret;
                }
            });
        });
    }

    if (!jQuery.support.style) {
        jQuery.attrHooks.style = {
            get: function get(elem) {
                // Return undefined in the case of empty string
                // Normalize to lowercase since IE uppercases css property names
                return elem.style.cssText.toLowerCase() || undefined;
            },
            set: function set(elem, value) {
                return elem.style.cssText = "" + value;
            }
        };
    }

    // Safari mis-reports the default selected property of an option
    // Accessing the parent's selectedIndex property fixes it
    if (!jQuery.support.optSelected) {
        jQuery.propHooks.selected = jQuery.extend(jQuery.propHooks.selected, {
            get: function get(elem) {
                var parent = elem.parentNode;

                if (parent) {
                    parent.selectedIndex;

                    // Make sure that it also works with optgroups, see #5701
                    if (parent.parentNode) {
                        parent.parentNode.selectedIndex;
                    }
                }
                return null;
            }
        });
    }

    // IE6/7 call enctype encoding
    if (!jQuery.support.enctype) {
        jQuery.propFix.enctype = "encoding";
    }

    // Radios and checkboxes getter/setter
    if (!jQuery.support.checkOn) {
        jQuery.each(["radio", "checkbox"], function () {
            jQuery.valHooks[this] = {
                get: function get(elem) {
                    // Handle the case where in Webkit "" is returned instead of "on" if a value isn't specified
                    return elem.getAttribute("value") === null ? "on" : elem.value;
                }
            };
        });
    }
    jQuery.each(["radio", "checkbox"], function () {
        jQuery.valHooks[this] = jQuery.extend(jQuery.valHooks[this], {
            set: function set(elem, value) {
                if (jQuery.isArray(value)) {
                    return elem.checked = jQuery.inArray(jQuery(elem).val(), value) >= 0;
                }
            }
        });
    });

    var rformElems = /^(?:textarea|input|select)$/i,
        rtypenamespace = /^([^\.]*)?(?:\.(.+))?$/,
        rhoverHack = /(?:^|\s)hover(\.\S+)?\b/,
        rkeyEvent = /^key/,
        rmouseEvent = /^(?:mouse|contextmenu)|click/,
        rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
        rquickIs = /^(\w*)(?:#([\w\-]+))?(?:\.([\w\-]+))?$/,
        quickParse = function quickParse(selector) {
        var quick = rquickIs.exec(selector);
        if (quick) {
            //   0  1    2   3
            // [ _, tag, id, class ]
            quick[1] = (quick[1] || "").toLowerCase();
            quick[3] = quick[3] && new RegExp("(?:^|\\s)" + quick[3] + "(?:\\s|$)");
        }
        return quick;
    },
        quickIs = function quickIs(elem, m) {
        var attrs = elem.attributes || {};
        return (!m[1] || elem.nodeName.toLowerCase() === m[1]) && (!m[2] || (attrs.id || {}).value === m[2]) && (!m[3] || m[3].test((attrs["class"] || {}).value));
    },
        hoverHack = function hoverHack(events) {
        return jQuery.event.special.hover ? events : events.replace(rhoverHack, "mouseenter$1 mouseleave$1");
    };

    /*
     * Helper functions for managing events -- not part of the public interface.
     * Props to Dean Edwards' addEvent library for many of the ideas.
     */
    jQuery.event = {

        add: function add(elem, types, handler, data, selector) {

            var elemData, _eventHandle, events, t, tns, type, namespaces, handleObj, handleObjIn, quick, handlers, special;

            // Don't attach events to noData or text/comment nodes (allow plain objects tho)
            if (elem.nodeType === 3 || elem.nodeType === 8 || !types || !handler || !(elemData = jQuery._data(elem))) {
                return;
            }

            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }

            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) {
                handler.guid = jQuery.guid++;
            }

            // Init the element's event structure and main handler, if this is the first
            events = elemData.events;
            if (!events) {
                elemData.events = events = {};
            }
            _eventHandle = elemData.handle;
            if (!_eventHandle) {
                elemData.handle = _eventHandle = function eventHandle(e) {
                    // Discard the second event of a jQuery.event.trigger() and
                    // when an event is called after a page has unloaded
                    return typeof jQuery !== "undefined" && (!e || jQuery.event.triggered !== e.type) ? jQuery.event.dispatch.apply(_eventHandle.elem, arguments) : undefined;
                };
                // Add elem as a property of the handle fn to prevent a memory leak with IE non-native events
                _eventHandle.elem = elem;
            }

            // Handle multiple events separated by a space
            // jQuery(...).bind("mouseover mouseout", fn);
            types = jQuery.trim(hoverHack(types)).split(" ");
            for (t = 0; t < types.length; t++) {

                tns = rtypenamespace.exec(types[t]) || [];
                type = tns[1];
                namespaces = (tns[2] || "").split(".").sort();

                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};

                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;

                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};

                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: tns[1],
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    quick: selector && quickParse(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);

                // Init the event handler queue if we're the first
                handlers = events[type];
                if (!handlers) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;

                    // Only use addEventListener/attachEvent if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, _eventHandle) === false) {
                        // Bind the global event handler to the element
                        if (elem.addEventListener) {
                            elem.addEventListener(type, _eventHandle, false);
                        } else if (elem.attachEvent) {
                            elem.attachEvent("on" + type, _eventHandle);
                        }
                    }
                }

                if (special.add) {
                    special.add.call(elem, handleObj);

                    if (!handleObj.handler.guid) {
                        handleObj.handler.guid = handler.guid;
                    }
                }

                // Add to the element's handler list, delegates in front
                if (selector) {
                    handlers.splice(handlers.delegateCount++, 0, handleObj);
                } else {
                    handlers.push(handleObj);
                }

                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }

            // Nullify elem to prevent memory leaks in IE
            elem = null;
        },

        global: {},

        // Detach an event or set of events from an element
        remove: function remove(elem, types, handler, selector, mappedTypes) {

            var elemData = jQuery.hasData(elem) && jQuery._data(elem),
                t,
                tns,
                type,
                origType,
                namespaces,
                origCount,
                j,
                events,
                special,
                handle,
                eventType,
                handleObj;

            if (!elemData || !(events = elemData.events)) {
                return;
            }

            // Once for each type.namespace in types; type may be omitted
            types = jQuery.trim(hoverHack(types || "")).split(" ");
            for (t = 0; t < types.length; t++) {
                tns = rtypenamespace.exec(types[t]) || [];
                type = origType = tns[1];
                namespaces = tns[2];

                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for (type in events) {
                        jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    }
                    continue;
                }

                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                eventType = events[type] || [];
                origCount = eventType.length;
                namespaces = namespaces ? new RegExp("(^|\\.)" + namespaces.split(".").sort().join("\\.(?:.*\\.)?") + "(\\.|$)") : null;

                // Remove matching events
                for (j = 0; j < eventType.length; j++) {
                    handleObj = eventType[j];

                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!namespaces || namespaces.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        eventType.splice(j--, 1);

                        if (handleObj.selector) {
                            eventType.delegateCount--;
                        }
                        if (special.remove) {
                            special.remove.call(elem, handleObj);
                        }
                    }
                }

                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (eventType.length === 0 && origCount !== eventType.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces) === false) {
                        jQuery.removeEvent(elem, type, elemData.handle);
                    }

                    delete events[type];
                }
            }

            // Remove the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) {
                handle = elemData.handle;
                if (handle) {
                    handle.elem = null;
                }

                // removeData also checks for emptiness and clears the expando if empty
                // so use it instead of delete
                jQuery.removeData(elem, ["events", "handle"], true);
            }
        },

        // Events that are safe to short-circuit if no handlers are attached.
        // Native DOM events should not be added, they may have inline handlers.
        customEvent: {
            "getData": true,
            "setData": true,
            "changeData": true
        },

        trigger: function trigger(event, data, elem, onlyHandlers) {
            // Don't do events on text and comment nodes
            if (elem && (elem.nodeType === 3 || elem.nodeType === 8)) {
                return;
            }

            // Event object or event type
            var type = event.type || event,
                namespaces = [],
                cache,
                exclusive,
                i,
                cur,
                old,
                ontype,
                special,
                handle,
                eventPath,
                bubbleType;

            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) {
                return;
            }

            if (type.indexOf("!") >= 0) {
                // Exclusive events trigger only for the exact event (no namespaces)
                type = type.slice(0, -1);
                exclusive = true;
            }

            if (type.indexOf(".") >= 0) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }

            if ((!elem || jQuery.event.customEvent[type]) && !jQuery.event.global[type]) {
                // No jQuery handlers for this event type, and it can't have inline handlers
                return;
            }

            // Caller can pass in an Event, Object, or just an event type string
            event = (typeof event === "undefined" ? "undefined" : (0, _typeof3.default)(event)) === "object" ?
            // jQuery.Event object
            event[jQuery.expando] ? event :
            // Object literal
            new jQuery.Event(type, event) :
            // Just the event type (string)
            new jQuery.Event(type);

            event.type = type;
            event.isTrigger = true;
            event.exclusive = exclusive;
            event.namespace = namespaces.join(".");
            event.namespace_re = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.)?") + "(\\.|$)") : null;
            ontype = type.indexOf(":") < 0 ? "on" + type : "";

            // Handle a global trigger
            if (!elem) {

                // TODO: Stop taunting the data cache; remove global events and always attach to document
                cache = jQuery.cache;
                for (i in cache) {
                    if (cache[i].events && cache[i].events[type]) {
                        jQuery.event.trigger(event, data, cache[i].handle.elem, true);
                    }
                }
                return;
            }

            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) {
                event.target = elem;
            }

            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data != null ? jQuery.makeArray(data) : [];
            data.unshift(event);

            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (special.trigger && special.trigger.apply(elem, data) === false) {
                return;
            }

            // Determine event propagation path in advance, per W3C events spec (#9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
            eventPath = [[elem, special.bindType || type]];
            if (!onlyHandlers && !special.noBubble && !jQuery.isWindow(elem)) {

                bubbleType = special.delegateType || type;
                cur = rfocusMorph.test(bubbleType + type) ? elem : elem.parentNode;
                old = null;
                for (; cur; cur = cur.parentNode) {
                    eventPath.push([cur, bubbleType]);
                    old = cur;
                }

                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (old && old === elem.ownerDocument) {
                    eventPath.push([old.defaultView || old.parentWindow || window, bubbleType]);
                }
            }

            // Fire handlers on the event path
            for (i = 0; i < eventPath.length && !event.isPropagationStopped(); i++) {

                cur = eventPath[i][0];
                event.type = eventPath[i][1];

                handle = (jQuery._data(cur, "events") || {})[event.type] && jQuery._data(cur, "handle");
                if (handle) {
                    handle.apply(cur, data);
                }
                // Note that this is a bare JS function and not a jQuery handler
                handle = ontype && cur[ontype];
                if (handle && jQuery.acceptData(cur) && handle.apply(cur, data) === false) {
                    event.preventDefault();
                }
            }
            event.type = type;

            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {

                if ((!special._default || special._default.apply(elem.ownerDocument, data) === false) && !(type === "click" && jQuery.nodeName(elem, "a")) && jQuery.acceptData(elem)) {

                    // Call a native DOM method on the target with the same name name as the event.
                    // Can't use an .isFunction() check here because IE6/7 fails that test.
                    // Don't do default actions on window, that's where global variables be (#6170)
                    // IE<9 dies on focus/blur to hidden element (#1486)
                    if (ontype && elem[type] && (type !== "focus" && type !== "blur" || event.target.offsetWidth !== 0) && !jQuery.isWindow(elem)) {

                        // Don't re-trigger an onFOO event when we call its FOO() method
                        old = elem[ontype];

                        if (old) {
                            elem[ontype] = null;
                        }

                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        elem[type]();
                        jQuery.event.triggered = undefined;

                        if (old) {
                            elem[ontype] = old;
                        }
                    }
                }
            }

            return event.result;
        },

        dispatch: function dispatch(event) {

            // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(event || window.event);

            var handlers = (jQuery._data(this, "events") || {})[event.type] || [],
                delegateCount = handlers.delegateCount,
                args = [].slice.call(arguments, 0),
                run_all = !event.exclusive && !event.namespace,
                special = jQuery.event.special[event.type] || {},
                handlerQueue = [],
                i,
                j,
                cur,
                jqcur,
                ret,
                selMatch,
                matched,
                matches,
                handleObj,
                sel,
                related;

            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            event.delegateTarget = this;

            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) {
                return;
            }

            // Determine handlers that should run if there are delegated events
            // Avoid non-left-click bubbling in Firefox (#3861)
            if (delegateCount && !(event.button && event.type === "click")) {

                // Pregenerate a single jQuery object for reuse with .is()
                jqcur = jQuery(this);
                jqcur.context = this.ownerDocument || this;

                for (cur = event.target; cur != this; cur = cur.parentNode || this) {

                    // Don't process events on disabled elements (#6911, #8165)
                    if (cur.disabled !== true) {
                        selMatch = {};
                        matches = [];
                        jqcur[0] = cur;
                        for (i = 0; i < delegateCount; i++) {
                            handleObj = handlers[i];
                            sel = handleObj.selector;

                            if (selMatch[sel] === undefined) {
                                selMatch[sel] = handleObj.quick ? quickIs(cur, handleObj.quick) : jqcur.is(sel);
                            }
                            if (selMatch[sel]) {
                                matches.push(handleObj);
                            }
                        }
                        if (matches.length) {
                            handlerQueue.push({ elem: cur, matches: matches });
                        }
                    }
                }
            }

            // Add the remaining (directly-bound) handlers
            if (handlers.length > delegateCount) {
                handlerQueue.push({ elem: this, matches: handlers.slice(delegateCount) });
            }

            // Run delegates first; they may want to stop propagation beneath us
            for (i = 0; i < handlerQueue.length && !event.isPropagationStopped(); i++) {
                matched = handlerQueue[i];
                event.currentTarget = matched.elem;

                for (j = 0; j < matched.matches.length && !event.isImmediatePropagationStopped(); j++) {
                    handleObj = matched.matches[j];

                    // Triggered event must either 1) be non-exclusive and have no namespace, or
                    // 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
                    if (run_all || !event.namespace && !handleObj.namespace || event.namespace_re && event.namespace_re.test(handleObj.namespace)) {

                        event.data = handleObj.data;
                        event.handleObj = handleObj;

                        ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);

                        if (ret !== undefined) {
                            event.result = ret;
                            if (ret === false) {
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        }
                    }
                }
            }

            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) {
                special.postDispatch.call(this, event);
            }

            return event.result;
        },

        // Includes some event props shared by KeyEvent and MouseEvent
        // *** attrChange attrName relatedNode srcElement  are not normalized, non-W3C, deprecated, will be removed in 1.8 ***
        props: "attrChange attrName relatedNode srcElement altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

        fixHooks: {},

        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function filter(event, original) {

                // Add which for key events
                if (event.which == null) {
                    event.which = original.charCode != null ? original.charCode : original.keyCode;
                }

                return event;
            }
        },

        mouseHooks: {
            props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function filter(event, original) {
                var eventDoc,
                    doc,
                    body,
                    button = original.button,
                    fromElement = original.fromElement;

                // Calculate pageX/Y if missing and clientX/Y available
                if (event.pageX == null && original.clientX != null) {
                    eventDoc = event.target.ownerDocument || document;
                    doc = eventDoc.documentElement;
                    body = eventDoc.body;

                    event.pageX = original.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
                    event.pageY = original.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
                }

                // Add relatedTarget, if necessary
                if (!event.relatedTarget && fromElement) {
                    event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
                }

                // Add which for click: 1 === left; 2 === middle; 3 === right
                // Note: button is not normalized, so don't use it
                if (!event.which && button !== undefined) {
                    event.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
                }

                return event;
            }
        },

        fix: function fix(event) {
            if (event[jQuery.expando]) {
                return event;
            }

            // Create a writable copy of the event object and normalize some properties
            var i,
                prop,
                originalEvent = event,
                fixHook = jQuery.event.fixHooks[event.type] || {},
                copy = fixHook.props ? this.props.concat(fixHook.props) : this.props;

            event = jQuery.Event(originalEvent);

            for (i = copy.length; i;) {
                prop = copy[--i];
                event[prop] = originalEvent[prop];
            }

            // Fix target property, if necessary (#1925, IE 6/7/8 & Safari2)
            if (!event.target) {
                event.target = originalEvent.srcElement || document;
            }

            // Target should not be a text node (#504, Safari)
            if (event.target.nodeType === 3) {
                event.target = event.target.parentNode;
            }

            // For mouse/key events; add metaKey if it's not there (#3368, IE6/7/8)
            if (event.metaKey === undefined) {
                event.metaKey = event.ctrlKey;
            }

            return fixHook.filter ? fixHook.filter(event, originalEvent) : event;
        },

        special: {
            ready: {
                // Make sure the ready event is setup
                setup: jQuery.bindReady
            },

            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },

            focus: {
                delegateType: "focusin"
            },
            blur: {
                delegateType: "focusout"
            },

            beforeunload: {
                setup: function setup(data, namespaces, eventHandle) {
                    // We only want to do this special case on windows
                    if (jQuery.isWindow(this)) {
                        this.onbeforeunload = eventHandle;
                    }
                },

                teardown: function teardown(namespaces, eventHandle) {
                    if (this.onbeforeunload === eventHandle) {
                        this.onbeforeunload = null;
                    }
                }
            }
        },

        simulate: function simulate(type, elem, event, bubble) {
            // Piggyback on a donor event to simulate a different one.
            // Fake originalEvent to avoid donor's stopPropagation, but if the
            // simulated event prevents default then we do the same on the donor.
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true,
                originalEvent: {}
            });
            if (bubble) {
                jQuery.event.trigger(e, null, elem);
            } else {
                jQuery.event.dispatch.call(elem, e);
            }
            if (e.isDefaultPrevented()) {
                event.preventDefault();
            }
        }
    };

    // Some plugins are using, but it's undocumented/deprecated and will be removed.
    // The 1.7 special event interface should provide all the hooks needed now.
    jQuery.event.handle = jQuery.event.dispatch;

    jQuery.removeEvent = document.removeEventListener ? function (elem, type, handle) {
        if (elem.removeEventListener) {
            elem.removeEventListener(type, handle, false);
        }
    } : function (elem, type, handle) {
        if (elem.detachEvent) {
            elem.detachEvent("on" + type, handle);
        }
    };

    jQuery.Event = function (src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) {
            return new jQuery.Event(src, props);
        }

        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;

            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.returnValue === false || src.getPreventDefault && src.getPreventDefault() ? returnTrue : returnFalse;

            // Event type
        } else {
            this.type = src;
        }

        // Put explicitly provided properties onto the event object
        if (props) {
            jQuery.extend(this, props);
        }

        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || jQuery.now();

        // Mark it as fixed
        this[jQuery.expando] = true;
    };

    function returnFalse() {
        return false;
    }

    function returnTrue() {
        return true;
    }

    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        preventDefault: function preventDefault() {
            this.isDefaultPrevented = returnTrue;

            var e = this.originalEvent;
            if (!e) {
                return;
            }

            // if preventDefault exists run it on the original event
            if (e.preventDefault) {
                e.preventDefault();

                // otherwise set the returnValue property of the original event to false (IE)
            } else {
                e.returnValue = false;
            }
        },
        stopPropagation: function stopPropagation() {
            this.isPropagationStopped = returnTrue;

            var e = this.originalEvent;
            if (!e) {
                return;
            }
            // if stopPropagation exists run it on the original event
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            // otherwise set the cancelBubble property of the original event to true (IE)
            e.cancelBubble = true;
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            this.isImmediatePropagationStopped = returnTrue;
            this.stopPropagation();
        },
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse
    };

    // Create mouseenter/leave events using mouseover/out and event-time checks
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    }, function (orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,

            handle: function handle(event) {
                var target = this,
                    related = event.relatedTarget,
                    handleObj = event.handleObj,
                    selector = handleObj.selector,
                    ret;

                // For mousenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });

    // IE submit delegation
    if (!jQuery.support.submitBubbles) {

        jQuery.event.special.submit = {
            setup: function setup() {
                // Only need this for delegated form submit events
                if (jQuery.nodeName(this, "form")) {
                    return false;
                }

                // Lazy-add a submit handler when a descendant form may potentially be submitted
                jQuery.event.add(this, "click._submit keypress._submit", function (e) {
                    // Node name check avoids a VML-related crash in IE (#9807)
                    var elem = e.target,
                        form = jQuery.nodeName(elem, "input") || jQuery.nodeName(elem, "button") ? elem.form : undefined;
                    if (form && !form._submit_attached) {
                        jQuery.event.add(form, "submit._submit", function (event) {
                            event._submit_bubble = true;
                        });
                        form._submit_attached = true;
                    }
                });
                // return undefined since we don't need an event listener
            },

            postDispatch: function postDispatch(event) {
                // If form was submitted by the user, bubble the event up the tree
                if (event._submit_bubble) {
                    delete event._submit_bubble;
                    if (this.parentNode && !event.isTrigger) {
                        jQuery.event.simulate("submit", this.parentNode, event, true);
                    }
                }
            },

            teardown: function teardown() {
                // Only need this for delegated form submit events
                if (jQuery.nodeName(this, "form")) {
                    return false;
                }

                // Remove delegated handlers; cleanData eventually reaps submit handlers attached above
                jQuery.event.remove(this, "._submit");
            }
        };
    }

    // IE change delegation and checkbox/radio fix
    if (!jQuery.support.changeBubbles) {

        jQuery.event.special.change = {

            setup: function setup() {

                if (rformElems.test(this.nodeName)) {
                    // IE doesn't fire change on a check/radio until blur; trigger it on click
                    // after a propertychange. Eat the blur-change in special.change.handle.
                    // This still fires onchange a second time for check/radio after blur.
                    if (this.type === "checkbox" || this.type === "radio") {
                        jQuery.event.add(this, "propertychange._change", function (event) {
                            if (event.originalEvent.propertyName === "checked") {
                                this._just_changed = true;
                            }
                        });
                        jQuery.event.add(this, "click._change", function (event) {
                            if (this._just_changed && !event.isTrigger) {
                                this._just_changed = false;
                                jQuery.event.simulate("change", this, event, true);
                            }
                        });
                    }
                    return false;
                }
                // Delegated event; lazy-add a change handler on descendant inputs
                jQuery.event.add(this, "beforeactivate._change", function (e) {
                    var elem = e.target;

                    if (rformElems.test(elem.nodeName) && !elem._change_attached) {
                        jQuery.event.add(elem, "change._change", function (event) {
                            if (this.parentNode && !event.isSimulated && !event.isTrigger) {
                                jQuery.event.simulate("change", this.parentNode, event, true);
                            }
                        });
                        elem._change_attached = true;
                    }
                });
            },

            handle: function handle(event) {
                var elem = event.target;

                // Swallow native change events from checkbox/radio, we already triggered them above
                if (this !== elem || event.isSimulated || event.isTrigger || elem.type !== "radio" && elem.type !== "checkbox") {
                    return event.handleObj.handler.apply(this, arguments);
                }
            },

            teardown: function teardown() {
                jQuery.event.remove(this, "._change");

                return rformElems.test(this.nodeName);
            }
        };
    }

    // Create "bubbling" focus and blur events
    if (!jQuery.support.focusinBubbles) {
        jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {

            // Attach a single capturing handler while someone wants focusin/focusout
            var attaches = 0,
                handler = function handler(event) {
                jQuery.event.simulate(fix, event.target, jQuery.event.fix(event), true);
            };

            jQuery.event.special[fix] = {
                setup: function setup() {
                    if (attaches++ === 0) {
                        document.addEventListener(orig, handler, true);
                    }
                },
                teardown: function teardown() {
                    if (--attaches === 0) {
                        document.removeEventListener(orig, handler, true);
                    }
                }
            };
        });
    }

    jQuery.fn.extend({

        on: function on(types, selector, data, fn, /*INTERNAL*/one) {
            var origFn, type;

            // Types can be a map of types/handlers
            if ((typeof types === "undefined" ? "undefined" : (0, _typeof3.default)(types)) === "object") {
                // ( types-Object, selector, data )
                if (typeof selector !== "string") {
                    // && selector != null
                    // ( types-Object, data )
                    data = data || selector;
                    selector = undefined;
                }
                for (type in types) {
                    this.on(type, selector, data, types[type], one);
                }
                return this;
            }

            if (data == null && fn == null) {
                // ( types, fn )
                fn = selector;
                data = selector = undefined;
            } else if (fn == null) {
                if (typeof selector === "string") {
                    // ( types, selector, fn )
                    fn = data;
                    data = undefined;
                } else {
                    // ( types, data, fn )
                    fn = data;
                    data = selector;
                    selector = undefined;
                }
            }
            if (fn === false) {
                fn = returnFalse;
            } else if (!fn) {
                return this;
            }

            if (one === 1) {
                origFn = fn;
                fn = function fn(event) {
                    // Can use an empty set, since event contains the info
                    jQuery().off(event);
                    return origFn.apply(this, arguments);
                };
                // Use same guid so caller can remove using origFn
                fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
            }
            return this.each(function () {
                jQuery.event.add(this, types, fn, data, selector);
            });
        },
        one: function one(types, selector, data, fn) {
            return this.on(types, selector, data, fn, 1);
        },
        off: function off(types, selector, fn) {
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                var handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if ((typeof types === "undefined" ? "undefined" : (0, _typeof3.default)(types)) === "object") {
                // ( types-object [, selector] )
                for (var type in types) {
                    this.off(type, selector, types[type]);
                }
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) {
                fn = returnFalse;
            }
            return this.each(function () {
                jQuery.event.remove(this, types, fn, selector);
            });
        },

        bind: function bind(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function unbind(types, fn) {
            return this.off(types, null, fn);
        },

        live: function live(types, data, fn) {
            jQuery(this.context).on(types, this.selector, data, fn);
            return this;
        },
        die: function die(types, fn) {
            jQuery(this.context).off(types, this.selector || "**", fn);
            return this;
        },

        delegate: function delegate(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function undelegate(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length == 1 ? this.off(selector, "**") : this.off(types, selector, fn);
        },

        trigger: function trigger(type, data) {
            return this.each(function () {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function triggerHandler(type, data) {
            if (this[0]) {
                return jQuery.event.trigger(type, data, this[0], true);
            }
        },

        toggle: function toggle(fn) {
            // Save reference to arguments for access in closure
            var args = arguments,
                guid = fn.guid || jQuery.guid++,
                i = 0,
                toggler = function toggler(event) {
                // Figure out which function to execute
                var lastToggle = (jQuery._data(this, "lastToggle" + fn.guid) || 0) % i;
                jQuery._data(this, "lastToggle" + fn.guid, lastToggle + 1);

                // Make sure that clicks stop
                event.preventDefault();

                // and execute the function
                return args[lastToggle].apply(this, arguments) || false;
            };

            // link all the functions, so any of them can unbind this click handler
            toggler.guid = guid;
            while (i < args.length) {
                args[i++].guid = guid;
            }

            return this.click(toggler);
        },

        hover: function hover(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });

    jQuery.each(("blur focus focusin focusout load resize scroll unload click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup error contextmenu").split(" "), function (i, name) {

        // Handle event binding
        jQuery.fn[name] = function (data, fn) {
            if (fn == null) {
                fn = data;
                data = null;
            }

            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };

        if (jQuery.attrFn) {
            jQuery.attrFn[name] = true;
        }

        if (rkeyEvent.test(name)) {
            jQuery.event.fixHooks[name] = jQuery.event.keyHooks;
        }

        if (rmouseEvent.test(name)) {
            jQuery.event.fixHooks[name] = jQuery.event.mouseHooks;
        }
    });

    /*!
     * Sizzle CSS Selector Engine
     *  Copyright 2011, The Dojo Foundation
     *  Released under the MIT, BSD, and GPL Licenses.
     *  More information: http://sizzlejs.com/
     */
    (function () {

        var chunker = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g,
            expando = "sizcache" + (Math.random() + '').replace('.', ''),
            done = 0,
            toString = Object.prototype.toString,
            hasDuplicate = false,
            baseHasDuplicate = true,
            rBackslash = /\\/g,
            rReturn = /\r\n/g,
            rNonWord = /\W/;

        // Here we check if the JavaScript engine is using some sort of
        // optimization where it does not always call our comparision
        // function. If that is the case, discard the hasDuplicate value.
        //   Thus far that includes Google Chrome.
        [0, 0].sort(function () {
            baseHasDuplicate = false;
            return 0;
        });

        var _Sizzle2 = function Sizzle(selector, context, results, seed) {
            results = results || [];
            context = context || document;

            var origContext = context;

            if (context.nodeType !== 1 && context.nodeType !== 9) {
                return [];
            }

            if (!selector || typeof selector !== "string") {
                return results;
            }

            var m,
                set,
                checkSet,
                extra,
                ret,
                cur,
                pop,
                i,
                prune = true,
                contextXML = _Sizzle2.isXML(context),
                parts = [],
                soFar = selector;

            // Reset the position of the chunker regexp (start from head)
            do {
                chunker.exec("");
                m = chunker.exec(soFar);

                if (m) {
                    soFar = m[3];

                    parts.push(m[1]);

                    if (m[2]) {
                        extra = m[3];
                        break;
                    }
                }
            } while (m);

            if (parts.length > 1 && origPOS.exec(selector)) {

                if (parts.length === 2 && Expr.relative[parts[0]]) {
                    set = posProcess(parts[0] + parts[1], context, seed);
                } else {
                    set = Expr.relative[parts[0]] ? [context] : _Sizzle2(parts.shift(), context);

                    while (parts.length) {
                        selector = parts.shift();

                        if (Expr.relative[selector]) {
                            selector += parts.shift();
                        }

                        set = posProcess(selector, set, seed);
                    }
                }
            } else {
                // Take a shortcut and set the context if the root selector is an ID
                // (but not if it'll be faster if the inner selector is an ID)
                if (!seed && parts.length > 1 && context.nodeType === 9 && !contextXML && Expr.match.ID.test(parts[0]) && !Expr.match.ID.test(parts[parts.length - 1])) {

                    ret = _Sizzle2.find(parts.shift(), context, contextXML);
                    context = ret.expr ? _Sizzle2.filter(ret.expr, ret.set)[0] : ret.set[0];
                }

                if (context) {
                    ret = seed ? { expr: parts.pop(), set: makeArray(seed) } : _Sizzle2.find(parts.pop(), parts.length === 1 && (parts[0] === "~" || parts[0] === "+") && context.parentNode ? context.parentNode : context, contextXML);

                    set = ret.expr ? _Sizzle2.filter(ret.expr, ret.set) : ret.set;

                    if (parts.length > 0) {
                        checkSet = makeArray(set);
                    } else {
                        prune = false;
                    }

                    while (parts.length) {
                        cur = parts.pop();
                        pop = cur;

                        if (!Expr.relative[cur]) {
                            cur = "";
                        } else {
                            pop = parts.pop();
                        }

                        if (pop == null) {
                            pop = context;
                        }

                        Expr.relative[cur](checkSet, pop, contextXML);
                    }
                } else {
                    checkSet = parts = [];
                }
            }

            if (!checkSet) {
                checkSet = set;
            }

            if (!checkSet) {
                _Sizzle2.error(cur || selector);
            }

            if (toString.call(checkSet) === "[object Array]") {
                if (!prune) {
                    results.push.apply(results, checkSet);
                } else if (context && context.nodeType === 1) {
                    for (i = 0; checkSet[i] != null; i++) {
                        if (checkSet[i] && (checkSet[i] === true || checkSet[i].nodeType === 1 && _Sizzle2.contains(context, checkSet[i]))) {
                            results.push(set[i]);
                        }
                    }
                } else {
                    for (i = 0; checkSet[i] != null; i++) {
                        if (checkSet[i] && checkSet[i].nodeType === 1) {
                            results.push(set[i]);
                        }
                    }
                }
            } else {
                makeArray(checkSet, results);
            }

            if (extra) {
                _Sizzle2(extra, origContext, results, seed);
                _Sizzle2.uniqueSort(results);
            }

            return results;
        };

        _Sizzle2.uniqueSort = function (results) {
            if (sortOrder) {
                hasDuplicate = baseHasDuplicate;
                results.sort(sortOrder);

                if (hasDuplicate) {
                    for (var i = 1; i < results.length; i++) {
                        if (results[i] === results[i - 1]) {
                            results.splice(i--, 1);
                        }
                    }
                }
            }

            return results;
        };

        _Sizzle2.matches = function (expr, set) {
            return _Sizzle2(expr, null, null, set);
        };

        _Sizzle2.matchesSelector = function (node, expr) {
            return _Sizzle2(expr, null, null, [node]).length > 0;
        };

        _Sizzle2.find = function (expr, context, isXML) {
            var set, i, len, match, type, left;

            if (!expr) {
                return [];
            }

            for (i = 0, len = Expr.order.length; i < len; i++) {
                type = Expr.order[i];

                if (match = Expr.leftMatch[type].exec(expr)) {
                    left = match[1];
                    match.splice(1, 1);

                    if (left.substr(left.length - 1) !== "\\") {
                        match[1] = (match[1] || "").replace(rBackslash, "");
                        set = Expr.find[type](match, context, isXML);

                        if (set != null) {
                            expr = expr.replace(Expr.match[type], "");
                            break;
                        }
                    }
                }
            }

            if (!set) {
                set = typeof context.getElementsByTagName !== "undefined" ? context.getElementsByTagName("*") : [];
            }

            return { set: set, expr: expr };
        };

        _Sizzle2.filter = function (expr, set, inplace, not) {
            var match,
                anyFound,
                type,
                found,
                item,
                filter,
                left,
                i,
                pass,
                old = expr,
                result = [],
                curLoop = set,
                isXMLFilter = set && set[0] && _Sizzle2.isXML(set[0]);

            while (expr && set.length) {
                for (type in Expr.filter) {
                    if ((match = Expr.leftMatch[type].exec(expr)) != null && match[2]) {
                        filter = Expr.filter[type];
                        left = match[1];

                        anyFound = false;

                        match.splice(1, 1);

                        if (left.substr(left.length - 1) === "\\") {
                            continue;
                        }

                        if (curLoop === result) {
                            result = [];
                        }

                        if (Expr.preFilter[type]) {
                            match = Expr.preFilter[type](match, curLoop, inplace, result, not, isXMLFilter);

                            if (!match) {
                                anyFound = found = true;
                            } else if (match === true) {
                                continue;
                            }
                        }

                        if (match) {
                            for (i = 0; (item = curLoop[i]) != null; i++) {
                                if (item) {
                                    found = filter(item, match, i, curLoop);
                                    pass = not ^ found;

                                    if (inplace && found != null) {
                                        if (pass) {
                                            anyFound = true;
                                        } else {
                                            curLoop[i] = false;
                                        }
                                    } else if (pass) {
                                        result.push(item);
                                        anyFound = true;
                                    }
                                }
                            }
                        }

                        if (found !== undefined) {
                            if (!inplace) {
                                curLoop = result;
                            }

                            expr = expr.replace(Expr.match[type], "");

                            if (!anyFound) {
                                return [];
                            }

                            break;
                        }
                    }
                }

                // Improper expression
                if (expr === old) {
                    if (anyFound == null) {
                        _Sizzle2.error(expr);
                    } else {
                        break;
                    }
                }

                old = expr;
            }

            return curLoop;
        };

        _Sizzle2.error = function (msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };

        /**
         * Utility function for retreiving the text value of an array of DOM nodes
         * @param {Array|Element} elem
         */
        var getText = _Sizzle2.getText = function (elem) {
            var i,
                node,
                nodeType = elem.nodeType,
                ret = "";

            if (nodeType) {
                if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                    // Use textContent || innerText for elements
                    if (typeof elem.textContent === 'string') {
                        return elem.textContent;
                    } else if (typeof elem.innerText === 'string') {
                        // Replace IE's carriage returns
                        return elem.innerText.replace(rReturn, '');
                    } else {
                        // Traverse it's children
                        for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                            ret += getText(elem);
                        }
                    }
                } else if (nodeType === 3 || nodeType === 4) {
                    return elem.nodeValue;
                }
            } else {

                // If no nodeType, this is expected to be an array
                for (i = 0; node = elem[i]; i++) {
                    // Do not traverse comment nodes
                    if (node.nodeType !== 8) {
                        ret += getText(node);
                    }
                }
            }
            return ret;
        };

        var Expr = _Sizzle2.selectors = {
            order: ["ID", "NAME", "TAG"],

            match: {
                ID: /#((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,
                CLASS: /\.((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,
                NAME: /\[name=['"]*((?:[\w\u00c0-\uFFFF\-]|\\.)+)['"]*\]/,
                ATTR: /\[\s*((?:[\w\u00c0-\uFFFF\-]|\\.)+)\s*(?:(\S?=)\s*(?:(['"])(.*?)\3|(#?(?:[\w\u00c0-\uFFFF\-]|\\.)*)|)|)\s*\]/,
                TAG: /^((?:[\w\u00c0-\uFFFF\*\-]|\\.)+)/,
                CHILD: /:(only|nth|last|first)-child(?:\(\s*(even|odd|(?:[+\-]?\d+|(?:[+\-]?\d*)?n\s*(?:[+\-]\s*\d+)?))\s*\))?/,
                POS: /:(nth|eq|gt|lt|first|last|even|odd)(?:\((\d*)\))?(?=[^\-]|$)/,
                PSEUDO: /:((?:[\w\u00c0-\uFFFF\-]|\\.)+)(?:\((['"]?)((?:\([^\)]+\)|[^\(\)]*)+)\2\))?/
            },

            leftMatch: {},

            attrMap: {
                "class": "className",
                "for": "htmlFor"
            },

            attrHandle: {
                href: function href(elem) {
                    return elem.getAttribute("href");
                },
                type: function type(elem) {
                    return elem.getAttribute("type");
                }
            },

            relative: {
                "+": function _(checkSet, part) {
                    var isPartStr = typeof part === "string",
                        isTag = isPartStr && !rNonWord.test(part),
                        isPartStrNotTag = isPartStr && !isTag;

                    if (isTag) {
                        part = part.toLowerCase();
                    }

                    for (var i = 0, l = checkSet.length, elem; i < l; i++) {
                        if (elem = checkSet[i]) {
                            while ((elem = elem.previousSibling) && elem.nodeType !== 1) {}

                            checkSet[i] = isPartStrNotTag || elem && elem.nodeName.toLowerCase() === part ? elem || false : elem === part;
                        }
                    }

                    if (isPartStrNotTag) {
                        _Sizzle2.filter(part, checkSet, true);
                    }
                },

                ">": function _(checkSet, part) {
                    var elem,
                        isPartStr = typeof part === "string",
                        i = 0,
                        l = checkSet.length;

                    if (isPartStr && !rNonWord.test(part)) {
                        part = part.toLowerCase();

                        for (; i < l; i++) {
                            elem = checkSet[i];

                            if (elem) {
                                var parent = elem.parentNode;
                                checkSet[i] = parent.nodeName.toLowerCase() === part ? parent : false;
                            }
                        }
                    } else {
                        for (; i < l; i++) {
                            elem = checkSet[i];

                            if (elem) {
                                checkSet[i] = isPartStr ? elem.parentNode : elem.parentNode === part;
                            }
                        }

                        if (isPartStr) {
                            _Sizzle2.filter(part, checkSet, true);
                        }
                    }
                },

                "": function _(checkSet, part, isXML) {
                    var nodeCheck,
                        doneName = done++,
                        checkFn = dirCheck;

                    if (typeof part === "string" && !rNonWord.test(part)) {
                        part = part.toLowerCase();
                        nodeCheck = part;
                        checkFn = dirNodeCheck;
                    }

                    checkFn("parentNode", part, doneName, checkSet, nodeCheck, isXML);
                },

                "~": function _(checkSet, part, isXML) {
                    var nodeCheck,
                        doneName = done++,
                        checkFn = dirCheck;

                    if (typeof part === "string" && !rNonWord.test(part)) {
                        part = part.toLowerCase();
                        nodeCheck = part;
                        checkFn = dirNodeCheck;
                    }

                    checkFn("previousSibling", part, doneName, checkSet, nodeCheck, isXML);
                }
            },

            find: {
                ID: function ID(match, context, isXML) {
                    if (typeof context.getElementById !== "undefined" && !isXML) {
                        var m = context.getElementById(match[1]);
                        // Check parentNode to catch when Blackberry 4.6 returns
                        // nodes that are no longer in the document #6963
                        return m && m.parentNode ? [m] : [];
                    }
                },

                NAME: function NAME(match, context) {
                    if (typeof context.getElementsByName !== "undefined") {
                        var ret = [],
                            results = context.getElementsByName(match[1]);

                        for (var i = 0, l = results.length; i < l; i++) {
                            if (results[i].getAttribute("name") === match[1]) {
                                ret.push(results[i]);
                            }
                        }

                        return ret.length === 0 ? null : ret;
                    }
                },

                TAG: function TAG(match, context) {
                    if (typeof context.getElementsByTagName !== "undefined") {
                        return context.getElementsByTagName(match[1]);
                    }
                }
            },
            preFilter: {
                CLASS: function CLASS(match, curLoop, inplace, result, not, isXML) {
                    match = " " + match[1].replace(rBackslash, "") + " ";

                    if (isXML) {
                        return match;
                    }

                    for (var i = 0, elem; (elem = curLoop[i]) != null; i++) {
                        if (elem) {
                            if (not ^ (elem.className && (" " + elem.className + " ").replace(/[\t\n\r]/g, " ").indexOf(match) >= 0)) {
                                if (!inplace) {
                                    result.push(elem);
                                }
                            } else if (inplace) {
                                curLoop[i] = false;
                            }
                        }
                    }

                    return false;
                },

                ID: function ID(match) {
                    return match[1].replace(rBackslash, "");
                },

                TAG: function TAG(match, curLoop) {
                    return match[1].replace(rBackslash, "").toLowerCase();
                },

                CHILD: function CHILD(match) {
                    if (match[1] === "nth") {
                        if (!match[2]) {
                            _Sizzle2.error(match[0]);
                        }

                        match[2] = match[2].replace(/^\+|\s*/g, '');

                        // parse equations like 'even', 'odd', '5', '2n', '3n+2', '4n-1', '-n+6'
                        var test = /(-?)(\d*)(?:n([+\-]?\d*))?/.exec(match[2] === "even" && "2n" || match[2] === "odd" && "2n+1" || !/\D/.test(match[2]) && "0n+" + match[2] || match[2]);

                        // calculate the numbers (first)n+(last) including if they are negative
                        match[2] = test[1] + (test[2] || 1) - 0;
                        match[3] = test[3] - 0;
                    } else if (match[2]) {
                        _Sizzle2.error(match[0]);
                    }

                    // TODO: Move to normal caching system
                    match[0] = done++;

                    return match;
                },

                ATTR: function ATTR(match, curLoop, inplace, result, not, isXML) {
                    var name = match[1] = match[1].replace(rBackslash, "");

                    if (!isXML && Expr.attrMap[name]) {
                        match[1] = Expr.attrMap[name];
                    }

                    // Handle if an un-quoted value was used
                    match[4] = (match[4] || match[5] || "").replace(rBackslash, "");

                    if (match[2] === "~=") {
                        match[4] = " " + match[4] + " ";
                    }

                    return match;
                },

                PSEUDO: function PSEUDO(match, curLoop, inplace, result, not) {
                    if (match[1] === "not") {
                        // If we're dealing with a complex expression, or a simple one
                        if ((chunker.exec(match[3]) || "").length > 1 || /^\w/.test(match[3])) {
                            match[3] = _Sizzle2(match[3], null, null, curLoop);
                        } else {
                            var ret = _Sizzle2.filter(match[3], curLoop, inplace, true ^ not);

                            if (!inplace) {
                                result.push.apply(result, ret);
                            }

                            return false;
                        }
                    } else if (Expr.match.POS.test(match[0]) || Expr.match.CHILD.test(match[0])) {
                        return true;
                    }

                    return match;
                },

                POS: function POS(match) {
                    match.unshift(true);

                    return match;
                }
            },

            filters: {
                enabled: function enabled(elem) {
                    return elem.disabled === false && elem.type !== "hidden";
                },

                disabled: function disabled(elem) {
                    return elem.disabled === true;
                },

                checked: function checked(elem) {
                    return elem.checked === true;
                },

                selected: function selected(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) {
                        elem.parentNode.selectedIndex;
                    }

                    return elem.selected === true;
                },

                parent: function parent(elem) {
                    return !!elem.firstChild;
                },

                empty: function empty(elem) {
                    return !elem.firstChild;
                },

                has: function has(elem, i, match) {
                    return !!_Sizzle2(match[3], elem).length;
                },

                header: function header(elem) {
                    return (/h\d/i.test(elem.nodeName)
                    );
                },

                text: function text(elem) {
                    var attr = elem.getAttribute("type"),
                        type = elem.type;
                    // IE6 and 7 will map elem.type to 'text' for new HTML5 types (search, etc)
                    // use getAttribute instead to test this case
                    return elem.nodeName.toLowerCase() === "input" && "text" === type && (attr === type || attr === null);
                },

                radio: function radio(elem) {
                    return elem.nodeName.toLowerCase() === "input" && "radio" === elem.type;
                },

                checkbox: function checkbox(elem) {
                    return elem.nodeName.toLowerCase() === "input" && "checkbox" === elem.type;
                },

                file: function file(elem) {
                    return elem.nodeName.toLowerCase() === "input" && "file" === elem.type;
                },

                password: function password(elem) {
                    return elem.nodeName.toLowerCase() === "input" && "password" === elem.type;
                },

                submit: function submit(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return (name === "input" || name === "button") && "submit" === elem.type;
                },

                image: function image(elem) {
                    return elem.nodeName.toLowerCase() === "input" && "image" === elem.type;
                },

                reset: function reset(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return (name === "input" || name === "button") && "reset" === elem.type;
                },

                button: function button(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && "button" === elem.type || name === "button";
                },

                input: function input(elem) {
                    return (/input|select|textarea|button/i.test(elem.nodeName)
                    );
                },

                focus: function focus(elem) {
                    return elem === elem.ownerDocument.activeElement;
                }
            },
            setFilters: {
                first: function first(elem, i) {
                    return i === 0;
                },

                last: function last(elem, i, match, array) {
                    return i === array.length - 1;
                },

                even: function even(elem, i) {
                    return i % 2 === 0;
                },

                odd: function odd(elem, i) {
                    return i % 2 === 1;
                },

                lt: function lt(elem, i, match) {
                    return i < match[3] - 0;
                },

                gt: function gt(elem, i, match) {
                    return i > match[3] - 0;
                },

                nth: function nth(elem, i, match) {
                    return match[3] - 0 === i;
                },

                eq: function eq(elem, i, match) {
                    return match[3] - 0 === i;
                }
            },
            filter: {
                PSEUDO: function PSEUDO(elem, match, i, array) {
                    var name = match[1],
                        filter = Expr.filters[name];

                    if (filter) {
                        return filter(elem, i, match, array);
                    } else if (name === "contains") {
                        return (elem.textContent || elem.innerText || getText([elem]) || "").indexOf(match[3]) >= 0;
                    } else if (name === "not") {
                        var not = match[3];

                        for (var j = 0, l = not.length; j < l; j++) {
                            if (not[j] === elem) {
                                return false;
                            }
                        }

                        return true;
                    } else {
                        _Sizzle2.error(name);
                    }
                },

                CHILD: function CHILD(elem, match) {
                    var first,
                        last,
                        doneName,
                        parent,
                        cache,
                        count,
                        diff,
                        type = match[1],
                        node = elem;

                    switch (type) {
                        case "only":
                        case "first":
                            while (node = node.previousSibling) {
                                if (node.nodeType === 1) {
                                    return false;
                                }
                            }

                            if (type === "first") {
                                return true;
                            }

                            node = elem;

                        /* falls through */
                        case "last":
                            while (node = node.nextSibling) {
                                if (node.nodeType === 1) {
                                    return false;
                                }
                            }

                            return true;

                        case "nth":
                            first = match[2];
                            last = match[3];

                            if (first === 1 && last === 0) {
                                return true;
                            }

                            doneName = match[0];
                            parent = elem.parentNode;

                            if (parent && (parent[expando] !== doneName || !elem.nodeIndex)) {
                                count = 0;

                                for (node = parent.firstChild; node; node = node.nextSibling) {
                                    if (node.nodeType === 1) {
                                        node.nodeIndex = ++count;
                                    }
                                }

                                parent[expando] = doneName;
                            }

                            diff = elem.nodeIndex - last;

                            if (first === 0) {
                                return diff === 0;
                            } else {
                                return diff % first === 0 && diff / first >= 0;
                            }
                    }
                },

                ID: function ID(elem, match) {
                    return elem.nodeType === 1 && elem.getAttribute("id") === match;
                },

                TAG: function TAG(elem, match) {
                    return match === "*" && elem.nodeType === 1 || !!elem.nodeName && elem.nodeName.toLowerCase() === match;
                },

                CLASS: function CLASS(elem, match) {
                    return (" " + (elem.className || elem.getAttribute("class")) + " ").indexOf(match) > -1;
                },

                ATTR: function ATTR(elem, match) {
                    var name = match[1],
                        result = _Sizzle2.attr ? _Sizzle2.attr(elem, name) : Expr.attrHandle[name] ? Expr.attrHandle[name](elem) : elem[name] != null ? elem[name] : elem.getAttribute(name),
                        value = result + "",
                        type = match[2],
                        check = match[4];

                    return result == null ? type === "!=" : !type && _Sizzle2.attr ? result != null : type === "=" ? value === check : type === "*=" ? value.indexOf(check) >= 0 : type === "~=" ? (" " + value + " ").indexOf(check) >= 0 : !check ? value && result !== false : type === "!=" ? value !== check : type === "^=" ? value.indexOf(check) === 0 : type === "$=" ? value.substr(value.length - check.length) === check : type === "|=" ? value === check || value.substr(0, check.length + 1) === check + "-" : false;
                },

                POS: function POS(elem, match, i, array) {
                    var name = match[2],
                        filter = Expr.setFilters[name];

                    if (filter) {
                        return filter(elem, i, match, array);
                    }
                }
            }
        };

        var origPOS = Expr.match.POS,
            fescape = function fescape(all, num) {
            return "\\" + (num - 0 + 1);
        };

        for (var type in Expr.match) {
            Expr.match[type] = new RegExp(Expr.match[type].source + /(?![^\[]*\])(?![^\(]*\))/.source);
            Expr.leftMatch[type] = new RegExp(/(^(?:.|\r|\n)*?)/.source + Expr.match[type].source.replace(/\\(\d+)/g, fescape));
        }
        // Expose origPOS
        // "global" as in regardless of relation to brackets/parens
        Expr.match.globalPOS = origPOS;

        var makeArray = function makeArray(array, results) {
            array = Array.prototype.slice.call(array, 0);

            if (results) {
                results.push.apply(results, array);
                return results;
            }

            return array;
        };

        // Perform a simple check to determine if the browser is capable of
        // converting a NodeList to an array using builtin methods.
        // Also verifies that the returned array holds DOM nodes
        // (which is not the case in the Blackberry browser)
        try {
            Array.prototype.slice.call(document.documentElement.childNodes, 0)[0].nodeType;

            // Provide a fallback method if it does not work
        } catch (e) {
            makeArray = function makeArray(array, results) {
                var i = 0,
                    ret = results || [];

                if (toString.call(array) === "[object Array]") {
                    Array.prototype.push.apply(ret, array);
                } else {
                    if (typeof array.length === "number") {
                        for (var l = array.length; i < l; i++) {
                            ret.push(array[i]);
                        }
                    } else {
                        for (; array[i]; i++) {
                            ret.push(array[i]);
                        }
                    }
                }

                return ret;
            };
        }

        var sortOrder, siblingCheck;

        if (document.documentElement.compareDocumentPosition) {
            sortOrder = function sortOrder(a, b) {
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }

                if (!a.compareDocumentPosition || !b.compareDocumentPosition) {
                    return a.compareDocumentPosition ? -1 : 1;
                }

                return a.compareDocumentPosition(b) & 4 ? -1 : 1;
            };
        } else {
            sortOrder = function sortOrder(a, b) {
                // The nodes are identical, we can exit early
                if (a === b) {
                    hasDuplicate = true;
                    return 0;

                    // Fallback to using sourceIndex (in IE) if it's available on both nodes
                } else if (a.sourceIndex && b.sourceIndex) {
                    return a.sourceIndex - b.sourceIndex;
                }

                var al,
                    bl,
                    ap = [],
                    bp = [],
                    aup = a.parentNode,
                    bup = b.parentNode,
                    cur = aup;

                // If the nodes are siblings (or identical) we can do a quick check
                if (aup === bup) {
                    return siblingCheck(a, b);

                    // If no parents were found then the nodes are disconnected
                } else if (!aup) {
                    return -1;
                } else if (!bup) {
                    return 1;
                }

                // Otherwise they're somewhere else in the tree so we need
                // to build up a full list of the parentNodes for comparison
                while (cur) {
                    ap.unshift(cur);
                    cur = cur.parentNode;
                }

                cur = bup;

                while (cur) {
                    bp.unshift(cur);
                    cur = cur.parentNode;
                }

                al = ap.length;
                bl = bp.length;

                // Start walking down the tree looking for a discrepancy
                for (var i = 0; i < al && i < bl; i++) {
                    if (ap[i] !== bp[i]) {
                        return siblingCheck(ap[i], bp[i]);
                    }
                }

                // We ended someplace up the tree so do a sibling check
                return i === al ? siblingCheck(a, bp[i], -1) : siblingCheck(ap[i], b, 1);
            };

            siblingCheck = function siblingCheck(a, b, ret) {
                if (a === b) {
                    return ret;
                }

                var cur = a.nextSibling;

                while (cur) {
                    if (cur === b) {
                        return -1;
                    }

                    cur = cur.nextSibling;
                }

                return 1;
            };
        }

        // Check to see if the browser returns elements by name when
        // querying by getElementById (and provide a workaround)
        (function () {
            // We're going to inject a fake input element with a specified name
            var form = document.createElement("div"),
                id = "script" + new Date().getTime(),
                root = document.documentElement;

            form.innerHTML = "<a name='" + id + "'/>";

            // Inject it into the root element, check its status, and remove it quickly
            root.insertBefore(form, root.firstChild);

            // The workaround has to do additional checks after a getElementById
            // Which slows things down for other browsers (hence the branching)
            if (document.getElementById(id)) {
                Expr.find.ID = function (match, context, isXML) {
                    if (typeof context.getElementById !== "undefined" && !isXML) {
                        var m = context.getElementById(match[1]);

                        return m ? m.id === match[1] || typeof m.getAttributeNode !== "undefined" && m.getAttributeNode("id").nodeValue === match[1] ? [m] : undefined : [];
                    }
                };

                Expr.filter.ID = function (elem, match) {
                    var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");

                    return elem.nodeType === 1 && node && node.nodeValue === match;
                };
            }

            root.removeChild(form);

            // release memory in IE
            root = form = null;
        })();

        (function () {
            // Check to see if the browser returns only elements
            // when doing getElementsByTagName("*")

            // Create a fake element
            var div = document.createElement("div");
            div.appendChild(document.createComment(""));

            // Make sure no comments are found
            if (div.getElementsByTagName("*").length > 0) {
                Expr.find.TAG = function (match, context) {
                    var results = context.getElementsByTagName(match[1]);

                    // Filter out possible comments
                    if (match[1] === "*") {
                        var tmp = [];

                        for (var i = 0; results[i]; i++) {
                            if (results[i].nodeType === 1) {
                                tmp.push(results[i]);
                            }
                        }

                        results = tmp;
                    }

                    return results;
                };
            }

            // Check to see if an attribute returns normalized href attributes
            div.innerHTML = "<a href='#'></a>";

            if (div.firstChild && typeof div.firstChild.getAttribute !== "undefined" && div.firstChild.getAttribute("href") !== "#") {

                Expr.attrHandle.href = function (elem) {
                    return elem.getAttribute("href", 2);
                };
            }

            // release memory in IE
            div = null;
        })();

        if (document.querySelectorAll) {
            (function () {
                var oldSizzle = _Sizzle2,
                    div = document.createElement("div"),
                    id = "__sizzle__";

                div.innerHTML = "<p class='TEST'></p>";

                // Safari can't handle uppercase or unicode characters when
                // in quirks mode.
                if (div.querySelectorAll && div.querySelectorAll(".TEST").length === 0) {
                    return;
                }

                _Sizzle2 = function _Sizzle(query, context, extra, seed) {
                    context = context || document;

                    // Only use querySelectorAll on non-XML documents
                    // (ID selectors don't work in non-HTML documents)
                    if (!seed && !_Sizzle2.isXML(context)) {
                        // See if we find a selector to speed up
                        var match = /^(\w+$)|^\.([\w\-]+$)|^#([\w\-]+$)/.exec(query);

                        if (match && (context.nodeType === 1 || context.nodeType === 9)) {
                            // Speed-up: Sizzle("TAG")
                            if (match[1]) {
                                return makeArray(context.getElementsByTagName(query), extra);

                                // Speed-up: Sizzle(".CLASS")
                            } else if (match[2] && Expr.find.CLASS && context.getElementsByClassName) {
                                return makeArray(context.getElementsByClassName(match[2]), extra);
                            }
                        }

                        if (context.nodeType === 9) {
                            // Speed-up: Sizzle("body")
                            // The body element only exists once, optimize finding it
                            if (query === "body" && context.body) {
                                return makeArray([context.body], extra);

                                // Speed-up: Sizzle("#ID")
                            } else if (match && match[3]) {
                                var elem = context.getElementById(match[3]);

                                // Check parentNode to catch when Blackberry 4.6 returns
                                // nodes that are no longer in the document #6963
                                if (elem && elem.parentNode) {
                                    // Handle the case where IE and Opera return items
                                    // by name instead of ID
                                    if (elem.id === match[3]) {
                                        return makeArray([elem], extra);
                                    }
                                } else {
                                    return makeArray([], extra);
                                }
                            }

                            try {
                                return makeArray(context.querySelectorAll(query), extra);
                            } catch (qsaError) {}

                            // qSA works strangely on Element-rooted queries
                            // We can work around this by specifying an extra ID on the root
                            // and working up from there (Thanks to Andrew Dupont for the technique)
                            // IE 8 doesn't work on object elements
                        } else if (context.nodeType === 1 && context.nodeName.toLowerCase() !== "object") {
                            var oldContext = context,
                                old = context.getAttribute("id"),
                                nid = old || id,
                                hasParent = context.parentNode,
                                relativeHierarchySelector = /^\s*[+~]/.test(query);

                            if (!old) {
                                context.setAttribute("id", nid);
                            } else {
                                nid = nid.replace(/'/g, "\\$&");
                            }
                            if (relativeHierarchySelector && hasParent) {
                                context = context.parentNode;
                            }

                            try {
                                if (!relativeHierarchySelector || hasParent) {
                                    return makeArray(context.querySelectorAll("[id='" + nid + "'] " + query), extra);
                                }
                            } catch (pseudoError) {} finally {
                                if (!old) {
                                    oldContext.removeAttribute("id");
                                }
                            }
                        }
                    }

                    return oldSizzle(query, context, extra, seed);
                };

                for (var prop in oldSizzle) {
                    _Sizzle2[prop] = oldSizzle[prop];
                }

                // release memory in IE
                div = null;
            })();
        }

        (function () {
            var html = document.documentElement,
                matches = html.matchesSelector || html.mozMatchesSelector || html.webkitMatchesSelector || html.msMatchesSelector;

            if (matches) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9 fails this)
                var disconnectedMatch = !matches.call(document.createElement("div"), "div"),
                    pseudoWorks = false;

                try {
                    // This should fail with an exception
                    // Gecko does not error, returns false instead
                    matches.call(document.documentElement, "[test!='']:sizzle");
                } catch (pseudoError) {
                    pseudoWorks = true;
                }

                _Sizzle2.matchesSelector = function (node, expr) {
                    // Make sure that attribute selectors are quoted
                    expr = expr.replace(/\=\s*([^'"\]]*)\s*\]/g, "='$1']");

                    if (!_Sizzle2.isXML(node)) {
                        try {
                            if (pseudoWorks || !Expr.match.PSEUDO.test(expr) && !/!=/.test(expr)) {
                                var ret = matches.call(node, expr);

                                // IE 9's matchesSelector returns false on disconnected nodes
                                if (ret || !disconnectedMatch ||
                                // As well, disconnected nodes are said to be in a document
                                // fragment in IE 9, so check for that
                                node.document && node.document.nodeType !== 11) {
                                    return ret;
                                }
                            }
                        } catch (e) {}
                    }

                    return _Sizzle2(expr, null, null, [node]).length > 0;
                };
            }
        })();

        (function () {
            var div = document.createElement("div");

            div.innerHTML = "<div class='test e'></div><div class='test'></div>";

            // Opera can't find a second classname (in 9.6)
            // Also, make sure that getElementsByClassName actually exists
            if (!div.getElementsByClassName || div.getElementsByClassName("e").length === 0) {
                return;
            }

            // Safari caches class attributes, doesn't catch changes (in 3.2)
            div.lastChild.className = "e";

            if (div.getElementsByClassName("e").length === 1) {
                return;
            }

            Expr.order.splice(1, 0, "CLASS");
            Expr.find.CLASS = function (match, context, isXML) {
                if (typeof context.getElementsByClassName !== "undefined" && !isXML) {
                    return context.getElementsByClassName(match[1]);
                }
            };

            // release memory in IE
            div = null;
        })();

        function dirNodeCheck(dir, cur, doneName, checkSet, nodeCheck, isXML) {
            for (var i = 0, l = checkSet.length; i < l; i++) {
                var elem = checkSet[i];

                if (elem) {
                    var match = false;

                    elem = elem[dir];

                    while (elem) {
                        if (elem[expando] === doneName) {
                            match = checkSet[elem.sizset];
                            break;
                        }

                        if (elem.nodeType === 1 && !isXML) {
                            elem[expando] = doneName;
                            elem.sizset = i;
                        }

                        if (elem.nodeName.toLowerCase() === cur) {
                            match = elem;
                            break;
                        }

                        elem = elem[dir];
                    }

                    checkSet[i] = match;
                }
            }
        }

        function dirCheck(dir, cur, doneName, checkSet, nodeCheck, isXML) {
            for (var i = 0, l = checkSet.length; i < l; i++) {
                var elem = checkSet[i];

                if (elem) {
                    var match = false;

                    elem = elem[dir];

                    while (elem) {
                        if (elem[expando] === doneName) {
                            match = checkSet[elem.sizset];
                            break;
                        }

                        if (elem.nodeType === 1) {
                            if (!isXML) {
                                elem[expando] = doneName;
                                elem.sizset = i;
                            }

                            if (typeof cur !== "string") {
                                if (elem === cur) {
                                    match = true;
                                    break;
                                }
                            } else if (_Sizzle2.filter(cur, [elem]).length > 0) {
                                match = elem;
                                break;
                            }
                        }

                        elem = elem[dir];
                    }

                    checkSet[i] = match;
                }
            }
        }

        if (document.documentElement.contains) {
            _Sizzle2.contains = function (a, b) {
                return a !== b && (a.contains ? a.contains(b) : true);
            };
        } else if (document.documentElement.compareDocumentPosition) {
            _Sizzle2.contains = function (a, b) {
                return !!(a.compareDocumentPosition(b) & 16);
            };
        } else {
            _Sizzle2.contains = function () {
                return false;
            };
        }

        _Sizzle2.isXML = function (elem) {
            // documentElement is verified for cases where it doesn't yet exist
            // (such as loading iframes in IE - #4833)
            var documentElement = (elem ? elem.ownerDocument || elem : 0).documentElement;

            return documentElement ? documentElement.nodeName !== "HTML" : false;
        };

        var posProcess = function posProcess(selector, context, seed) {
            var match,
                tmpSet = [],
                later = "",
                root = context.nodeType ? [context] : context;

            // Position selectors must be done after the filter
            // And so must :not(positional) so we move all PSEUDOs to the end
            while (match = Expr.match.PSEUDO.exec(selector)) {
                later += match[0];
                selector = selector.replace(Expr.match.PSEUDO, "");
            }

            selector = Expr.relative[selector] ? selector + "*" : selector;

            for (var i = 0, l = root.length; i < l; i++) {
                _Sizzle2(selector, root[i], tmpSet, seed);
            }

            return _Sizzle2.filter(later, tmpSet);
        };

        // EXPOSE
        // Override sizzle attribute retrieval
        _Sizzle2.attr = jQuery.attr;
        _Sizzle2.selectors.attrMap = {};
        jQuery.find = _Sizzle2;
        jQuery.expr = _Sizzle2.selectors;
        jQuery.expr[":"] = jQuery.expr.filters;
        jQuery.unique = _Sizzle2.uniqueSort;
        jQuery.text = _Sizzle2.getText;
        jQuery.isXMLDoc = _Sizzle2.isXML;
        jQuery.contains = _Sizzle2.contains;
    })();

    var runtil = /Until$/,
        rparentsprev = /^(?:parents|prevUntil|prevAll)/,

    // Note: This RegExp should be improved, or likely pulled from Sizzle
    rmultiselector = /,/,
        isSimple = /^.[^:#\[\.,]*$/,
        slice = Array.prototype.slice,
        POS = jQuery.expr.match.globalPOS,

    // methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };

    jQuery.fn.extend({
        find: function find(selector) {
            var self = this,
                i,
                l;

            if (typeof selector !== "string") {
                return jQuery(selector).filter(function () {
                    for (i = 0, l = self.length; i < l; i++) {
                        if (jQuery.contains(self[i], this)) {
                            return true;
                        }
                    }
                });
            }

            var ret = this.pushStack("", "find", selector),
                length,
                n,
                r;

            for (i = 0, l = this.length; i < l; i++) {
                length = ret.length;
                jQuery.find(selector, this[i], ret);

                if (i > 0) {
                    // Make sure that the results are unique
                    for (n = length; n < ret.length; n++) {
                        for (r = 0; r < length; r++) {
                            if (ret[r] === ret[n]) {
                                ret.splice(n--, 1);
                                break;
                            }
                        }
                    }
                }
            }

            return ret;
        },

        has: function has(target) {
            var targets = jQuery(target);
            return this.filter(function () {
                for (var i = 0, l = targets.length; i < l; i++) {
                    if (jQuery.contains(this, targets[i])) {
                        return true;
                    }
                }
            });
        },

        not: function not(selector) {
            return this.pushStack(winnow(this, selector, false), "not", selector);
        },

        filter: function filter(selector) {
            return this.pushStack(winnow(this, selector, true), "filter", selector);
        },

        is: function is(selector) {
            return !!selector && (typeof selector === "string" ?
            // If this is a positional selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            POS.test(selector) ? jQuery(selector, this.context).index(this[0]) >= 0 : jQuery.filter(selector, this).length > 0 : this.filter(selector).length > 0);
        },

        closest: function closest(selectors, context) {
            var ret = [],
                i,
                l,
                cur = this[0];

            // Array (deprecated as of jQuery 1.7)
            if (jQuery.isArray(selectors)) {
                var level = 1;

                while (cur && cur.ownerDocument && cur !== context) {
                    for (i = 0; i < selectors.length; i++) {

                        if (jQuery(cur).is(selectors[i])) {
                            ret.push({ selector: selectors[i], elem: cur, level: level });
                        }
                    }

                    cur = cur.parentNode;
                    level++;
                }

                return ret;
            }

            // String
            var pos = POS.test(selectors) || typeof selectors !== "string" ? jQuery(selectors, context || this.context) : 0;

            for (i = 0, l = this.length; i < l; i++) {
                cur = this[i];

                while (cur) {
                    if (pos ? pos.index(cur) > -1 : jQuery.find.matchesSelector(cur, selectors)) {
                        ret.push(cur);
                        break;
                    } else {
                        cur = cur.parentNode;
                        if (!cur || !cur.ownerDocument || cur === context || cur.nodeType === 11) {
                            break;
                        }
                    }
                }
            }

            ret = ret.length > 1 ? jQuery.unique(ret) : ret;

            return this.pushStack(ret, "closest", selectors);
        },

        // Determine the position of an element within
        // the matched set of elements
        index: function index(elem) {

            // No argument, return index in parent
            if (!elem) {
                return this[0] && this[0].parentNode ? this.prevAll().length : -1;
            }

            // index in selector
            if (typeof elem === "string") {
                return jQuery.inArray(this[0], jQuery(elem));
            }

            // Locate the position of the desired element
            return jQuery.inArray(
            // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem, this);
        },

        add: function add(selector, context) {
            var set = typeof selector === "string" ? jQuery(selector, context) : jQuery.makeArray(selector && selector.nodeType ? [selector] : selector),
                all = jQuery.merge(this.get(), set);

            return this.pushStack(isDisconnected(set[0]) || isDisconnected(all[0]) ? all : jQuery.unique(all));
        },

        andSelf: function andSelf() {
            return this.add(this.prevObject);
        }
    });

    // A painfully simple check to see if an element is disconnected
    // from a document (should be improved, where feasible).
    function isDisconnected(node) {
        return !node || !node.parentNode || node.parentNode.nodeType === 11;
    }

    jQuery.each({
        parent: function parent(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function parents(elem) {
            return jQuery.dir(elem, "parentNode");
        },
        parentsUntil: function parentsUntil(elem, i, until) {
            return jQuery.dir(elem, "parentNode", until);
        },
        next: function next(elem) {
            return jQuery.nth(elem, 2, "nextSibling");
        },
        prev: function prev(elem) {
            return jQuery.nth(elem, 2, "previousSibling");
        },
        nextAll: function nextAll(elem) {
            return jQuery.dir(elem, "nextSibling");
        },
        prevAll: function prevAll(elem) {
            return jQuery.dir(elem, "previousSibling");
        },
        nextUntil: function nextUntil(elem, i, until) {
            return jQuery.dir(elem, "nextSibling", until);
        },
        prevUntil: function prevUntil(elem, i, until) {
            return jQuery.dir(elem, "previousSibling", until);
        },
        siblings: function siblings(elem) {
            return jQuery.sibling((elem.parentNode || {}).firstChild, elem);
        },
        children: function children(elem) {
            return jQuery.sibling(elem.firstChild);
        },
        contents: function contents(elem) {
            return jQuery.nodeName(elem, "iframe") ? elem.contentDocument || elem.contentWindow.document : jQuery.makeArray(elem.childNodes);
        }
    }, function (name, fn) {
        jQuery.fn[name] = function (until, selector) {
            var ret = jQuery.map(this, fn, until);

            if (!runtil.test(name)) {
                selector = until;
            }

            if (selector && typeof selector === "string") {
                ret = jQuery.filter(selector, ret);
            }

            ret = this.length > 1 && !guaranteedUnique[name] ? jQuery.unique(ret) : ret;

            if ((this.length > 1 || rmultiselector.test(selector)) && rparentsprev.test(name)) {
                ret = ret.reverse();
            }

            return this.pushStack(ret, name, slice.call(arguments).join(","));
        };
    });

    jQuery.extend({
        filter: function filter(expr, elems, not) {
            if (not) {
                expr = ":not(" + expr + ")";
            }

            return elems.length === 1 ? jQuery.find.matchesSelector(elems[0], expr) ? [elems[0]] : [] : jQuery.find.matches(expr, elems);
        },

        dir: function dir(elem, _dir, until) {
            var matched = [],
                cur = elem[_dir];

            while (cur && cur.nodeType !== 9 && (until === undefined || cur.nodeType !== 1 || !jQuery(cur).is(until))) {
                if (cur.nodeType === 1) {
                    matched.push(cur);
                }
                cur = cur[_dir];
            }
            return matched;
        },

        nth: function nth(cur, result, dir, elem) {
            result = result || 1;
            var num = 0;

            for (; cur; cur = cur[dir]) {
                if (cur.nodeType === 1 && ++num === result) {
                    break;
                }
            }

            return cur;
        },

        sibling: function sibling(n, elem) {
            var r = [];

            for (; n; n = n.nextSibling) {
                if (n.nodeType === 1 && n !== elem) {
                    r.push(n);
                }
            }

            return r;
        }
    });

    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, keep) {

        // Can't pass null or undefined to indexOf in Firefox 4
        // Set to 0 to skip string check
        qualifier = qualifier || 0;

        if (jQuery.isFunction(qualifier)) {
            return jQuery.grep(elements, function (elem, i) {
                var retVal = !!qualifier.call(elem, i, elem);
                return retVal === keep;
            });
        } else if (qualifier.nodeType) {
            return jQuery.grep(elements, function (elem, i) {
                return elem === qualifier === keep;
            });
        } else if (typeof qualifier === "string") {
            var filtered = jQuery.grep(elements, function (elem) {
                return elem.nodeType === 1;
            });

            if (isSimple.test(qualifier)) {
                return jQuery.filter(qualifier, filtered, !keep);
            } else {
                qualifier = jQuery.filter(qualifier, filtered);
            }
        }

        return jQuery.grep(elements, function (elem, i) {
            return jQuery.inArray(elem, qualifier) >= 0 === keep;
        });
    }

    function createSafeFragment(document) {
        var list = nodeNames.split("|"),
            safeFrag = document.createDocumentFragment();

        if (safeFrag.createElement) {
            while (list.length) {
                safeFrag.createElement(list.pop());
            }
        }
        return safeFrag;
    }

    var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|" + "header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
        rinlinejQuery = / jQuery\d+="(?:\d+|null)"/g,
        rleadingWhitespace = /^\s+/,
        rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,
        rtagName = /<([\w:]+)/,
        rtbody = /<tbody/i,
        rhtml = /<|&#?\w+;/,
        rnoInnerhtml = /<(?:script|style)/i,
        rnocache = /<(?:script|object|embed|option|style)/i,
        rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),

    // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
        rscriptType = /\/(java|ecma)script/i,
        rcleanScript = /^\s*<!(?:\[CDATA\[|\-\-)/,
        wrapMap = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        legend: [1, "<fieldset>", "</fieldset>"],
        thead: [1, "<table>", "</table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
        area: [1, "<map>", "</map>"],
        _default: [0, "", ""]
    },
        safeFragment = createSafeFragment(document);

    wrapMap.optgroup = wrapMap.option;
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;

    // IE can't serialize <link> and <script> tags normally
    if (!jQuery.support.htmlSerialize) {
        wrapMap._default = [1, "div<div>", "</div>"];
    }

    jQuery.fn.extend({
        text: function text(value) {
            return jQuery.access(this, function (value) {
                return value === undefined ? jQuery.text(this) : this.empty().append((this[0] && this[0].ownerDocument || document).createTextNode(value));
            }, null, value, arguments.length);
        },

        wrapAll: function wrapAll(html) {
            if (jQuery.isFunction(html)) {
                return this.each(function (i) {
                    jQuery(this).wrapAll(html.call(this, i));
                });
            }

            if (this[0]) {
                // The elements to wrap the target around
                var wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

                if (this[0].parentNode) {
                    wrap.insertBefore(this[0]);
                }

                wrap.map(function () {
                    var elem = this;

                    while (elem.firstChild && elem.firstChild.nodeType === 1) {
                        elem = elem.firstChild;
                    }

                    return elem;
                }).append(this);
            }

            return this;
        },

        wrapInner: function wrapInner(html) {
            if (jQuery.isFunction(html)) {
                return this.each(function (i) {
                    jQuery(this).wrapInner(html.call(this, i));
                });
            }

            return this.each(function () {
                var self = jQuery(this),
                    contents = self.contents();

                if (contents.length) {
                    contents.wrapAll(html);
                } else {
                    self.append(html);
                }
            });
        },

        wrap: function wrap(html) {
            var isFunction = jQuery.isFunction(html);

            return this.each(function (i) {
                jQuery(this).wrapAll(isFunction ? html.call(this, i) : html);
            });
        },

        unwrap: function unwrap() {
            return this.parent().each(function () {
                if (!jQuery.nodeName(this, "body")) {
                    jQuery(this).replaceWith(this.childNodes);
                }
            }).end();
        },

        append: function append() {
            return this.domManip(arguments, true, function (elem) {
                if (this.nodeType === 1) {
                    this.appendChild(elem);
                }
            });
        },

        prepend: function prepend() {
            return this.domManip(arguments, true, function (elem) {
                if (this.nodeType === 1) {
                    this.insertBefore(elem, this.firstChild);
                }
            });
        },

        before: function before() {
            if (this[0] && this[0].parentNode) {
                return this.domManip(arguments, false, function (elem) {
                    this.parentNode.insertBefore(elem, this);
                });
            } else if (arguments.length) {
                var set = jQuery.clean(arguments);
                set.push.apply(set, this.toArray());
                return this.pushStack(set, "before", arguments);
            }
        },

        after: function after() {
            if (this[0] && this[0].parentNode) {
                return this.domManip(arguments, false, function (elem) {
                    this.parentNode.insertBefore(elem, this.nextSibling);
                });
            } else if (arguments.length) {
                var set = this.pushStack(this, "after", arguments);
                set.push.apply(set, jQuery.clean(arguments));
                return set;
            }
        },

        // keepData is for internal use only--do not document
        remove: function remove(selector, keepData) {
            for (var i = 0, elem; (elem = this[i]) != null; i++) {
                if (!selector || jQuery.filter(selector, [elem]).length) {
                    if (!keepData && elem.nodeType === 1) {
                        jQuery.cleanData(elem.getElementsByTagName("*"));
                        jQuery.cleanData([elem]);
                    }

                    if (elem.parentNode) {
                        elem.parentNode.removeChild(elem);
                    }
                }
            }

            return this;
        },

        empty: function empty() {
            for (var i = 0, elem; (elem = this[i]) != null; i++) {
                // Remove element nodes and prevent memory leaks
                if (elem.nodeType === 1) {
                    jQuery.cleanData(elem.getElementsByTagName("*"));
                }

                // Remove any remaining nodes
                while (elem.firstChild) {
                    elem.removeChild(elem.firstChild);
                }
            }

            return this;
        },

        clone: function clone(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

            return this.map(function () {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },

        html: function html(value) {
            return jQuery.access(this, function (value) {
                var elem = this[0] || {},
                    i = 0,
                    l = this.length;

                if (value === undefined) {
                    return elem.nodeType === 1 ? elem.innerHTML.replace(rinlinejQuery, "") : null;
                }

                if (typeof value === "string" && !rnoInnerhtml.test(value) && (jQuery.support.leadingWhitespace || !rleadingWhitespace.test(value)) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {

                    value = value.replace(rxhtmlTag, "<$1></$2>");

                    try {
                        for (; i < l; i++) {
                            // Remove element nodes and prevent memory leaks
                            elem = this[i] || {};
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(elem.getElementsByTagName("*"));
                                elem.innerHTML = value;
                            }
                        }

                        elem = 0;

                        // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }

                if (elem) {
                    this.empty().append(value);
                }
            }, null, value, arguments.length);
        },

        replaceWith: function replaceWith(value) {
            if (this[0] && this[0].parentNode) {
                // Make sure that the elements are removed from the DOM before they are inserted
                // this can help fix replacing a parent with child elements
                if (jQuery.isFunction(value)) {
                    return this.each(function (i) {
                        var self = jQuery(this),
                            old = self.html();
                        self.replaceWith(value.call(this, i, old));
                    });
                }

                if (typeof value !== "string") {
                    value = jQuery(value).detach();
                }

                return this.each(function () {
                    var next = this.nextSibling,
                        parent = this.parentNode;

                    jQuery(this).remove();

                    if (next) {
                        jQuery(next).before(value);
                    } else {
                        jQuery(parent).append(value);
                    }
                });
            } else {
                return this.length ? this.pushStack(jQuery(jQuery.isFunction(value) ? value() : value), "replaceWith", value) : this;
            }
        },

        detach: function detach(selector) {
            return this.remove(selector, true);
        },

        domManip: function domManip(args, table, callback) {
            var results,
                first,
                fragment,
                parent,
                value = args[0],
                scripts = [];

            // We can't cloneNode fragments that contain checked, in WebKit
            if (!jQuery.support.checkClone && arguments.length === 3 && typeof value === "string" && rchecked.test(value)) {
                return this.each(function () {
                    jQuery(this).domManip(args, table, callback, true);
                });
            }

            if (jQuery.isFunction(value)) {
                return this.each(function (i) {
                    var self = jQuery(this);
                    args[0] = value.call(this, i, table ? self.html() : undefined);
                    self.domManip(args, table, callback);
                });
            }

            if (this[0]) {
                parent = value && value.parentNode;

                // If we're in a fragment, just use that instead of building a new one
                if (jQuery.support.parentNode && parent && parent.nodeType === 11 && parent.childNodes.length === this.length) {
                    results = { fragment: parent };
                } else {
                    results = jQuery.buildFragment(args, this, scripts);
                }

                fragment = results.fragment;

                if (fragment.childNodes.length === 1) {
                    first = fragment = fragment.firstChild;
                } else {
                    first = fragment.firstChild;
                }

                if (first) {
                    table = table && jQuery.nodeName(first, "tr");

                    for (var i = 0, l = this.length, lastIndex = l - 1; i < l; i++) {
                        callback.call(table ? root(this[i], first) : this[i],
                        // Make sure that we do not leak memory by inadvertently discarding
                        // the original fragment (which might have attached data) instead of
                        // using it; in addition, use the original fragment object for the last
                        // item instead of first because it can end up being emptied incorrectly
                        // in certain situations (Bug #8070).
                        // Fragments from the fragment cache must always be cloned and never used
                        // in place.
                        results.cacheable || l > 1 && i < lastIndex ? jQuery.clone(fragment, true, true) : fragment);
                    }
                }

                if (scripts.length) {
                    jQuery.each(scripts, function (i, elem) {
                        if (elem.src) {
                            jQuery.ajax({
                                type: "GET",
                                global: false,
                                url: elem.src,
                                async: false,
                                dataType: "script"
                            });
                        } else {
                            jQuery.globalEval((elem.text || elem.textContent || elem.innerHTML || "").replace(rcleanScript, "/*$0*/"));
                        }

                        if (elem.parentNode) {
                            elem.parentNode.removeChild(elem);
                        }
                    });
                }
            }

            return this;
        }
    });

    function root(elem, cur) {
        return jQuery.nodeName(elem, "table") ? elem.getElementsByTagName("tbody")[0] || elem.appendChild(elem.ownerDocument.createElement("tbody")) : elem;
    }

    function cloneCopyEvent(src, dest) {

        if (dest.nodeType !== 1 || !jQuery.hasData(src)) {
            return;
        }

        var type,
            i,
            l,
            oldData = jQuery._data(src),
            curData = jQuery._data(dest, oldData),
            events = oldData.events;

        if (events) {
            delete curData.handle;
            curData.events = {};

            for (type in events) {
                for (i = 0, l = events[type].length; i < l; i++) {
                    jQuery.event.add(dest, type, events[type][i]);
                }
            }
        }

        // make the cloned public data object a copy from the original
        if (curData.data) {
            curData.data = jQuery.extend({}, curData.data);
        }
    }

    function cloneFixAttributes(src, dest) {
        var nodeName;

        // We do not need to do anything for non-Elements
        if (dest.nodeType !== 1) {
            return;
        }

        // clearAttributes removes the attributes, which we don't want,
        // but also removes the attachEvent events, which we *do* want
        if (dest.clearAttributes) {
            dest.clearAttributes();
        }

        // mergeAttributes, in contrast, only merges back on the
        // original attributes, not the events
        if (dest.mergeAttributes) {
            dest.mergeAttributes(src);
        }

        nodeName = dest.nodeName.toLowerCase();

        // IE6-8 fail to clone children inside object elements that use
        // the proprietary classid attribute value (rather than the type
        // attribute) to identify the type of content to display
        if (nodeName === "object") {
            dest.outerHTML = src.outerHTML;
        } else if (nodeName === "input" && (src.type === "checkbox" || src.type === "radio")) {
            // IE6-8 fails to persist the checked state of a cloned checkbox
            // or radio button. Worse, IE6-7 fail to give the cloned element
            // a checked appearance if the defaultChecked value isn't also set
            if (src.checked) {
                dest.defaultChecked = dest.checked = src.checked;
            }

            // IE6-7 get confused and end up setting the value of a cloned
            // checkbox/radio button to an empty string instead of "on"
            if (dest.value !== src.value) {
                dest.value = src.value;
            }

            // IE6-8 fails to return the selected option to the default selected
            // state when cloning options
        } else if (nodeName === "option") {
            dest.selected = src.defaultSelected;

            // IE6-8 fails to set the defaultValue to the correct value when
            // cloning other types of input fields
        } else if (nodeName === "input" || nodeName === "textarea") {
            dest.defaultValue = src.defaultValue;

            // IE blanks contents when cloning scripts
        } else if (nodeName === "script" && dest.text !== src.text) {
            dest.text = src.text;
        }

        // Event data gets referenced instead of copied if the expando
        // gets copied too
        dest.removeAttribute(jQuery.expando);

        // Clear flags for bubbling special change/submit events, they must
        // be reattached when the newly cloned events are first activated
        dest.removeAttribute("_submit_attached");
        dest.removeAttribute("_change_attached");
    }

    jQuery.buildFragment = function (args, nodes, scripts) {
        var fragment,
            cacheable,
            cacheresults,
            doc,
            first = args[0];

        // nodes may contain either an explicit document object,
        // a jQuery collection or context object.
        // If nodes[0] contains a valid object to assign to doc
        if (nodes && nodes[0]) {
            doc = nodes[0].ownerDocument || nodes[0];
        }

        // Ensure that an attr object doesn't incorrectly stand in as a document object
        // Chrome and Firefox seem to allow this to occur and will throw exception
        // Fixes #8950
        if (!doc.createDocumentFragment) {
            doc = document;
        }

        // Only cache "small" (1/2 KB) HTML strings that are associated with the main document
        // Cloning options loses the selected state, so don't cache them
        // IE 6 doesn't like it when you put <object> or <embed> elements in a fragment
        // Also, WebKit does not clone 'checked' attributes on cloneNode, so don't cache
        // Lastly, IE6,7,8 will not correctly reuse cached fragments that were created from unknown elems #10501
        if (args.length === 1 && typeof first === "string" && first.length < 512 && doc === document && first.charAt(0) === "<" && !rnocache.test(first) && (jQuery.support.checkClone || !rchecked.test(first)) && (jQuery.support.html5Clone || !rnoshimcache.test(first))) {

            cacheable = true;

            cacheresults = jQuery.fragments[first];
            if (cacheresults && cacheresults !== 1) {
                fragment = cacheresults;
            }
        }

        if (!fragment) {
            fragment = doc.createDocumentFragment();
            jQuery.clean(args, doc, fragment, scripts);
        }

        if (cacheable) {
            jQuery.fragments[first] = cacheresults ? fragment : 1;
        }

        return { fragment: fragment, cacheable: cacheable };
    };

    jQuery.fragments = {};

    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function (name, original) {
        jQuery.fn[name] = function (selector) {
            var ret = [],
                insert = jQuery(selector),
                parent = this.length === 1 && this[0].parentNode;

            if (parent && parent.nodeType === 11 && parent.childNodes.length === 1 && insert.length === 1) {
                insert[original](this[0]);
                return this;
            } else {
                for (var i = 0, l = insert.length; i < l; i++) {
                    var elems = (i > 0 ? this.clone(true) : this).get();
                    jQuery(insert[i])[original](elems);
                    ret = ret.concat(elems);
                }

                return this.pushStack(ret, name, insert.selector);
            }
        };
    });

    function getAll(elem) {
        if (typeof elem.getElementsByTagName !== "undefined") {
            return elem.getElementsByTagName("*");
        } else if (typeof elem.querySelectorAll !== "undefined") {
            return elem.querySelectorAll("*");
        } else {
            return [];
        }
    }

    // Used in clean, fixes the defaultChecked property
    function fixDefaultChecked(elem) {
        if (elem.type === "checkbox" || elem.type === "radio") {
            elem.defaultChecked = elem.checked;
        }
    }

    // Finds all inputs and passes them to fixDefaultChecked
    function findInputs(elem) {
        var nodeName = (elem.nodeName || "").toLowerCase();
        if (nodeName === "input") {
            fixDefaultChecked(elem);
            // Skip scripts, get other children
        } else if (nodeName !== "script" && typeof elem.getElementsByTagName !== "undefined") {
            jQuery.grep(elem.getElementsByTagName("input"), fixDefaultChecked);
        }
    }

    // Derived From: http://www.iecss.com/shimprove/javascript/shimprove.1-0-1.js
    function shimCloneNode(elem) {
        var div = document.createElement("div");
        safeFragment.appendChild(div);

        div.innerHTML = elem.outerHTML;
        return div.firstChild;
    }

    jQuery.extend({
        clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
            var srcElements,
                destElements,
                i,

            // IE<=8 does not properly clone detached, unknown element nodes
            clone = jQuery.support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test("<" + elem.nodeName + ">") ? elem.cloneNode(true) : shimCloneNode(elem);

            if ((!jQuery.support.noCloneEvent || !jQuery.support.noCloneChecked) && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // IE copies events bound via attachEvent when using cloneNode.
                // Calling detachEvent on the clone will also remove the events
                // from the original. In order to get around this, we use some
                // proprietary methods to clear the events. Thanks to MooTools
                // guys for this hotness.

                cloneFixAttributes(elem, clone);

                // Using Sizzle here is crazy slow, so we use getElementsByTagName instead
                srcElements = getAll(elem);
                destElements = getAll(clone);

                // Weird iteration because IE will replace the length property
                // with an element if you are cloning the body and one of the
                // elements on the page has a name or id of "length"
                for (i = 0; srcElements[i]; ++i) {
                    // Ensure that the destination node is not null; Fixes #9587
                    if (destElements[i]) {
                        cloneFixAttributes(srcElements[i], destElements[i]);
                    }
                }
            }

            // Copy the events from the original to the clone
            if (dataAndEvents) {
                cloneCopyEvent(elem, clone);

                if (deepDataAndEvents) {
                    srcElements = getAll(elem);
                    destElements = getAll(clone);

                    for (i = 0; srcElements[i]; ++i) {
                        cloneCopyEvent(srcElements[i], destElements[i]);
                    }
                }
            }

            srcElements = destElements = null;

            // Return the cloned set
            return clone;
        },

        clean: function clean(elems, context, fragment, scripts) {
            var checkScriptType,
                script,
                j,
                ret = [];

            context = context || document;

            // !context.createElement fails in IE with an error but returns typeof 'object'
            if (typeof context.createElement === "undefined") {
                context = context.ownerDocument || context[0] && context[0].ownerDocument || document;
            }

            for (var i = 0, elem; (elem = elems[i]) != null; i++) {
                if (typeof elem === "number") {
                    elem += "";
                }

                if (!elem) {
                    continue;
                }

                // Convert html string into DOM nodes
                if (typeof elem === "string") {
                    if (!rhtml.test(elem)) {
                        elem = context.createTextNode(elem);
                    } else {
                        // Fix "XHTML"-style tags in all browsers
                        elem = elem.replace(rxhtmlTag, "<$1></$2>");

                        // Trim whitespace, otherwise indexOf won't work as expected
                        var tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase(),
                            wrap = wrapMap[tag] || wrapMap._default,
                            depth = wrap[0],
                            div = context.createElement("div"),
                            safeChildNodes = safeFragment.childNodes,
                            remove;

                        // Append wrapper element to unknown element safe doc fragment
                        if (context === document) {
                            // Use the fragment we've already created for this document
                            safeFragment.appendChild(div);
                        } else {
                            // Use a fragment created with the owner document
                            createSafeFragment(context).appendChild(div);
                        }

                        // Go to html and back, then peel off extra wrappers
                        div.innerHTML = wrap[1] + elem + wrap[2];

                        // Move to the right depth
                        while (depth--) {
                            div = div.lastChild;
                        }

                        // Remove IE's autoinserted <tbody> from table fragments
                        if (!jQuery.support.tbody) {

                            // String was a <table>, *may* have spurious <tbody>
                            var hasBody = rtbody.test(elem),
                                tbody = tag === "table" && !hasBody ? div.firstChild && div.firstChild.childNodes :

                            // String was a bare <thead> or <tfoot>
                            wrap[1] === "<table>" && !hasBody ? div.childNodes : [];

                            for (j = tbody.length - 1; j >= 0; --j) {
                                if (jQuery.nodeName(tbody[j], "tbody") && !tbody[j].childNodes.length) {
                                    tbody[j].parentNode.removeChild(tbody[j]);
                                }
                            }
                        }

                        // IE completely kills leading whitespace when innerHTML is used
                        if (!jQuery.support.leadingWhitespace && rleadingWhitespace.test(elem)) {
                            div.insertBefore(context.createTextNode(rleadingWhitespace.exec(elem)[0]), div.firstChild);
                        }

                        elem = div.childNodes;

                        // Clear elements from DocumentFragment (safeFragment or otherwise)
                        // to avoid hoarding elements. Fixes #11356
                        if (div) {
                            div.parentNode.removeChild(div);

                            // Guard against -1 index exceptions in FF3.6
                            if (safeChildNodes.length > 0) {
                                remove = safeChildNodes[safeChildNodes.length - 1];

                                if (remove && remove.parentNode) {
                                    remove.parentNode.removeChild(remove);
                                }
                            }
                        }
                    }
                }

                // Resets defaultChecked for any radios and checkboxes
                // about to be appended to the DOM in IE 6/7 (#8060)
                var len;
                if (!jQuery.support.appendChecked) {
                    if (elem[0] && typeof (len = elem.length) === "number") {
                        for (j = 0; j < len; j++) {
                            findInputs(elem[j]);
                        }
                    } else {
                        findInputs(elem);
                    }
                }

                if (elem.nodeType) {
                    ret.push(elem);
                } else {
                    ret = jQuery.merge(ret, elem);
                }
            }

            if (fragment) {
                checkScriptType = function checkScriptType(elem) {
                    return !elem.type || rscriptType.test(elem.type);
                };
                for (i = 0; ret[i]; i++) {
                    script = ret[i];
                    if (scripts && jQuery.nodeName(script, "script") && (!script.type || rscriptType.test(script.type))) {
                        scripts.push(script.parentNode ? script.parentNode.removeChild(script) : script);
                    } else {
                        if (script.nodeType === 1) {
                            var jsTags = jQuery.grep(script.getElementsByTagName("script"), checkScriptType);

                            ret.splice.apply(ret, [i + 1, 0].concat(jsTags));
                        }
                        fragment.appendChild(script);
                    }
                }
            }

            return ret;
        },

        cleanData: function cleanData(elems) {
            var data,
                id,
                cache = jQuery.cache,
                special = jQuery.event.special,
                deleteExpando = jQuery.support.deleteExpando;

            for (var i = 0, elem; (elem = elems[i]) != null; i++) {
                if (elem.nodeName && jQuery.noData[elem.nodeName.toLowerCase()]) {
                    continue;
                }

                id = elem[jQuery.expando];

                if (id) {
                    data = cache[id];

                    if (data && data.events) {
                        for (var type in data.events) {
                            if (special[type]) {
                                jQuery.event.remove(elem, type);

                                // This is a shortcut to avoid jQuery.event.remove's overhead
                            } else {
                                jQuery.removeEvent(elem, type, data.handle);
                            }
                        }

                        // Null the DOM reference to avoid IE6/7/8 leak (#7054)
                        if (data.handle) {
                            data.handle.elem = null;
                        }
                    }

                    if (deleteExpando) {
                        delete elem[jQuery.expando];
                    } else if (elem.removeAttribute) {
                        elem.removeAttribute(jQuery.expando);
                    }

                    delete cache[id];
                }
            }
        }
    });

    var ralpha = /alpha\([^)]*\)/i,
        ropacity = /opacity=([^)]*)/,

    // fixed for IE9, see #8346
    rupper = /([A-Z]|^ms)/g,
        rnum = /^[\-+]?(?:\d*\.)?\d+$/i,
        rnumnonpx = /^-?(?:\d*\.)?\d+(?!px)[^\d\s]+$/i,
        rrelNum = /^([\-+])=([\-+.\de]+)/,
        rmargin = /^margin/,
        cssShow = { position: "absolute", visibility: "hidden", display: "block" },


    // order is important!
    cssExpand = ["Top", "Right", "Bottom", "Left"],
        curCSS,
        getComputedStyle,
        currentStyle;

    jQuery.fn.css = function (name, value) {
        return jQuery.access(this, function (elem, name, value) {
            return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
        }, name, value, arguments.length > 1);
    };

    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function get(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    } else {
                        return elem.style.opacity;
                    }
                }
            }
        },

        // Exclude the following css properties to add px
        cssNumber: {
            "fillOpacity": true,
            "fontWeight": true,
            "lineHeight": true,
            "opacity": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },

        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {
            // normalize float css property
            "float": jQuery.support.cssFloat ? "cssFloat" : "styleFloat"
        },

        // Get and set the style property on a DOM Node
        style: function style(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
                return;
            }

            // Make sure that we're working with the right name
            var ret,
                type,
                origName = jQuery.camelCase(name),
                style = elem.style,
                hooks = jQuery.cssHooks[origName];

            name = jQuery.cssProps[origName] || origName;

            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value);

                // convert relative number strings (+= or -=) to relative numbers. #7345
                if (type === "string" && (ret = rrelNum.exec(value))) {
                    value = +(ret[1] + 1) * +ret[2] + parseFloat(jQuery.css(elem, name));
                    // Fixes bug #9237
                    type = "number";
                }

                // Make sure that NaN and null values aren't set. See: #7116
                if (value == null || type === "number" && isNaN(value)) {
                    return;
                }

                // If a number was passed in, add 'px' to the (except for certain CSS properties)
                if (type === "number" && !jQuery.cssNumber[origName]) {
                    value += "px";
                }

                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value)) !== undefined) {
                    // Wrapped to prevent IE from throwing errors when 'invalid' values are provided
                    // Fixes bug #5509
                    try {
                        style[name] = value;
                    } catch (e) {}
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
                    return ret;
                }

                // Otherwise just get the value from the style object
                return style[name];
            }
        },

        css: function css(elem, name, extra) {
            var ret, hooks;

            // Make sure that we're working with the right name
            name = jQuery.camelCase(name);
            hooks = jQuery.cssHooks[name];
            name = jQuery.cssProps[name] || name;

            // cssFloat needs a special treatment
            if (name === "cssFloat") {
                name = "float";
            }

            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks && (ret = hooks.get(elem, true, extra)) !== undefined) {
                return ret;

                // Otherwise, if a way to get the computed value exists, use that
            } else if (curCSS) {
                return curCSS(elem, name);
            }
        },

        // A method for quickly swapping in/out CSS properties to get correct calculations
        swap: function swap(elem, options, callback) {
            var old = {},
                ret,
                name;

            // Remember the old values, and insert the new ones
            for (name in options) {
                old[name] = elem.style[name];
                elem.style[name] = options[name];
            }

            ret = callback.call(elem);

            // Revert the old values
            for (name in options) {
                elem.style[name] = old[name];
            }

            return ret;
        }
    });

    // DEPRECATED in 1.3, Use jQuery.css() instead
    jQuery.curCSS = jQuery.css;

    if (document.defaultView && document.defaultView.getComputedStyle) {
        getComputedStyle = function getComputedStyle(elem, name) {
            var ret,
                defaultView,
                computedStyle,
                width,
                style = elem.style;

            name = name.replace(rupper, "-$1").toLowerCase();

            if ((defaultView = elem.ownerDocument.defaultView) && (computedStyle = defaultView.getComputedStyle(elem, null))) {

                ret = computedStyle.getPropertyValue(name);
                if (ret === "" && !jQuery.contains(elem.ownerDocument.documentElement, elem)) {
                    ret = jQuery.style(elem, name);
                }
            }

            // A tribute to the "awesome hack by Dean Edwards"
            // WebKit uses "computed value (percentage if specified)" instead of "used value" for margins
            // which is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
            if (!jQuery.support.pixelMargin && computedStyle && rmargin.test(name) && rnumnonpx.test(ret)) {
                width = style.width;
                style.width = ret;
                ret = computedStyle.width;
                style.width = width;
            }

            return ret;
        };
    }

    if (document.documentElement.currentStyle) {
        currentStyle = function currentStyle(elem, name) {
            var left,
                rsLeft,
                uncomputed,
                ret = elem.currentStyle && elem.currentStyle[name],
                style = elem.style;

            // Avoid setting ret to empty string here
            // so we don't default to auto
            if (ret == null && style && (uncomputed = style[name])) {
                ret = uncomputed;
            }

            // From the awesome hack by Dean Edwards
            // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291

            // If we're not dealing with a regular pixel number
            // but a number that has a weird ending, we need to convert it to pixels
            if (rnumnonpx.test(ret)) {

                // Remember the original values
                left = style.left;
                rsLeft = elem.runtimeStyle && elem.runtimeStyle.left;

                // Put in the new values to get a computed value out
                if (rsLeft) {
                    elem.runtimeStyle.left = elem.currentStyle.left;
                }
                style.left = name === "fontSize" ? "1em" : ret;
                ret = style.pixelLeft + "px";

                // Revert the changed values
                style.left = left;
                if (rsLeft) {
                    elem.runtimeStyle.left = rsLeft;
                }
            }

            return ret === "" ? "auto" : ret;
        };
    }

    curCSS = getComputedStyle || currentStyle;

    function getWidthOrHeight(elem, name, extra) {

        // Start with offset property
        var val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
            i = name === "width" ? 1 : 0,
            len = 4;

        if (val > 0) {
            if (extra !== "border") {
                for (; i < len; i += 2) {
                    if (!extra) {
                        val -= parseFloat(jQuery.css(elem, "padding" + cssExpand[i])) || 0;
                    }
                    if (extra === "margin") {
                        val += parseFloat(jQuery.css(elem, extra + cssExpand[i])) || 0;
                    } else {
                        val -= parseFloat(jQuery.css(elem, "border" + cssExpand[i] + "Width")) || 0;
                    }
                }
            }

            return val + "px";
        }

        // Fall back to computed then uncomputed css if necessary
        val = curCSS(elem, name);
        if (val < 0 || val == null) {
            val = elem.style[name];
        }

        // Computed unit is not pixels. Stop here and return.
        if (rnumnonpx.test(val)) {
            return val;
        }

        // Normalize "", auto, and prepare for extra
        val = parseFloat(val) || 0;

        // Add padding, border, margin
        if (extra) {
            for (; i < len; i += 2) {
                val += parseFloat(jQuery.css(elem, "padding" + cssExpand[i])) || 0;
                if (extra !== "padding") {
                    val += parseFloat(jQuery.css(elem, "border" + cssExpand[i] + "Width")) || 0;
                }
                if (extra === "margin") {
                    val += parseFloat(jQuery.css(elem, extra + cssExpand[i])) || 0;
                }
            }
        }

        return val + "px";
    }

    jQuery.each(["height", "width"], function (i, name) {
        jQuery.cssHooks[name] = {
            get: function get(elem, computed, extra) {
                if (computed) {
                    if (elem.offsetWidth !== 0) {
                        return getWidthOrHeight(elem, name, extra);
                    } else {
                        return jQuery.swap(elem, cssShow, function () {
                            return getWidthOrHeight(elem, name, extra);
                        });
                    }
                }
            },

            set: function set(elem, value) {
                return rnum.test(value) ? value + "px" : value;
            }
        };
    });

    if (!jQuery.support.opacity) {
        jQuery.cssHooks.opacity = {
            get: function get(elem, computed) {
                // IE uses filters for opacity
                return ropacity.test((computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "") ? parseFloat(RegExp.$1) / 100 + "" : computed ? "1" : "";
            },

            set: function set(elem, value) {
                var style = elem.style,
                    currentStyle = elem.currentStyle,
                    opacity = jQuery.isNumeric(value) ? "alpha(opacity=" + value * 100 + ")" : "",
                    filter = currentStyle && currentStyle.filter || style.filter || "";

                // IE has trouble with opacity if it does not have layout
                // Force it by setting the zoom level
                style.zoom = 1;

                // if setting opacity to 1, and no other filters exist - attempt to remove filter attribute #6652
                if (value >= 1 && jQuery.trim(filter.replace(ralpha, "")) === "") {

                    // Setting style.filter to null, "" & " " still leave "filter:" in the cssText
                    // if "filter:" is present at all, clearType is disabled, we want to avoid this
                    // style.removeAttribute is IE Only, but so apparently is this code path...
                    style.removeAttribute("filter");

                    // if there there is no filter style applied in a css rule, we are done
                    if (currentStyle && !currentStyle.filter) {
                        return;
                    }
                }

                // otherwise, set new filter values
                style.filter = ralpha.test(filter) ? filter.replace(ralpha, opacity) : filter + " " + opacity;
            }
        };
    }

    jQuery(function () {
        // This hook cannot be added until DOM ready because the support test
        // for it is not run until after DOM ready
        if (!jQuery.support.reliableMarginRight) {
            jQuery.cssHooks.marginRight = {
                get: function get(elem, computed) {
                    // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
                    // Work around by temporarily setting element display to inline-block
                    return jQuery.swap(elem, { "display": "inline-block" }, function () {
                        if (computed) {
                            return curCSS(elem, "margin-right");
                        } else {
                            return elem.style.marginRight;
                        }
                    });
                }
            };
        }
    });

    if (jQuery.expr && jQuery.expr.filters) {
        jQuery.expr.filters.hidden = function (elem) {
            var width = elem.offsetWidth,
                height = elem.offsetHeight;

            return width === 0 && height === 0 || !jQuery.support.reliableHiddenOffsets && (elem.style && elem.style.display || jQuery.css(elem, "display")) === "none";
        };

        jQuery.expr.filters.visible = function (elem) {
            return !jQuery.expr.filters.hidden(elem);
        };
    }

    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function (prefix, suffix) {

        jQuery.cssHooks[prefix + suffix] = {
            expand: function expand(value) {
                var i,


                // assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [value],
                    expanded = {};

                for (i = 0; i < 4; i++) {
                    expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                }

                return expanded;
            }
        };
    });

    var r20 = /%20/g,
        rbracket = /\[\]$/,
        rCRLF = /\r?\n/g,
        rhash = /#.*$/,
        rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,
        // IE leaves an \r character at EOL
    rinput = /^(?:color|date|datetime|datetime-local|email|hidden|month|number|password|range|search|tel|text|time|url|week)$/i,

    // #7653, #8125, #8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app\-storage|.+\-extension|file|res|widget):$/,
        rnoContent = /^(?:GET|HEAD)$/,
        rprotocol = /^\/\//,
        rquery = /\?/,
        rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
        rselectTextarea = /^(?:select|textarea)/i,
        rspacesAjax = /\s+/,
        rts = /([?&])_=[^&]*/,
        rurl = /^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+))?)?/,


    // Keep a copy of the old load method
    _load = jQuery.fn.load,


    /* Prefilters
     * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
     * 2) These are called:
     *    - BEFORE asking for a transport
     *    - AFTER param serialization (s.data is a string if s.processData is true)
     * 3) key is the dataType
     * 4) the catchall symbol "*" can be used
     * 5) execution will start with transport dataType and THEN continue down to "*" if needed
     */
    prefilters = {},


    /* Transports bindings
     * 1) key is the dataType
     * 2) the catchall symbol "*" can be used
     * 3) selection will start with transport dataType and THEN go to "*" if needed
     */
    transports = {},


    // Document location
    ajaxLocation,


    // Document location segments
    ajaxLocParts,


    // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
    allTypes = ["*/"] + ["*"];

    // #8138, IE may throw an exception when accessing
    // a field from window.location if document.domain has been set
    try {
        ajaxLocation = location.href;
    } catch (e) {
        // Use the href attribute of an A element
        // since IE will modify it given document.location
        ajaxLocation = document.createElement("a");
        ajaxLocation.href = "";
        ajaxLocation = ajaxLocation.href;
    }

    // Segment location into parts
    ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || [];

    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {

        // dataTypeExpression is optional and defaults to "*"
        return function (dataTypeExpression, func) {

            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }

            if (jQuery.isFunction(func)) {
                var dataTypes = dataTypeExpression.toLowerCase().split(rspacesAjax),
                    i = 0,
                    length = dataTypes.length,
                    dataType,
                    list,
                    placeBefore;

                // For each dataType in the dataTypeExpression
                for (; i < length; i++) {
                    dataType = dataTypes[i];
                    // We control if we're asked to add before
                    // any existing element
                    placeBefore = /^\+/.test(dataType);
                    if (placeBefore) {
                        dataType = dataType.substr(1) || "*";
                    }
                    list = structure[dataType] = structure[dataType] || [];
                    // then we add to the structure accordingly
                    list[placeBefore ? "unshift" : "push"](func);
                }
            }
        };
    }

    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR, dataType /* internal */, inspected /* internal */) {

        dataType = dataType || options.dataTypes[0];
        inspected = inspected || {};

        inspected[dataType] = true;

        var list = structure[dataType],
            i = 0,
            length = list ? list.length : 0,
            executeOnly = structure === prefilters,
            selection;

        for (; i < length && (executeOnly || !selection); i++) {
            selection = list[i](options, originalOptions, jqXHR);
            // If we got redirected to another dataType
            // we try there if executing only and not done already
            if (typeof selection === "string") {
                if (!executeOnly || inspected[selection]) {
                    selection = undefined;
                } else {
                    options.dataTypes.unshift(selection);
                    selection = inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR, selection, inspected);
                }
            }
        }
        // If we're only executing or nothing was selected
        // we try the catchall dataType if not done already
        if ((executeOnly || !selection) && !inspected["*"]) {
            selection = inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR, "*", inspected);
        }
        // unnecessary when only executing (prefilters)
        // but it'll be ignored by the caller in that case
        return selection;
    }

    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes #9887
    function ajaxExtend(target, src) {
        var key,
            deep,
            flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for (key in src) {
            if (src[key] !== undefined) {
                (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
            }
        }
        if (deep) {
            jQuery.extend(true, target, deep);
        }
    }

    jQuery.fn.extend({
        load: function load(url, params, callback) {
            if (typeof url !== "string" && _load) {
                return _load.apply(this, arguments);

                // Don't do a request if no elements are being requested
            } else if (!this.length) {
                return this;
            }

            var off = url.indexOf(" ");
            if (off >= 0) {
                var selector = url.slice(off, url.length);
                url = url.slice(0, off);
            }

            // Default to a GET request
            var type = "GET";

            // If the second parameter was provided
            if (params) {
                // If it's a function
                if (jQuery.isFunction(params)) {
                    // We assume that it's the callback
                    callback = params;
                    params = undefined;

                    // Otherwise, build a param string
                } else if ((typeof params === "undefined" ? "undefined" : (0, _typeof3.default)(params)) === "object") {
                    params = jQuery.param(params, jQuery.ajaxSettings.traditional);
                    type = "POST";
                }
            }

            var self = this;

            // Request the remote document
            jQuery.ajax({
                url: url,
                type: type,
                dataType: "html",
                data: params,
                // Complete callback (responseText is used internally)
                complete: function complete(jqXHR, status, responseText) {
                    // Store the response as specified by the jqXHR object
                    responseText = jqXHR.responseText;
                    // If successful, inject the HTML into all the matched elements
                    if (jqXHR.isResolved()) {
                        // #4825: Get the actual response in case
                        // a dataFilter is present in ajaxSettings
                        jqXHR.done(function (r) {
                            responseText = r;
                        });
                        // See if a selector was specified
                        self.html(selector ?
                        // Create a dummy div to hold the results
                        jQuery("<div>")
                        // inject the contents of the document in, removing the scripts
                        // to avoid any 'Permission Denied' errors in IE
                        .append(responseText.replace(rscript, ""))

                        // Locate the specified elements
                        .find(selector) :

                        // If not, just inject the full result
                        responseText);
                    }

                    if (callback) {
                        self.each(callback, [responseText, status, jqXHR]);
                    }
                }
            });

            return this;
        },

        serialize: function serialize() {
            return jQuery.param(this.serializeArray());
        },

        serializeArray: function serializeArray() {
            return this.map(function () {
                return this.elements ? jQuery.makeArray(this.elements) : this;
            }).filter(function () {
                return this.name && !this.disabled && (this.checked || rselectTextarea.test(this.nodeName) || rinput.test(this.type));
            }).map(function (i, elem) {
                var val = jQuery(this).val();

                return val == null ? null : jQuery.isArray(val) ? jQuery.map(val, function (val, i) {
                    return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
                }) : { name: elem.name, value: val.replace(rCRLF, "\r\n") };
            }).get();
        }
    });

    // Attach a bunch of functions for handling common AJAX events
    jQuery.each("ajaxStart ajaxStop ajaxComplete ajaxError ajaxSuccess ajaxSend".split(" "), function (i, o) {
        jQuery.fn[o] = function (f) {
            return this.on(o, f);
        };
    });

    jQuery.each(["get", "post"], function (i, method) {
        jQuery[method] = function (url, data, callback, type) {
            // shift arguments if data argument was omitted
            if (jQuery.isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }

            return jQuery.ajax({
                type: method,
                url: url,
                data: data,
                success: callback,
                dataType: type
            });
        };
    });

    jQuery.extend({

        getScript: function getScript(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        },

        getJSON: function getJSON(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },

        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function ajaxSetup(target, settings) {
            if (settings) {
                // Building a settings object
                ajaxExtend(target, jQuery.ajaxSettings);
            } else {
                // Extending ajaxSettings
                settings = target;
                target = jQuery.ajaxSettings;
            }
            ajaxExtend(target, settings);
            return target;
        },

        ajaxSettings: {
            url: ajaxLocation,
            isLocal: rlocalProtocol.test(ajaxLocParts[1]),
            global: true,
            type: "GET",
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            processData: true,
            async: true,
            /*
             timeout: 0,
             data: null,
             dataType: null,
             username: null,
             password: null,
             cache: null,
             traditional: false,
             headers: {},
             */

            accepts: {
                xml: "application/xml, text/xml",
                html: "text/html",
                text: "text/plain",
                json: "application/json, text/javascript",
                "*": allTypes
            },

            contents: {
                xml: /xml/,
                html: /html/,
                json: /json/
            },

            responseFields: {
                xml: "responseXML",
                text: "responseText"
            },

            // List of data converters
            // 1) key format is "source_type destination_type" (a single space in-between)
            // 2) the catchall symbol "*" can be used for source_type
            converters: {

                // Convert anything to text
                "* text": window.String,

                // Text to html (true = no transformation)
                "text html": true,

                // Evaluate text as a json expression
                "text json": jQuery.parseJSON,

                // Parse text as xml
                "text xml": jQuery.parseXML
            },

            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                context: true,
                url: true
            }
        },

        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),

        // Main method
        ajax: function ajax(url, options) {

            // If url is an object, simulate pre-1.5 signature
            if ((typeof url === "undefined" ? "undefined" : (0, _typeof3.default)(url)) === "object") {
                options = url;
                url = undefined;
            }

            // Force options to be an object
            options = options || {};

            var // Create the final options object
            s = jQuery.ajaxSetup({}, options),

            // Callbacks context
            callbackContext = s.context || s,

            // Context for global events
            // It's the callbackContext if one was provided in the options
            // and if it's a DOM node or a jQuery collection
            globalEventContext = callbackContext !== s && (callbackContext.nodeType || callbackContext instanceof jQuery) ? jQuery(callbackContext) : jQuery.event,

            // Deferreds
            deferred = jQuery.Deferred(),
                completeDeferred = jQuery.Callbacks("once memory"),

            // Status-dependent callbacks
            statusCode = s.statusCode || {},

            // ifModified key
            ifModifiedKey,

            // Headers (they are sent all at once)
            requestHeaders = {},
                requestHeadersNames = {},

            // Response headers
            responseHeadersString,
                responseHeaders,

            // transport
            transport,

            // timeout handle
            timeoutTimer,

            // Cross-domain detection vars
            parts,

            // The jqXHR state
            state = 0,

            // To know if global events are to be dispatched
            fireGlobals,

            // Loop variable
            i,

            // Fake xhr
            jqXHR = {

                readyState: 0,

                // Caches the header
                setRequestHeader: function setRequestHeader(name, value) {
                    if (!state) {
                        var lname = name.toLowerCase();
                        name = requestHeadersNames[lname] = requestHeadersNames[lname] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },

                // Raw string
                getAllResponseHeaders: function getAllResponseHeaders() {
                    return state === 2 ? responseHeadersString : null;
                },

                // Builds headers hashtable if needed
                getResponseHeader: function getResponseHeader(key) {
                    var match;
                    if (state === 2) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while (match = rheaders.exec(responseHeadersString)) {
                                responseHeaders[match[1].toLowerCase()] = match[2];
                            }
                        }
                        match = responseHeaders[key.toLowerCase()];
                    }
                    return match === undefined ? null : match;
                },

                // Overrides response content-type header
                overrideMimeType: function overrideMimeType(type) {
                    if (!state) {
                        s.mimeType = type;
                    }
                    return this;
                },

                // Cancel the request
                abort: function abort(statusText) {
                    statusText = statusText || "abort";
                    if (transport) {
                        transport.abort(statusText);
                    }
                    done(0, statusText);
                    return this;
                }
            };

            // Callback for when everything is done
            // It is defined here because jslint complains if it is declared
            // at the end of the function (which would be more logical and readable)
            function done(status, nativeStatusText, responses, headers) {

                // Called once
                if (state === 2) {
                    return;
                }

                // State is "done" now
                state = 2;

                // Clear timeout if it exists
                if (timeoutTimer) {
                    clearTimeout(timeoutTimer);
                }

                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;

                // Cache response headers
                responseHeadersString = headers || "";

                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;

                var isSuccess,
                    success,
                    error,
                    statusText = nativeStatusText,
                    response = responses ? ajaxHandleResponses(s, jqXHR, responses) : undefined,
                    lastModified,
                    etag;

                // If successful, handle type chaining
                if (status >= 200 && status < 300 || status === 304) {

                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {

                        if (lastModified = jqXHR.getResponseHeader("Last-Modified")) {
                            jQuery.lastModified[ifModifiedKey] = lastModified;
                        }
                        if (etag = jqXHR.getResponseHeader("Etag")) {
                            jQuery.etag[ifModifiedKey] = etag;
                        }
                    }

                    // If not modified
                    if (status === 304) {

                        statusText = "notmodified";
                        isSuccess = true;

                        // If we have data
                    } else {

                        try {
                            success = ajaxConvert(s, response);
                            statusText = "success";
                            isSuccess = true;
                        } catch (e) {
                            // We have a parsererror
                            statusText = "parsererror";
                            error = e;
                        }
                    }
                } else {
                    // We extract error from statusText
                    // then normalize statusText and status for non-aborts
                    error = statusText;
                    if (!statusText || status) {
                        statusText = "error";
                        if (status < 0) {
                            status = 0;
                        }
                    }
                }

                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = "" + (nativeStatusText || statusText);

                // Success/Error
                if (isSuccess) {
                    deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
                } else {
                    deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
                }

                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;

                if (fireGlobals) {
                    globalEventContext.trigger("ajax" + (isSuccess ? "Success" : "Error"), [jqXHR, s, isSuccess ? success : error]);
                }

                // Complete
                completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
                    // Handle the global AJAX counter
                    if (! --jQuery.active) {
                        jQuery.event.trigger("ajaxStop");
                    }
                }
            }

            // Attach deferreds
            deferred.promise(jqXHR);
            jqXHR.success = jqXHR.done;
            jqXHR.error = jqXHR.fail;
            jqXHR.complete = completeDeferred.add;

            // Status-dependent callbacks
            jqXHR.statusCode = function (map) {
                if (map) {
                    var tmp;
                    if (state < 2) {
                        for (tmp in map) {
                            statusCode[tmp] = [statusCode[tmp], map[tmp]];
                        }
                    } else {
                        tmp = map[jqXHR.status];
                        jqXHR.then(tmp, tmp);
                    }
                }
                return this;
            };

            // Remove hash character (#7531: and string promotion)
            // Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
            // We also use the url parameter if available
            s.url = ((url || s.url) + "").replace(rhash, "").replace(rprotocol, ajaxLocParts[1] + "//");

            // Extract dataTypes list
            s.dataTypes = jQuery.trim(s.dataType || "*").toLowerCase().split(rspacesAjax);

            // Determine if a cross-domain request is in order
            if (s.crossDomain == null) {
                parts = rurl.exec(s.url.toLowerCase());
                s.crossDomain = !!(parts && (parts[1] != ajaxLocParts[1] || parts[2] != ajaxLocParts[2] || (parts[3] || (parts[1] === "http:" ? 80 : 443)) != (ajaxLocParts[3] || (ajaxLocParts[1] === "http:" ? 80 : 443))));
            }

            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") {
                s.data = jQuery.param(s.data, s.traditional);
            }

            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

            // If request was aborted inside a prefilter, stop there
            if (state === 2) {
                return false;
            }

            // We can fire global events as of now if asked to
            fireGlobals = s.global;

            // Uppercase the type
            s.type = s.type.toUpperCase();

            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);

            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) {
                jQuery.event.trigger("ajaxStart");
            }

            // More options handling for requests with no content
            if (!s.hasContent) {

                // If data is available, append data to url
                if (s.data) {
                    s.url += (rquery.test(s.url) ? "&" : "?") + s.data;
                    // #9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }

                // Get ifModifiedKey before adding the anti-cache parameter
                ifModifiedKey = s.url;

                // Add anti-cache in url if needed
                if (s.cache === false) {

                    var ts = jQuery.now(),

                    // try replacing _= if it is there
                    ret = s.url.replace(rts, "$1_=" + ts);

                    // if nothing was replaced, add timestamp to the end
                    s.url = ret + (ret === s.url ? (rquery.test(s.url) ? "&" : "?") + "_=" + ts : "");
                }
            }

            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
                jqXHR.setRequestHeader("Content-Type", s.contentType);
            }

            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                ifModifiedKey = ifModifiedKey || s.url;
                if (jQuery.lastModified[ifModifiedKey]) {
                    jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[ifModifiedKey]);
                }
                if (jQuery.etag[ifModifiedKey]) {
                    jqXHR.setRequestHeader("If-None-Match", jQuery.etag[ifModifiedKey]);
                }
            }

            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);

            // Check for headers option
            for (i in s.headers) {
                jqXHR.setRequestHeader(i, s.headers[i]);
            }

            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || state === 2)) {
                // Abort if not done already
                jqXHR.abort();
                return false;
            }

            // Install callbacks on deferreds
            for (i in { success: 1, error: 1, complete: 1 }) {
                jqXHR[i](s[i]);
            }

            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

            // If no transport, we auto-abort
            if (!transport) {
                done(-1, "No Transport");
            } else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxSend", [jqXHR, s]);
                }
                // Timeout
                if (s.async && s.timeout > 0) {
                    timeoutTimer = setTimeout(function () {
                        jqXHR.abort("timeout");
                    }, s.timeout);
                }

                try {
                    state = 1;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Propagate exception as error if not done
                    if (state < 2) {
                        done(-1, e);
                        // Simply rethrow otherwise
                    } else {
                        throw e;
                    }
                }
            }

            return jqXHR;
        },

        // Serialize an array of form elements or a set of
        // key/values into a query string
        param: function param(a, traditional) {
            var s = [],
                add = function add(key, value) {
                // If value is a function, invoke it and return its value
                value = jQuery.isFunction(value) ? value() : value;
                s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
            };

            // Set traditional to true for jQuery <= 1.3.2 behavior.
            if (traditional === undefined) {
                traditional = jQuery.ajaxSettings.traditional;
            }

            // If an array was passed in, assume that it is an array of form elements.
            if (jQuery.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
                // Serialize the form elements
                jQuery.each(a, function () {
                    add(this.name, this.value);
                });
            } else {
                // If traditional, encode the "old" way (the way 1.3.2 or older
                // did it), otherwise encode params recursively.
                for (var prefix in a) {
                    buildParams(prefix, a[prefix], traditional, add);
                }
            }

            // Return the resulting serialization
            return s.join("&").replace(r20, "+");
        }
    });

    function buildParams(prefix, obj, traditional, add) {
        if (jQuery.isArray(obj)) {
            // Serialize array item.
            jQuery.each(obj, function (i, v) {
                if (traditional || rbracket.test(prefix)) {
                    // Treat each array item as a scalar.
                    add(prefix, v);
                } else {
                    // If array item is non-scalar (array or object), encode its
                    // numeric index to resolve deserialization ambiguity issues.
                    // Note that rack (as of 1.0.0) can't currently deserialize
                    // nested arrays properly, and attempting to do so may cause
                    // a server error. Possible fixes are to modify rack's
                    // deserialization algorithm or to provide an option or flag
                    // to force array serialization to be shallow.
                    buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : (0, _typeof3.default)(v)) === "object" ? i : "") + "]", v, traditional, add);
                }
            });
        } else if (!traditional && jQuery.type(obj) === "object") {
            // Serialize object item.
            for (var name in obj) {
                buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
            }
        } else {
            // Serialize scalar item.
            add(prefix, obj);
        }
    }

    // This is still on the jQuery object... for now
    // Want to move this to jQuery.ajax some day
    jQuery.extend({

        // Counter for holding the number of active queries
        active: 0,

        // Last-Modified header cache for next request
        lastModified: {},
        etag: {}

    });

    /* Handles responses to an ajax request:
     * - sets all responseXXX fields accordingly
     * - finds the right dataType (mediates between content-type and expected dataType)
     * - returns the corresponding response
     */
    function ajaxHandleResponses(s, jqXHR, responses) {

        var contents = s.contents,
            dataTypes = s.dataTypes,
            responseFields = s.responseFields,
            ct,
            type,
            finalDataType,
            firstDataType;

        // Fill responseXXX fields
        for (type in responseFields) {
            if (type in responses) {
                jqXHR[responseFields[type]] = responses[type];
            }
        }

        // Remove auto dataType and get content-type in the process
        while (dataTypes[0] === "*") {
            dataTypes.shift();
            if (ct === undefined) {
                ct = s.mimeType || jqXHR.getResponseHeader("content-type");
            }
        }

        // Check if we're dealing with a known content-type
        if (ct) {
            for (type in contents) {
                if (contents[type] && contents[type].test(ct)) {
                    dataTypes.unshift(type);
                    break;
                }
            }
        }

        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) {
            finalDataType = dataTypes[0];
        } else {
            // Try convertible dataTypes
            for (type in responses) {
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) {
                    firstDataType = type;
                }
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }

        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) {
                dataTypes.unshift(finalDataType);
            }
            return responses[finalDataType];
        }
    }

    // Chain conversions given the request and the original response
    function ajaxConvert(s, response) {

        // Apply the dataFilter if provided
        if (s.dataFilter) {
            response = s.dataFilter(response, s.dataType);
        }

        var dataTypes = s.dataTypes,
            converters = {},
            i,
            key,
            length = dataTypes.length,
            tmp,

        // Current and previous dataTypes
        current = dataTypes[0],
            prev,

        // Conversion expression
        conversion,

        // Conversion function
        conv,

        // Conversion functions (transitive conversion)
        conv1,
            conv2;

        // For each dataType in the chain
        for (i = 1; i < length; i++) {

            // Create converters map
            // with lowercased keys
            if (i === 1) {
                for (key in s.converters) {
                    if (typeof key === "string") {
                        converters[key.toLowerCase()] = s.converters[key];
                    }
                }
            }

            // Get the dataTypes
            prev = current;
            current = dataTypes[i];

            // If current is auto dataType, update it to prev
            if (current === "*") {
                current = prev;
                // If no auto and dataTypes are actually different
            } else if (prev !== "*" && prev !== current) {

                // Get the converter
                conversion = prev + " " + current;
                conv = converters[conversion] || converters["* " + current];

                // If there is no direct converter, search transitively
                if (!conv) {
                    conv2 = undefined;
                    for (conv1 in converters) {
                        tmp = conv1.split(" ");
                        if (tmp[0] === prev || tmp[0] === "*") {
                            conv2 = converters[tmp[1] + " " + current];
                            if (conv2) {
                                conv1 = converters[conv1];
                                if (conv1 === true) {
                                    conv = conv2;
                                } else if (conv2 === true) {
                                    conv = conv1;
                                }
                                break;
                            }
                        }
                    }
                }
                // If we found no converter, dispatch an error
                if (!(conv || conv2)) {
                    jQuery.error("No conversion from " + conversion.replace(" ", " to "));
                }
                // If found converter is not an equivalence
                if (conv !== true) {
                    // Convert with 1 or 2 converters accordingly
                    response = conv ? conv(response) : conv2(conv1(response));
                }
            }
        }
        return response;
    }

    var jsc = jQuery.now(),
        jsre = /(\=)\?(&|$)|\?\?/i;

    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
            return jQuery.expando + "_" + jsc++;
        }
    });

    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {

        var inspectData = typeof s.data === "string" && /^application\/x\-www\-form\-urlencoded/.test(s.contentType);

        if (s.dataTypes[0] === "jsonp" || s.jsonp !== false && (jsre.test(s.url) || inspectData && jsre.test(s.data))) {

            var responseContainer,
                jsonpCallback = s.jsonpCallback = jQuery.isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback,
                previous = window[jsonpCallback],
                url = s.url,
                data = s.data,
                replace = "$1" + jsonpCallback + "$2";

            if (s.jsonp !== false) {
                url = url.replace(jsre, replace);
                if (s.url === url) {
                    if (inspectData) {
                        data = data.replace(jsre, replace);
                    }
                    if (s.data === data) {
                        // Add callback manually
                        url += (/\?/.test(url) ? "&" : "?") + s.jsonp + "=" + jsonpCallback;
                    }
                }
            }

            s.url = url;
            s.data = data;

            // Install callback
            window[jsonpCallback] = function (response) {
                responseContainer = [response];
            };

            // Clean-up function
            jqXHR.always(function () {
                // Set callback back to previous value
                window[jsonpCallback] = previous;
                // Call if it was a function and we have a response
                if (responseContainer && jQuery.isFunction(previous)) {
                    window[jsonpCallback](responseContainer[0]);
                }
            });

            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function () {
                if (!responseContainer) {
                    jQuery.error(jsonpCallback + " was not called");
                }
                return responseContainer[0];
            };

            // force json dataType
            s.dataTypes[0] = "json";

            // Delegate to script
            return "script";
        }
    });

    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /javascript|ecmascript/
        },
        converters: {
            "text script": function textScript(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });

    // Handle cache's special case and global
    jQuery.ajaxPrefilter("script", function (s) {
        if (s.cache === undefined) {
            s.cache = false;
        }
        if (s.crossDomain) {
            s.type = "GET";
            s.global = false;
        }
    });

    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function (s) {

        // This transport only deals with cross domain requests
        if (s.crossDomain) {

            var script,
                head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;

            return {

                send: function send(_, callback) {

                    script = document.createElement("script");

                    script.async = "async";

                    if (s.scriptCharset) {
                        script.charset = s.scriptCharset;
                    }

                    script.src = s.url;

                    // Attach handlers for all browsers
                    script.onload = script.onreadystatechange = function (_, isAbort) {

                        if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {

                            // Handle memory leak in IE
                            script.onload = script.onreadystatechange = null;

                            // Remove the script
                            if (head && script.parentNode) {
                                head.removeChild(script);
                            }

                            // Dereference the script
                            script = undefined;

                            // Callback if not abort
                            if (!isAbort) {
                                callback(200, "success");
                            }
                        }
                    };
                    // Use insertBefore instead of appendChild  to circumvent an IE6 bug.
                    // This arises when a base node is used (#2709 and #4378).
                    head.insertBefore(script, head.firstChild);
                },

                abort: function abort() {
                    if (script) {
                        script.onload(0, 1);
                    }
                }
            };
        }
    });

    var // #5280: Internet Explorer will keep connections alive if we don't abort on unload
    xhrOnUnloadAbort = window.ActiveXObject ? function () {
        // Abort all pending requests
        for (var key in xhrCallbacks) {
            xhrCallbacks[key](0, 1);
        }
    } : false,
        xhrId = 0,
        xhrCallbacks;

    // Functions to create xhrs
    function createStandardXHR() {
        try {
            return new window.XMLHttpRequest();
        } catch (e) {}
    }

    function createActiveXHR() {
        try {
            return new window.ActiveXObject("Microsoft.XMLHTTP");
        } catch (e) {}
    }

    // Create the request object
    // (This is still attached to ajaxSettings for backward compatibility)
    jQuery.ajaxSettings.xhr = window.ActiveXObject ?
    /* Microsoft failed to properly
     * implement the XMLHttpRequest in IE7 (can't request local files),
     * so we use the ActiveXObject when it is available
     * Additionally XMLHttpRequest can be disabled in IE7/IE8 so
     * we need a fallback.
     */
    function () {
        return !this.isLocal && createStandardXHR() || createActiveXHR();
    } :
    // For all other browsers, use the standard XMLHttpRequest object
    createStandardXHR;

    // Determine support properties
    (function (xhr) {
        jQuery.extend(jQuery.support, {
            ajax: !!xhr,
            cors: !!xhr && "withCredentials" in xhr
        });
    })(jQuery.ajaxSettings.xhr());

    // Create transport if the browser can provide an xhr
    if (jQuery.support.ajax) {

        jQuery.ajaxTransport(function (s) {
            // Cross domain only allowed if supported through XMLHttpRequest
            if (!s.crossDomain || jQuery.support.cors) {

                var _callback;

                return {
                    send: function send(headers, complete) {

                        // Get a new xhr
                        var xhr = s.xhr(),
                            handle,
                            i;

                        // Open the socket
                        // Passing null username, generates a login popup on Opera (#2865)
                        if (s.username) {
                            xhr.open(s.type, s.url, s.async, s.username, s.password);
                        } else {
                            xhr.open(s.type, s.url, s.async);
                        }

                        // Apply custom fields if provided
                        if (s.xhrFields) {
                            for (i in s.xhrFields) {
                                xhr[i] = s.xhrFields[i];
                            }
                        }

                        // Override mime type if needed
                        if (s.mimeType && xhr.overrideMimeType) {
                            xhr.overrideMimeType(s.mimeType);
                        }

                        // X-Requested-With header
                        // For cross-domain requests, seeing as conditions for a preflight are
                        // akin to a jigsaw puzzle, we simply never set it to be sure.
                        // (it can always be set on a per-request basis or even using ajaxSetup)
                        // For same-domain requests, won't change header if already provided.
                        if (!s.crossDomain && !headers["X-Requested-With"]) {
                            headers["X-Requested-With"] = "XMLHttpRequest";
                        }

                        // Need an extra try/catch for cross domain requests in Firefox 3
                        try {
                            for (i in headers) {
                                xhr.setRequestHeader(i, headers[i]);
                            }
                        } catch (_) {}

                        // Do send the request
                        // This may raise an exception which is actually
                        // handled in jQuery.ajax (so no try/catch here)
                        xhr.send(s.hasContent && s.data || null);

                        // Listener
                        _callback = function callback(_, isAbort) {

                            var status, statusText, responseHeaders, responses, xml;

                            // Firefox throws exceptions when accessing properties
                            // of an xhr when a network error occured
                            // http://helpful.knobs-dials.com/index.php/Component_returned_failure_code:_0x80040111_(NS_ERROR_NOT_AVAILABLE)
                            try {

                                // Was never called and is aborted or complete
                                if (_callback && (isAbort || xhr.readyState === 4)) {

                                    // Only called once
                                    _callback = undefined;

                                    // Do not keep as active anymore
                                    if (handle) {
                                        xhr.onreadystatechange = jQuery.noop;
                                        if (xhrOnUnloadAbort) {
                                            delete xhrCallbacks[handle];
                                        }
                                    }

                                    // If it's an abort
                                    if (isAbort) {
                                        // Abort it manually if needed
                                        if (xhr.readyState !== 4) {
                                            xhr.abort();
                                        }
                                    } else {
                                        status = xhr.status;
                                        responseHeaders = xhr.getAllResponseHeaders();
                                        responses = {};
                                        xml = xhr.responseXML;

                                        // Construct response list
                                        if (xml && xml.documentElement /* #4958 */) {
                                                responses.xml = xml;
                                            }

                                        // When requesting binary data, IE6-9 will throw an exception
                                        // on any attempt to access responseText (#11426)
                                        try {
                                            responses.text = xhr.responseText;
                                        } catch (_) {}

                                        // Firefox throws an exception when accessing
                                        // statusText for faulty cross-domain requests
                                        try {
                                            statusText = xhr.statusText;
                                        } catch (e) {
                                            // We normalize with Webkit giving an empty statusText
                                            statusText = "";
                                        }

                                        // Filter status for non standard behaviors

                                        // If the request is local and we have data: assume a success
                                        // (success with no data won't get notified, that's the best we
                                        // can do given current implementations)
                                        if (!status && s.isLocal && !s.crossDomain) {
                                            status = responses.text ? 200 : 404;
                                            // IE - #1450: sometimes returns 1223 when it should be 204
                                        } else if (status === 1223) {
                                            status = 204;
                                        }
                                    }
                                }
                            } catch (firefoxAccessException) {
                                if (!isAbort) {
                                    complete(-1, firefoxAccessException);
                                }
                            }

                            // Call complete if needed
                            if (responses) {
                                complete(status, statusText, responses, responseHeaders);
                            }
                        };

                        // if we're in sync mode or it's in cache
                        // and has been retrieved directly (IE6 & IE7)
                        // we need to manually fire the callback
                        if (!s.async || xhr.readyState === 4) {
                            _callback();
                        } else {
                            handle = ++xhrId;
                            if (xhrOnUnloadAbort) {
                                // Create the active xhrs callbacks list if needed
                                // and attach the unload handler
                                if (!xhrCallbacks) {
                                    xhrCallbacks = {};
                                    jQuery(window).unload(xhrOnUnloadAbort);
                                }
                                // Add to list of active xhrs callbacks
                                xhrCallbacks[handle] = _callback;
                            }
                            xhr.onreadystatechange = _callback;
                        }
                    },

                    abort: function abort() {
                        if (_callback) {
                            _callback(0, 1);
                        }
                    }
                };
            }
        });
    }

    var elemdisplay = {},
        iframe,
        iframeDoc,
        rfxtypes = /^(?:toggle|show|hide)$/,
        rfxnum = /^([+\-]=)?([\d+.\-]+)([a-z%]*)$/i,
        timerId,
        fxAttrs = [
    // height animations
    ["height", "marginTop", "marginBottom", "paddingTop", "paddingBottom"],
    // width animations
    ["width", "marginLeft", "marginRight", "paddingLeft", "paddingRight"],
    // opacity animations
    ["opacity"]],
        fxNow;

    jQuery.fn.extend({
        show: function show(speed, easing, callback) {
            var elem, display;

            if (speed || speed === 0) {
                return this.animate(genFx("show", 3), speed, easing, callback);
            } else {
                for (var i = 0, j = this.length; i < j; i++) {
                    elem = this[i];

                    if (elem.style) {
                        display = elem.style.display;

                        // Reset the inline display of this element to learn if it is
                        // being hidden by cascaded rules or not
                        if (!jQuery._data(elem, "olddisplay") && display === "none") {
                            display = elem.style.display = "";
                        }

                        // Set elements which have been overridden with display: none
                        // in a stylesheet to whatever the default browser style is
                        // for such an element
                        if (display === "" && jQuery.css(elem, "display") === "none" || !jQuery.contains(elem.ownerDocument.documentElement, elem)) {
                            jQuery._data(elem, "olddisplay", defaultDisplay(elem.nodeName));
                        }
                    }
                }

                // Set the display of most of the elements in a second loop
                // to avoid the constant reflow
                for (i = 0; i < j; i++) {
                    elem = this[i];

                    if (elem.style) {
                        display = elem.style.display;

                        if (display === "" || display === "none") {
                            elem.style.display = jQuery._data(elem, "olddisplay") || "";
                        }
                    }
                }

                return this;
            }
        },

        hide: function hide(speed, easing, callback) {
            if (speed || speed === 0) {
                return this.animate(genFx("hide", 3), speed, easing, callback);
            } else {
                var elem,
                    display,
                    i = 0,
                    j = this.length;

                for (; i < j; i++) {
                    elem = this[i];
                    if (elem.style) {
                        display = jQuery.css(elem, "display");

                        if (display !== "none" && !jQuery._data(elem, "olddisplay")) {
                            jQuery._data(elem, "olddisplay", display);
                        }
                    }
                }

                // Set the display of the elements in a second loop
                // to avoid the constant reflow
                for (i = 0; i < j; i++) {
                    if (this[i].style) {
                        this[i].style.display = "none";
                    }
                }

                return this;
            }
        },

        // Save the old toggle function
        _toggle: jQuery.fn.toggle,

        toggle: function toggle(fn, fn2, callback) {
            var bool = typeof fn === "boolean";

            if (jQuery.isFunction(fn) && jQuery.isFunction(fn2)) {
                this._toggle.apply(this, arguments);
            } else if (fn == null || bool) {
                this.each(function () {
                    var state = bool ? fn : jQuery(this).is(":hidden");
                    jQuery(this)[state ? "show" : "hide"]();
                });
            } else {
                this.animate(genFx("toggle", 3), fn, fn2, callback);
            }

            return this;
        },

        fadeTo: function fadeTo(speed, to, easing, callback) {
            return this.filter(":hidden").css("opacity", 0).show().end().animate({ opacity: to }, speed, easing, callback);
        },

        animate: function animate(prop, speed, easing, callback) {
            var optall = jQuery.speed(speed, easing, callback);

            if (jQuery.isEmptyObject(prop)) {
                return this.each(optall.complete, [false]);
            }

            // Do not change referenced properties as per-property easing will be lost
            prop = jQuery.extend({}, prop);

            function doAnimation() {
                // XXX 'this' does not always have a nodeName when running the
                // test suite

                if (optall.queue === false) {
                    jQuery._mark(this);
                }

                var opt = jQuery.extend({}, optall),
                    isElement = this.nodeType === 1,
                    hidden = isElement && jQuery(this).is(":hidden"),
                    name,
                    val,
                    p,
                    e,
                    hooks,
                    replace,
                    parts,
                    start,
                    end,
                    unit,
                    method;

                // will store per property easing and be used to determine when an animation is complete
                opt.animatedProperties = {};

                // first pass over propertys to expand / normalize
                for (p in prop) {
                    name = jQuery.camelCase(p);
                    if (p !== name) {
                        prop[name] = prop[p];
                        delete prop[p];
                    }

                    if ((hooks = jQuery.cssHooks[name]) && "expand" in hooks) {
                        replace = hooks.expand(prop[name]);
                        delete prop[name];

                        // not quite $.extend, this wont overwrite keys already present.
                        // also - reusing 'p' from above because we have the correct "name"
                        for (p in replace) {
                            if (!(p in prop)) {
                                prop[p] = replace[p];
                            }
                        }
                    }
                }

                for (name in prop) {
                    val = prop[name];
                    // easing resolution: per property > opt.specialEasing > opt.easing > 'swing' (default)
                    if (jQuery.isArray(val)) {
                        opt.animatedProperties[name] = val[1];
                        val = prop[name] = val[0];
                    } else {
                        opt.animatedProperties[name] = opt.specialEasing && opt.specialEasing[name] || opt.easing || 'swing';
                    }

                    if (val === "hide" && hidden || val === "show" && !hidden) {
                        return opt.complete.call(this);
                    }

                    if (isElement && (name === "height" || name === "width")) {
                        // Make sure that nothing sneaks out
                        // Record all 3 overflow attributes because IE does not
                        // change the overflow attribute when overflowX and
                        // overflowY are set to the same value
                        opt.overflow = [this.style.overflow, this.style.overflowX, this.style.overflowY];

                        // Set display property to inline-block for height/width
                        // animations on inline elements that are having width/height animated
                        if (jQuery.css(this, "display") === "inline" && jQuery.css(this, "float") === "none") {

                            // inline-level elements accept inline-block;
                            // block-level elements need to be inline with layout
                            if (!jQuery.support.inlineBlockNeedsLayout || defaultDisplay(this.nodeName) === "inline") {
                                this.style.display = "inline-block";
                            } else {
                                this.style.zoom = 1;
                            }
                        }
                    }
                }

                if (opt.overflow != null) {
                    this.style.overflow = "hidden";
                }

                for (p in prop) {
                    e = new jQuery.fx(this, opt, p);
                    val = prop[p];

                    if (rfxtypes.test(val)) {

                        // Tracks whether to show or hide based on private
                        // data attached to the element
                        method = jQuery._data(this, "toggle" + p) || (val === "toggle" ? hidden ? "show" : "hide" : 0);
                        if (method) {
                            jQuery._data(this, "toggle" + p, method === "show" ? "hide" : "show");
                            e[method]();
                        } else {
                            e[val]();
                        }
                    } else {
                        parts = rfxnum.exec(val);
                        start = e.cur();

                        if (parts) {
                            end = parseFloat(parts[2]);
                            unit = parts[3] || (jQuery.cssNumber[p] ? "" : "px");

                            // We need to compute starting value
                            if (unit !== "px") {
                                jQuery.style(this, p, (end || 1) + unit);
                                start = (end || 1) / e.cur() * start;
                                jQuery.style(this, p, start + unit);
                            }

                            // If a +=/-= token was provided, we're doing a relative animation
                            if (parts[1]) {
                                end = (parts[1] === "-=" ? -1 : 1) * end + start;
                            }

                            e.custom(start, end, unit);
                        } else {
                            e.custom(start, val, "");
                        }
                    }
                }

                // For JS strict compliance
                return true;
            }

            return optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },

        stop: function stop(type, clearQueue, gotoEnd) {
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue && type !== false) {
                this.queue(type || "fx", []);
            }

            return this.each(function () {
                var index,
                    hadTimers = false,
                    timers = jQuery.timers,
                    data = jQuery._data(this);

                // clear marker counters if we know they won't be
                if (!gotoEnd) {
                    jQuery._unmark(true, this);
                }

                function stopQueue(elem, data, index) {
                    var hooks = data[index];
                    jQuery.removeData(elem, index, true);
                    hooks.stop(gotoEnd);
                }

                if (type == null) {
                    for (index in data) {
                        if (data[index] && data[index].stop && index.indexOf(".run") === index.length - 4) {
                            stopQueue(this, data, index);
                        }
                    }
                } else if (data[index = type + ".run"] && data[index].stop) {
                    stopQueue(this, data, index);
                }

                for (index = timers.length; index--;) {
                    if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                        if (gotoEnd) {

                            // force the next step to be the last
                            timers[index](true);
                        } else {
                            timers[index].saveState();
                        }
                        hadTimers = true;
                        timers.splice(index, 1);
                    }
                }

                // start the next in the queue if the last step wasn't forced
                // timers currently will call their complete callbacks, which will dequeue
                // but only if they were gotoEnd
                if (!(gotoEnd && hadTimers)) {
                    jQuery.dequeue(this, type);
                }
            });
        }

    });

    // Animations created synchronously will run synchronously
    function createFxNow() {
        setTimeout(clearFxNow, 0);
        return fxNow = jQuery.now();
    }

    function clearFxNow() {
        fxNow = undefined;
    }

    // Generate parameters to create a standard animation
    function genFx(type, num) {
        var obj = {};

        jQuery.each(fxAttrs.concat.apply([], fxAttrs.slice(0, num)), function () {
            obj[this] = type;
        });

        return obj;
    }

    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show", 1),
        slideUp: genFx("hide", 1),
        slideToggle: genFx("toggle", 1),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" }
    }, function (name, props) {
        jQuery.fn[name] = function (speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });

    jQuery.extend({
        speed: function speed(_speed, easing, fn) {
            var opt = _speed && (typeof _speed === "undefined" ? "undefined" : (0, _typeof3.default)(_speed)) === "object" ? jQuery.extend({}, _speed) : {
                complete: fn || !fn && easing || jQuery.isFunction(_speed) && _speed,
                duration: _speed,
                easing: fn && easing || easing && !jQuery.isFunction(easing) && easing
            };

            opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration : opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[opt.duration] : jQuery.fx.speeds._default;

            // normalize opt.queue - true/undefined/null -> "fx"
            if (opt.queue == null || opt.queue === true) {
                opt.queue = "fx";
            }

            // Queueing
            opt.old = opt.complete;

            opt.complete = function (noUnmark) {
                if (jQuery.isFunction(opt.old)) {
                    opt.old.call(this);
                }

                if (opt.queue) {
                    jQuery.dequeue(this, opt.queue);
                } else if (noUnmark !== false) {
                    jQuery._unmark(this);
                }
            };

            return opt;
        },

        easing: {
            linear: function linear(p) {
                return p;
            },
            swing: function swing(p) {
                return -Math.cos(p * Math.PI) / 2 + 0.5;
            }
        },

        timers: [],

        fx: function fx(elem, options, prop) {
            this.options = options;
            this.elem = elem;
            this.prop = prop;

            options.orig = options.orig || {};
        }

    });

    jQuery.fx.prototype = {
        // Simple function for setting a style value
        update: function update() {
            if (this.options.step) {
                this.options.step.call(this.elem, this.now, this);
            }

            (jQuery.fx.step[this.prop] || jQuery.fx.step._default)(this);
        },

        // Get the current size
        cur: function cur() {
            if (this.elem[this.prop] != null && (!this.elem.style || this.elem.style[this.prop] == null)) {
                return this.elem[this.prop];
            }

            var parsed,
                r = jQuery.css(this.elem, this.prop);
            // Empty strings, null, undefined and "auto" are converted to 0,
            // complex values such as "rotate(1rad)" are returned as is,
            // simple values such as "10px" are parsed to Float.
            return isNaN(parsed = parseFloat(r)) ? !r || r === "auto" ? 0 : r : parsed;
        },

        // Start an animation from one number to another
        custom: function custom(from, to, unit) {
            var self = this,
                fx = jQuery.fx;

            this.startTime = fxNow || createFxNow();
            this.end = to;
            this.now = this.start = from;
            this.pos = this.state = 0;
            this.unit = unit || this.unit || (jQuery.cssNumber[this.prop] ? "" : "px");

            function t(gotoEnd) {
                return self.step(gotoEnd);
            }

            t.queue = this.options.queue;
            t.elem = this.elem;
            t.saveState = function () {
                if (jQuery._data(self.elem, "fxshow" + self.prop) === undefined) {
                    if (self.options.hide) {
                        jQuery._data(self.elem, "fxshow" + self.prop, self.start);
                    } else if (self.options.show) {
                        jQuery._data(self.elem, "fxshow" + self.prop, self.end);
                    }
                }
            };

            if (t() && jQuery.timers.push(t) && !timerId) {
                timerId = setInterval(fx.tick, fx.interval);
            }
        },

        // Simple 'show' function
        show: function show() {
            var dataShow = jQuery._data(this.elem, "fxshow" + this.prop);

            // Remember where we started, so that we can go back to it later
            this.options.orig[this.prop] = dataShow || jQuery.style(this.elem, this.prop);
            this.options.show = true;

            // Begin the animation
            // Make sure that we start at a small width/height to avoid any flash of content
            if (dataShow !== undefined) {
                // This show is picking up where a previous hide or show left off
                this.custom(this.cur(), dataShow);
            } else {
                this.custom(this.prop === "width" || this.prop === "height" ? 1 : 0, this.cur());
            }

            // Start by showing the element
            jQuery(this.elem).show();
        },

        // Simple 'hide' function
        hide: function hide() {
            // Remember where we started, so that we can go back to it later
            this.options.orig[this.prop] = jQuery._data(this.elem, "fxshow" + this.prop) || jQuery.style(this.elem, this.prop);
            this.options.hide = true;

            // Begin the animation
            this.custom(this.cur(), 0);
        },

        // Each step of an animation
        step: function step(gotoEnd) {
            var p,
                n,
                complete,
                t = fxNow || createFxNow(),
                done = true,
                elem = this.elem,
                options = this.options;

            if (gotoEnd || t >= options.duration + this.startTime) {
                this.now = this.end;
                this.pos = this.state = 1;
                this.update();

                options.animatedProperties[this.prop] = true;

                for (p in options.animatedProperties) {
                    if (options.animatedProperties[p] !== true) {
                        done = false;
                    }
                }

                if (done) {
                    // Reset the overflow
                    if (options.overflow != null && !jQuery.support.shrinkWrapBlocks) {

                        jQuery.each(["", "X", "Y"], function (index, value) {
                            elem.style["overflow" + value] = options.overflow[index];
                        });
                    }

                    // Hide the element if the "hide" operation was done
                    if (options.hide) {
                        jQuery(elem).hide();
                    }

                    // Reset the properties, if the item has been hidden or shown
                    if (options.hide || options.show) {
                        for (p in options.animatedProperties) {
                            jQuery.style(elem, p, options.orig[p]);
                            jQuery.removeData(elem, "fxshow" + p, true);
                            // Toggle data is no longer needed
                            jQuery.removeData(elem, "toggle" + p, true);
                        }
                    }

                    // Execute the complete function
                    // in the event that the complete function throws an exception
                    // we must ensure it won't be called twice. #5684

                    complete = options.complete;
                    if (complete) {

                        options.complete = false;
                        complete.call(elem);
                    }
                }

                return false;
            } else {
                // classical easing cannot be used with an Infinity duration
                if (options.duration == Infinity) {
                    this.now = t;
                } else {
                    n = t - this.startTime;
                    this.state = n / options.duration;

                    // Perform the easing function, defaults to swing
                    this.pos = jQuery.easing[options.animatedProperties[this.prop]](this.state, n, 0, 1, options.duration);
                    this.now = this.start + (this.end - this.start) * this.pos;
                }
                // Perform the next step of the animation
                this.update();
            }

            return true;
        }
    };

    jQuery.extend(jQuery.fx, {
        tick: function tick() {
            var timer,
                timers = jQuery.timers,
                i = 0;

            for (; i < timers.length; i++) {
                timer = timers[i];
                // Checks the timer has not already been removed
                if (!timer() && timers[i] === timer) {
                    timers.splice(i--, 1);
                }
            }

            if (!timers.length) {
                jQuery.fx.stop();
            }
        },

        interval: 13,

        stop: function stop() {
            clearInterval(timerId);
            timerId = null;
        },

        speeds: {
            slow: 600,
            fast: 200,
            // Default speed
            _default: 400
        },

        step: {
            opacity: function opacity(fx) {
                jQuery.style(fx.elem, "opacity", fx.now);
            },

            _default: function _default(fx) {
                if (fx.elem.style && fx.elem.style[fx.prop] != null) {
                    fx.elem.style[fx.prop] = fx.now + fx.unit;
                } else {
                    fx.elem[fx.prop] = fx.now;
                }
            }
        }
    });

    // Ensure props that can't be negative don't go there on undershoot easing
    jQuery.each(fxAttrs.concat.apply([], fxAttrs), function (i, prop) {
        // exclude marginTop, marginLeft, marginBottom and marginRight from this list
        if (prop.indexOf("margin")) {
            jQuery.fx.step[prop] = function (fx) {
                jQuery.style(fx.elem, prop, Math.max(0, fx.now) + fx.unit);
            };
        }
    });

    if (jQuery.expr && jQuery.expr.filters) {
        jQuery.expr.filters.animated = function (elem) {
            return jQuery.grep(jQuery.timers, function (fn) {
                return elem === fn.elem;
            }).length;
        };
    }

    // Try to restore the default display value of an element
    function defaultDisplay(nodeName) {

        if (!elemdisplay[nodeName]) {

            var body = document.body,
                elem = jQuery("<" + nodeName + ">").appendTo(body),
                display = elem.css("display");
            elem.remove();

            // If the simple way fails,
            // get element's real default display by attaching it to a temp iframe
            if (display === "none" || display === "") {
                // No iframe to use yet, so create it
                if (!iframe) {
                    iframe = document.createElement("iframe");
                    iframe.frameBorder = iframe.width = iframe.height = 0;
                }

                body.appendChild(iframe);

                // Create a cacheable copy of the iframe document on first call.
                // IE and Opera will allow us to reuse the iframeDoc without re-writing the fake HTML
                // document to it; WebKit & Firefox won't allow reusing the iframe document.
                if (!iframeDoc || !iframe.createElement) {
                    iframeDoc = (iframe.contentWindow || iframe.contentDocument).document;
                    iframeDoc.write((jQuery.support.boxModel ? "<!doctype html>" : "") + "<html><body>");
                    iframeDoc.close();
                }

                elem = iframeDoc.createElement(nodeName);

                iframeDoc.body.appendChild(elem);

                display = jQuery.css(elem, "display");
                body.removeChild(iframe);
            }

            // Store the correct default display
            elemdisplay[nodeName] = display;
        }

        return elemdisplay[nodeName];
    }

    var getOffset,
        rtable = /^t(?:able|d|h)$/i,
        rroot = /^(?:body|html)$/i;

    if ("getBoundingClientRect" in document.documentElement) {
        getOffset = function getOffset(elem, doc, docElem, box) {
            try {
                box = elem.getBoundingClientRect();
            } catch (e) {}

            // Make sure we're not dealing with a disconnected DOM node
            if (!box || !jQuery.contains(docElem, elem)) {
                return box ? { top: box.top, left: box.left } : { top: 0, left: 0 };
            }

            var body = doc.body,
                win = getWindow(doc),
                clientTop = docElem.clientTop || body.clientTop || 0,
                clientLeft = docElem.clientLeft || body.clientLeft || 0,
                scrollTop = win.pageYOffset || jQuery.support.boxModel && docElem.scrollTop || body.scrollTop,
                scrollLeft = win.pageXOffset || jQuery.support.boxModel && docElem.scrollLeft || body.scrollLeft,
                top = box.top + scrollTop - clientTop,
                left = box.left + scrollLeft - clientLeft;

            return { top: top, left: left };
        };
    } else {
        getOffset = function getOffset(elem, doc, docElem) {
            var computedStyle,
                offsetParent = elem.offsetParent,
                prevOffsetParent = elem,
                body = doc.body,
                defaultView = doc.defaultView,
                prevComputedStyle = defaultView ? defaultView.getComputedStyle(elem, null) : elem.currentStyle,
                top = elem.offsetTop,
                left = elem.offsetLeft;

            while ((elem = elem.parentNode) && elem !== body && elem !== docElem) {
                if (jQuery.support.fixedPosition && prevComputedStyle.position === "fixed") {
                    break;
                }

                computedStyle = defaultView ? defaultView.getComputedStyle(elem, null) : elem.currentStyle;
                top -= elem.scrollTop;
                left -= elem.scrollLeft;

                if (elem === offsetParent) {
                    top += elem.offsetTop;
                    left += elem.offsetLeft;

                    if (jQuery.support.doesNotAddBorder && !(jQuery.support.doesAddBorderForTableAndCells && rtable.test(elem.nodeName))) {
                        top += parseFloat(computedStyle.borderTopWidth) || 0;
                        left += parseFloat(computedStyle.borderLeftWidth) || 0;
                    }

                    prevOffsetParent = offsetParent;
                    offsetParent = elem.offsetParent;
                }

                if (jQuery.support.subtractsBorderForOverflowNotVisible && computedStyle.overflow !== "visible") {
                    top += parseFloat(computedStyle.borderTopWidth) || 0;
                    left += parseFloat(computedStyle.borderLeftWidth) || 0;
                }

                prevComputedStyle = computedStyle;
            }

            if (prevComputedStyle.position === "relative" || prevComputedStyle.position === "static") {
                top += body.offsetTop;
                left += body.offsetLeft;
            }

            if (jQuery.support.fixedPosition && prevComputedStyle.position === "fixed") {
                top += Math.max(docElem.scrollTop, body.scrollTop);
                left += Math.max(docElem.scrollLeft, body.scrollLeft);
            }

            return { top: top, left: left };
        };
    }

    jQuery.fn.offset = function (options) {
        if (arguments.length) {
            return options === undefined ? this : this.each(function (i) {
                jQuery.offset.setOffset(this, options, i);
            });
        }

        var elem = this[0],
            doc = elem && elem.ownerDocument;

        if (!doc) {
            return null;
        }

        if (elem === doc.body) {
            return jQuery.offset.bodyOffset(elem);
        }

        return getOffset(elem, doc, doc.documentElement);
    };

    jQuery.offset = {

        bodyOffset: function bodyOffset(body) {
            var top = body.offsetTop,
                left = body.offsetLeft;

            if (jQuery.support.doesNotIncludeMarginInBodyOffset) {
                top += parseFloat(jQuery.css(body, "marginTop")) || 0;
                left += parseFloat(jQuery.css(body, "marginLeft")) || 0;
            }

            return { top: top, left: left };
        },

        setOffset: function setOffset(elem, options, i) {
            var position = jQuery.css(elem, "position");

            // set position first, in-case top/left are set even on static elem
            if (position === "static") {
                elem.style.position = "relative";
            }

            var curElem = jQuery(elem),
                curOffset = curElem.offset(),
                curCSSTop = jQuery.css(elem, "top"),
                curCSSLeft = jQuery.css(elem, "left"),
                calculatePosition = (position === "absolute" || position === "fixed") && jQuery.inArray("auto", [curCSSTop, curCSSLeft]) > -1,
                props = {},
                curPosition = {},
                curTop,
                curLeft;

            // need to be able to calculate position if either top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }

            if (jQuery.isFunction(options)) {
                options = options.call(elem, i, curOffset);
            }

            if (options.top != null) {
                props.top = options.top - curOffset.top + curTop;
            }
            if (options.left != null) {
                props.left = options.left - curOffset.left + curLeft;
            }

            if ("using" in options) {
                options.using.call(elem, props);
            } else {
                curElem.css(props);
            }
        }
    };

    jQuery.fn.extend({

        position: function position() {
            if (!this[0]) {
                return null;
            }

            var elem = this[0],


            // Get *real* offsetParent
            offsetParent = this.offsetParent(),


            // Get correct offsets
            offset = this.offset(),
                parentOffset = rroot.test(offsetParent[0].nodeName) ? { top: 0, left: 0 } : offsetParent.offset();

            // Subtract element margins
            // note: when an element has margin: auto the offsetLeft and marginLeft
            // are the same in Safari causing offset.left to incorrectly be 0
            offset.top -= parseFloat(jQuery.css(elem, "marginTop")) || 0;
            offset.left -= parseFloat(jQuery.css(elem, "marginLeft")) || 0;

            // Add offsetParent borders
            parentOffset.top += parseFloat(jQuery.css(offsetParent[0], "borderTopWidth")) || 0;
            parentOffset.left += parseFloat(jQuery.css(offsetParent[0], "borderLeftWidth")) || 0;

            // Subtract the two offsets
            return {
                top: offset.top - parentOffset.top,
                left: offset.left - parentOffset.left
            };
        },

        offsetParent: function offsetParent() {
            return this.map(function () {
                var offsetParent = this.offsetParent || document.body;
                while (offsetParent && !rroot.test(offsetParent.nodeName) && jQuery.css(offsetParent, "position") === "static") {
                    offsetParent = offsetParent.offsetParent;
                }
                return offsetParent;
            });
        }
    });

    // Create scrollLeft and scrollTop methods
    jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
        var top = /Y/.test(prop);

        jQuery.fn[method] = function (val) {
            return jQuery.access(this, function (elem, method, val) {
                var win = getWindow(elem);

                if (val === undefined) {
                    return win ? prop in win ? win[prop] : jQuery.support.boxModel && win.document.documentElement[method] || win.document.body[method] : elem[method];
                }

                if (win) {
                    win.scrollTo(!top ? val : jQuery(win).scrollLeft(), top ? val : jQuery(win).scrollTop());
                } else {
                    elem[method] = val;
                }
            }, method, val, arguments.length, null);
        };
    });

    function getWindow(elem) {
        return jQuery.isWindow(elem) ? elem : elem.nodeType === 9 ? elem.defaultView || elem.parentWindow : false;
    }

    // Create width, height, innerHeight, innerWidth, outerHeight and outerWidth methods
    jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
        var clientProp = "client" + name,
            scrollProp = "scroll" + name,
            offsetProp = "offset" + name;

        // innerHeight and innerWidth
        jQuery.fn["inner" + name] = function () {
            var elem = this[0];
            return elem ? elem.style ? parseFloat(jQuery.css(elem, type, "padding")) : this[type]() : null;
        };

        // outerHeight and outerWidth
        jQuery.fn["outer" + name] = function (margin) {
            var elem = this[0];
            return elem ? elem.style ? parseFloat(jQuery.css(elem, type, margin ? "margin" : "border")) : this[type]() : null;
        };

        jQuery.fn[type] = function (value) {
            return jQuery.access(this, function (elem, type, value) {
                var doc, docElemProp, orig, ret;

                if (jQuery.isWindow(elem)) {
                    // 3rd condition allows Nokia support, as it supports the docElem prop but not CSS1Compat
                    doc = elem.document;
                    docElemProp = doc.documentElement[clientProp];
                    return jQuery.support.boxModel && docElemProp || doc.body && doc.body[clientProp] || docElemProp;
                }

                // Get document width or height
                if (elem.nodeType === 9) {
                    // Either scroll[Width/Height] or offset[Width/Height], whichever is greater
                    doc = elem.documentElement;

                    // when a window > document, IE6 reports a offset[Width/Height] > client[Width/Height]
                    // so we can't use max, as it'll choose the incorrect offset[Width/Height]
                    // instead we use the correct client[Width/Height]
                    // support:IE6
                    if (doc[clientProp] >= doc[scrollProp]) {
                        return doc[clientProp];
                    }

                    return Math.max(elem.body[scrollProp], doc[scrollProp], elem.body[offsetProp], doc[offsetProp]);
                }

                // Get width or height on the element
                if (value === undefined) {
                    orig = jQuery.css(elem, type);
                    ret = parseFloat(orig);
                    return jQuery.isNumeric(ret) ? ret : orig;
                }

                // Set the width or height on the element
                jQuery(elem).css(type, value);
            }, type, value, arguments.length, null);
        };
    });

    // Expose jQuery to the global object
    window.jQuery = window.$ = jQuery;

    // Expose jQuery as an AMD module, but only for AMD loaders that
    // understand the issues with loading multiple versions of jQuery
    // in a page that all might call define(). The loader will indicate
    // they have special allowances for multiple jQuery versions by
    // specifying define.amd.jQuery = true. Register as a named module,
    // since jQuery can be concatenated with other files that may use define,
    // but not use a proper concatenation script that understands anonymous
    // AMD modules. A named AMD is safest and most robust way to register.
    // Lowercase jquery is used because AMD module names are derived from
    // file names, and jQuery is normally delivered in a lowercase file name.
    // Do this after creating the global so that if an AMD module wants to call
    // noConflict to hide this version of jQuery, it will work.
    if ("function" === "function" && __webpack_require__(24) && __webpack_require__(24).jQuery) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return jQuery;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
})(window);

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (undefined) {
	var Base64 = {
		_keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function encode(e) {
			var t = "";
			var n, r, i, s, o, u, a;
			var f = 0;
			e = Base64._utf8_encode(e);
			while (f < e.length) {
				n = e.charCodeAt(f++);
				r = e.charCodeAt(f++);
				i = e.charCodeAt(f++);
				s = n >> 2;
				o = (n & 3) << 4 | r >> 4;
				u = (r & 15) << 2 | i >> 6;
				a = i & 63;
				if (isNaN(r)) {
					u = a = 64;
				} else if (isNaN(i)) {
					a = 64;
				} else {
					// 注释
				}
				t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
			}
			return t;
		}, decode: function decode(e) {
			var t = "";
			var n, r, i;
			var s, o, u, a;
			var f = 0;
			e = e.replace(/[^A-Za-z0-9+/=]/g, "");
			while (f < e.length) {
				s = this._keyStr.indexOf(e.charAt(f++));
				o = this._keyStr.indexOf(e.charAt(f++));
				u = this._keyStr.indexOf(e.charAt(f++));
				a = this._keyStr.indexOf(e.charAt(f++));
				n = s << 2 | o >> 4;
				r = (o & 15) << 4 | u >> 2;
				i = (u & 3) << 6 | a;
				t = t + String.fromCharCode(n);
				if (u != 64) {
					t = t + String.fromCharCode(r);
				}
				if (a != 64) {
					t = t + String.fromCharCode(i);
				}
			}
			t = Base64._utf8_decode(t);
			return t;
		}, _utf8_encode: function _utf8_encode(e) {
			e = e.replace(/rn/g, "n");
			var t = "";
			for (var n = 0; n < e.length; n++) {
				var r = e.charCodeAt(n);
				if (r < 128) {
					t += String.fromCharCode(r);
				} else if (r > 127 && r < 2048) {
					t += String.fromCharCode(r >> 6 | 192);
					t += String.fromCharCode(r & 63 | 128);
				} else {
					t += String.fromCharCode(r >> 12 | 224);
					t += String.fromCharCode(r >> 6 & 63 | 128);
					t += String.fromCharCode(r & 63 | 128);
				}
			}
			return t;
		}, _utf8_decode: function _utf8_decode(e) {
			var t = "";
			var n = 0;
			var r = 0;
			var c2 = 0;var c3 = 0;
			while (n < e.length) {
				r = e.charCodeAt(n);
				if (r < 128) {
					t += String.fromCharCode(r);
					n++;
				} else if (r > 191 && r < 224) {
					c2 = e.charCodeAt(n + 1);
					t += String.fromCharCode((r & 31) << 6 | c2 & 63);
					n += 2;
				} else {
					c2 = e.charCodeAt(n + 1);
					c3 = e.charCodeAt(n + 2);
					t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
					n += 3;
				}
			}
			return t;
		}
	};
	window.Base64 = Base64;
})();

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.listTeacherSubjectClass = exports.listGradeSchool = exports.listAreaSchool = exports.listRoleAuth = exports.statisticAreaSchool = exports.listSchoolTeacher = exports.getClassInfoUnderArea = exports.getClassInfoUnderSchool = exports.getSchoolInfo = exports.getConfigInfo = exports.deleteReceiveNotice = exports.deleteNotice = exports.sendNotice = exports.getNoticeDetail = exports.getReceiveNoticeInfo = exports.getNoticeInfo = exports.getpersonalInfo = exports.getlistClassStudentInfo = exports.getlistTeacherClassInfo = exports.getLoginUserInfo = undefined;

var _handleResult = __webpack_require__(2);

var _handleResult2 = _interopRequireDefault(_handleResult);

var _request = __webpack_require__(5);

var _request2 = _interopRequireDefault(_request);

var _serviceConfig = __webpack_require__(6);

var _serviceConfig2 = _interopRequireDefault(_serviceConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//根据token获取登录用户信息
var getLoginUserInfo = exports.getLoginUserInfo = function getLoginUserInfo(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.personalInfo, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res, true);
    });
};

//获取班级列表
var getlistTeacherClassInfo = exports.getlistTeacherClassInfo = function getlistTeacherClassInfo(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.listTeacherClassPath, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res, true);
    });
};

//获取学生列表（根据班级ID+老师id）
var getlistClassStudentInfo = exports.getlistClassStudentInfo = function getlistClassStudentInfo(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.listClassStudent, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//获取个人信息
var getpersonalInfo = exports.getpersonalInfo = function getpersonalInfo(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.personalInfo, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//获取个人发布消息列表
var getNoticeInfo = exports.getNoticeInfo = function getNoticeInfo(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.noticeInfo, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//获取个人接收消息列表
var getReceiveNoticeInfo = exports.getReceiveNoticeInfo = function getReceiveNoticeInfo(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.receiveNoticeInfo, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//获取公告详情
var getNoticeDetail = exports.getNoticeDetail = function getNoticeDetail(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.noticeDetail, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//发送消息
var sendNotice = exports.sendNotice = function sendNotice(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.sendNotice, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//删除该公告
var deleteNotice = exports.deleteNotice = function deleteNotice(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.deleteNotice, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//s删除接收到的消息
var deleteReceiveNotice = exports.deleteReceiveNotice = function deleteReceiveNotice(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.deleteReceiveNotice, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//获取配置信息
var getConfigInfo = exports.getConfigInfo = function getConfigInfo(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.configUrl, _serviceConfig2.default.interfaceGroupId.config).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//教研员角色，获取学校信息
var getSchoolInfo = exports.getSchoolInfo = function getSchoolInfo(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.schoolInfo, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//查询学校下的班级
var getClassInfoUnderSchool = exports.getClassInfoUnderSchool = function getClassInfoUnderSchool(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.schoolClassInfo, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//查询学校下的班级
var getClassInfoUnderArea = exports.getClassInfoUnderArea = function getClassInfoUnderArea(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.areaSchoolInfo, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//根据学校用户的学校id查询的学校老师列表
var listSchoolTeacher = exports.listSchoolTeacher = function listSchoolTeacher(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.listSchoolTeacher, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};
//区教研员查询该区域的统计信息
var statisticAreaSchool = exports.statisticAreaSchool = function statisticAreaSchool(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.statisticAreaSchool, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};
//查询角色权限列表
var listRoleAuth = exports.listRoleAuth = function listRoleAuth(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.auth_listRoleAuth, _serviceConfig2.default.interfaceGroupId.auth).then(function (res) {
        return _handleResult2.default.common(res);
    });
};
//查询学校列表
var listAreaSchool = exports.listAreaSchool = function listAreaSchool(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.listAreaSchool, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//查询年级下的班级列表
var listGradeSchool = exports.listGradeSchool = function listGradeSchool(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.listGradeSchool, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

//查询老师的班级
var listTeacherSubjectClass = exports.listTeacherSubjectClass = function listTeacherSubjectClass(param) {
    return _request2.default.requestMethod(param, _serviceConfig2.default.interfacePath.user.listTeacherSubjectClass, _serviceConfig2.default.interfaceGroupId.user).then(function (res) {
        return _handleResult2.default.common(res);
    });
};

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (undefined) {
    var loc = window.location,
        href = loc.href,
        rHash = /\#.*$/;

    var Url = {
        removeHash: function removeHash(url) {
            return (url || href).replace(rHash, '');
        },
        getHash: function getHash(url) {
            var match = (url || href).match(rHash);
            return match && match[0] ? match[0] : '';
        },
        removeParams: function removeParams(params, url) {
            url = url || href;

            var hash = Url.getHash(url),
                url = this.removeHash(url),
                i;

            for (i = params.length - 1; i >= 0; i--) {
                url = url.replace(new RegExp("(?:[\\?\\&](" + params[i] + "=[^&]*))", "g"), "");
            }

            url = url.replace(/\&+/, "&").replace(/[\&]+$/, "").replace(/[\?]+$/, "") + hash;
            return (/^[^?]*\&/.test(url) ? url.replace("&", "?") : url
            );
        },
        addParams: function addParams(params, url) {
            url = url || href;

            var removeArr = [],
                addArr = [],
                hash = Url.getHash(url),
                url = this.removeHash(url),
                i;

            for (i in params) {
                if (params.hasOwnProperty(i)) {
                    removeArr.push(i);
                    addArr.push(i + "=" + encodeURIComponent(params[i]));
                }
            }

            url = this.removeParams(removeArr, url);
            return url + (addArr[0] ? (url.indexOf('?') === -1 ? '?' : '&') + addArr.join('&') : '') + hash;
        },
        queryString: function queryString(name, url) {
            // ;
            var params = this.getParams(url);
            return params[name] != null ? params[name] : undefined;
        },
        getParams: function getParams(url) {
            var search = url.indexOf('?') === -1 ? [] : url.substr(url.indexOf('?') + 1).split("&"),
                i = 0,
                len = search.length,
                params = {},
                pos;

            for (; i < len; i++) {
                pos = search[i].indexOf("=");
                if (pos > 0) {
                    params[search[i].substring(0, pos)] = decodeURIComponent(search[i].substring(pos + 1));
                }
            }
            return params;
        },
        getUrl: function getUrl() {
            return loc.protocol + "//" + loc.host + loc.pathname;
        },
        redirect: function redirect(url) {
            loc.href = url;
            try {
                window.event.returnValue = false;
            } catch (e) {}
        }
    };

    window.Url = Url;
})();

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(18);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(0);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONF_INIT = 'CONF_INIT'; //配置信息


exports.default = {
    state: JSON.parse(sessionStorage.getItem('conf')) || {},
    mutations: (0, _defineProperty3.default)({}, CONF_INIT, function (state, conf) {
        sessionStorage.setItem('conf', (0, _stringify2.default)(conf));
        (0, _extends3.default)(state, conf);
    }),
    actions: (0, _defineProperty3.default)({}, CONF_INIT, function (_ref, conf) {
        var commit = _ref.commit;

        commit(CONF_INIT, conf);
    })
};

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.USER_ROLE = exports.USER_CLASS = exports.UPDATE_MAC = exports.UPDATE_TOKEN = exports.USER_SIGNOUT = exports.USER_SIGNIN = undefined;

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(0);

var _stringify2 = _interopRequireDefault(_stringify);

var _mutations, _actions;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_SIGNIN = exports.USER_SIGNIN = 'USER_SIGNIN'; //登录成功
var USER_SIGNOUT = exports.USER_SIGNOUT = 'USER_SIGNOUT'; //退出登录
var UPDATE_TOKEN = exports.UPDATE_TOKEN = 'UPDATE_TOKEN'; //TOKEN
var UPDATE_MAC = exports.UPDATE_MAC = 'UPDATE_MAC'; //用户班级
var USER_CLASS = exports.USER_CLASS = 'USER_CLASS'; //用户班级
var USER_ROLE = exports.USER_ROLE = 'USER_ROLE'; //用户角色
exports.default = {
    state: {
        userinfo: JSON.parse(sessionStorage.getItem('user')),
        token: sessionStorage.getItem('token'),
        userclass: JSON.parse(sessionStorage.getItem('classinfo')),
        rolecode: sessionStorage.getItem('rolecode')
    },
    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, USER_SIGNIN, function (state, user) {
        //   if(user.phaseCode){
        //     let pharseArr = user.phaseCode.split(",");
        //     let index = pharseArr.indexOf("05");
        //     if (index > -1) {
        //       pharseArr.splice(index, 1);
        //     }
        //     user.phaseCode = pharseArr.join(",");
        //   }
        sessionStorage.setItem('user', (0, _stringify2.default)(user));
        state.userinfo = user;
    }), (0, _defineProperty3.default)(_mutations, USER_SIGNOUT, function (state) {
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('classinfo');
        sessionStorage.removeItem('mac');
        sessionStorage.removeItem('tgt');
        sessionStorage.removeItem('rolecode');
    }), (0, _defineProperty3.default)(_mutations, UPDATE_TOKEN, function (state, token) {
        sessionStorage.setItem('token', token);
        state.token = token;
    }), (0, _defineProperty3.default)(_mutations, UPDATE_MAC, function (state, mac) {
        sessionStorage.setItem('mac', mac);
        state.mac = mac;
    }), (0, _defineProperty3.default)(_mutations, USER_CLASS, function (state, classinfo) {
        sessionStorage.setItem('classinfo', (0, _stringify2.default)(classinfo));
        state.userclass = classinfo;
    }), (0, _defineProperty3.default)(_mutations, USER_ROLE, function (state, rolecode) {
        sessionStorage.setItem('rolecode', rolecode);
        state.rolecode = rolecode;
    }), _mutations),
    actions: (_actions = {}, (0, _defineProperty3.default)(_actions, USER_SIGNIN, function (_ref, user) {
        var commit = _ref.commit;

        commit(USER_SIGNIN, user);
    }), (0, _defineProperty3.default)(_actions, USER_SIGNOUT, function (_ref2) {
        var commit = _ref2.commit;

        commit(USER_SIGNOUT);
    }), (0, _defineProperty3.default)(_actions, UPDATE_TOKEN, function (_ref3) {
        var commit = _ref3.commit;

        commit(UPDATE_TOKEN);
    }), (0, _defineProperty3.default)(_actions, UPDATE_MAC, function (_ref4) {
        var commit = _ref4.commit;

        commit(UPDATE_MAC);
    }), (0, _defineProperty3.default)(_actions, USER_CLASS, function (_ref5) {
        var commit = _ref5.commit;

        commit(USER_CLASS);
    }), (0, _defineProperty3.default)(_actions, USER_ROLE, function (_ref6) {
        var commit = _ref6.commit;

        commit(USER_ROLE);
    }), _actions)
};

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by yuxin Wei on 2017/8/4.
 *封装正则regex
*/
exports.default = {
  //考试名称 4~30位中文字符、英文字符、数字字符及-()_
  taskName: /^([a-zA-Z0-9\u4E00-\u9FA5\（）()_-]){4,30}$/,
  //计划名称
  planName: /^([a-zA-Z0-9\u4E00-\u9FA5\（）()_-]){4,20}$/,
  //学生姓名 2~9位汉字、英文、数字组合
  studentName: /^[a-zA-Z0-9\u4E00-\u9FA5]{2,9}$/,
  //学号 8~22位英文、数字组合
  studentId: /^[0-9a-zA-Z]{8,22}$/,
  //3~30位汉字、字母、数字、括号组合 示例：初三（1）班
  className: /^([0-9a-zA-Z\u4E00-\u9FA5\（）()]){3,30}$/,
  //班级号 首字母C+12位数字
  classId: /^C[0-9]{12}$/,
  //邮箱
  email: /(\w|-)+@((\w|-)+\.)+[a-z]{2,5}/,
  //登录名
  userName: /^[a-zA-Z]{1}([a-zA-Z0-9]){3,29}$/,
  //密码
  password: /^(\w){6,30}$/,
  //真实姓名
  realname: /^[a-zA-Z0-9\u4E00-\u9FA5]{2,9}$/,
  //手机号码
  telephone: /^1\d{10}$/,
  //前后空格
  aroundSpace: /(^\s*)|(\s*$)/g,
  //中间空格替换成' '
  centerSpace: /\s+/g,
  //数字格式化小数
  isAllZero: /[1-9]{1,}/,
  //匹配正整数
  isNum: /^[1-9]\d*$/,
  //匹配搜索框的字符
  searchSpace: /^([a-zA-Z0-9\u4E00-\u9FA5\s&:：（）()_-])/
};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(0);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(13);

var _typeof3 = _interopRequireDefault(_typeof2);

var _constants = __webpack_require__(22);

var _constants2 = _interopRequireDefault(_constants);

var _config = __webpack_require__(1);

var _config2 = _interopRequireDefault(_config);

var _user = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calendar = {
  /**
   * 农历1900-2100的润大小信息表
   * @Array Of Property
   * @return Hex
   */
  lunarInfo: [0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0, 0x09ad0, 0x055d2, //1900-1909
  0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540, 0x0d6a0, 0x0ada2, 0x095b0, 0x14977, //1910-1919
  0x04970, 0x0a4b0, 0x0b4b5, 0x06a50, 0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970, //1920-1929
  0x06566, 0x0d4a0, 0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950, //1930-1939
  0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2, 0x0a950, 0x0b557, //1940-1949
  0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5b0, 0x14573, 0x052b0, 0x0a9a8, 0x0e950, 0x06aa0, //1950-1959
  0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0, //1960-1969
  0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b6a0, 0x195a6, //1970-1979
  0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60, 0x09570, //1980-1989
  0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x055c0, 0x0ab60, 0x096d5, 0x092e0, //1990-1999
  0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5, //2000-2009
  0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930, //2010-2019
  0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65, 0x0d530, //2020-2029
  0x05aa0, 0x076a3, 0x096d0, 0x04afb, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520, 0x0dd45, //2030-2039
  0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0, //2040-2049
  /**Add By JJonline@JJonline.Cn**/
  0x14b63, 0x09370, 0x049f8, 0x04970, 0x064b0, 0x168a6, 0x0ea50, 0x06b20, 0x1a6c4, 0x0aae0, //2050-2059
  0x0a2e0, 0x0d2e3, 0x0c960, 0x0d557, 0x0d4a0, 0x0da50, 0x05d55, 0x056a0, 0x0a6d0, 0x055d4, //2060-2069
  0x052d0, 0x0a9b8, 0x0a950, 0x0b4a0, 0x0b6a6, 0x0ad50, 0x055a0, 0x0aba4, 0x0a5b0, 0x052b0, //2070-2079
  0x0b273, 0x06930, 0x07337, 0x06aa0, 0x0ad50, 0x14b55, 0x04b60, 0x0a570, 0x054e4, 0x0d160, //2080-2089
  0x0e968, 0x0d520, 0x0daa0, 0x16aa6, 0x056d0, 0x04ae0, 0x0a9d4, 0x0a2d0, 0x0d150, 0x0f252, //2090-2099
  0x0d520], //2100

  /**
   * 公历每个月份的天数普通表
   * @Array Of Property
   * @return Number
   */
  solarMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

  /**
   * 天干地支之天干速查表
   * @Array Of Property trans["甲","乙","丙","丁","戊","己","庚","辛","壬","癸"]
   * @return Cn string
   */
  Gan: ["\u7532", "\u4E59", "\u4E19", "\u4E01", "\u620A", "\u5DF1", "\u5E9A", "\u8F9B", "\u58EC", "\u7678"],

  /**
   * 天干地支之地支速查表
   * @Array Of Property
   * @trans["子","丑","寅","卯","辰","巳","午","未","申","酉","戌","亥"]
   * @return Cn string
   */
  Zhi: ["\u5B50", "\u4E11", "\u5BC5", "\u536F", "\u8FB0", "\u5DF3", "\u5348", "\u672A", "\u7533", "\u9149", "\u620C", "\u4EA5"],

  /**
   * 天干地支之地支速查表<=>生肖
   * @Array Of Property
   * @trans["鼠","牛","虎","兔","龙","蛇","马","羊","猴","鸡","狗","猪"]
   * @return Cn string
   */
  Animals: ["\u9F20", "\u725B", "\u864E", "\u5154", "\u9F99", "\u86C7", "\u9A6C", "\u7F8A", "\u7334", "\u9E21", "\u72D7", "\u732A"],

  /**
   * 24节气速查表
   * @Array Of Property
   * @trans["小寒","大寒","立春","雨水","惊蛰","春分","清明","谷雨","立夏","小满","芒种","夏至","小暑","大暑","立秋","处暑","白露","秋分","寒露","霜降","立冬","小雪","大雪","冬至"]
   * @return Cn string
   */
  solarTerm: ["\u5C0F\u5BD2", "\u5927\u5BD2", "\u7ACB\u6625", "\u96E8\u6C34", "\u60CA\u86F0", "\u6625\u5206", "\u6E05\u660E", "\u8C37\u96E8", "\u7ACB\u590F", "\u5C0F\u6EE1", "\u8292\u79CD", "\u590F\u81F3", "\u5C0F\u6691", "\u5927\u6691", "\u7ACB\u79CB", "\u5904\u6691", "\u767D\u9732", "\u79CB\u5206", "\u5BD2\u9732", "\u971C\u964D", "\u7ACB\u51AC", "\u5C0F\u96EA", "\u5927\u96EA", "\u51AC\u81F3"],

  /**
   * 1900-2100各年的24节气日期速查表
   * @Array Of Property
   * @return 0x string For splice
   */
  sTermInfo: ["9778397bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf97c3598082c95f8c965cc920f", "97bd0b06bdb0722c965ce1cfcc920f", "b027097bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf97c359801ec95f8c965cc920f", "97bd0b06bdb0722c965ce1cfcc920f", "b027097bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf97c359801ec95f8c965cc920f", "97bd0b06bdb0722c965ce1cfcc920f", "b027097bd097c36b0b6fc9274c91aa", "9778397bd19801ec9210c965cc920e", "97b6b97bd19801ec95f8c965cc920f", "97bd09801d98082c95f8e1cfcc920f", "97bd097bd097c36b0b6fc9210c8dc2", "9778397bd197c36c9210c9274c91aa", "97b6b97bd19801ec95f8c965cc920e", "97bd09801d98082c95f8e1cfcc920f", "97bd097bd097c36b0b6fc9210c8dc2", "9778397bd097c36c9210c9274c91aa", "97b6b97bd19801ec95f8c965cc920e", "97bcf97c3598082c95f8e1cfcc920f", "97bd097bd097c36b0b6fc9210c8dc2", "9778397bd097c36c9210c9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf97c3598082c95f8c965cc920f", "97bd097bd097c35b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf97c3598082c95f8c965cc920f", "97bd097bd097c35b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf97c359801ec95f8c965cc920f", "97bd097bd097c35b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf97c359801ec95f8c965cc920f", "97bd097bd097c35b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf97c359801ec95f8c965cc920f", "97bd097bd07f595b0b6fc920fb0722", "9778397bd097c36b0b6fc9210c8dc2", "9778397bd19801ec9210c9274c920e", "97b6b97bd19801ec95f8c965cc920f", "97bd07f5307f595b0b0bc920fb0722", "7f0e397bd097c36b0b6fc9210c8dc2", "9778397bd097c36c9210c9274c920e", "97b6b97bd19801ec95f8c965cc920f", "97bd07f5307f595b0b0bc920fb0722", "7f0e397bd097c36b0b6fc9210c8dc2", "9778397bd097c36c9210c9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bd07f1487f595b0b0bc920fb0722", "7f0e397bd097c36b0b6fc9210c8dc2", "9778397bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf7f1487f595b0b0bb0b6fb0722", "7f0e397bd097c35b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf7f1487f595b0b0bb0b6fb0722", "7f0e397bd097c35b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf7f1487f531b0b0bb0b6fb0722", "7f0e397bd097c35b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c965cc920e", "97bcf7f1487f531b0b0bb0b6fb0722", "7f0e397bd07f595b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b97bd19801ec9210c9274c920e", "97bcf7f0e47f531b0b0bb0b6fb0722", "7f0e397bd07f595b0b0bc920fb0722", "9778397bd097c36b0b6fc9210c91aa", "97b6b97bd197c36c9210c9274c920e", "97bcf7f0e47f531b0b0bb0b6fb0722", "7f0e397bd07f595b0b0bc920fb0722", "9778397bd097c36b0b6fc9210c8dc2", "9778397bd097c36c9210c9274c920e", "97b6b7f0e47f531b0723b0b6fb0722", "7f0e37f5307f595b0b0bc920fb0722", "7f0e397bd097c36b0b6fc9210c8dc2", "9778397bd097c36b0b70c9274c91aa", "97b6b7f0e47f531b0723b0b6fb0721", "7f0e37f1487f595b0b0bb0b6fb0722", "7f0e397bd097c35b0b6fc9210c8dc2", "9778397bd097c36b0b6fc9274c91aa", "97b6b7f0e47f531b0723b0b6fb0721", "7f0e27f1487f595b0b0bb0b6fb0722", "7f0e397bd097c35b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b7f0e47f531b0723b0b6fb0721", "7f0e27f1487f531b0b0bb0b6fb0722", "7f0e397bd097c35b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b7f0e47f531b0723b0b6fb0721", "7f0e27f1487f531b0b0bb0b6fb0722", "7f0e397bd097c35b0b6fc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b7f0e47f531b0723b0b6fb0721", "7f0e27f1487f531b0b0bb0b6fb0722", "7f0e397bd07f595b0b0bc920fb0722", "9778397bd097c36b0b6fc9274c91aa", "97b6b7f0e47f531b0723b0787b0721", "7f0e27f0e47f531b0b0bb0b6fb0722", "7f0e397bd07f595b0b0bc920fb0722", "9778397bd097c36b0b6fc9210c91aa", "97b6b7f0e47f149b0723b0787b0721", "7f0e27f0e47f531b0723b0b6fb0722", "7f0e397bd07f595b0b0bc920fb0722", "9778397bd097c36b0b6fc9210c8dc2", "977837f0e37f149b0723b0787b0721", "7f07e7f0e47f531b0723b0b6fb0722", "7f0e37f5307f595b0b0bc920fb0722", "7f0e397bd097c35b0b6fc9210c8dc2", "977837f0e37f14998082b0787b0721", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e37f1487f595b0b0bb0b6fb0722", "7f0e397bd097c35b0b6fc9210c8dc2", "977837f0e37f14998082b0787b06bd", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e27f1487f531b0b0bb0b6fb0722", "7f0e397bd097c35b0b6fc920fb0722", "977837f0e37f14998082b0787b06bd", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e27f1487f531b0b0bb0b6fb0722", "7f0e397bd097c35b0b6fc920fb0722", "977837f0e37f14998082b0787b06bd", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e27f1487f531b0b0bb0b6fb0722", "7f0e397bd07f595b0b0bc920fb0722", "977837f0e37f14998082b0787b06bd", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e27f1487f531b0b0bb0b6fb0722", "7f0e397bd07f595b0b0bc920fb0722", "977837f0e37f14998082b0787b06bd", "7f07e7f0e47f149b0723b0787b0721", "7f0e27f0e47f531b0b0bb0b6fb0722", "7f0e397bd07f595b0b0bc920fb0722", "977837f0e37f14998082b0723b06bd", "7f07e7f0e37f149b0723b0787b0721", "7f0e27f0e47f531b0723b0b6fb0722", "7f0e397bd07f595b0b0bc920fb0722", "977837f0e37f14898082b0723b02d5", "7ec967f0e37f14998082b0787b0721", "7f07e7f0e47f531b0723b0b6fb0722", "7f0e37f1487f595b0b0bb0b6fb0722", "7f0e37f0e37f14898082b0723b02d5", "7ec967f0e37f14998082b0787b0721", "7f07e7f0e47f531b0723b0b6fb0722", "7f0e37f1487f531b0b0bb0b6fb0722", "7f0e37f0e37f14898082b0723b02d5", "7ec967f0e37f14998082b0787b06bd", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e37f1487f531b0b0bb0b6fb0722", "7f0e37f0e37f14898082b072297c35", "7ec967f0e37f14998082b0787b06bd", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e27f1487f531b0b0bb0b6fb0722", "7f0e37f0e37f14898082b072297c35", "7ec967f0e37f14998082b0787b06bd", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e27f1487f531b0b0bb0b6fb0722", "7f0e37f0e366aa89801eb072297c35", "7ec967f0e37f14998082b0787b06bd", "7f07e7f0e47f149b0723b0787b0721", "7f0e27f1487f531b0b0bb0b6fb0722", "7f0e37f0e366aa89801eb072297c35", "7ec967f0e37f14998082b0723b06bd", "7f07e7f0e47f149b0723b0787b0721", "7f0e27f0e47f531b0723b0b6fb0722", "7f0e37f0e366aa89801eb072297c35", "7ec967f0e37f14998082b0723b06bd", "7f07e7f0e37f14998083b0787b0721", "7f0e27f0e47f531b0723b0b6fb0722", "7f0e37f0e366aa89801eb072297c35", "7ec967f0e37f14898082b0723b02d5", "7f07e7f0e37f14998082b0787b0721", "7f07e7f0e47f531b0723b0b6fb0722", "7f0e36665b66aa89801e9808297c35", "665f67f0e37f14898082b0723b02d5", "7ec967f0e37f14998082b0787b0721", "7f07e7f0e47f531b0723b0b6fb0722", "7f0e36665b66a449801e9808297c35", "665f67f0e37f14898082b0723b02d5", "7ec967f0e37f14998082b0787b06bd", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e36665b66a449801e9808297c35", "665f67f0e37f14898082b072297c35", "7ec967f0e37f14998082b0787b06bd", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e26665b66a449801e9808297c35", "665f67f0e37f1489801eb072297c35", "7ec967f0e37f14998082b0787b06bd", "7f07e7f0e47f531b0723b0b6fb0721", "7f0e27f1487f531b0b0bb0b6fb0722"],

  /**
   * 数字转中文速查表
   * @Array Of Property
   * @trans ['日','一','二','三','四','五','六','七','八','九','十']
   * @return Cn string
   */
  nStr1: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341"],

  /**
   * 日期转农历称呼速查表
   * @Array Of Property
   * @trans ['初','十','廿','卅']
   * @return Cn string
   */
  nStr2: ["\u521D", "\u5341", "\u5EFF", "\u5345"],

  /**
   * 月份转农历称呼速查表
   * @Array Of Property
   * @trans ['正','一','二','三','四','五','六','七','八','九','十','冬','腊']
   * @return Cn string
   */
  nStr3: ["\u6B63", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u51AC", "\u814A"],

  /**
   * 返回农历y年一整年的总天数
   * @param lunar Year
   * @return Number
   * @eg:var count = calendar.lYearDays(1987) ;//count=387
   */
  lYearDays: function lYearDays(y) {
    var i,
        sum = 348;
    for (i = 0x8000; i > 0x8; i >>= 1) {
      sum += calendar.lunarInfo[y - 1900] & i ? 1 : 0;
    }
    return sum + calendar.leapDays(y);
  },

  /**
   * 返回农历y年闰月是哪个月；若y年没有闰月 则返回0
   * @param lunar Year
   * @return Number (0-12)
   * @eg:var leapMonth = calendar.leapMonth(1987) ;//leapMonth=6
   */
  leapMonth: function leapMonth(y) {
    //闰字编码 \u95f0
    return calendar.lunarInfo[y - 1900] & 0xf;
  },

  /**
   * 返回农历y年闰月的天数 若该年没有闰月则返回0
   * @param lunar Year
   * @return Number (0、29、30)
   * @eg:var leapMonthDay = calendar.leapDays(1987) ;//leapMonthDay=29
   */
  leapDays: function leapDays(y) {
    if (calendar.leapMonth(y)) {
      return calendar.lunarInfo[y - 1900] & 0x10000 ? 30 : 29;
    }
    return 0;
  },

  /**
   * 返回农历y年m月（非闰月）的总天数，计算m为闰月时的天数请使用leapDays方法
   * @param lunar Year
   * @return Number (-1、29、30)
   * @eg:var MonthDay = calendar.monthDays(1987,9) ;//MonthDay=29
   */
  monthDays: function monthDays(y, m) {
    if (m > 12 || m < 1) {
      return -1;
    } //月份参数从1至12，参数错误返回-1
    return calendar.lunarInfo[y - 1900] & 0x10000 >> m ? 30 : 29;
  },

  /**
   * 返回公历(!)y年m月的天数
   * @param solar Year
   * @return Number (-1、28、29、30、31)
   * @eg:var solarMonthDay = calendar.leapDays(1987) ;//solarMonthDay=30
   */
  solarDays: function solarDays(y, m) {
    if (m > 12 || m < 1) {
      return -1;
    } //若参数错误 返回-1
    var ms = m - 1;
    if (ms == 1) {
      //2月份的闰平规律测算后确认返回28或29
      return y % 4 == 0 && y % 100 != 0 || y % 400 == 0 ? 29 : 28;
    } else {
      return calendar.solarMonth[ms];
    }
  },

  /**
   * 农历年份转换为干支纪年
   * @param  lYear 农历年的年份数
   * @return Cn string
   */
  toGanZhiYear: function toGanZhiYear(lYear) {
    var ganKey = (lYear - 3) % 10;
    var zhiKey = (lYear - 3) % 12;
    if (ganKey == 0) ganKey = 10; //如果余数为0则为最后一个天干
    if (zhiKey == 0) zhiKey = 12; //如果余数为0则为最后一个地支
    return calendar.Gan[ganKey - 1] + calendar.Zhi[zhiKey - 1];
  },

  /**
   * 公历月、日判断所属星座
   * @param  cMonth [description]
   * @param  cDay [description]
   * @return Cn string
   */
  toAstro: function toAstro(cMonth, cDay) {
    var s = "\u9B54\u7FAF\u6C34\u74F6\u53CC\u9C7C\u767D\u7F8A\u91D1\u725B\u53CC\u5B50\u5DE8\u87F9\u72EE\u5B50\u5904\u5973\u5929\u79E4\u5929\u874E\u5C04\u624B\u9B54\u7FAF";
    var arr = [20, 19, 21, 21, 21, 22, 23, 23, 23, 23, 22, 22];
    return s.substr(cMonth * 2 - (cDay < arr[cMonth - 1] ? 2 : 0), 2) + "\u5EA7"; //座
  },

  /**
   * 传入offset偏移量返回干支
   * @param offset 相对甲子的偏移量
   * @return Cn string
   */
  toGanZhi: function toGanZhi(offset) {
    return calendar.Gan[offset % 10] + calendar.Zhi[offset % 12];
  },

  /**
   * 传入公历(!)y年获得该年第n个节气的公历日期
   * @param y公历年(1900-2100)；n二十四节气中的第几个节气(1~24)；从n=1(小寒)算起
   * @return day Number
   * @eg:var _24 = calendar.getTerm(1987,3) ;//_24=4;意即1987年2月4日立春
   */
  getTerm: function getTerm(y, n) {
    if (y < 1900 || y > 2100) {
      return -1;
    }
    if (n < 1 || n > 24) {
      return -1;
    }
    var _table = calendar.sTermInfo[y - 1900];
    var _info = [parseInt("0x" + _table.substr(0, 5)).toString(), parseInt("0x" + _table.substr(5, 5)).toString(), parseInt("0x" + _table.substr(10, 5)).toString(), parseInt("0x" + _table.substr(15, 5)).toString(), parseInt("0x" + _table.substr(20, 5)).toString(), parseInt("0x" + _table.substr(25, 5)).toString()];
    var _calday = [_info[0].substr(0, 1), _info[0].substr(1, 2), _info[0].substr(3, 1), _info[0].substr(4, 2), _info[1].substr(0, 1), _info[1].substr(1, 2), _info[1].substr(3, 1), _info[1].substr(4, 2), _info[2].substr(0, 1), _info[2].substr(1, 2), _info[2].substr(3, 1), _info[2].substr(4, 2), _info[3].substr(0, 1), _info[3].substr(1, 2), _info[3].substr(3, 1), _info[3].substr(4, 2), _info[4].substr(0, 1), _info[4].substr(1, 2), _info[4].substr(3, 1), _info[4].substr(4, 2), _info[5].substr(0, 1), _info[5].substr(1, 2), _info[5].substr(3, 1), _info[5].substr(4, 2)];
    return parseInt(_calday[n - 1]);
  },

  /**
   * 传入农历数字月份返回汉语通俗表示法
   * @param lunar month
   * @return Cn string
   * @eg:var cnMonth = calendar.toChinaMonth(12) ;//cnMonth='腊月'
   */
  toChinaMonth: function toChinaMonth(m) {
    // 月 => \u6708
    if (m > 12 || m < 1) {
      return -1;
    } //若参数错误 返回-1
    var s = calendar.nStr3[m - 1];
    s += "\u6708"; //加上月字
    return s;
  },

  /**
   * 传入农历日期数字返回汉字表示法
   * @param lunar day
   * @return Cn string
   * @eg:var cnDay = calendar.toChinaDay(21) ;//cnMonth='廿一'
   */
  toChinaDay: function toChinaDay(d) {
    //日 => \u65e5
    var s;
    switch (d) {
      case 10:
        s = "\u521D\u5341";
        break;
      case 20:
        s = "\u4E8C\u5341";
        break;
        break;
      case 30:
        s = "\u4E09\u5341";
        break;
        break;
      default:
        s = calendar.nStr2[Math.floor(d / 10)];
        s += calendar.nStr1[d % 10];
    }
    return s;
  },

  /**
   * 年份转生肖[!仅能大致转换] => 精确划分生肖分界线是“立春”
   * @param y year
   * @return Cn string
   * @eg:var animal = calendar.getAnimal(1987) ;//animal='兔'
   */
  getAnimal: function getAnimal(y) {
    return calendar.Animals[(y - 4) % 12];
  },

  /**
   * 传入阳历年月日获得详细的公历、农历object信息 <=>JSON
   * @param y  solar year
   * @param m  solar month
   * @param d  solar day
   * @return JSON object
   * @eg:console.log(calendar.solar2lunar(1987,11,01));
   */
  solar2lunar: function solar2lunar(y, m, d) {
    //参数区间1900.1.31~2100.12.31
    //年份限定、上限
    if (y < 1900 || y > 2100) {
      return -1; // undefined转换为数字变为NaN
    }
    //公历传参最下限
    if (y == 1900 && m == 1 && d < 31) {
      return -1;
    }
    //未传参  获得当天
    if (!y) {
      var objDate = new Date();
    } else {
      var objDate = new Date(y, parseInt(m) - 1, d);
    }
    var i,
        leap = 0,
        temp = 0;
    //修正ymd参数
    var y = objDate.getFullYear(),
        m = objDate.getMonth() + 1,
        d = objDate.getDate();
    var offset = (Date.UTC(objDate.getFullYear(), objDate.getMonth(), objDate.getDate()) - Date.UTC(1900, 0, 31)) / 86400000;
    for (i = 1900; i < 2101 && offset > 0; i++) {
      temp = calendar.lYearDays(i);
      offset -= temp;
    }
    if (offset < 0) {
      offset += temp;
      i--;
    }

    //是否今天
    var isTodayObj = new Date(),
        isToday = false;
    if (isTodayObj.getFullYear() == y && isTodayObj.getMonth() + 1 == m && isTodayObj.getDate() == d) {
      isToday = true;
    }
    //星期几
    var nWeek = objDate.getDay(),
        cWeek = calendar.nStr1[nWeek];
    //数字表示周几顺应天朝周一开始的惯例
    if (nWeek == 0) {
      nWeek = 7;
    }
    //农历年
    var year = i;
    var leap = calendar.leapMonth(i); //闰哪个月
    var isLeap = false;

    //效验闰月
    for (i = 1; i < 13 && offset > 0; i++) {
      //闰月
      if (leap > 0 && i == leap + 1 && isLeap == false) {
        --i;
        isLeap = true;
        temp = calendar.leapDays(year); //计算农历闰月天数
      } else {
        temp = calendar.monthDays(year, i); //计算农历普通月天数
      }
      //解除闰月
      if (isLeap == true && i == leap + 1) {
        isLeap = false;
      }
      offset -= temp;
    }
    // 闰月导致数组下标重叠取反
    if (offset == 0 && leap > 0 && i == leap + 1) {
      if (isLeap) {
        isLeap = false;
      } else {
        isLeap = true;
        --i;
      }
    }
    if (offset < 0) {
      offset += temp;
      --i;
    }
    //农历月
    var month = i;
    //农历日
    var day = offset + 1;
    //天干地支处理
    var sm = m - 1;
    var gzY = calendar.toGanZhiYear(year);

    // 当月的两个节气
    // bugfix-2017-7-24 11:03:38 use lunar Year Param `y` Not `year`
    var firstNode = calendar.getTerm(y, m * 2 - 1); //返回当月「节」为几日开始
    var secondNode = calendar.getTerm(y, m * 2); //返回当月「节」为几日开始

    // 依据12节气修正干支月
    var gzM = calendar.toGanZhi((y - 1900) * 12 + m + 11);
    if (d >= firstNode) {
      gzM = calendar.toGanZhi((y - 1900) * 12 + m + 12);
    }

    //传入的日期的节气与否
    var isTerm = false;
    var Term = null;
    if (firstNode == d) {
      isTerm = true;
      Term = calendar.solarTerm[m * 2 - 2];
    }
    if (secondNode == d) {
      isTerm = true;
      Term = calendar.solarTerm[m * 2 - 1];
    }
    //日柱 当月一日与 1900/1/1 相差天数
    var dayCyclical = Date.UTC(y, sm, 1, 0, 0, 0, 0) / 86400000 + 25567 + 10;
    var gzD = calendar.toGanZhi(dayCyclical + d - 1);
    //该日期所属的星座
    var astro = calendar.toAstro(m, d);

    return {
      lYear: year,
      lMonth: month,
      lDay: day,
      Animal: calendar.getAnimal(year),
      IMonthCn: (isLeap ? "\u95F0" : "") + calendar.toChinaMonth(month),
      IDayCn: calendar.toChinaDay(day),
      cYear: y,
      cMonth: m,
      cDay: d,
      gzYear: gzY,
      gzMonth: gzM,
      gzDay: gzD,
      isToday: isToday,
      isLeap: isLeap,
      nWeek: nWeek,
      ncWeek: "\u661F\u671F" + cWeek,
      isTerm: isTerm,
      Term: Term,
      astro: astro
    };
  },

  /**
   * 传入农历年月日以及传入的月份是否闰月获得详细的公历、农历object信息 <=>JSON
   * @param y  lunar year
   * @param m  lunar month
   * @param d  lunar day
   * @param isLeapMonth  lunar month is leap or not.[如果是农历闰月第四个参数赋值true即可]
   * @return JSON object
   * @eg:console.log(calendar.lunar2solar(1987,9,10));
   */
  lunar2solar: function lunar2solar(y, m, d, isLeapMonth) {
    //参数区间1900.1.31~2100.12.1
    var isLeapMonth = !!isLeapMonth;
    var leapOffset = 0;
    var leapMonth = calendar.leapMonth(y);
    var leapDay = calendar.leapDays(y);
    if (isLeapMonth && leapMonth != m) {
      return -1;
    } //传参要求计算该闰月公历 但该年得出的闰月与传参的月份并不同
    if (y == 2100 && m == 12 && d > 1 || y == 1900 && m == 1 && d < 31) {
      return -1;
    } //超出了最大极限值
    var day = calendar.monthDays(y, m);
    var _day = day;
    //bugFix 2016-9-25
    //if month is leap, _day use leapDays method
    if (isLeapMonth) {
      _day = calendar.leapDays(y, m);
    }
    if (y < 1900 || y > 2100 || d > _day) {
      return -1;
    } //参数合法性效验

    //计算农历的时间差
    var offset = 0;
    for (var i = 1900; i < y; i++) {
      offset += calendar.lYearDays(i);
    }
    var leap = 0,
        isAdd = false;
    for (var i = 1; i < m; i++) {
      leap = calendar.leapMonth(y);
      if (!isAdd) {
        //处理闰月
        if (leap <= i && leap > 0) {
          offset += calendar.leapDays(y);
          isAdd = true;
        }
      }
      offset += calendar.monthDays(y, i);
    }
    //转换闰月农历 需补充该年闰月的前一个月的时差
    if (isLeapMonth) {
      offset += day;
    }
    //1900年农历正月一日的公历时间为1900年1月30日0时0分0秒(该时间也是本农历的最开始起始点)
    var stmap = Date.UTC(1900, 1, 30, 0, 0, 0);
    var calObj = new Date((offset + d - 31) * 86400000 + stmap);
    var cY = calObj.getUTCFullYear();
    var cM = calObj.getUTCMonth() + 1;
    var cD = calObj.getUTCDate();

    return calendar.solar2lunar(cY, cM, cD);
  }
}; /**
    *公共
    */
exports.default = {
  solar2lunar: calendar.solar2lunar,

  lunar2solar: calendar.lunar2solar,

  isEmptyObject: function isEmptyObject(obj) {
    for (var key in obj) {
      return false;
    }
    return true;
  },
  isValueNullInObj: function isValueNullInObj(obj, key) {
    if (obj.hasOwnProperty(key) && obj[key] != null && obj[key] != "") {
      return false;
    }
    return true;
  },
  addDays: function addDays(date, day) {
    var d = new Date(date);
    d.setDate(d.getDate() + day);
    return d;
  },
  addMonths: function addMonths(date, month) {
    var d = new Date(date);
    var day = d.getDate();
    d.setMonth(d.getMonth(), month);
    var maxDay = d.getDate();
    if (day > maxDay) {
      day = maxDay;
    }
    d.setDate(day);
    return d;
  },
  dateFormat: function dateFormat(data, format) {
    if (!data) return "";
    var date = new Date(data);
    var o = {
      "M+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
      "h+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(format)) format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }return format;
  },
  formatDate: function formatDate(timestamp) {
    var date = new Date(timestamp);
    // 获取年份、月份、日期、小时、分钟、秒钟，并转为字符串
    var year = date.getFullYear().toString().padStart(4, '0');
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    var hour = date.getHours().toString().padStart(2, '0');
    var minute = date.getMinutes().toString().padStart(2, '0');
    var second = date.getSeconds().toString().padStart(2, '0');
    // 拼接字符串并返回
    return year + "-" + month + "-" + day;
  },

  /**
   * @Author: jylu2
   * @Description: 把字符串转化为日期的方法
   * @Date:2017/8/16
   */
  toDate: function toDate(strDate, format) {
    if (strDate === "" || strDate == undefined) {
      return null;
    }
    if ((typeof strDate === "undefined" ? "undefined" : (0, _typeof3.default)(strDate)) == "object") {
      return strDate;
    }
    var t = ["y+", "M+", "d+", "H+", "h+", "m+", "s+", "S"];
    var v = [];
    var iso = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/;
    var js = /\/Date\((\d+)\)\//gi;
    var re = RegExp;

    if (js.test(strDate)) {
      return new Date(+re.$1);
    } else if (iso.test(strDate)) {
      return new Date(Date.UTC(+re.$1, +re.$2 - 1, +re.$3, +re.$4, +re.$5, +re.$6));
    } else {}

    for (var k in t) {
      var temp = new RegExp("(" + t[k] + ")", "g");
      temp.test(format);
      var index = temp.lastIndex;
      if (index == 0) {
        v[k] = 0;
        continue;
      }
      var length = format.match(temp)[0].length;
      index -= length;
      v[k] = parseInt(strDate.substr(index, length));
    }
    v[1]--;
    v[4] += 12;
    return new Date(v[0], v[1], v[2], v[3] || v[4], v[5], v[6]);
  },
  strSlic: function strSlic(str, n) {
    var r = /[^\x00-\xff]/g;
    if (str.replace(r, "mm").length <= n) {
      return str;
    } else {
      return str.substring(0, n - 3) + "...";
    }
    /*var m = Math.floor(n / 2);
     for (var i = m; i < str.length + 1; i++) {
     if (str.substr(0, i).replace(r, "mm").length >= n) {
     return str.substr(0, i - 1) + "..";
     }
     }*/
  },
  stringTrim: function stringTrim(str) {
    // 清除两边的空格
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  toUTC: function toUTC(time) {
    var date = new Date(time);
    date.setHours(date.getHours() - 8); // 转换为 UTC 时间
    return date.toISOString();
  },

  /**
   * 格式化月份,日期, 传入数字无0前缀补0
   * */
  formatWithZero: function formatWithZero(toFormat) {
    var str = toFormat + "";
    return str.length == 1 ? "0" + str : str;
  },

  /**
   * 获取学期分割点
   * */
  getTermSplitDate: function getTermSplitDate(year) {
    var solar = this.lunar2solar(year + 1, _constants2.default.TERM_SPLIT_MONTH, _constants2.default.TERM_SPLIT_DATE, false);
    var month = this.formatWithZero(solar.cMonth);
    var day = this.formatWithZero(solar.cDay);
    return solar.cYear + "-" + month + "-" + day;
  },

  /**
   * 获取四舍五入保留N位有效数字的百分数, 如0.2333 => "23.3%", N在配置中配置, 默认3位, 不合法返回空串 "", fixNum 可不传用默认配置
   * */
  rateTransfer: function rateTransfer(num, fixNum, isPercent) {
    var trans = parseFloat(num);
    if (isNaN(trans)) {
      return "";
    } else {
      if (!isPercent) {
        return trans.toFixed(fixNum || _constants2.default.RATE_FIXED_NUM) + "";
      } else {
        return (trans * 100).toFixed(fixNum || _constants2.default.RATE_FIXED_NUM) + "%";
      }
    }
  },

  /**
   * 获取分数保留小数后结果, 如23.45454 => "23.45", fixNum 可不传用默认配置
   * */
  scoreTransfer: function scoreTransfer(num, fixNum) {
    var trans = parseFloat(num);
    if (isNaN(trans)) {
      return "";
    } else {
      return trans.toFixed(fixNum || _constants2.default.SCORE_FIXED_NUM);
    }
  },

  generateStartEnd: function generateStartEnd(year, term) {
    var start = "0000-01-01";
    var end = "9999-12-31";
    if (year == "all") {} else if (term == "all") {
      start = year + "-" + _constants2.default.TERM_START_DATE;
      end = year + 1 + "-" + _constants2.default.TERM_END_DATE;
    } else {
      var splitDate = this.getTermSplitDate(year);
      start = term === 1 ? year + "-" + _constants2.default.TERM_START_DATE : splitDate;
      end = term === 1 ? this.yesterday(splitDate) : year + 1 + "-" + _constants2.default.TERM_END_DATE;
    }
    return {
      start: start,
      end: end
    };
  },

  /**
   * @Author: jylu2
   * @Description: 传入一个日期字符串，返回该日期昨天的年月日字符串
   * @Date:2017/8/16
   */
  yesterday: function yesterday(oneDay) {
    var toDay = this.toDate(oneDay, "yyyy-MM-dd");
    var t = toDay.getTime() - 1000 * 60 * 60 * 24;
    var yesterday = new Date(t);
    yesterday = this.toFormat(yesterday, "yyyy-MM-dd");
    return yesterday;
  },

  // 函数名称： toFormat
  // 函数功能： 用日期格式化(yyyy-MM-dd HH:mm:ss)
  // 函数参数： 日期及要返回的字符串格式
  // 返 回 值： 字符串
  // 创 建 人： jylu2
  // 创建日期：
  toFormat: function toFormat(myDate, format) {
    var o = {
      "M+": myDate.getMonth() + 1,
      "d+": myDate.getDate(),
      "H+": myDate.getHours(),
      "h+": myDate.getHours() - 12,
      "m+": myDate.getMinutes(),
      "s+": myDate.getSeconds(),
      "q+": Math.floor((myDate.getMonth() + 3) / 3),
      S: myDate.getMilliseconds()
    };

    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (myDate.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return format;
  },


  /**
   * 用于按学期发送后台请求的公共方法, 默认按照传入的学年学期, 组织startTime和endTime参数
   *
   * @param year 学年 Number
   * @param term 学期 Number 取1或2
   * @param param 额外参数, 如没有需要传一个空对象
   * @param api 调用请求的对象
   * @param method 请求对象的具体请求方法(函数类型)
   * @param success 请求成功回调方法
   * @param [fail] 请求失败回调方法, 可选
   * @param [caller] 绑定调用对象, 可选, 绑定后success fail由caller对象调用
   *
   * */
  queryWithDate: function queryWithDate(_ref) {
    var year = _ref.year,
        term = _ref.term,
        param = _ref.param,
        api = _ref.api,
        method = _ref.method,
        success = _ref.success,
        fail = _ref.fail,
        caller = _ref.caller;

    var start = "0000-01-01";
    var end = "9999-12-31";
    if (year == "all") {} else if (term == "all") {
      start = year + "-" + _constants2.default.TERM_START_DATE;
      end = year + 1 + "-" + _constants2.default.TERM_END_DATE;
    } else {
      var splitDate = this.getTermSplitDate(year);
      start = term === 1 ? year + "-" + _constants2.default.TERM_START_DATE : splitDate;
      end = term === 1 ? this.yesterday(splitDate) : year + 1 + "-" + _constants2.default.TERM_END_DATE;
    }

    var paramObj = {
      startTime: start,
      endTime: end
    };

    if (!year || !term || !api || !method || typeof success !== "function") {
      typeof fail === "function" ? !caller ? fail(res.body.message, res.body) : fail.call(caller, res.body.message, res.body) : console.log("调用请求函数的参数错误");
    }

    if (param && (typeof param === "undefined" ? "undefined" : (0, _typeof3.default)(param)) === "object") {
      for (var key in param) {
        paramObj[key] = param[key];
      }
    }

    method.call(api, paramObj, function (res) {
      if (res.body && res.body.flag === true) {
        !caller ? success(res.body.data, res.body) : success.call(caller, res.body.data, res.body);
      } else {
        typeof fail === "function" ? !caller ? fail(res.body.message, res.body) : fail.call(caller, res.body.message, res.body) : console.log("\u8BF7\u6C42\u5931\u8D25! " + res.body.message);
      }
    });
  },
  query: function query(_ref2) {
    var param = _ref2.param,
        api = _ref2.api,
        method = _ref2.method,
        success = _ref2.success,
        fail = _ref2.fail,
        caller = _ref2.caller;

    method.call(api, param, function (res) {
      if (res.body && res.body.flag === true) {
        !caller ? success(res.body.data, res.body) : success.call(caller, res.body.data, res.body);
      } else {
        typeof fail === "function" ? !caller ? fail(res.body.message, res.body) : fail.call(caller, res.body.message, res.body) : console.log("\u8BF7\u6C42\u5931\u8D25! " + res.body.message);
      }
    });
  },

  /**
   * 计算区间数组
   * @param step    步长
   * @param totalScore 总分
   */
  calcStep: function calcStep(step, totalScore) {
    if (!step || !totalScore) return [];
    var stepArr = [];
    var residualValue = totalScore % step;
    var avaliableValue = totalScore - residualValue;
    var count = avaliableValue / step;
    for (var i = 0; i < count; i++) {
      stepArr.push({
        s: i * step,
        e: i * step + step
      });
    }
    if (residualValue != 0) {
      stepArr.push({
        s: avaliableValue,
        e: totalScore
      });
    }
    return stepArr;
  },


  /**
   * 获取Url的参数
   * @param name 参数名
   * @returns {string|null}
   */
  getUrlKey: function getUrlKey(name) {
    return decodeURIComponent((new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(location.href) || [, ""])[1].replace(/\+/g, "%20")) || null;
  },

  /**
   * 判断是否数字
   * @param val
   * @returns {boolean}
   */
  isNumber: function isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if (regPos.test(val) || regNeg.test(val)) {
      return true;
    } else {
      return false;
    }
  },

  uuid: function uuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == "x" ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  },

  /**
   * 删除数组元素
   * @param item,arr
   * @returns arr
   */
  splice: function splice(item, arr) {
    arr.splice(arr.findIndex(function (_item) {
      return _item === item;
    }), 1);
    return arr;
  },
  spliceItem: function spliceItem(item, arr, dateperiod) {
    var index = arr.findIndex(function (_item) {
      return _item === item;
    });
    var tempStartTime = "";
    var tempEndTime = "";
    if (arr.length > 1 && index == 0) {
      tempStartTime = arr[index].period.chooseStartTime;
      tempEndTime = arr[index + 1].period.chooseEndTime;
      arr.splice(index, 1);
      arr[0].period.chooseStartTime = tempStartTime;
      arr[0].period.chooseEndTime = tempEndTime;
      arr[index].pickOptions = {
        disabledDate: function disabledDate(time) {
          var temp = time.getTime() < arr[index].period.chooseStartTime || time.getTime() > dateperiod[1];
          return temp;
        }
      };
      return arr;
    }
    if (index == 0 || index == arr.length - 1) {
      arr.splice(index, 1);
      return arr;
    } else {
      for (var i = 0; i < arr.length; i++) {
        if (i == index) {
          tempStartTime = arr[index].period.chooseStartTime;
          tempEndTime = arr[index + 1].period.chooseEndTime;
          arr.splice(i, 1);
          arr[i].period.chooseStartTime = tempStartTime;
          arr[i].period.chooseEndTime = tempEndTime;
          arr[index].pickOptions = {
            disabledDate: function disabledDate(time) {
              var temp = time.getTime() < arr[index].period.chooseStartTime || time.getTime() > dateperiod[1];
              return temp;
            }
          };
          return arr;
        }
      }
    }
  },
  isInArray: function isInArray(item, arr) {
    var index = arr.findIndex(function (_item) {
      return _item === item;
    });
    return index > -1;
  },
  /**
   * 将年级编码转换成对应的年级名称
   * 例如 : senior1 => 高中一年级
   * @param gradeCode
   * @returns {*}
   */
  gradeCodeToName: function gradeCodeToName(gradeCode) {
    try {
      var map = {
        12: "高三",
        11: "高二",
        10: "高一",
        "09": "九年级",
        "08": "八年级",
        "07": "七年级",
        "06": "六年级",
        "05": "五年级",
        "04": "四年级",
        "03": "三年级",
        "02": "二年级",
        "01": "一年级"
      };
      if (map[gradeCode]) {
        return map[gradeCode];
      } else {
        return gradeCode;
      }
    } catch (ex) {
      return gradeCode;
    }
  },
  // 获取评语
  getsummary: function getsummary(array, value) {
    var discription = "";
    if (array == null || array.length == 0) {
      return "";
    }
    array.forEach(function (item, index) {
      if (item["minrange"] != undefined && item["maxrang"] != undefined && item["discription"] != undefined) {
        if (value >= item["minrange"] && value < item["maxrang"]) {
          discription = item["discription"];
        } else if (index == array.length - 1 && value == item["maxrang"]) {
          discription = item["discription"];
        } else {}
      }
    });
    return discription;
  },
  // 计算过去多久
  getDateDiff: function getDateDiff(setdateTimeStamp) {
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var halfamonth = day * 15;
    var month = day * 30;

    var dateTimeStamp = new Date(setdateTimeStamp);
    var nowTime = new Date();
    var now = nowTime.getTime();
    var diffValue = now - dateTimeStamp;
    if (diffValue < 0) {
      //若日期不符则弹出窗口告之
      return "结束日期不能小于开始日期！";
    }
    var monthC = diffValue / month;
    var weekC = diffValue / (7 * day);
    var dayC = diffValue / day;
    //如果相差时间大于当天时间，并且小于24小时时，则为昨天day-now-dayC*day为去掉多少天的秒数，与现在的时间相差几分钟，如果大于零，则为第二天，如果小于零则第一天
    var dayLessDayHour = diffValue - now - parseInt(dayC) * day + new Date(nowTime.toLocaleDateString()).getTime();
    var hourC = diffValue / hour;
    var minC = diffValue / minute;
    var result = "";
    if (monthC >= 1) {
      result = parseInt(monthC) + "个月前";
    } else if (weekC >= 1) {
      result = parseInt(weekC) + "周前";
    } else if (parseInt(dayC) == 6 && dayLessDayHour > 0) {
      result = "1周前";
    } else if (dayC >= 1 && dayLessDayHour > 0) {
      result = parseInt(dayC + 1) + "天前";
    } else if (dayC >= 1) {
      result = parseInt(dayC) + "天前";
    } else if (dayLessDayHour > 0) {
      result = "1天前";
    } else if (hourC >= 1) {
      result = parseInt(hourC) + "个小时前";
    } else if (minC >= 1) {
      result = parseInt(minC) + "分钟前";
    } else result = "刚刚";
    // alert(result);
    return result;
  },
  //对象排序
  sortObject: function sortObject(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  },

  bubbleSort: function bubbleSort(array) {
    for (var i = 0; i < array.length; i++) {
      for (var j = array.length - 1; j > i; j--) {
        if (array[j].score > array[j - 1].score) {
          var temp = array[j];
          array[j] = array[j - 1];
          array[j - 1] = temp;
        }
      }
    }
    return array;
  },
  stringFormat: function stringFormat(template, args) {
    var result = template;
    if (template.length > 0) {
      if (template.length == 1 && (typeof args === "undefined" ? "undefined" : (0, _typeof3.default)(args)) == "object") {
        for (var key in args) {
          if (args[key] != undefined) {
            var reg = new RegExp("({" + key + "})", "g");
            result = result.replace(reg, args[key]);
          }
        }
      } else {
        for (var i = 0; i < args.length; i++) {
          if (args[i] != undefined) {
            //var reg = new RegExp("({[" + i + "]})", "g");//这个在索引大于9时会有问题
            var reg = new RegExp("({)" + i + "(})", "g");
            result = result.replace(reg, args[i]);
          }
        }
      }
    }
    return result;
  },
  initSectionName: function initSectionName(name) {
    var namestr = name.replace("一、", "");
    namestr = namestr.replace("二、", "");
    namestr = namestr.replace("三、", "");
    namestr = namestr.replace("四、", "");
    namestr = namestr.replace("五、", "");
    namestr = namestr.replace("六、", "");
    namestr = namestr.replace("七、", "");
    namestr = namestr.replace("八、", "");
    namestr = namestr.replace("九、", "");
    namestr = namestr.replace("十、", "");
    namestr = namestr.replace("第一节、", "");
    namestr = namestr.replace("第二节、", "");
    namestr = namestr.replace("第三节、", "");
    namestr = namestr.replace("第四节、", "");
    namestr = namestr.replace("第五节、", "");
    namestr = namestr.replace("第六节、", "");
    namestr = namestr.replace("第七节、", "");
    namestr = namestr.replace("第八节、", "");
    namestr = namestr.replace("第九节、", "");
    namestr = namestr.replace("第十节、", "");
    return namestr;
  },
  //获取文件服务资源认证参数
  getFileAuthParams: function getFileAuthParams() {
    var _downloadUrl = _config2.default.getConfig().downloadUrl;
    if (_downloadUrl.indexOf("auth/file") === -1) {
      return "";
    }
    var prams = "";
    var deviceId = this.getCookie("deviceId");
    var token = this.getCookie("token");
    var appkey = this.getCookie("appkey");
    var clientType = "web";
    prams = "&deviceId=" + deviceId + "&token=" + token + "&appkey=" + appkey + "&clientType=" + clientType;
    return prams;
  },
  getCystorageUrl: function getCystorageUrl() {
    var _downloadUrl = _config2.default.gestConfig().downloadUrl;
    return _downloadUrl === undefined ? "" : _downloadUrl;
  },
  getCookie: function getCookie(name, base64) {
    var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      if (base64 === true) return Base64.decode(unescape(arr[2]));else return unescape(arr[2]);
    } else return null;
  },
  /**
   * @param arr1 数组1
   * @param arr2 数组2
   * @param key 如果数组里边包裹着对象，则可以比较对象的某个键值对（可选）
   * @param order 数组中的顺序是否可以打乱（可选）
   * @returns {boolean}
   */
  arryEquals: function arryEquals(arr1, arr2, key, order) {
    // 1.判断是否为空
    var isNotBlank = function isNotBlank(value) {
      if (value === null || value === undefined || value !== value || value === "null" || value === "undefined" || value === "NaN" || value === "") {
        return false;
      } else {
        var jsonStr = null;
        try {
          jsonStr = (0, _stringify2.default)(value);
        } catch (error) {
          jsonStr = "";
        }
        if (jsonStr === "{}") {
          return false;
        }
        return true;
      }
    };

    // 2.判断两个数组是否相等（包括数组里的键值是否相等）
    Array.prototype.equals = function (array, key, order) {
      // array--要比较的数组（必需）
      // key--如果数组里边包裹着对象，则可以比较对象的某个键值对（可选）
      // order--数组中的顺序是否可以打乱（可选）
      if (!array instanceof Array) return false;
      if (this.length != array.length) return false;
      if (order) {
        // 顺序要求一致
        for (var i = 0; i < this.length; i++) {
          if (isNotBlank(key)) {
            if (this[i][key] !== array[i][key]) {
              return false;
              break;
            }
          } else {
            if (this[i] !== array[i]) {
              return false;
              break;
            }
          }
        }
      } else {
        // 顺序可以不一致
        for (var _i = 0; _i < this.length; _i++) {
          var log = false;
          for (var j = 0; j < array.length; j++) {
            if (isNotBlank(key)) {
              if (this[_i][key] === array[j][key]) {
                log = true;
                break;
              }
            } else {
              if (this[_i] === array[j]) {
                log = true;
                break;
              }
            }
          }
          if (!log) {
            return false;
            break;
          }
        }
      }
      return true;
    };
    Object.defineProperty(Array.prototype, "equals", {
      enumerable: false
    });
    return arr1.equals(arr2, key, order);
  },

  /**
   * 检查字符串字节是否超过限制（中文2字节，非中文1字节）
   * @param str 待检测字符串
   * @param maxLength 限定最大长度
   * @returns {maxLength为null，则返回字节长度。否则true为规定长度内}
   */
  checkCodeLength: function checkCodeLength(str, maxLength) {
    var sumLength = 0;
    if (!str) {
      if (maxLength == null) {
        return sumLength;
      }
      return true;
    }
    var isChinese = function isChinese(str) {
      var reCh = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
      return reCh.test(str);
    };
    for (var i = 0; i < str.length; i++) {
      if (isChinese(str.charAt(i))) {
        sumLength = sumLength + 2; //中文为2个字符
      } else {
        sumLength = sumLength + 1; //英文一个字符
      }
    }
    if (maxLength == null) {
      return sumLength;
    } else {
      return !(sumLength > maxLength);
    }
  },
  /**
   * 输入限制自定义截取字符串（中文2字节，非中文1字节）
   * @param str 待检测字符串
   * @param maxLength 限定最大长度
   * @returns {String}
   */
  customSubString: function customSubString(str, maxLength) {
    var hasEnteredLength = 0; //已经输入字数0
    var textValArr = []; //存储textarea值数组
    var isChinese = function isChinese(str) {
      var reCh = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
      return reCh.test(str);
    };
    for (var i = 0; i < str.length; i++) {
      if (isChinese(str.charAt(i))) {
        hasEnteredLength = hasEnteredLength + 2; //中文为2个字符
      } else {
        hasEnteredLength = hasEnteredLength + 1; //英文一个字符
      }
      //将当前值push到数组中
      textValArr.push(str.charAt(i));
      if (hasEnteredLength >= maxLength) {
        //大于限定字符 自动截取
        return textValArr.join("");
      }
    }
    return textValArr.join("");
  },

  /**
   * 过滤富文本标签（全部）
   * @param str 待过滤字符串
   * @returns {String}
   */
  filterRichText: function filterRichText(str) {
    if (!!str) {
      str = str.replace(/(\n)/g, "");
      str = str.replace(/(\t)/g, "");
      str = str.replace(/(\r)/g, "");
      str = str.replace(/<\/?[^>]*>/g, " ");
    }
    return str;
  },
  /**
   * 校验任务名称是否含有特殊字符
   * 允许中  英文大小写  数字  -  _  (  )  ：  中文双引号及空格
   * @param str 待过滤字符串
   * @returns {Boolean}
   */
  checktaskName: function checktaskName(str) {
    var pattner = /^[\u4e00-\u9fa5_a-zA-Z0-9\-()：“” ]{1,50}$/;
    return pattner.test(str);
  },
  filterHTMLTag: function filterHTMLTag(msg) {
    var msg = msg.replace(/<\/?[^>]*>/g, ""); //去除HTML Tag
    msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
    msg = msg.replace(/&npsp;/gi, ""); //去掉npsp
    return msg;
  },
  /**将英语字母转为中文拼音
   * @param str 待过滤字符串
   * @returns {String}
   */
  enTochn: function enTochn(str) {
    return str.replace(/a/g, "ɑ").replace(/v/g, "ü").replace(/g/g, "ɡ");
  },

  /**替换声调
   * @param str 待过滤字符串
   * @returns {String}
   */
  replaceSD: function replaceSD(val) {
    var result = "";
    if (val) {
      switch (val) {
        case "1":
        case "—":
          result = "一声";
          break;
        case "2":
        case "/":
          result = "二声";
          break;
        case "3":
        case "∨":
          result = "三声";
          break;
        case "4":
        case "\\":
          result = "四声";
          break;
        case "ZERO":
          result = "零声母";
          break;
        default:
          result = val;
      }
    }
    return result;
  },
  isNumeric: function isNumeric(str) {
    return !isNaN(str) && isFinite(str);
  },

  // 敏感词校验，替换敏感词为空
  checkSensitiveWord: function checkSensitiveWord(str) {
    if (!this.isNumeric(str)) {
      return (0, _user.recognizeText)({ text: str }).then(function (res) {
        res = JSON.parse(res);
        if (res && res.length) {
          res.forEach(function (item) {
            str = str.replace(item, '');
          });
        }
        return str;
      });
    } else {
      return str;
    }
  }
};

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  loginInfo: {
    username: "",
    password: "",
    captchaCode: ""
  }
};

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(0);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(18);

var _extends3 = _interopRequireDefault(_extends2);

var _config = __webpack_require__(1);

var _config2 = _interopRequireDefault(_config);

var _commonUtils = __webpack_require__(4);

var _commonUtils2 = _interopRequireDefault(_commonUtils);

var _constants = __webpack_require__(7);

var _constants2 = _interopRequireDefault(_constants);

__webpack_require__(10);

var _handleResult = __webpack_require__(2);

var _handleResult2 = _interopRequireDefault(_handleResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      env_name: "production"
    };
  },

  isInit: false,

  //path :'/task/classwork/create'
  //groupId:'b6dea5e3dfd2420fae6fee0cb845f246'
  requestMethod: function requestMethod(param, path, groupId) {
    var self = this;
    if (!self.isInit) {
      var apiConfig = (0, _extends3.default)({}, _config2.default.getConfig().apiConfig);
      shield.ShieldConfig.config(apiConfig);
      // // 配置初始化
      shield.ShieldConfig.init();
      this.isInit = true;
    }
    // 创建请求参数
    var params = new shield.ParamsBuilder({
      scheme:  true ? shield.HttpConstant.SCHEME_HTTPS : shield.HttpConstant.SCHEME_HTTP,
      method: shield.Method.POST,
      path: _config2.default.getConfig().apiConfig.prefixPath + path,
      authType: shield.SdkConstant.AUTH_TYPE_DEFAULT,
      groupId: groupId
    });
    if (!!param) {
      params.addParam("param", (0, _stringify2.default)(param), shield.ParamPosition.FORM, false);
    }
    var token = sessionStorage.getItem('token');
    //let mac = sessionStorage.getItem('mac');
    var rolecode = sessionStorage.getItem('rolecode');
    var deviceId = SSO.deviceId;

    var extInfoStr = this.getExtInfo(deviceId, rolecode);
    params.addParam("S-Auth-Token", token, shield.ParamPosition.HEADER, true);
    params.addParam("S-Auth-ClientType", _config2.default.getConfig().ssoConfig.client, shield.ParamPosition.HEADER, true);
    params.addParam("S-Auth-DeviceId", deviceId, shield.ParamPosition.HEADER, true);
    //params.addParam("S-Auth-Mac", mac, shield.ParamPosition.HEADER, true);
    //params.addParam("S-Auth-ClientIp", '192.168.1.100', shield.ParamPosition.HEADER, true);
    params.addParam("S-Auth-ExtInfo", extInfoStr, shield.ParamPosition.HEADER, true);
    // http请求
    return new _promise2.default(function (resolve, reject) {
      shield.request(params).then(function (res) {
        resolve(res);
      }, function (res) {
        return _handleResult2.default.doError(res, reject);
      });
    });
  },
  getExtInfo: function getExtInfo(deviceId, rolecode) {
    var extInfoStr = _commonUtils2.default.stringFormat("deviceId:{0};roleCode:{1}", [deviceId, rolecode]);
    return extInfoStr;
  }
};

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *  平台管理接口与groupId
 */

exports.default = {
  //教学服务 接口调整
  //路径 以类区分
  interfacePath: {
    exam: {
      listTestTask: "/zxxxj/testtask/listTestTask",
      //查询全部
      listAllPlanDetailDTO: "/zxxxj/complan/list/allPlan",
      //增加班级测试
      addExamTask: "/zxxxj/testtask/addTestTask",
      //更新班级测试
      updateExamTask: "/zxxxj/testtask/updateTestTask",
      //删除班级测试
      deleteExamTask: "/zxxxj/testtask/deleteTestTask",
      //下发班级测试
      isseuedTask: "/zxxxj/testtask/downTestTask",
      //取消下发
      cancelIsseued: "/zxxxj/testtask/calcelDownTestTask",
      // 模考记录list
      testExamList: "/zxxxj/mock/listMockPlan",
      //获取任务明细
      getTestTaskDetail: "/zxxxj/testtask/getTestTaskDetail",
      //查询个人成绩详情
      getStudentScore: "/zxxxj/testtask/getStudentScore",
      //区级联考个人成绩详情
      getStudentScorePlan: "/zxxxj/testtask/getStudentScorePlan",
      //查询班级成绩数据
      listClassStudentScore: "/zxxxj/testtask/listClassStudentScore",
      //班级测试成绩发布
      publishTaskScore: "/zxxxj/testtask/publishTaskScore",
      //修订班级成绩数据
      updateClassStudentsScore: "/zxxxj/testtask/updateClassStudentsScore",
      //查询班级测试默认名称
      getTestTaskName: "/zxxxj/testtask/getTestTaskName",
      // 查询报告详情接口
      getStudentTaskReport: "/zxxxj/testtask/getStudentTaskReport"
    },
    //联考
    plan: {
      getUnitePlanName: "/zxxxj/unite/getUnitePlanName",
      // 获取市级联考名称
      getCityPlanName: "/zxxxj/city/getCityPlanName",
      // 获取省级联考名称
      getProvincePlanName: "/zxxxj/province/getProvincePlanName",
      //获取区级联考列表
      listUnitePlan: "/zxxxj/unite/listUnitePlan",
      // 获取市级联考列表
      listCityPlan: '/zxxxj/city/listCityPlan',
      // 获取省级联考列表
      listProvincePlan: '/zxxxj/province/listProvincePlan',
      //保存区级联考
      saveUnite: "/zxxxj/unite/saveUnite",
      // 保存市级联考
      saveCity: '/zxxxj/city/saveCity',
      // 保存省级联考
      saveProvince: '/zxxxj/province/saveProvince',
      //下发联考计划
      updateUnitePlanState: "/zxxxj/unite/updateUnitePlanState",
      // 列表-下发市级联考计划
      updateCityPlanState: '/zxxxj/city/updateCityPlanState',
      // 编辑-保存、下发市级联考计划
      updateCityPlan: '/zxxxj/city/updateCityPlan',
      // 列表-下发省级联考计划
      updateProvincePlanState: '/zxxxj/province/updateProvincePlanState',
      // 编辑-保存、下发市级联考计划
      updateProvincePlan: '/zxxxj/province/updateProvincePlan',
      //获取联考学校列表
      listAreasSchool: "/zxxxj/user/listAreaSchool",
      // 省、市级获取省份范围
      listArea: '/zxxxj/area/listArea',
      //区级联考计划学校列表
      listUnitePlanSchool: "/zxxxj/unite/listUnitePlanSchool",
      // 市级联考任务学校列表
      listCityPlanSchool: '/zxxxj/city/listCityPlanSchool',
      // 省级联考任务学校列表
      listProvincePlanSchool: '/zxxxj/province/listProvincePlanSchool',
      //取消下发
      deleteUnitePlanState: "/zxxxj/unite/deleteUnitePlanState",
      // 列表-取消市级任务下发
      deleteCityPlanState: '/zxxxj/city/deleteCityPlanState',
      // 列表-取消省级任务下发
      deleteProvincePlanState: '/zxxxj/province/deleteProvincePlanState',
      //区级联考学校编排情况
      getUnitePlanArrange: "/zxxxj/unite/getUnitePlanArrange",
      //市级联考学校编排情况
      getCityPlanArrange: '/zxxxj/city/getCityPlanArrange',
      //省级联考学校编排情况
      getProvincePlanArrange: '/zxxxj/province/getProvincePlanArrange',
      //结束区级考试
      updateUnitePlanToEnd: "/zxxxj/unite/updateUnitePlanToEnd",
      //结束市级考试
      updateCityPlanToEnd: "/zxxxj/city/updateCityPlanToEnd",
      //结束省级考试
      updateProvincePlanToEnd: "/zxxxj/province/updateProvincePlanToEnd",
      //查询联考计划明细
      getUnitePlanDetail: "/zxxxj/unite/getUnitePlanDetail",
      // 查询市级联考计划明细
      getCityPlanDetail: "/zxxxj/city/getCityPlanDetail",
      // 查询省级联考计划明细
      getProvincePlanDetail: "/zxxxj/province/getProvincePlanDetail",
      //修改联考计划
      updateUnitePlan: "/zxxxj/unite/updateUnitePlan",
      //删除联考计划
      deleteUnitePlan: "/zxxxj/unite/deleteUnitePlan",
      // 删除市级联考计划
      deleteCityPlan: "/zxxxj/city/deleteCityPlan",
      // 删除省级联考计划
      deleteProvincePlan: "/zxxxj/province/deleteProvincePlan",
      //查询未完成任务列表
      getUnitePlanStateArrange: "/zxxxj/unite/getUnitePlanStateArrange",
      //联考延期
      updateDelayUnitePlan: "/zxxxj/unite/updateDelayUnitePlan",
      //查询联考学校成绩
      listSchoolScoreSummary: "/zxxxj/unite/listSchoolScoreSummary",
      //区级联考发布成绩
      publishScoreUnitePlan: "/zxxxj/unite/publishScoreUnitePlan",
      // 市级联考发布成绩
      publishScoreCityPlan: '/zxxxj/city/publishScoreCityPlan',
      // 省级联考发布成绩
      publishScoreProvincePlan: '/zxxxj/province/publishScoreProvincePlan',
      //获取导出列表
      pageEmsUserExportRecord: "/zxxxj/record/pageEmsUserExportRecord",
      //导出列表
      exportMockPlanStatistics: "/zxxxj/mock/exportMockPlanStatistics",
      // 导出校级联考任务
      exportSchoolMockPlanStudents: '/zxxxj/mock/exportSchoolMockPlanStudents'
    },
    mock: {
      //获取模考列表
      listMockPlan: "/zxxxj/mock/listMockPlan",
      //查询校级模考明细
      getMockPlanDetail: "/zxxxj/mock/getMockPlanDetail",
      //查询市级联考明细
      getCityPlanDetail: "/zxxxj/city/getCityPlanDetail",
      //考务安排
      creartMockTask: "/zxxxj/mock/creartMockTask",
      //新建模考返回名称
      getMockPlanName: "/zxxxj/mock/getMockPlanName",
      //删除校级模考
      deleteMockPlan: "/zxxxj/mock/deleteMockPlan",
      //创建校级模考
      saveMock: "/zxxxj/mock/saveMock",
      //修改校级模考
      updateMockPlan: "/zxxxj/mock/updateMockPlan",
      //下发校级模考
      updateMockPlanState: "/zxxxj/mock/updateMockPlanState",
      //结束考试
      endMockPlan: "/zxxxj/mock/endMockPlan",
      //模考撤销下发
      backOutDownMock: "/zxxxj/mock/backOutDownMock",
      //查询学校班级成绩
      listClassScoreSummary: "/zxxxj/mock/listClassScoreSummary",
      //校级发布成绩
      publishScoreMockPlan: "/zxxxj/mock/publishScoreMockPlan",
      //单个模考下未考试完成任务列表
      listMockPlanForNoDone: "/zxxxj/mock/listMockPlanForNoDone",
      //模考延期
      delayMockPlan: "/zxxxj/mock/delayMockPlan"
    },
    resource: {
      //查询难度列表
      res_listDifficulty: "/zxxxj/attribute/difficulty/list",
      res_listAuthTemplatePapers: "/zxxxj/paperTemplate/listAuthTemplatePapers",
      res_listTemplatePapers: "/zxxxj/paperTemplate/listTemplatePapers",
      res_listPapers: "/zxxxj/paper/listPapers",
      res_listPaperItemsByPaperIds: "/zxxxj/paper/listPaperItemsByPaperIds"
    },
    task: {
      // 课后练习任务list
      listHomeWorkTaskPath: "/zxxxj/task/listClassworkForTeacher",
      // 保存课后练习任务
      saveItemTask: "/zxxxj/task/classwork/create",
      // 删除课后练习
      deleteItemTask: "/zxxxj/task/deleteClasswork",
      //修改课后练习
      updateItemTask: "/zxxxj/task/updateClasswork",
      // 更新课后练习的试题顺序及删除试题
      saveSortItemTask: "/zxxxj/task/updateClassworkItems",
      //下发课后练习
      downItemTask: "/zxxxj/task/downClasswork",
      // 结束课后练习
      completeItemTask: "/zxxxj/task/updateClassworkComplate",
      //班级课后练习完成情况
      classTaskInfo: "/zxxxj/task/listClassworkClassStudent",
      // 查询单个课后练习明细
      listTaskDetail: "/zxxxj/task/getClasswork",
      getTheLastTask: "/zxxxj/task/getTheLastTaskId",
      analysisReport: "/zxxxj/report/analysisReport",
      classReport: "/zxxxj/report/studentReport",
      report: "/zxxxj/report/classReport",
      homeworkDefaultName: "/zxxxj/task/getClassworkNewName",
      task_getClasswork: "/zxxxj/task/getClasswork",
      // 查询备练习列表接口
      getTrainingTask: "/zxxxj/task/getTrainingTask",
      // 保存备练习接口
      saveTrainingTask: "/zxxxj/task/saveTrainingTask",
      // 备练习编辑接口
      updateTrainingTask: "/zxxxj/task/updateTrainingTask",
      // 备练习删除接口
      deleteTrainingTask: "/zxxxj/task/deleteTrainingTask",
      //备练习预览接口
      getTrainingTaskDetail: "/zxxxj/task/getTrainingTaskDetail",
      //备练习下发接口
      publishTrainingTask: "/zxxxj/task/publishTrainingTask",
      //获取备练习任务名称接口
      getTrainingTaskName: "/zxxxj/task/getTrainingTaskName",
      // 获取考生重复考试任务
      getRepeatExamStudentScore: '/zxxxj/complan/getRepeatExamStudentScore',
      // 缓存重复考生选择
      saveStudentScoreCache: '/zxxxj/complan/saveStudentScoreCache',
      // 清除所有手动选择的考生
      clearManuallySelectedScore: '/zxxxj/complan/clearManuallySelectedScore',
      // 保存成绩接口
      saveStudentScore: '/zxxxj/complan/saveStudentScore'
    },
    user: {
      // listTeacherClassPath: "/zxxxj/user/list/teacherClass",
      listTeacherClassPath: "/zxxxj/user/listTeacherSubjectClass",
      listClassStudent: "/zxxxj/user/list/classStudent",
      personalInfo: "/zxxxj/user/loginUser", //个人信息
      noticeInfo: "/zxxxj/msg/message/listMessage", //查询个人消息列表
      receiveNoticeInfo: "/zxxxj/msg/received/listReceivedMessage", //查询个人接收消息列表
      noticeDetail: "/zxxxj/msg/message/getMessage", //公告详情
      sendNotice: "/zxxxj/msg/message/saveMessage", //发送通知
      deleteNotice: "/zxxxj/msg/message/deleteMessage", //删除个人信息
      deleteReceiveNotice: "/zxxxj/msg/received/saveReadMessage", //删除接收到的消息
      configUrl: "/zxxxj/config/configInfo", //获取服务配置信息
      //获取学校信息
      schoolInfo: "/zxxxj/user/getSchool",
      //获取学校年级列表
      schoolGrade: "/zxxxj/user/schoolGrade",
      //获取学校下的班级列表
      schoolClassInfo: "/zxxxj/user/listSchoolClass",
      //根据学校用户的学校id查询的学校老师列表
      listSchoolTeacher: "/zxxxj/user/listSchoolTeacher",
      //查询该区域的统计信息
      statisticAreaSchool: "/zxxxj/user/statisticAreaSchool",
      // listSchoolTeacher:'/zxxxj/user/listSchoolTeacher',
      //查询角色权限列表
      auth_listRoleAuth: "/zxxxj/auth/listRoleAuth",
      //查询区域下的学校列表
      listAreaSchool: "/zxxxj/user/listAreaSchool",
      //查询年级下的班级列表
      listGradeSchool: "/zxxxj/user/gradeClass",
      //查询老师的班级
      listTeacherSubjectClass: "/zxxxj/user/listTeacherSubjectClass",
      //获取所有年级列表
      listAllGrade: "/zxxxj/user/listAllGrade",
      // 获取全部班级接口
      teacherClass: "/zxxxj/user/list/teacherClass",
      // 敏感词校验：
      recognizeText: '/zxxxj/user/recognizeText'
    },
    teaching: {
      // 试题包list
      listItemPacket: "/zxxxj/packet/item/list",
      getPacketsNum: "/zxxxj/packet/getPacketsNum",
      deleteItemForItemCart: "/zxxxj/packet/item/delete",
      // 试题列表
      listQuestionPath: "/zxxxj/item/list",
      updateItemPacketBasicInfo: "/zxxxj/packet/item/info/basic/update",
      listGrade: "/zxxxj/attribute/grade/list",
      listResourceOrigin: "/zxxxj/attribute/resource/origin/list",
      listDifficult: "/zxxxj/attribute/difficulty/list",
      textbookType: "/zxxxj/textbook/list", //教材列表
      listPublishType: "/zxxxj/attribute/listPublish", //获取出版社列表
      listPressByGradeCode: "/zxxxj/textbook/listPressByGradeCode",
      listUnitType: "/zxxxj/textbook/id/unit", //获取册别
      listItemType: "/zxxxj/attribute/item/type/list", //题型列表
      listTheme: "/zxxxj/attribute/theme/list", //主题列表
      listAttrByParentCode: "/zxxxj/attribute/listAttrByParentCode", //朝代查询
      // 保存试题包
      saveItemPacket: "/zxxxj/packet/saveItemPacket",
      // 查询试题包内试题列表
      listItemForItemPacket: "/zxxxj/packet/detail/item/list",
      updateItemPacketDetailInfo: "/zxxxj/packet/item/info/detail/update",
      listInteractiveForTeacherRecord: "/zxxxj/record/listInteractiveForTeacherRecord",
      studentReport: "/zxxxj/report/studentReport",
      // 报告-获取成绩单
      listStudentScore: "/zxxxj/report/taskStudentsScore",
      // 报告-数据统计分析
      analyseReport: "/zxxxj/report/analysisReport",
      packetNum: "/zxxxj/packet/getPacketsNum",
      //切换获取全部教材接口
      listAuth: "/zxxxj/textbook/listAuth",
      //获取课程接口
      listLesson: "/zxxxj/textbook/listLesson",
      //获取单元接口
      unit: "/zxxxj/textbook/id/unit",
      //选择班级后获取默认教材接口
      listChooseClassBook: "/zxxxj/teaching/listChooseClassBook"
    },
    student: {
      studentClassInfo: "/zxxxj/report/getStudentClassInfo",
      //课堂互动记录
      studentInteractRecord: "/zxxxj/record/listInteractiveStudent",
      //点赞记录
      record_getVoteInfoRecords: "/zxxxj/record/getVoteInfoRecords",
      //获取学校记录
      report_getStudentSchoolInfo: "/zxxxj/report/getStudentSchoolInfo",
      //课堂互动练习列表
      task_listClassworkForStudent: "/zxxxj/task/listClassworkForStudent"
    },

    report: {
      //获取班级-试卷分析
      report_getClassPaperInfo: "/zxxxj/report/getClassPaperInfo",
      //获取班级-成绩列表
      report_getClassScoreListInfo: "/zxxxj/report/getClassScoreListInfo",
      //获取班级-统计分析
      report_getClassStaticsInfo: "/zxxxj/report/getClassStaticsInfo",
      //获取区级-各个学校的总体评价
      report_getAllSchoolPreviewInfo: "/zxxxj/report/getAllSchoolPreviewInfo",
      //获取区级-各个学校的统计分析
      report_getAllSchoolStaticsInfo: "/zxxxj/report/getAllSchoolStaticsInfo",
      //分页获取区级-各个学校的统计分析
      report_getSchoolListStaticsInfo: "/zxxxj/report/getSchoolListStaticsInfo",
      //分页获取区级-各个学校历史对比分析
      report_getSchoolHistoryCompareInfo: "/zxxxj/report/getSchoolHistoryCompareInfo",
      //获取区级-各个学校历史对比分析
      report_getSchoolHistoryCompareAllInfo: "/zxxxj/report/getSchoolHistoryCompareAllStaticsInfo",
      //获取区级-总体统计分析
      report_getDistrictStaticsInfo: "/zxxxj/report/getDistrictStaticsInfo",
      //获取区级-试卷分析
      report_getDistrictPaperInfo: "/zxxxj/report/getDistrictPaperInfo",
      //获取校级-试卷分析
      report_getSchoolPaperInfo: "/zxxxj/report/getSchoolPaperInfo",
      //获取校级报告-统计分析
      report_getSchoolStaticsInfo: "/zxxxj/report/getSchoolStaticsInfo",
      //获取校级-各个班级统计分析
      report_getAllClassStaticsInfo: "/zxxxj/report/getAllClassStaticsInfo",
      //分页获取校级-各个班级统计分析
      report_getClassListStaticsInfo: "/zxxxj/report/getClassListStaticsInfo",
      //分页获取校级-各个班级历史对比分析
      report_getClassHistoryCompareInfo: "/zxxxj/report/getClassHistoryCompareInfo",
      //获取校级-各个班级历史对比分析
      report_getClassHistoryCompareAllStaticsInfo: "/zxxxj/report/getClassHistoryCompareAllStaticsInfo",
      //获取校级-各个班级的总体评价
      report_getAllClassPreviewInfo: "/zxxxj/report/getAllClassPreviewInfo",
      // 获取所有考试详情
      report_getMkTask: "/zxxxj/report/getMkTask",
      //获取考试学校班级
      report_getSchoolClassList: "/zxxxj/report/getSchoolClassList"
    },
    area: {
      area_listArea: "/zxxxj/user/listArea"
    },
    analysis: {
      /**学习分析 开始 */
      // 获取学期时间
      analysis_listAcademicYearBySchoolId: "/zxxxj/user/listAcademicYearBySchoolId",
      //获取学年数据列表
      analysis_getSchoolYearList: "/zxxxj/common/schoolYearList",
      //获取学期数据列表
      analysis_getSemesterList: "/zxxxj/common/semesterList",
      //获取学年学期月份数据列表
      analysis_getYearMonthList: "/zxxxj/common/yearMonthList",
      //获取概览数据
      analysis_getOverviewData: "/zxxxj/common/staticOverview",
      //获取城市情况数据列表
      analysis_getCitySituationList: "/zxxxj/province/citySituation",
      //获取区县情况数据列表
      analysis_getCountySituationList: "/zxxxj/city/countySituation",
      //获取学校情况数据列表
      analysis_getSchoolSituationList: "/zxxxj/county/schoolSituation",
      //获取年级情况数据列表
      analysis_getGradeSituationList: "/zxxxj/school/gradeSituation",
      //获取班级情况数据列表
      analysis_getClassSituationList: "/zxxxj/grade/classSituation",
      //获取年级基础学习列表
      analysis_getGradeBasicLiearningList: "/zxxxj/grade/gradeBasicLearning",
      //获取年级课本同步人次统计列表
      analysis_getGradeBookSyncCountList: "/zxxxj/grade/gradeBookSyncCount",
      //获取年级话题表述人次统计列表
      analysis_getGradeTopicExprCountList: "/zxxxj/grade/gradeTopicExprCount",
      //获取班级基础学习列表
      analysis_getClassAnalyzeBasicLiearningList: "/zxxxj/class/classBasicLearning",
      //获取班级课本同步人次统计列表
      analysis_getClassAnalyzeBookSynCountList: "/zxxxj/class/classBookSyncCount",
      //获取班级话题表述人次统计列表
      analysis_getClassAnalyzeTopicCountList: "/zxxxj/class/classTopicExprCount",

      //班级详情-基础学习
      analysis_getClassInfoBasicLiearningList: "/zxxxj/class/classBasicLearningInfo",
      //班级详情-课本同步
      analysis_getClassInfoBookSynchronizationList: "/zxxxj/class/classBookSyncInfo",
      //班级详情-话题表述
      analysis_getClassInfoTopicExpressionList: "/zxxxj/class/classTopicExprInfo",
      //班级详情-经典欣赏
      analysis_getClassInfoClassicsReadingList: "/zxxxj/class/classClassicsReadingInfo",
      //班级详情-N次统计
      analysis_getClassInfoSummaryList: "/zxxxj/report/SummaryReport",

      //学生报告-基础学习
      analysis_getBaseLearnReport: "/zxxxj/report/baselearnreport",
      //学生报告-话题表述
      analysis_getLearnTopicReportList: "/zxxxj/report/learntopicreport",
      //学生报告-课本同步
      analysis_getLearnBookReport: "/zxxxj/report/learnbookreport",

      /**学习分析 结束 */

      /**考务分析 开始 */
      //（区县、学校、年级、班级）概览
      analysis_getExamOverview: "/zxxxj/common/getExamOverview",
      //（区县、学校、年级、班级）历次成绩概览
      analysis_getScoreOverview: "/zxxxj/common/getScoreOverview",
      //（区县、学校、年级、班级）历次成绩列表
      analysis_getScoreList: "/zxxxj/common/getScoreList",
      //各校成绩列表
      analysis_getSchoolScoreList: "/zxxxj/county/getSchoolScoreList",
      //各年级成绩列表
      analysis_getGradeScoreList: "/zxxxj/school/getGradeScoreList",
      //各班级成绩列表
      analysis_getClassScoreList: "/zxxxj/grade/getClassScoreList",
      //学生成绩列表
      analysis_getStudentScoreList: "/zxxxj/class/getStudentScoreList",
      //（省、市、区县、学校、年级、班级）单次考试报告-概览
      analysis_getSingleTaskOverview: "/zxxxj/common/getSingleTaskOverview",
      //省级单次考试报告-各校成绩对比
      analysis_getCompareCityScore: "/zxxxj/province/compareCityScore",
      //省级单次考试报告-各校成绩统计
      analysis_getCompareCityDetail: "/zxxxj/province/compareCityDetail",
      //市级单次考试报告-各校成绩对比
      analysis_getCompareCountyScore: "/zxxxj/city/compareCountyScore",
      //市级单次考试报告-各校成绩统计
      analysis_getCompareCountyDetail: "/zxxxj/city/compareCountyDetail",
      //区县单次考试报告-各校成绩对比
      analysis_getCompareSchoolScore: "/zxxxj/county/compareSchoolScore",
      //区县单次考试报告-各校成绩统计
      analysis_getCompareSchoolDetail: "/zxxxj/county/compareSchoolDetail",
      //（学校、年级）单次考试报告-各班成绩对比
      analysis_getCompareClassScore: "/zxxxj/grade/compareClassScore",
      //（学校、年级）单次考试报告-各班成绩统计
      analysis_getCompareClassDetail: "/zxxxj/grade/compareClassDetail",
      //班级单次考试报告-学生成绩列表
      analysis_getCompareStudentDetail: "/zxxxj/class/compareStudentDetail",
      //学生历次成绩报告
      analysis_getStudentScoreReport: "/zxxxj/class/getStudentScoreReport",
      // 新-获取学年日期
      listThreeAcademicYearBySchoolId: "/zxxxj/user/listThreeAcademicYearBySchoolId"
    },
    item: {
      itemList: "/zxxxj/item/itemIds/list",
      res_listItem: "/zxxxj/item/list"
    },
    // 获取音频路径
    getTempDownloadUrl: '/zxxxj/oss/getTempDownloadUrl'
  },
  //groupId 以类区分
  interfaceGroupId: {
    teaching: "28b2d0dfbc0a46a8b4522066ee87cd02",
    task: "42005f009f364449985a6094bacb66b9",

    unit: "2392df3b9b504205b9eb0f8e11d505d4",
    mock: "8b2f5c683bd94babaed6844c6845d11b",
    user: "0e4014657bc74189bfdb6e15924f643f",
    record: "b92d4699cdac43db8d70e72549b22a16",
    config: "975f4434875c42c3b42f0941f0c93f3f",

    template: "d3dd582424e94ab2a766467574c3ea86",
    /**************************************试卷****************************************************/
    paper: "702c1f90a3434633922ffc12ec5f5101",
    /**************************************资源服务****************************************************/
    packet: "3ee106a04c624f039fcf038cda3441d1",
    textbook: "1064b6e966454225959930ce62cf1a24",
    attribute: "35bba5143e464a8ba260a1f769b6505d",
    monitor: "42005f009f364449985a6094bacb66b9",
    auth: "3415265e5a1648498cf03333bd18d314",
    item: "226c1649cbb94daab45f48a4320869e4",
    respondence: "8110a8f2049641568db01d8256e3f68e",

    /**************************************模考服务****************************************************/
    examtask: "aae582298a134ff49739a014877280b4",

    /**************************************公共搜索组件****************************************************/
    search_res: "28b2d0dfbc0a46a8b4522066ee87cd02",

    /**************************************报告****************************************************/
    report: "e424f6202d4f45ce88c9250153a48bd9",

    /**************************************学习分析****************************************************/
    analysis: "bc8a92b87ead45fa965210166de2886f",
    /**************************************区域列表****************************************************/
    area: "0a8d83b66c86431ebd024538b977c6e8"
  }
};

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by yuxin Wei on 2017/11/15.
 * 封装常量constants
 */
exports.default = {
  //试卷分类
  paperCategory: {
    mockExam: {
      code: '1701',
      name: '模拟考试'
    },
    officiallyExam: {
      code: '1702',
      name: '历年真题'
    }
  },
  //考试类型
  examType: {
    task: 'task',
    mock: 'mock',
    plan: 'plan'
  },
  //产品编码
  productTypeCode: {
    jkpt: '0701'
  },
  interfaceResult: {
    success: 1,
    error: 0,
    tokenfail: 'SHD-0112',
    noRight: 'QM-1003' //没有权限
  },
  // 试题包类型
  teachPackageType: {
    preparPackage: 1901, //备课包
    testPackage: 1902, // 随堂测试包
    homeworkPackage: 1903 // 课后练习包
  },
  //课后练习任务状态
  taskState: {
    '-1': '全部',
    '0': '待下发',
    '1': '进行中',
    '2': '已结束'
  },
  //资源包状态（发布/未发布）
  sourceState: {
    unpublished: 2202, //未发布
    published: 2201 //发布资源
  },
  //成绩单相对路径
  scorelistpath: {
    path: '/jkpt/hy/tas/score_file/'
  }
};

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(0);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _elementUi = __webpack_require__(25);

var _elementUi2 = _interopRequireDefault(_elementUi);

var _store = __webpack_require__(15);

var _store2 = _interopRequireDefault(_store);

var _user = __webpack_require__(405);

var _user2 = _interopRequireDefault(_user);

var _vuex = __webpack_require__(9);

var _regex = __webpack_require__(32);

var _regex2 = _interopRequireDefault(_regex);

var _usercenter = __webpack_require__(28);

var _storage = __webpack_require__(8);

var _storage2 = _interopRequireDefault(_storage);

__webpack_require__(10);

__webpack_require__(958);

var _config2 = __webpack_require__(1);

var _config3 = _interopRequireDefault(_config2);

var _constants = __webpack_require__(7);

var _constants2 = _interopRequireDefault(_constants);

var _constants3 = __webpack_require__(117);

var _constants4 = _interopRequireDefault(_constants3);

var _commonUtils = __webpack_require__(4);

var _commonUtils2 = _interopRequireDefault(_commonUtils);

var _analysisRedirect = __webpack_require__(21);

var _analysisRedirect2 = _interopRequireDefault(_analysisRedirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loading = function loading() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 89));
}; // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


_vue2.default.config.productionTip = false;
_vue2.default.use(_elementUi2.default);
/* eslint-disable no-new */

new _vue2.default({
  el: "#wrap",
  store: _store2.default,
  components: {
    loading: loading
  },
  data: {
    user: _user2.default.loginInfo,
    userName: "",
    passWord: "",
    loginInfoError: false, //账号或密码错误,
    loginPass: false,
    //国家通用语言文字学习平台-中小学版允许登录的角色集合
    roleCodes: ["student", "teacher", "subjectLeader", "instructor", "cityAdmin", "provinceAdmin", 'cityInstructor', 'proInstructor'],
    oldaddress: "",
    checked: false,
    codeType: "third", // 验证类型 third/pic
    captchaUrl: "", // 验证码图片
    msg: "",
    loading: false
  },
  computed: (0, _vuex.mapState)({
    name: function name(state) {
      return state.name;
    },
    userInfo: function userInfo(state) {
      return state.user.userinfo;
    }
  }),
  created: function created() {
    //清除session中的用户信息
    sessionStorage.clear();
    this.getCaptcha();
    this.getAccessToken();
  },

  watch: {
    user: {
      handler: function handler(newvalue, oldvalue) {
        this.loginInfoError = false;
      },
      deep: true
    }
  },
  methods: {
    getAccessToken: function getAccessToken() {
      var self = this;
      SSO.getLoginState(function (resultObj) {
        if (resultObj.code == 1001) {
          SSO.getAccessToken(function (response) {
            console.log('res', response);
            if (response && response.result === 'success') {
              self.afterSSOSuccess(response.data);
            } else {
              self.$alert('用户信息已过期，自动登录失败！', '提示');
            }
          });
        } else {
          // self.$alert('用户信息已过期，自动登录失败！', '提示')
        }
      });
    },


    chooseRole: function chooseRole(val) {
      var self = this;
      self.redirect(val);
    },
    login: function login() {
      var self = this;
      self.loginInfoError = false;
      var store = this.$store;
      var userName = this.user.username.replace(_regex2.default.aroundSpace, "");
      var passWord = this.user.password.replace(_regex2.default.aroundSpace, "");
      var captchaCode = this.user.captchaCode.replace(_regex2.default.aroundSpace, "");
      if (userName === "" && passWord === "") {
        self.loginInfoError = true;
        self.msg = "登录信息为空";
        return;
      }
      if (userName === "") {
        self.loginInfoError = true;
        self.msg = "账号为空";
        return;
      }
      if (passWord === "") {
        self.loginInfoError = true;
        self.msg = "密码为空";
        return;
      }
      if (captchaCode === "" && this.codeType === "pic") {
        self.loginInfoError = true;
        self.msg = "验证码为空";
        return;
      }
      self.loading = true;
      console.log("开启loading");
      if (SSO.captchaType === SSO.picCaptchaType) {
        if (captchaCode === "") {
          self.loginInfoError = true;
          self.msg = "请输入验证码";
          this.getCaptcha();
          return;
        }
        var loginParams = {
          account: userName,
          password: passWord,
          captchaCode: captchaCode
        };
        this.SSOLogin(loginParams);
      } else if (SSO.captchaType === SSO.thirdCaptchaType) {
        // 滑块验证
        SSO.verify();
      } else {}
    },
    afterSSOSuccess: function afterSSOSuccess(result) {
      var self = this;
      var param = {
        token: result.token,
        deviceId: SSO.deviceId,
        deviceName: SSO.client,
        osType: self.getOsType(),
        flush: true
      };
      console.log("getLoginUserInfo", param);
      _store2.default.commit("UPDATE_TOKEN", result.token);
      _store2.default.commit("UPDATE_MAC", result.mac);
      sessionStorage.setItem("tgt", result.tgt);
      //获取用户信息
      (0, _usercenter.getLoginUserInfo)(param).then(function (res) {
        self.loading = false;
        console.log(res);
        var loginResult = res.data;
        if (res.statusCode == _constants2.default.interfaceResult.error) {
          self.loginInfoError = true;
          self.msg = res.message;
          self.getCaptcha();
          return;
        } else if (res.statusCode == _constants2.default.interfaceResult.noRight) {
          self.loginInfoError = true;
          self.msg = res.message;
          self.getCaptcha();
          return;
        } else if (res.statusCode == _constants2.default.interfaceResult.tokenfail) {
          self.loginInfoError = true;
          self.msg = "获取用户信息失败";
          self.getCaptcha();
          return;
        } else {
          if (loginResult == null) {
            self.loginInfoError = true;
            self.msg = "获取用户信息失败";
            self.getCaptcha();
            return;
          }
        }
        loginResult.roleCodes = self.checkRoleCode(loginResult.roleCodes);
        if (loginResult.roleCodes.length == 0) {
          self.loginInfoError = true;
          self.msg = "该账号没有权限登录系统";
          self.getCaptcha();
          return;
        }
        // if (loginResult.roleCodes[0] == "student") {
        //   self.loginInfoError = true;
        //   self.msg = "暂未开放权限";
        //   self.getCaptcha();
        //   return;
        // }
        var params = {
          userId: loginResult.userId
        };
        _store2.default.commit("USER_SIGNIN", loginResult);
        //设置cookie,访问资源需要使用
        var _config = _config3.default.getConfig().apiConfig;
        SSO.setCookie("appkey", _config.appId, 1);
        SSO.setCookie("token", result.token, 1);
        SSO.setCookie("clientType", "web", 1);
        self.loginInfoError = false;
        if (loginResult.roleCodes.length == 1) {
          self.redirect(loginResult.roleCodes[0]);
        } else {
          self.loginPass = true;
        }
      }).catch(function (res) {
        self.loginInfoError = true;
        self.loading = false;
        self.msg = "服务器异常！";
        self.getCaptcha();
      });
    },

    // SSO封装登录接口
    SSOLogin: function SSOLogin(loginParams) {
      var self = this;
      SSO.loginExt(loginParams, function (res) {
        var result = res.data;
        console.log("loginExt返回", res);
        if (!!result.token) {
          //代表该用户存在
          self.afterSSOSuccess(result);
        } else {
          self.loading = false;
          if (_constants4.default.login_Info.loginErrCode == res.code) {
            self.msg = res.data;
          } else if (_constants4.default.login_Info.captchaCodeErr == res.code) {
            self.msg = res.data;
          } else {
            self.msg = "账号或密码错误";
          }
          self.loginInfoError = true;
          self.getCaptcha();
          return;
        }
      });
    },

    //获取权限集合
    getAuthList: function getAuthList(item) {
      var self = this;
      return new _promise2.default(function (resolve, reject) {
        var param = {};
        var result = false;
        param.role = [item];
        (0, _usercenter.listRoleAuth)(param).then(function (res) {
          console.log(res);
          console.log("【authList】:" + res);
          if (res != null && res.length > 0) {
            localStorage.setItem("roleCodes", (0, _stringify2.default)(res));
            resolve(true);
          } else {
            self.$message({
              message: "获取列表失败",
              type: "error",
              offset: 135
            });
            reject(false);
          }
        });
      });
    },

    //跳转
    redirect: function redirect(item) {
      var self = this;
      _store2.default.commit("USER_ROLE", item);
      this.getAuthList(item).then(function (res) {
        if (res) {
          _storage2.default.setSessionStorage("role", item);
          if (item == "teacher") {
            (0, _usercenter.getlistTeacherClassInfo)({
              studentCount: true,
              schoolId: self.userInfo.schoolId,
              teacherId: self.userInfo.userId,
              subjectCode: "01"
            }).then(function (classResult) {
              _store2.default.commit("USER_CLASS", classResult.data);
              // analysisRedirect.redirect2Index();
              window.location.href = "exam.html";
            }).catch(function (res) {
              self.loginInfoError = true;
              self.msg = res;
              self.getCaptcha();
            });
          } else if (item === "student") {
            window.location.href = "examHistoryReport.html";
          } else if (item === "instructor") {
            window.location.href = "plan.html";
          } else if (item === "subjectLeader") {
            (0, _usercenter.getlistTeacherClassInfo)({
              studentCount: true,
              schoolId: self.userInfo.schoolId,
              teacherId: self.userInfo.userId,
              subjectCode: "01"
            }).then(function (classResult) {
              _store2.default.commit("USER_CLASS", classResult.data);
              // analysisRedirect.redirect2Index();
              window.location.href = "mock.html";
            }).catch(function (res) {
              self.loginInfoError = true;
              self.msg = res;
              self.getCaptcha();
            });
          } else {
            _analysisRedirect2.default.redirect2Index();
          }
        }
      });
    },
    //关闭身份选择
    closeChoose: function closeChoose() {
      var self = this;
      self.loginPass = false;
    },
    //过滤角色
    checkRoleCode: function checkRoleCode(roles) {
      if (roles == undefined) {
        return [];
      }
      var self = this;
      var tempcode = [];
      roles.forEach(function (item, index) {
        if (_commonUtils2.default.isInArray(item, self.roleCodes)) {
          tempcode.push(item);
        }
      });
      return tempcode;
    },
    openold: function openold() {
      window.open(this.oldaddress);
    },
    // 验证码
    getCaptcha: function getCaptcha() {
      var _this = this;

      SSO.getCaptcha({
        getCaptchaResultCB: function getCaptchaResultCB(result) {
          return _this.getCaptchaResultCB(result);
        },
        captchaSuccessResultCB: function captchaSuccessResultCB(result) {
          return _this.captchaSuccessResultCB(result);
        },
        captchaCloseCB: function captchaCloseCB(result) {
          _this.captchaCloseCB(result);
        }
      });
    },
    captchaCloseCB: function captchaCloseCB() {
      this.loading = false;
    },

    // 获取验证信息
    getCaptchaResultCB: function getCaptchaResultCB(resultObj) {
      console.log(resultObj, "getCaptchaResultCB");
      if (resultObj && resultObj.code === "success") {
        var captchaData = resultObj.data;
        if (captchaData.captchaType) {
          this.codeType = captchaData.captchaType;
        }
        if (captchaData.captchaType === SSO.picCaptchaType && captchaData.captchaUrl) {
          console.log("进行图形验证");
          // 图形验证
          this.captchaUrl = captchaData.captchaUrl;
        }
      }
    },

    // 极验验证成功回调
    captchaSuccessResultCB: function captchaSuccessResultCB(resultObj) {
      console.log("极验被成功调用");
      var userName = this.user.username.replace(_regex2.default.aroundSpace, "");
      var passWord = this.user.password.replace(_regex2.default.aroundSpace, "");
      var loginParams = {
        account: userName,
        password: passWord
      };
      this.SSOLogin(loginParams);
    },

    // 判断设备类型
    getOsType: function getOsType() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      if (/msie/i.test(sUserAgent) && !/opera/.test(sUserAgent)) {
        return "ie";
      } else if (/firefox/i.test(sUserAgent)) {
        return "firefox";
      } else if (/chrome/i.test(sUserAgent)) {
        return "chrome";
      } else if (/opera/i.test(sUserAgent)) {
        return "opera";
      } else if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
        return "safari";
      } else if (/edg/i.test(sUserAgent)) {
        return "edge";
      } else if (/360/i.test(sUserAgent)) {
        return "360";
      } else if (/se 2.x/i.test(sUserAgent)) {
        return "sogou";
      } else if (/qqbrowser/i.test(sUserAgent)) {
        return "qq";
      } else if (/baidu/i.test(sUserAgent)) {
        return "baidu";
      } else if (/uc/i.test(sUserAgent)) {
        return "uc";
      } else {
        return "other";
      }
    }
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by yuxin Wei on 2017/10/19.
 */
/* 封装sessionStorage、localStorage*/
exports.default = {
  //localStorage教材信息
  getlocalStorage: function getlocalStorage(key, value, currentData) {
    var params = localStorage.getItem(value);
    if (params) {
      var obj = JSON.parse(params);
      for (var i = 0, len = currentData.length; i < len; i++) {
        if (currentData[i].code === obj.code) {
          //当前存在
          return obj;
        }
      }
      return currentData[0];
    } else {
      return currentData[0];
    }
  },
  getParamFromSessionStorage: function getParamFromSessionStorage(key, value) {
    var paramsTemp = sessionStorage.getItem('selfStudyState');
    if (paramsTemp) {
      var objTemp = JSON.parse(paramsTemp);
      return objTemp[key];
    }
    return value;
  },

  //公共session
  getSessionStorage: function getSessionStorage(key, value) {
    var keyValue = sessionStorage.getItem(key);
    if (keyValue) {
      return keyValue;
    }
    return value;
  },

  getSessionStorageExtend: function getSessionStorageExtend(key, defaultValue, isObject) {
    var keyResult = this.getSessionStorage(key, defaultValue);
    if (isObject) {
      return JSON.parse(keyResult);
    } else {
      return keyResult;
    }
  },
  setSessionStorage: function setSessionStorage(key, value) {
    sessionStorage.setItem(key, value);
  },
  removeSessionStorage: function removeSessionStorage(key) {
    sessionStorage.removeItem(key);
  },
  removeAllSessionStorage: function removeAllSessionStorage() {
    sessionStorage.clear();
  }
};

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _config = __webpack_require__(1);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (w, d, s) {
  var l = 'IFlyCollector',
      f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      w = window;
  w[l] = {};
  var c = w[l];
  c._o = function (a) {
    return function () {
      (c._e = c._e || []).push([a, arguments]);
    };
  };
  var e = ['init', 'onEvent', 'onError', 'bindUser', 'updateCustomConfig'];
  for (var i = 0; i < e.length; i++) {
    c[e[i]] = c._o.call(null, e[i]);
  }
  j.async = true;
  j.src = 'http://ebgjs.changyan.com/jssdk/entry.js';
  f.parentNode.insertBefore(j, f);
})(window, document, 'script');

IFlyCollector.init({
  appId: _config2.default.getConfig().mdianConfig.appId,
  host: _config2.default.getConfig().mdianConfig.host, //接入SDK的网站的域名
  debug: true, //
  spa: false,
  configUrl: _config2.default.getConfig().mdianConfig.configUrl,
  collectUrl: _config2.default.getConfig().mdianConfig.collectUrl,
  source: _config2.default.getConfig().mdianConfig.source
});

/***/ })

},[2015]);


// WEBPACK FOOTER //
// static/js/login.0877d6b8ceb6762688a4.js